export const fr = {
    "name": "French",
    "flagCode": "fr",
    "locale": "fr-fr",
    "project": {
        "name": "QUp New CC "
    },
    "MigrationBanner": {
        "title": "Next-Generation Command Center",
        "subtitle": "Explorez le nouveau tableau de bord et finalisez votre migration avant le %{deadline}.",
        "tryNow": "Essayer maintenant",
        "dismiss": "Fermer"
    },

    "Sidebar": {
        "Product_Discovery": "Découverte de produit",
        "Setting": "Paramètres",
        "Map": "Carte",
        "Cue": "Liste reservations",
        "Invoice": "Facture",
        "Supplier": "Fournisseur",
        "Vehicle": "Véhicule",
        "Merchant": "Marchand",
        "ImportBookings": "Réservations de transport d'importation",
        "ImportDeliveryBookings": "Réservations de livraison d'importation",
        "Trip": "Voyage",
        "New_booking": "Nouvelle réservation",
        "City": "Ville",
        "Chauffeur": "Transport",
        "Delivery": "Livraison",
        "Shuttle": "Navette",
        "Intercity": "Interurbain",
        "Customer": "Clients",
        "Driver": "Chauffeurs",
        "REPORTS": "Rapports",
        "Corporate": "Entreprise",
        "mDispatcher": "MDispatcher",
        "Reservation": "Calendrier",
        "withdrawalRequest": "Demandes de retrait",
        "Driver_Settlement": "Règlement du conducteur",
        "Dashboard": "Statistiques",
        "SmartData": "Données intelligentes",
        "Smart_Data": "Données intelligentes",
        "Campaign_Builder": "Générateur de campagnes",
        "Company_operator": "Opérateur d'entreprise",
        "Queuing_area": "Zone d'attente",
        "Withdrawal_Requests": "Demandes de retrait",
        "pickUp": "Pick up",
        "dropOff": "Dépose",
        "SignUpNotifications": "Notifications d'inscription",
        "Payout": "Paiement ",
        "Payout_label": "Paiement ",
        "Invoice_Setting": "Facture",
        "payout": {
            "payoutDriver": "Paiement du conducteur",
            "payoutMerchant": "Paiement aux marchands",
            "payoutSupplier": "Paiement du fournisseur",
            "Pay_To_Driver": "Paiement aux chauffeurs",
            "payoutDriverHistory": "Historique des conducteurs de paiement",
            "Pay_To_Merchant": "Paiement aux marchands",
            "Payout_History_For_Merchant": "Historique des paiements aux marchands",
            "Pay_To_Supplier": "Payer les fournisseurs",
            "payoutSupplierHistory": "Histoire des paiements des fournisseurs",
            "Driver_Payout": "Paiement du conducteur",
            "Supplier_Payout": "Paiement du fournisseur",
            "Merchant_Payout": "Paiement du marchand"
        },
        "number_of_records_to_export": "Nombre d'enregistrements à exporter",
        "export": "Exporter",
        "Airline": "Compagnie aérienne",
        "driverPayout": {
            "Pay_to_driver": "Paiement aux chauffeurs",
            "Payout_history": "Historique des paiements"
        },
        "Reports": {
            "Driver_Referral_history": "Un chauffeur recommande un client",
            "Driver_refers_Pax": "Chauffeurs",
            "Refund": "Remboursement",
            "Driver_refers_Pax_Customers": "Clients",
            "Driver_refers_Pax_Bookings": "Réservations",
            "Driver_refers_customer_Drivers": "Un chauffeur recommande un client (Chauffeurs)",
            "Driver_refers_customer_Customers": "Un chauffeur recommande un client (Clients)",
            "Driver_refers_customer_Bookings": "Un chauffeur recommande un client (Réservations)",
            "Passenger_refers_Passengers": "Un client recommande un client",
            "Driver_refers_drivers_Referrer": "Un chauffeur recommande des chauffeurs (Référent)",
            "Deletion_request": "Demande de suppression",
            "Driver_refers_drivers_Referee": "Un chauffeur est recommandé par un autre chauffeur (Référé)",
            "Supplier_Wallet": "Portefeuille Fournisseur",
            "Driver_refers_Driver": "Un chauffeur recommande un autre chauffeur",
            "Driver_refers_driver_Referrer": "Référent",
            "Driver_refers_driver_Referee": "Référé",
            "Referral_history": "Historique des recommandations",
            "Booking_details": "Détails réservations",
            "Financial": "Financier",
            "Financial_driver": "Pilotes",
            "Financial_fleet": "Flotte",
            "Financial_company": "Compagnie",
            "Financial_Driver": "Financier (Pilotes)",
            "Financial_Fleet": "Financier (Flotte)",
            "Financial_Company": "Financier (Compagnie)",
            "Financial_fleet_profit": "Profit de la flotte",
            "Financial_Company_Tooltip": "Rapport des revenus net de chaque Transport, groupé par compagnie",
            "Financial_Driver_ToolTip": "Rapport des revenus net de chaque Transport",
            "Financial_Fleet_Profit_ToolTip": "Profit de la flotte",
            "Driver_activity": "Activité du Driver",
            "Revenue_Summary": "Résumé des revenus",
            "Revenue_fleet": "Flotte",
            "Revenue_driver": "Chauffeurs",
            "Revenue_monthly": "Monsuel",
            "Revenue_Summary_Fleet": "Récapitulatif des recettes (Flotte)",
            "Revenue_Summary_Driver": "Récapitulatif des recettes (Pilotes)",
            "Revenue_Summary_Monthly": "Récapitulatif des recettes (Monsuel)",
            "Total_adjustment": "Ajustement total",
            "Promotion": "Promotion",
            "Incident_Cancellation": "Incident & annulation",
            "Booking_logs": "Logs réservations",
            "Rating": "Évaluation",
            "Thumbs_rating": "Thumbs rating",
            "Stars_rating": "Driver rating",
            "Operator_logs": "Logs opérateur",
            "Daily": "Quotidien",
            "Daily_Driver": "Transport (quotidien)",
            "Daily_Car": "Voiture (quotidien)",
            "Daily_Driver_Car": "Transport Voiture (quotidien)",
            "mDispatcher": "MDispatcher",
            "Corporate": "Entreprise",
            "Driver_login_status": "Statut de connexion du Transport",
            "Car_activity": "Activité du véhicule",
            "Partner": "Partenaire",
            "Prepaid_top_up": "Réapprovisionner la carte prépayée",
            "Affiliation": "Affiliation",
            "Affiliation_penalty_compensation": "Pénalité/Compensation",
            "Affiliation_payout_history": "Historique des règlements",
            "Affiliation_bookings": "Réservations",
            "Booking_summary": "Résumé des réservations",
            "Cash_Wallet": "Portefeuille en espèces",
            "Credit_Wallet": "Portefeuille de crédit",
            "Driver_wallet": "Portefeuille du conducteur",
            "Driver_Deposit": "Credit Wallet",
            "Driver_cash_wallet": "Portefeuille en espèces",
            "Driver_Deposit_old": "Dépôt du chauffeur",
            "Document_expiry": "Expiration du document",
            "Settlement": "Installation",
            "Unapproved_Driver": "Driver non approuvé",
            "Approved_Driver": "Driver approuvé",
            "Pay_to_driver": "Payé au Transport",
            "Settlement_history": "Historique d'implantation",
            "Withdrawal_History": "Retrait du Transport",
            "creditWalletTooltip": "Le Transport a fait un dépot dans le porte-monnaie",
            "Incomplete_payment": "Paiement incomplet",
            "Driver_withdrawal": "Retrait du chauffeur",
            "Incident_&_Cancellation": "Portefeuille du passager",
            "Passenger_wallet": "Portefeuille du passager",
            "Accept_Cancel_rate": "Acceptance/Cancellation rate",
            "Acceptance/Cancellation_rate": "Acceptance/Cancellation rate",
            "driverDepositTooltip": "Le chauffeur a fait un dépot dans le porte-monnaie",
            "Customer_quest": "Quête",
            "First_will_win": "Le premier gagnera",
            "Largest_will_win": "Le plus grand gagnera",
            "redeemed": "Code #",
            "Code_#": "Code #",
            "Quests": "Quête",
            "Merchant_Report": "Vendeur",
            "Merchant_Financial_Report": "Financier",
            "Merchant_Cash_Report": "Portefeuille en espèces",
            "Merchant_Credit_Report": "Portefeuille de crédit",
            "Deletion_Request": "Demande de suppression",
            "Driver_Rating": "Le client note le chauffeur",
            "Passenger_Rating": "Le chauffeur note le client",
            "Company_settlement": "Règlement de l'entreprise",
            "Export": "Historique des exportations",
            "Third_Party_Booking": "Réservation par un tiers",
            "BookingDotCom": "Booking.com",
            "Third_Party_Booking_Bookingcom": "Réservation par un tiers (Booking.com)",
            "Third_Party_Booking_HolidayTaxis": "Réservation par un tiers (HolidayTaxis)",
            "Third_Party_Booking_Karhoo": "Réservation par un tiers (Karhoo)",
            "Third_Party_Booking_Hoppa": "Réservation par un tiers (Hoppa)",
            "Third_Party_Booking_Klook": "Réservation par un tiers (Klook)",
            "Third_Party_Booking_TransferZ": "Réservation par un tiers (TransferZ)",
            "supplierWallet": "Portefeuille Fournisseur"
        },
        "Settings": {
            "Block_Passenger": "Bloquer le passager",
            "Fleet_info": "Informations de la flotte",
            "Product_Discovery": "Découverte de produit",
            "Surchage_Policy": "Politique de surtaxe",
            "RateLegacy": "Tarif (Ancien)",
            "Driver": "Conducteur",
            "Merchant": "Marchand",
            "Calendar": "Calendrier",
            "Socaial": "Socaial",
            "Quest": "Quête",
            "Referral": "Référence",
            "Addon_Template": "Add-On Template",
            "Social": "Social",
            "Shift": "Déplacement",
            "Rate_Templates": "Modèles de tarifs",
            "Supplier_Plan": "Plan du fournisseur",
            "Vehicle_Lead_Time": "Délai de livraison du véhicule",
            "Penalty_Policy": "Politique de pénalité",
            "Stripe_connect": "Stripe Connect",
            "stripe_title_connect": "Activez votre compte Stripe Connect pour recevoir votre paiement automatiquement.",
            "Payment_info": "Informations de facturation",
            "Permission": "Autorisation",
            "Driver_refer_driver": "Un chauffeur recommande un autre chauffeur",
            "Show_referal_history": "Afficher/masquer l'historique des recommandations sur l'application chauffeur",
            "companyTooltip": "Entreprise fournisseur",
            "User": "Utilisateur",
            "General": "Général",
            "Regular": "Ordinaire",
            "Sharing": "Partage de rue",
            "Flat": "Forfaits",
            "Hourly": "Tarif de mise à disposition",
            "Company": "Compagnie",
            "Dispatch": "Dispatching",
            "Voice_SMS": "Voix & SMS",
            "Rate": "Tarif",
            "RateNew": "Tarif",
            "Car": "Véhicule",
            "Car_type": "Type de véhicule",
            "Car_mgmt": "Gestion des véhicules",
            "Car_Make": " Marque et modèle",
            "Meeting_Zone": "Zone de réunion",
            "Restricted_Zone": "Zone restreinte",
            "Stripe_Connect": "Stripe Connect",
            "Voice_&_SMS": "Voix et SMS",
            "Street-sharing_rate": "Tarif du partage de rue",
            "Partner_type": "Type de partenaire",
            "Shift_template": "Modèle Shift",
            "Billing_Usage": "Utilisation de la facturation",
            "Driver_App": "Application chauffeur",
            "Shift_settings": "Paramètres Shift",
            "Operation": "Opération",
            "Driver_Note": "Note du chauffeur",
            "Promotion_code": "Code promo",
            "Point_config": "Configuration des points",
            "Code_#": "Code #",
            "Voucher_code": "Code #",
            "Campaign": "Campagne",
            "Queuing_area": "Zone de file d'attente",
            "Referral_code": "Code Parrainage",
            "City": "Ville",
            "category": "Catégorie",
            "3rd_party_location": "Emplacement de la 3ème partie",
            "Zone": "Zone de filtre",
            "App_banner": "Banière de l'application",
            "App_banner_pegasus": "Bannière de l'appli",
            "Flight_integration": "Intégration des vols",
            "SMS_integration": "Intégration SMS",
            "Invoice_Setting": "Facture",
            "Payout_Setting": "Modèle de paiement",
            "AI_Atlas": "Chatbot Atlas AI",
            "Driver_refers_customer": "Un chauffeur recommande un client",
            "Pax_refers_Pax": "Un client recommande un autre client",
            "Customer_refers_customer": "Un client recommande un autre client",
            "Dynamic_Surcharge": "Supplément dynamique",
            "Dynamic_Fare": "Tarif dynamique",
            "FlatZone": "Tarif fixe",
            "IntercityZone": "Interurbain",
            "Intercity_Zone": "Zone interurbaine",
            "Intercity_Rate": "Tarif interurbain",
            "Car_Color": "Couleur du véhicule",
            "third_party_integration": "Intégration de tiers",
            "bookingCom": "Booking.com",
            "HolidayTaxis": "HolidayTaxis",
            "Karhoo": "Karhoo",
            "Corporate": "Entreprise",
            "KarhooIntegration": "Intégration Karhoo",
            "holidaytaxis": "HolidayTaxis",
            "karhoo": "Karhoo",
            "hoppa": "Hoppa",
            "Hoppa": "Hoppa",
            "HoppaIntegration": "Intégration Hoppa",
            "Third_Party_Integration_Hoppa": "Intégration de tiers (Hoppa.com)",
            "titleHoppa": "Identifiants API Hoppa",
            "noteHoppa": "Communiquez avec l'équipe technique de Hoppa pour obtenir le client et la clé secrète afin de vous connecter à leur système.",
            "titleHoppaWebhook": "Configuration du webhook",
            "noteHoppaWebhook": "Fournissez les paramètres ci-dessous pour que Hoppa puisse les configurer. Ces identifiants sont utilisés pour la communication entre les deux plateformes. Pour tout problème, veuillez contacter votre fournisseur technologique.",
            "klook": "Klook",
            "Klook": "Klook",
            "KlookIntegration": "Intégration Klook",
            "Third_Party_Integration_Klook": "Intégration tierce (Klook.com)",
            "titleKlook": "Identifiants de l'API Klook",
            "noteKlook": "Communiquez avec l'équipe technique de Klook pour vous fournir le client et la clé secrète afin de vous connecter à leur système.",
            "titleKlookWebhook": "Configuration du Webhook",
            "noteKlookWebhook": "Fournissez les paramètres ci-dessous pour que Klook puisse configurer. Ces identifiants sont utilisés pour communiquer entre les deux plateformes. Pour tout problème, veuillez contacter votre fournisseur technique.",
            "transferZ": "TransferZ",
            "TransferZ": "TransferZ",
            "TransferZIntegration": "Intégration TransferZ",
            "Third_Party_Integration_TransferZ": "Intégration tierce (TransferZ.com)",
            "titleTransferZ": "Identifiants de l'API TransferZ",
            "noteTransferZ": "Communiquez avec l'équipe technique de TransferZ pour vous fournir le client et la clé secrète afin de vous connecter à leur système.",
            "titleTransferZWebhook": "Configuration du Webhook",
            "noteTransferZWebhook": "Fournissez les paramètres ci-dessous pour que TransferZ puisse configurer. Ces identifiants sont utilisés pour communiquer entre les deux plateformes. Pour tout problème, veuillez contacter votre fournisseur technique.",
            "Third_Party_Integration_Booking": "Intégration de tiers (Booking.com)",
            "Third_Party_Integration_HolidayTaxis": "Intégration de tiers (HolidayTaxis)",
            "Third_Party_Integration_Karhoo": "Intégration de tiers (Karhoo.com)",
            "Third_Party_Integration_Mozio": "Intégration de tiers (Mozio.com)",
            "invoiceBranding": "Personnalisation de la facture",
            "invoiceLogo": "Logo de la facture",
            "invoiceColor": "Couleur de la facture",
            "payoutBranding": "Marque de paiement",
            "titleInvoice": "Personnalisez les informations d'en-tête et de pied de page de votre entreprise.",
            "titlePayout": "Personnalisez les informations de l'en-tête et du pied de page de votre entreprise.",
            "titleheader": "Titre de l'en-tête",
            "descriptionHeader": "Description de l'en-tête",
            "placehodelHeader": "Par exemple, ajoutez les détails de l'entreprise comme l'email, le numéro de téléphone, l'adresse, le numéro fiscal, etc.",
            "titleFooter": "Titre du pied de page",
            "placehodelFooter": "Par exemple, ajoutez les informations de virement bancaire ou toute politique, etc.",
            "descriptionFooter": "Description du pied de page",
            "defaultEmailMessage": "Message email par défaut",
            "placeholderEmailMessage": "Le montant sera transféré sur votre compte en utilisant votre méthode de paiement préférée. N'hésitez pas à nous contacter à <email> si vous avez des questions.\n\nMerci pour les services fournis. Nous sommes impatients d'une coopération fructueuse à l'avenir.\n\nCordialement,  \nL'équipe Good Journey\n\nSi aucune objection n'est reçue dans les sept jours, la facture auto-facturée est considérée comme approuvée.",
            "titleBookingCom": "Identifiants API Booking.com",
            "noteBookingCom": "Communiquez avec l'équipe technique de Booking.com pour obtenir le client et la clé secrète afin de vous connecter à leur système.",
            "clientKey": "Clé client",
            "placeHolderClientKey": "Saisissez la clé client",
            "secretKey": "Clé secrète",
            "placeHolderSecretKey": "Saisissez la clé secrète",
            "titleBookingComWebhook": "Configuration du webhook",
            "noteBookingComWebhook": "Fournissez les paramètres ci-dessous pour que Booking.com puisse les configurer. Ces identifiants sont utilisés pour la communication entre les deux plateformes. Pour tout problème, veuillez contacter votre fournisseur technologique.",
            "webhook": "URL du webhook de flotte",
            "clientId": "Clé client de flotte",
            "clientSecret": "Clé secrète de flotte",
            "driver_app": "Application chauffeur",
            "Jobs_tab": "Onglet des tâches",
            "Email_config": "Configuration de l'email",
            "Driver_fields": "Champs du chauffeur",
            "Driver_document": "Document du chauffeur",
            "Selected": "Sélectionné",
            "API_Management": "Gestion de l'API",
            "Penalty_Policy_Customer": "Politique de pénalité client",
            "Penalty_Policy_Supplier": "Politique de pénalité fournisseur",
            "Stop_Sales": "Arrêter les ventes",
            "RestrictedZone": "Zone restreinte",
            "MeetingZone": "Zone de réunion",
            "block_passenger": "Bloquer le passager",
            "Billing_usage": "Utilisation de facturation"
        }
    },
    "welcome": {
        "next": "Next",
        "getStarted": "Get Started",
        "step1": {
            "title": "Product Discovery",
            "description": "Welcome to Good Journey! Access all the products included in your plan, such as the <span class=\"highlight-white\">Driver App, Customer Web Booker</span> and more.",
            "button": "Learn more"
        },
        "step2": {
            "title": "Introducing Fleet Wallet",
            "description": "Once you reach your free allowance, any additional overage will check your fleet wallet to deduct per additional request.",
            "moreInfo": "💡 Maintain a positive balance, check usage and transaction reports here."
        },
        "step3": {
            "title": "Never Miss a Beat",
            "description": "You can setup <span class=\"highlight-white\">Automated Top-up</span> to ensure no service disruption on top of usage.",
            "description2": "This ensures your drivers stay on the road and your data keeps flowing, no matter how busy things get."
        },
        "step4": {
            "title": "Getting Started",
            "description": "We’re thrilled to have you onboard! Check out our <span class=\"highlight-white\">Guides & Tutorials</span> section to master the platform and get the most out of your fleet management tools."
        }
    },
    "productDiscovery": {
        "title": "Découverte de produit",
        "fleetCode": "Code de flotte",
        "fleetCodeDescription": "Les conducteurs utilisant l'application mondiale pour conducteurs doivent entrer ce code avant de se connecter.",
        "description": "Explorez et activez les outils qui alimentent votre flotte. Accédez à l'application Conducteur, à l'application Client, au Portail de Réservation Web et aux applications Partenaire Booker — toutes conçues pour rationaliser les opérations, se connecter avec les passagers et développer votre entreprise.",
        "web": "Web",
        "ios": "iOS",
        "android": "Android",
        "guide": "Guide",
        "gallery": "Galerie",
        "downloadLinks": "Liens de téléchargement",
        "customize": "Paramètres",
        "base": "Base de connaissances",
        "base_description": "Votre guide tout-en-un pour la plateforme. Explorez des tutoriels étape par étape, des FAQ et des meilleures pratiques pour maîtriser les réservations, l'envoi, les paiements, et plus encore.",
        "base_allowed": {
            "platform_guides": "Guides de la plateforme",
            "step_by_step_tutorials": "Tutoriels étape par étape",
            "faqs_troubleshooting": "FAQs et Dépannage",
            "best_practices": "Meilleures pratiques",
            "product_releases_updates": "Lancement de produit et mises à jour"
        },
        "driver_app": "Application de conducteur",
        "driver_app_description": "Équipez vos chauffeurs d'une application pour gérer les missions, compléter les courses et mettre à jour les réservations sans effort.",
        "driver_app_allowed": {
            "booking_notifications": "Notifications de réservation",
            "trip_management": "Gestion des voyages",
            "navigate_realtime_tracking": "Navigation et Suivi en Temps Réel",
            "inapp_communication_support": "Communication et support dans l'application",
            "track_driver_earnings": "Suivre les gains des conducteurs",
            "driver_signup_link": "Lien d'inscription du conducteur"
        },
        "passenger_app": "Application Passager",
        "passenger_app_description": "Réservez et gérez vos trajets en toute simplicité. L'application Passager offre une expérience premium pour les voyageurs — de la réservation instantanée aux mises à jour en temps réel — garantissant confort, fiabilité et contrôle à chaque étape.",
        "passenger_app_allowed": {
            "seamless_ride_booking": "Réservation de trajet sans couture",
            "realtime_tracking_notifications": "Suivi en temps réel et notifications",
            "inapp_communication": "Communication dans l'application",
            "flexible_payment_receipts": "Paiements et reçus flexibles",
            "ride_history_favorites": "Historique des trajets et Favoris"
        },
        "web_driver_app": "Application Web du Conducteur",
        "web_driver_app_description": "Donnez aux sous-traitants et aux conducteurs partenaires un moyen facile d'accepter et de gérer des missions sans installer d'application. L'application Web pour conducteurs fonctionne directement dans le navigateur — parfaite pour les conducteurs occasionnels ou les partenaires utilisant leurs propres systèmes, avec des notifications envoyées par e-mail, SMS ou alertes web.",
        "web_driver_app_allowed": {
            "job_access_via_web_link": "Accès à l'emploi via lien web",
            "trip_management": "Gestion des voyages",
            "notifications_email_sms_web": "Notifications par Email/SMS/Web",
            "navigation_status_updates": "Navigation et mises à jour de statut",
            "simple_lightweight": "Simple et léger",
            "signup_link": "Lien d'inscription des conducteurs"
        },
        "web_passenger_app": "Application de réservation en ligne",
        "web_passenger_app_description": "Permettez à vos clients et partenaires de réserver des trajets directement depuis votre site web. L'application de réservation en ligne est conçue pour les transferts aéroport, les services de chauffeur et les réservations à la demande — offrant aux OTA, hôtels et agents de voyage un moyen simple de connecter les voyageurs avec votre flotte.",
        "web_passenger_app_allowed": {
            "embed_anywhere": "Incorporer n'importe où",
            "create_ride_bookings": "Créer des réservations de trajet",
            "seamless_web_experience": "Expérience Web sans couture",
            "partner_ready": "Prêt pour les partenaires",
            "customer_friendly_checkout": "Paiement convivial"
        },
        "concierge_booker": "Concierge Booker",
        "concierge_booker_description": "Une application web simple pour les partenaires et le personnel — des concierges d'hôtel et des voituriers aux barmans et hôtes de restaurant — pour créer des trajets pour leurs invités en quelques clics seulement. Chaque utilisateur a son propre identifiant, peut réserver au nom des voyageurs et suivre les commissions gagnées.",
        "concierge_booker_allowed": {
            "quick_guest_booking": "Réservations rapides pour les invités",
            "individual_user_login": "Connexions Utilisateur Individuelles",
            "commission_tracking": "Suivi des commissions",
            "easy_web_access": "Accès Web Facile",
            "partner_friendly_setup": "Mise en place conviviale pour les partenaires"
        },
        "gojo_api": "API Bon Voyage",
        "gojo_api_description": "Construisez en toute confiance. Accédez à notre portail développeur pour explorer les références API, les guides d'intégration et les exemples de flux de travail pour les réservations, l'envoi, les paiements, et plus encore.",
        "gojo_api_allowed": {
            "comprehensive_api_reference": "Références API complètes",
            "integration_guides": "Guides d'intégration",
            "sandbox_testing_tools": "Sandbox et Outils de Test"
        },
        "gojo_canvas": "Toile de Bon Voyage",
        "gojo_canvas_description": "Concevez et personnalisez votre expérience de super-app. Good Journey Canvas vous donne un contrôle créatif total pour gérer les menus, les formulaires de livraison, les promotions et les mises en page de l'écran d'accueil — le tout à partir d'une seule interface simple.",
        "gojo_canvas_allowed": {
            "menu_management": "Gestion du menu",
            "custom_delivery_forms": "Formulaires de livraison personnalisés",
            "super_app_home_builder": "Super-App Constructeur de Maison",
            "promotion_advertising": "Promotions et Publicité",
            "flexible_content_management": "Gestion de contenu flexible"
        },
        "gojo_chatbot": "Bon Voyage AI Chat Bot",
        "gojo_chatbot_description": "Réservez des trajets simplement par une conversation. L'assistant de chat alimenté par l'IA aide les clients, partenaires ou employés à créer des réservations instantanément — en tapant des demandes, en parlant naturellement, ou même en téléchargeant des itinéraires.",
        "gojo_chatbot_allowed": {
            "conversational_booking": "Réservation Conversationnelle",
            "file_itinerary_uploads": "Téléchargement de fichiers et d'itinéraires",
            "multi_channel_access": "Accès Multi-Canal",
            "smart_suggestions": "Suggestions intelligentes",
            "operator_assistance": "Assistance de l'opérateur"
        },
        "concierge_booker_web_setting": "Paramètres - Concierge Booker",
        "pax_app_setting": "Paramètres - Application Passager",
        "driver_app_setting": "Paramètres - Application de conducteur globale",
        "pax_web_setting": "Paramètres - Application de réservation en ligne",
        "driver_web_setting": "Paramètres - Application Web du Pilote",
        "save": "Enregistrer",
        "cancel": "Annuler",
        "themes": "Thèmes",
        "links": "Liens",
        "ios_driver_app": "Application pilote iOS",
        "android_driver_app": "Application de pilote Android",
        "gallery_driver_app": "Application du conducteur de galerie",
        "ios_pax_app": "Application Passager iOS",
        "android_pax_app": "Application Passager Android",
        "gallery_pax_app": "Application Passager Gallery",
        "light_mode": "Mode clair",
        "dark_mode": "Mode Sombre",
        "primary_color": "Couleur primaire",
        "secondary_color": "Couleur secondaire",
        "longName": "PWA Long Name",
        "shortName": "Nom court PWA",
        "adsTracking": "Suivi des annonces",
        "googleId": "ID de balise Google",
        "metaId": "ID de pixel Meta",
        "customUrl": "Lien Web de réservation",
        "partnerLink": "Liens Web Partenaire",
        "webBookingSettings": "Paramètres de réservation en ligne",
        "enableBookNow": "Réservations maintenant",
        "enableBookLater": "Réservations ultérieures",
        "enableGuestCheckout": "Paiement en tant qu'invité",
        "icon192": "Icône d'application PWA (192x192)",
        "icon512": "Icône d'application PWA (512x512)",
        "icon192Driver": "Icône d'application PWA (192x192)",
        "icon512Driver": "Icône d'application PWA (512x512)",
        "pax_app": "Application passager",
        "default": "Par défaut",
        "customized": "Personnalisé",
        "html": "HTML",
        "quoteSettings": "Quote Settings",
        "about": "À propos",
        "email": "Support par email",
        "enablePhone": "Numéro de téléphone",
        "phone": "",
        "policy": "Politique de confidentialité du lien",
        "termOfUse": "Conditions d'utilisation du lien",
        "site": "Site web",
        "logoDriverIOS": "Logo - IOS",
        "logoDriverAndroid": "Logo - Android",
        "htmlUrl": "fichier HTML",
        "Update_fail": "Les erreurs se sont produites",
        "Update_success": "Les paramètres ont été mis à jour avec succès",
        "driverSignUp": "Lien d'inscription des conducteurs",
        "customUrlDriver": "Lien de l'application Web du conducteur"
    },
    "APIKeySetting": {
        "APIKey": "Clés API",
        "APIKey_title": "Ne partagez pas votre clé API avec d'autres personnes, ni ne l'exposez dans le navigateur ou dans un autre code côté client. Afin de protéger la sécurité de votre compte, Good Journey peut également désactiver automatiquement toute clé API qui aurait été divulguée publiquement.",
        "newKeyBtn": "Créer une nouvelle clé",
        "updateApplication": "Mettre à jour l'application",
        "RegisterApp": "Enregistrer une nouvelle application",
        "RegisterBtn": "Enregistrer l'application",
        "appDescription": "Description de l'application",
        "webhookUrl": "Point de terminaison Webhook",
        "appName": "Nom de l'application",
        "clientKey": "Clé client",
        "secretKey": "Clé secrète",
        "hostedEndPoint": "Points de terminaison hébergés",
        "maxEndpoints": "Vous pouvez avoir un maximum de 5 points de terminaison",
        "addEndpoint": "Ajouter un point de terminaison",
        "updateEndpoint": "Mettre à jour le point de terminaison",
        "ManageWebhooks": "Gérer les webhooks",
        "CreateWebhook": "Créer des webhooks",
        "subscriptionID": "ID d'abonnement",
        "webhookURL": "URL du webhoo ",
        "signingSecret": "Clé secrète de signature",
        "eventsToSend": "Événements à envoyer",
        "listeningFor": "Écoute de",
        "assignedDriver": "Chauffeur assigné",
        "bookingStatus": "Statut de la réservation",
        "driverLocation": "Localisation du chauffeur",
        "titleSigningSecret": "Cette clé secrète est fournie par votre partenaire. Si, pour une raison quelconque, la clé secrète a été compromise, vous pouvez la mettre à jour ou supprimer le webhook.",
        "notUsingHTTPS": "L'URL du webhook n'utilise pas HTTPS.",
        "invalidURL": "L'URL du webhook est invalide.",
        "clientType": "Type de client",
        "individual": "Individuel",
        "corporate": "Entreprise",
        "signingSecretLength": "La clé secrète de signature doit comporter au moins 30 caractères.",
        "bookingCreated": "Réservation créée",
        "partner": "Partenaire",
        "fleetManager": "Gestionnaire de flotte",
        "apiProvider": "Fournisseur d'API",
        "selectAPITitle": "Sélectionnez l'API que vous souhaitez intégrer",
        "isAutoAccept": "Réservation d'auto-acceptation",
        "isAutoAcceptPA": "Acceptation automatique de l'amendement en attente",
        "assignedVehicle": "Véhicule attribué"
    },
    "messages": {
        "credits": {
            "406": "L'action a échoué",
            "407": "L'action a échoué",
            "416": "Le coupon a été utilisé",
            "417": "Votre compte est inactif. Veuillez contacter notre administrateur.",
            "418": "Des erreurs sont survenues lors du paiement",
            "419": "Le code promo est invalide !",
            "420": "Ce code promo a été utilisé pour une autre course. Veuillez en utiliser un autre.",
            "421": "Le numéro de la carte n'est pas valide.",
            "422": "Date d'expiration non valide.",
            "429": "Code postal invalide.",
            "430": "L'AVS et le Code postal ne correspondent pas",
            "431": "Code postal non vérifié par AVS",
            "432": "CVV non valide.",
            "433": "CVV ne correspond pas",
            "434": "CVV non vérifié",
            "435": "L'émetteur du CVV ne participe pas",
            "436": "Cette carte a été déclinée par l'émetteur. Veuillez le contacter pour plus d'informations",
            "437": "Fonds insuffisants. S'il vous plaît vérifier votre solde!",
            "439": "CVV non traité",
            "441": "Aucune donnée CVV de l'émetteur",
            "443": "Pas de données de l'émetteur/Banknet switch",
            "445": "Système AVS dans l'impossibilité d'exécuter",
            "446": "La banque émettrice ne prend pas en charge les AVS",
            "447": "Erreur, AVS non pris en charge pour votre entreprise",
            "448": "Cette carte a été bloquée à cause de plusieurs tentatives de paiement refusées. Veuillez changer de moyen de paiement ou réessayer plus tard",
            "452": "Votre carte est refusée. Veuillez saisir une autre carte de crédit enregistrée dans la même zone que votre numéro de téléphone",
            "453": "Non supporté",
            "454": "La vérification d'adresse ne correspond pas",
            "455": "Les vérifications d'adresse et de Code Postal ne correspondent pas",
            "458": "Authentification échouée",
            "459": "La banque ne prend pas en charge",
            "461": "Cette carte n'est pas prise en charge",
            "462": "Nom du titulaire invalide",
            "463": "Code de vérification invalide",
            "464": "La banque ne prend pas en charge l'envoi et la vérification de code",
            "470": "Please enter the traveler's email address before make a booking with credit card",
            "474": "Please enter the traveler's name before make a booking with credit card",
            "475": "Le numéro de téléphone est requis",
            "476": "Le montant est invalide",
            "524": "Le compte n'a pas les fonds suffisants pour couvrir le montant de la transaction.",
            "911": "Nous ne pouvons pas authentifier votre méthode de paiement. Veuillez choisir une autre méthode de paiement et réessayer.",
            "2000": "N'honorez pas",
            "2001": "Le compte n'a pas les fonds suffisants pour couvrir le montant de la transaction.",
            "2002": "Limite dépassée",
            "2003": "Le détenteur de la carte a dépassé sa limite d'activité",
            "2004": "Carte périmée",
            "2005": "Numéro de carte de crédit non valide",
            "2006": "Date d'expiration non valide",
            "2007": "Pas de compte",
            "2008": "Problème de longueur de numéro de compte",
            "2009": "Cet emetteur n'existe pas",
            "2010": "CVV refusé",
            "2011": "Autorisation vocale requise. La banque du titulaire de la carte demande au commerçant d'appeler pour obtenir un code d'autorisation spécial afin de finaliser cette transaction.",
            "2012": "Paiement décliné - Possibilité que la carte soit perdue",
            "2013": "Paiement décliné - Possibilité que la carte soit volée",
            "2014": "Paiement décliné - Fraude suspectée.",
            "2015": "Transaction refusée",
            "2016": "Dupliquer la transaction",
            "2017": "Le détenteur a annulé la transaction",
            "2018": "Le détenteur de la carte a annulé toutes ses transactions",
            "2019": "Transaction invalide",
            "2020": "Violation",
            "2021": "Violation de sécurité",
            "2022": "Refusé - Nouveau détenteur disponible",
            "2023": "Cette fonction n'est pas prise en charge",
            "2024": "Type de carte non activé",
            "2025": "Erreur de set-up - Commercant",
            "2026": "Numéro de commercant invalide",
            "2027": "Erreur de set-up - Montant",
            "2028": "Erreur de set-up - Hierarchie",
            "2029": "Erreur de set-up - Carte",
            "2030": "Erreur de set-up - Terminal",
            "2031": "Erreur d'encryptage",
            "2032": "Supplément refusé",
            "2033": "Donnée incompatible",
            "2034": "Pas d'action effectuée",
            "2035": "Acceptation Partielle pour le montant en version Group III",
            "2036": "L'autorisation est introuvable pour l'annulation",
            "2037": "Déjà annulé",
            "2038": "Refus du processeur. La banque du client refuse d'accepter la transaction, il faut contacter leur banque pour plus de détails.",
            "2039": "Code d'autorisation invalide",
            "2040": "Store invalide",
            "2041": "Refusé - Appeler pour autorisation",
            "2042": "Numéro de client invalide",
            "2043": "Erreur - ne pas réessayer et appeler l'émetteur",
            "2044": "Refusé - Appeler l'émetteur",
            "2045": "Numéro de Commercant invzlide",
            "2046": "Refusé. La banque du client refuse d'accepter la transaction, il faut contacter leur banque pour plus de détails.",
            "2047": "Appelez l'émetteur. Récupérez la Carte.Cette erreur indique que la carte a été reportée volée ou perdue par le titulaire",
            "2048": "Montant invalide",
            "2049": "SKU invalide",
            "2050": "Plan de crédit invalide",
            "2051": "Le numéro de carte bleue ne correspond pas à la méthode de paiement",
            "2052": "Achat Niveau III invalide",
            "2053": "Carte reportée perdue ou volée",
            "2054": "Le montant ne correspond pas à l'autorisation",
            "2055": "Numéro de transaction invalide",
            "2056": "Le montant de la transaction excède la limite de division",
            "2057": "L'émetteur ou le titulaire a indiqué une restriction sur la carte",
            "2058": "Le commerçant n'a pas activé le code de sécurité Master CardMerchant not MasterCard SecureCode enabled.",
            "2060": "Vérification de l'Adresse et Code de Sécurité de la Carte échoués",
            "2061": "Données de transaction invalides",
            "2062": "Montant de Taxe invalide",
            "2064": "Code de devise invalide",
            "2078": "Donnée de sécurisation de paiement invalide",
            "2080": "Crédits utilisateur invalides",
            "3000": "Réseau indisponiblle - Réessayez",
            "4001": "Règlement refusé",
            "4006": "Le montant excède la limite autorisée",
            "81703": "Type de carte de crédit non accepté par ce compte marchand.",
            "81706": "CVV nécessaire",
            "81707": "CVV doit être 3 ou 4 chiffres.",
            "81709": "Date d'expiration nécessaire.",
            "81710": "Date d'expiration invalide.",
            "81714": "Un numéro de carte de crédit est nécessaire.",
            "81715": "Le numéro de carte de crédit est invalide.",
            "81716": "Le numéro de carte de crédit doit être de 12 à 19 chiffres.",
            "81717": "Le numéro de carte de crédit n'a pas un nombre de test accepté.",
            "81718": "Le numéro de carte de crédit ne peut pas être mis à jour vers un type de carte non pris en charge tant qu'il est associé à des inscriptions.",
            "81723": "Le nom du titulaire est trop long. Maximum 175 caractères.",
            "81809": "Le code postal ne peut contenir plus de 9 caractères",
            "81813": "Le code postal ne peut contenir que des lettres, chiffres, espaces, et tirets",
            "91722": "Le mode de paiement jeton est nécessaire.",
            "91723": "Mis à jour du jeton existant invalide",
            "91730": "Vérification non prise en charge sur ce compte marchand.",
            "91734": "Type de carte de crédit non accepté par ce compte marchand.",
            "91738": "Le mode de paiement spécifié n'est pas une carte de crédit.",
            "91745": "Paramètres non valides pour la mise à jour de carte de crédit.",
            "91826": "Code postal invalide. Il doit être composé de 5 à 9 caractères, qui peuvent être séparés par un tiret ou un espace",
            "-1": "Ce client a été désactivé"
        },
        "reBookingMsg": {
            "303": "L'heure que vous avez sélectionné doit être postérieure à l'heure actuelle!",
            "304": "Voulez-vous terminer cette réservation sans paiement?",
            "500": "Certaines informations de réservation sont invalides ou manquantes. Veuillez vérifier et réessayez!"
        },
        "promoMsg": {
            "304": "Le code promo est pas invalide",
            "306": "Code promotionnel invalide. Il semble que la promotion soit appliquée à d'autres zones.\n",
            "413": "Désolé, ce code promo n'est pas disponible en ce moment",
            "414": "Le code promo est pas invalide",
            "415": "Le code promo est pas invalide",
            "416": "Le code promo a été utilisé.",
            "419": "Désolé, ce code promo n'est pas disponible en ce moment",
            "420": "Désolé, vous avez atteint votre limite d'utilisation de promotions.",
            "421": "Désolé, ce code promo a atteint sa quantité maximale ",
            "422": "Ce code promo ne peut pas être utilisé avec votre compte ",
            "423": "Désolé, vous avez atteint votre limite de budget de promotions ",
            "424": "Code promotionnel invalide. Il semble que la promotion soit uniquement appliquée aux clients recommandés.",
            "425": "Ce code promotionnel a atteint sa limite d'utilisation quotidienne.",
            "426": "Vous avez atteint votre limite d'utilisation de promotions par jour.",
            "427": "Impossible d'appliquer le code promotionnel. Le profil de ce client est incomplet.",
            "428": "Ce client a épuisé son code promotionnel mensuel.",
            "430": "Vous avez épuisé vos codes promotionnels annuels.",
            "431": "Le code promotionnel ne peut pas être utilisé avec cette méthode de paiement.",
            "432": "Ce montant de tarif n'est pas éligible au code promotionnel.",
            "433": "Le code promotionnel n'est pas éligible à l'heure sélectionnée.",
            "434": "Désolé, vous avez atteint votre budget promotionnel limité.",
            "phoneInvalid": "Veuillez entrer le numéro de téléphone du passager avant d'appliquer le code promo"
        },
        "updateBookingMsg": {
            "303": "La mise à jour de la réservation a échoué, Veuillez vérifier et essayer à nouveau!",
            "304": "Cette réservation n'a pas été trouvée",
            "pickUpTime": "L'heure que vous avez sélectionné doit être postérieure à l'heure actuelle!",
            "pickup": "Il n'y a pas de service de réservation disponible dans cette zone",
            "destination": "Certaines informations de réservation sont invalides ou manquantes. Veuillez vérifier et réessayez!",
            "dispatchType": "Certaines informations de réservation sont invalides ou manquantes. Veuillez vérifier et réessayez!"
        },
        "sessionExpired": {
            "403": "Vous avez été deconnecté car votre compte est connecté depuis un autre appareil, ou votre session a expiré"
        },
        "not_found": {
            "404": "La page que vous avez demandée est introuvable."
        },
        "booking": {
            "303": "L'heure que vous avez sélectionné doit être postérieure à l'heure actuelle!",
            "304": "Cette réservation n'a pas été trouvée",
            "305": "Réservation annulée ou complétée par Booking.com ; veuillez rejeter la tâche pour la supprimer de la file d'attente.",
            "306": "Aucun tarif attribué au type de voiture sélectionné. Pour appliquer un tarif à un type de voiture, veuillez aller dans Paramètres > Voiture > Type de voiture.",
            "307": "Impossible de mettre à jour la réservation. Veuillez réessayer plus tard.",
            "407": "Le type de tarif ne prend pas en charge l'emplacement supplémentaire.",
            "500": "Certaines informations de réservation sont invalides ou manquantes. Veuillez vérifier et réessayez!",
            "upgroup_success": "La réservation a été dissociée avec succès.",
            "Please_Select_driver": "Veuillez sélectionner un chauffeur.",
            "assign_driver_vehicle_success": "Chauffeur/Véhicule attribué avec succès.",
            "assign_driver_success": "Le chauffeur a été attribué avec succès.",
            "detach_driver_success": "Driver has been detach successfully",
            "detach_vehicle_success": "Vehicle has been detach successfully",
            "Group_success": "La réservation a été regroupée avec succès.",
            "change_supplier_success": "La réservation a été modifiée avec succès pour un autre fournisseur.",
            "change_supplier_partial": "Succès partiel : L'affectation en lot a échoué pour les trajets suivants (ID de réservation) en raison d'actions en cours : {0}.",
            "detach_driver_partial": "Succès partiel : L'affectation en lot a échoué pour les trajets suivants (ID de réservation) en raison d'actions en cours : {0}.",
            "assign_driver_partial": "Succès partiel : L'affectation en lot a échoué pour les trajets suivants (ID de réservation) en raison d'actions en cours : {0}.",
            "update_dispatch": "Mise à jour et dispatching",
            "remove_booking_false": "Échec de la suppression de la réservation",
            "remove_booking_success": "La réservation a été supprimée avec succès",
            "GROUP_NOT_FOUND": "L'ID de groupe est introuvable",
            "NO_SHARING_BOOKINGS": "Vous ne pouvez regrouper les réservations que si la réservation du client autorise le covoiturage.",
            "DIFFERENT_CAR_TYPES": "La réservation que vous essayez de regrouper concerne un type de voiture différent.",
            "LIMIT_EXCEEDED_ON_SEATS_OR_LUGGAGE": "La réservation ne peut pas être regroupée : Limite de sièges ou de bagages dépassée.",
            "INVALID_CAR_TYPE": "Impossible d'assigner un chauffeur, vérifiez la capacité en sièges et bagages du véhicule du chauffeur.",
            "VALIDATION_ERROR": "Erreur de validation",
            "INTERNAL": "Erreur interne du serveur",
            "fare_gt_zero": "Le tarif doit être supérieur à 0!",
            "edit_total_fail": "Echec de la modification de la valeur totale!",
            "complete_fail": "La réservation ne peut pas être complétée !",
            "cancle_fail": "Echec de l'annulation",
            "incident_fail": "Echec de l'incident",
            "phone_invalid": "Numéro de téléphone non valide!",
            "add_psg_fail": "Impossible d'ajouter de nouveaux passagers",
            "REMOVE_RECIPIENT_DELIVERED": "Impossible de supprimer le destinataire, la livraison a été effectuée.",
            "REMOVE_LAST_ACTIVE_RECIPIENT": "Impossible de supprimer le dernier destinataire actif.",
            "ORDER_HAS_BEEN_FINISHED": "La commande a déjà été terminée.",
            "end_booking_leave": "Quitter cette page mettra fin à votre réservation",
            "update_booking_fail": "La mise à jour de la réservation a échoué",
            "EXTERNAL_ID_EXISTED": "L'ID externe existe déjà dans le système.",
            "area_service_unavailable": "Il n'y a pas de service de réservation disponible dans cette zone",
            "pickupSameDestination": "L'adresse de prise en charge doit être différente de la destination.",
            "time_invalid": "L'heure que vous avez sélectionné doit être postérieure à l'heure actuelle!",
            "psg_inactivate": "Votre compte a été inactif. Veuillez contacter notre administrateur",
            "data_incorect": "Une erreur s'est produite. Veuillez réessayer plus tard.",
            "preAuthorize": "Veuillez vérifier votre compte, un montant de {0} est requis pour garantir votre réservation.",
            "booking_limited": "Désolé, vous avez atteint le nombre maximal de réservations par minute/jour. Veuillez réessayer plus tard.",
            "minimumBookAhead": "L'heure de prise en charge de la réservation doit être au moins {0} heure(s) {1} minute(s) à partir de l'heure actuelle.",
            "exDoDiffDo": "La destination supplémentaire doit être différente de la destination principale.",
            "recurringTimeRange": "Date hors plage. Vous ne pouvez créer des réservations que {0} mois à l'avance. Veuillez contacter l'administrateur en cas de problème.",
            "recipientsLimit": "Le nombre maximal de destinataires est {0}.",
            "maximumBookAhead": "L'heure de prise en charge de la réservation ne peut pas être ultérieure à {0} jour(s) à partir de l'heure actuelle.",
            "Please_select_or_add_a_card": "Veuillez sélectionner ou ajouter une carte!",
            "Unable_to_process_by_fare_zero": "Nous ne pouvons pas traiter votre demande, veuillez changer le type de voiture ou le type de réservation et réessayer. Si vous avez besoin d'aide, veuillez contacter notre équipe de support.",
            "Can_not_connect_to_server": "Impossible de se connecter au serveur !",
            "Check_connection_or_contact_system_support": "Veuillez vérifier votre connexion ou contacter le support système pour obtenir de l'aide !",
            "Create_new_booking_success": "Une nouvelle réservation a été créée avec succès !",
            "Create_new_recurring_booking_success": "De nouvelles réservations ont été créées avec succès.",
            "Update_booking_success": "Cette réservation a été mise à jour avec succès !",
            "addon_exceeded": "{0} quota exceeded.",
            "addon_exceeded_with_params": "Veuillez recharger votre solde de portefeuille pour continuer à utiliser {0}.",
            "Booking_drop_of_success": "Dépose de la réservation réussie.",
            "Cancel_booking_success": "Cette réservation a été annulée avec succès !",
            "Cancel_booking_fails": "Cette réservation ne peut pas être annulée !",
            "adjust_fare_booking_success": "Le tarif a été ajusté avec succès !",
            "adjust_fare_booking_fail": "L'ajustement du tarif a échoué !",
            "Booking_detail_not_found": "Les détails de la réservation sont introuvables !",
            "Check_promo_error": "Erreur de vérification du code promo !",
            "Invalid_format": "Format invalide",
            "Flight_not_found": "Vol introuvable !",
            "Add_new_credit_error": "Erreur lors de l'ajout d'un nouveau crédit !",
            "Socket_server_disconnected": "Serveur de socket déconnecté !",
            "Please_reload_page_or_check_your_connection": "Désolé. Votre demande ne peut pas être traitée. Veuillez réessayer.",
            "request_timeout": "Désolé. Votre demande a expiré. Veuillez réessayer.",
            "Check_customer_error": "Erreur de vérification du client !",
            "Please_select_car_type": "Veuillez sélectionner un type de voiture.",
            "DropOff_country": "Le point de dépose n'est pas disponible pour ce type de voiture. Veuillez choisir un autre type de voiture ou ajuster l'itinéraire.",
            "Different_Country": "Les lieux de prise en charge et de dépose doivent être dans deux pays différents.",
            "Please_enter_destination_for_ridesharing_booking": "Veuillez entrer une destination pour la réservation de covoiturage.",
            "Extra_detination_must_be_difference_from_destination": "Extra detination must be difference from destination",
            "Pickup_address_must_be_different_from_destination": "Pick-up address must be different from destination",
            "Best_price": "Meilleur prix",
            "You_may_be_charged_extra_fee_if_your_trip_excceds": "You may be charged extra fee if your trip exceeds",
            "You_may_be_charged_extra_fee_if_your_trip_excceds_with_params": "You may be charged extra fee if your trip exceeds {0} {1}, {2} {3}",
            "Reject_booking_success": "Cette réservation a été rejetée avec succès !",
            "Reject_fail": "Une erreur s'est produite lors du rejet de cette réservation. Veuillez réessayer !",
            "Please_select_payment_method": "Veuillez sélectionner une méthode de paiement.",
            "Driver_signed_out_or_deactivated": "Ce chauffeur vient de se déconnecter ou a été désactivé.",
            "reservation_booking_overlaps": "Désolé, cette réservation chevauche une autre que le chauffeur a acceptée.",
            "driver_is_not_available": "Sorry, this driver isn’t available at the requested time.",
            "seats_luggage_limit": "This booking can’t be assigned to the driver because the seats/luggage limit has been exceeded.",
            "full_capacity": "Cette réservation ne peut pas être attribuée au chauffeur car le trajet a atteint sa capacité maximale.",
            "marked_failed_ok": "La commande a été marquée comme échouée.",
            "warning_markFail_lastRecipient": "Il s'agit du dernier destinataire de cette réservation. Si vous marquez cette commande comme échouée, vous devrez alors compléter cette réservation.",
            "BOOKINGS_LIMIT_EXCEEDED": "Vous ne pouvez attribuer qu'un maximum de 5 commandes par groupe.",
            "bookingCanceled": "Réservation annulée ou complétée par Booking.com ; veuillez rejeter la tâche pour la supprimer de la file d'attente.",
            "contact_info_required": "Veuillez sélectionner un profil utilisateur valide ou en créer un nouveau avant de continuer. Alternativement, vous pouvez créer une réservation en tant qu'invité.",
            "UNSUPPORTED_ZONE": "La zone n'est pas prise en charge.",
            "INVALID_GUEST_PHONE_NUMBER": "Le numéro de téléphone du passager est invalide",
            "NEGATIVE_FLEET_BALANCE": "Il semble que votre solde soit trop bas pour créer une nouvelle réservation. Veuillez ajouter des fonds ou régler tout paiement en attente pour continuer."
        },
        "item_no_found": "Aucun élément n'a été trouvé.",
        "commonMessages": {
            "greater_than_0": "Veuillez entrer une valeur supérieure à 0.",
            "Required_field": "Ce champ est requis",
            "bankPhone_is_required": "Le numéro de téléphone est invalide.",
            "bankPhone": "Numéro de téléphone.",
            "distance_from_equa_or_smaller": "La distance « de » doit être inférieure ou égale à la distance « à ».",
            "must_be_number": "Veuillez entrer un nombre valide",
            "equal_or_greater_than_0": "Veuillez entrer une valeur égale ou supérieure à 0.",
            "must_be_integer": "Veuillez entrer un nombre entier",
            "invalid_email_format": "Veuillez entrer un email valide",
            "greater_or_equa": "Veuillez entrer une valeur supérieure ou égale à {0}.",
            "value_must_between": "Veuillez entrer une valeur entre {0} et {1}.",
            "large_10x_markup_price": "Le tarif modifié ne doit pas dépasser 10 fois le tarif estimé.",
            "greater_than": "Veuillez entrer une valeur supérieure à {0}.",
            "less_than": "Veuillez entrer une valeur inférieure à {0}.",
            "less_or_equal": "Veuillez entrer une valeur inférieure ou égale à {0}.",
            "driver_earnings_warning": "Paiements hors ligne : Les gains du chauffeur ne doivent pas dépasser le tarif collecté.",
            "limit_amount": "Veuillez entrer une valeur inférieure ou égale au montant limite.",
            "Integer_from_range": "Veuillez entrer un nombre entier entre {0} et {1}",
            "integer_greater_than_0": "Veuillez entrer un nombre entier supérieur à 0. (Inférieur à 100 avec le pourcentage et le séparateur décimal en un seul caractère)",
            "Error_message": "Erreur !",
            "callcenter_newbooking_message": "Demande de réservation par téléphone <span class='bold'>{0}</span>",
            "callcenter_existed_booking_message": "Une réservation active <span class='bold'>#{0}</span> existe avec téléphone <span class='bold'>{1}</span>",
            "callcenter_close_newbooking_form_warning": "Veuillez fermer /terminer votre réservation en cours avant de recevoir une nouvelle demande client",
            "Emergency_SOS_Title": "SOS d'urgence",
            "Please_enter_a_future_date": "Veuillez entrer une date future.",
            "Card_holder_is_required": "Le titulaire de la carte est requis.",
            "Card_number_is_required": "Le numéro de carte est requis.",
            "Expired_date_is_required": "La date d'expiration est requise.",
            "Credit_code_is_required": "Veuillez entrer le code de crédit (dernière validation).",
            "Expired_date_is_invalid": "La date d'expiration est invalide. Veuillez entrer la date d'expiration au format mm/aa.",
            "cvv_is_required": "Le code CVV est requis.",
            "City_is_required": "La ville est requise.",
            "State_is_required": "L'état est requis.",
            "Address_is_required": "L'adresse est requise.",
            "Zipcode_is_required": "Le code postal est requis.",
            "Country_is_required": "Le pays est requis.",
            "Over_query_limit": "L'API Google ne peut pas se charger en raison d'une erreur temporaire. Veuillez réessayer plus tard.",
            "outOfInputQueueOrder": "Le numéro de commande ne peut pas être supérieur au nombre total de chauffeurs dans la file d'attente.",
            "Same_pickup_destination": "Pick-up address must be different from destination address.",
            "Max_length": "La longueur maximale est de {0} caractères.",
            "choose_at_least_one": "Veuillez choisir au moins une option.",
            "choose_at_least_one_intercity_schedule": "Veuillez ajouter un horaire ou permettre au client de demander son heure préférée.",
            "startDate_greater_than_endDate": "La date de début est postérieure à la date de fin."
        },
        "trip": {
            "cancel_trip_success": "Ce trajet a été annulé avec succès !",
            "data_incorect": "Aucun chauffeur n'a été attribué. Sélectionnez un chauffeur dans la liste déroulante. <br/> Si aucun chauffeur n'est disponible, sélectionnez Auto Dispatch pour l'assigner plus tard.",
            "INTERNAL": "Erreur interne du serveur.",
            "NOT_FOUND": "Trajet introuvable ou statut invalide.",
            "SAME_DRIVER": "L'assigné doit être différent du chauffeur actuel.",
            "OVERLAP": "Désolé, ce trajet chevauche un autre trajet accepté par ce chauffeur.",
            "CANNOT_ASSIGN": "Ce chauffeur est invalide (chauffeur introuvable, hors ligne ou non connecté)."
        },
        "car_mgmt": {
            "Search_car_color": "Rechercher la couleur de la voiture",
            "Searching": "Recherche en cours"
        },
        "driver_note": {
            "Search_driver_note": "Recherche de la note du conducteur",
            "Searching": "Recherche en cours"
        }
    },
    "errors": {
        "303": "Utilisateur non trouvé",
        "453": "Passerelle non prise en charge",
        "553": "Désolé ! Le client a une réservation en cours, veuillez réessayer plus tard.",
        "1007": "La période entre la date de début et la date de fin doit être inférieure à 60 jours !!",
        "3001": "Numéro de téléphone déjà existant",
        "3002": "Date de naissance invalide",
        "3003": "Date d'expiration du permis de conduire non valide",
        "3004": "Chauffeur non trouvé",
        "3005": "Informations sur le règlement du chauffeur manquantes (adresse de la banque, ville, état, code postal)",
        "3006": "Informations de compte bancaire manquantes (nom du compte, type de compte, numéro de routing, numéro de compte, ssn)",
        "3007": "Vous ne pouvez pas modifier ce chauffeur, qui est en course",
        "3008": "Ce Driver est en train de se connecter. Veuillez lui demander de se déconnecter afin de modifier ses informations.",
        "3009": "Ce Driver a accepté une ou plusieurs réservation(s). Veuillez affecter lales réservation(s) à d'autre(s) Driver(s) avant de désactiver le Driver.",
        "3010": "Échec de la connexion au dispatch.",
        "3011": "Ce chauffeur doit être configuré pour fonctionner avant d'être activé.",
        "3012": "Ce chauffeur doit être configuré pour fonctionner avant d'être activé.",
        "3013": "Seul un élément qui a un statut d'inactif peut être supprimé.",
        "3014": "Les champs obligatoires sont manquants. Veuillez vérifier",
        "3015": "Année de naissance non valide. Veuillez vérifier",
        "3016": "Code postal invalide. Veuillez vérifier",
        "3017": "Etat/Province invalide. Veuillez vérifier",
        "3018": "Nom de compte invalide. Veuillez vérifier",
        "3019": "Numéro de routage invalide. Veuillez vérifier",
        "3020": "La date de naissance est obligatoire. Veuillez vérifier",
        "3021": "Numéro de ssn invalide. Veuillez vérifier",
        "3022": "Le compte bancaire du chauffeur ne peut recevoir de fonds. Vérifiez s'il vous plaît.",
        "3023": "La connexion des Drivers ne peut pas être effectuée. Veuillez réessayer plus tard.",
        "3026": "Le chauffeur n'existe plus.",
        "3027": "Le compte bancaire du conducteur n'est pas configuré. Veuillez vous rendre sur le module Chauffeurs pour configurer son compte bancaire.",
        "3028": "Échec du paiement du (des) chauffeur (s) sélectionné (s). Veuillez réessayer.",
        "3029": "Echec de l'effacement des données de gain de chauffeur. Veuillez réessayer.",
        "3032": "Ce nom d'utilisateur existe déjà dans notre système.Veuillez en entrer un autre.",
        "3033": "BSB invalide. Le numéro doit comporter 6 chiffres au format xxxxxx.",
        "3036": "Captcha est requis",
        "3037": "Captcha invalide",
        "3039": "L'ID de groupe est requis.",
        "3040": "Ce numéro de téléphone est déjà utilisé par un chauffeur %{brandName} (c'est-à-dire que le numéro ne peut pas être dupliqué). Veuillez en entrer un autre.",
        "3041": "Le nom d'utilisateur existe déjà.",
        "3044": "La carte d'identité nationale est dupliquée.",
        "3045": "Le chauffeur a déjà un véhicule, veuillez rafraîchir la page.",
        "3046": "L'entreprise du véhicule et celle du chauffeur sont différentes.",
        "4001": "Votre plaque d'immatriculation existe déjà sur le système. Veuillez en saisir un autre.",
        "4002": "Date d'expiration invalide",
        "4003": "Vehicle is active (must deactive before deleting)",
        "4004": "Véhicule introuvable",
        "4005": "Vehicle is inactive (and no need to deactive any more)",
        "4006": "Vehicle is in using (cannot delete or deactive)",
        "4007": "Le numéro de plaque est requis",
        "4009": "Le véhicule est en cours d'affectation à une réservation.",
        "4010": "Le véhicule est en cours d'affectation à un chauffeur.",
        "5001": "L'entreprise existe déjà",
        "5004": "Entreprise introuvable",
        "6001": "Le modèle de véhicule existe déjà",
        "6004": "Modèle de véhicule introuvable",
        "6005": "Le modèle de véhicule est en cours d'utilisation",
        "7001": "Le nom de la marque de votre voiture existe déjà dans le système. Veuillez en entrer un autre.",
        "7004": "Marque du véhicule introuvable",
        "8001": "Le type de véhicule existe déjà",
        "8004": "Type de véhicule introuvable",
        "9001": "L'itinéraire fixe existe déjà",
        "9004": "Itinéraire fixe introuvable",
        "10001": "La zone existe déjà",
        "10004": "Zone introuvable",
        "11001": "La zone existe déjà",
        "11002": "Zone conflict",
        "11003": "La zone doit être un objet polygonal",
        "11004": "Zone introuvable",
        "11005": "Zone is in using",
        "12001": "La boîte de réception existe déjà",
        "12002": "Veuillez configurer SMS Twilio.",
        "12004": "Boîte de réception introuvable",
        "12005": "Aucun destinataire ne correspond à vos filtres. Veuillez vérifier la liste et réessayer.",
        "12006": "Aucun client n'existe dans le fichier.",
        "13001": "Ce code promotionnel existe déjà dans le système. Veuillez en entrer un autre.",
        "13002": "Date invalide",
        "13003": "Privé",
        "13004": "Code promotionnel introuvable",
        "13005": "Uniquement pour les nouveaux clients",
        "13006": "Dépassement de la limite de quantité",
        "13007": "Dépassement de la limite budgétaire",
        "13008": "Over Total Uses Limit",
        "13011": "Promoction campaign has been deactivated or deleted",
        "13012": "La plage de dates est invalide",
        "13013": "Code promotionnel invalide. Il semble que la promotion soit appliquée à d'autres zones.",
        "13014": "La zone que vous avez sélectionnée a été désactivée.",
        "14004": "Réservation introuvable",
        "15002": "Votre flotte a été désactivé. Veuillez contacter notre administrateur",
        "15004": "Flotte introuvable",
        "16001": "Le nom de votre tarif fixe existe déjà dans le système. Veuillez en entrer un autre.",
        "16004": "Tarif introuvable",
        "17001": "Le nom existe déjà",
        "17004": "Tarif du forfait introuvable",
        "18001": "Le nom existe déjà",
        "18002": "Tarif en cours d'utilisation",
        "18004": "Tarif introuvable",
        "19001": "Name is existed",
        "19002": "Tarif en cours d'utilisation",
        "19004": "Tarif introuvable",
        "20001": "Ce nom d'utilisateur existe déjà dans notre système. Veuillez en entrer un autre.",
        "20002": "Votre compte a été désactivé. Veuillez contacter notre administrateur",
        "20003": "Le nom d'utilisateur ou le mot de passe que vous avez tapé est incorrect. Veuillez réessayer",
        "20004": "Le nom d'utilisateur n'est pas enregistré dans le système.",
        "20005": "Ce lien a expiré",
        "20006": "Le mot de passe actuel ne correspond pas. Veuillez réessayer.",
        "20007": "L'utilisateur # existe déjà.",
        "20008": "Cet email existe déjà dans notre système. Veuillez en entrer un autre.",
        "20012": "L'ID de flotte existe déjà",
        "21001": "Votre nom de permission existe déjà sur le système. Veuillez en saisir un autre.",
        "21002": "Impossible de désactiver cette permission, car elle est attribué à un utilisateur ou plus.",
        "21003": "Rôle actif.",
        "21004": "Rôle introuvable.",
        "22001": "Le client existe déjà.",
        "22004": "Client introuvable.",
        "22005": "Format de fichier invalide.",
        "22006": "Le numéro de téléphone existe",
        "24001": "Le numéro de téléphone est invalide",
        "25001": "Ce nom existe déjà sur le système. Veuillez en saisir un autre.",
        "25002": "Plage de temps incorrecte",
        "25004": "Shift non trouvé",
        "26001": "Ce nom existe déjà sur le système. Veuillez en saisir un autre.",
        "26002": "Ce shift est actuellement utilisé en exécution, veuillez lui retirer son assignation avant de l'effacer",
        "26004": "Modèle de shift non trouvé",
        "27001": "La campagne existe déjà.",
        "27002": "La campagne est activée.",
        "27004": "Campagne introuvable.",
        "28001": "La ville existe déjà.",
        "28002": "City is beeing active",
        "28003": "La ville est en cours d'utilisation.",
        "28004": "Ville introuvable.",
        "29002": "Le numéro de téléphone existe déjà.",
        "30001": "Zone d'attente introuvable.",
        "30002": "Zone d'attente en cours d'utilisation.",
        "30003": "Le nom de votre zone d'attente existe déjà dans le système. Veuillez en entrer un autre.",
        "30004": "Les zones d'attente ne doivent pas se chevaucher.",
        "30005": "Les coordonnées de la zone d'attente sont invalides.",
        "30006": "Pick-up areas are invalid",
        "31001": "Votre nom de compagnie existe déjà sur le système. Veuillez en saisir un autre.",
        "31002": "Ce nom d'utilisateur existe déjà dans notre système.Veuillez en entrer un autre.",
        "31003": "Compte entreprise introuvable.",
        "31004": "Corporate's User not found.",
        "31005": "Seules les sociétés inactives peuvent être supprimées.",
        "31006": "Ce téléphone est déjà existant sur le voyageur entreprise. Veuillez en saisir un autre.",
        "31007": "Corporate's Traveler not found.",
        "31008": "Carte introuvable.",
        "31009": "Ce téléphone existe déjà sur le système. Veuillez en saisir un autre",
        "31010": "Ce compte entreprise a été désactivé. Veuillez contacter l'administrateur pour plus d'informations.",
        "31011": "Ce voyageur ne peut pas être activé car il appartient à un compte entreprise inactif.",
        "31013": "Une entreprise portant ce nom existe déjà.",
        "31014": "Veuillez attribuer un tarif à au moins un type de véhicule.",
        "31015": "Cet email/téléphone est déjà lié à un autre compte.",
        "31016": "Cet email/téléphone est lié à un autre compte entreprise. Veuillez mettre à jour le profil ou supprimer l'utilisateur du compte existant avant de l'affecter à un nouveau.",
        "31017": "Cet email/téléphone est vide. Veuillez entrer un email/téléphone valide.",
        "32001": "Le nom de votre service existe déjà dans le système. Veuillez en entrer un autre.",
        "32004": "Service introuvable.",
        "33002": "Les intervalles de temps ne doivent pas se chevaucher les uns avec les autres",
        "34001": "Le code existe déjà.",
        "34013": "La plage de dates est invalide.",
        "36001": "Le nom existe déjà.",
        "39001": "Le document est requis.",
        "43001": "Le modèle de pénalité existe déjà.",
        "43002": "Modèle de pénalité introuvable.",
        "44001": "Le modèle de tarif existe déjà.",
        "44002": "Modèle de tarif introuvable.",
        "44003": "Le modèle de tarif est actuellement attribué à une entreprise. Veuillez le désaffecter avant de le supprimer.",
        "45001": "La politique de surtaxe existe déjà.",
        "45002": "Politique de surtaxe introuvable.",
        "45003": "Élément de surtaxe introuvable.",
        "46001": "Le nom existe déjà.\n",
        "46002": "Élément introuvable.",
        "47001": "Les ventes arrêtées existaient",
        "47002": "Ventes arrêtées non trouvées",
        "48003": "La localisation personnalisée ne contient pas la même zone.",
        "49003": "Dupliquer l'entreprise dans le paiement",
        "49004": "Imei existe",
        "50001": "Add-on template existed",
        "50002": "Add-on template not found",
        "50003": "Add-on service existed",
        "50004": "Add-on service not found",
        "71001": "La surtaxe dynamique existe déjà.",
        "71002": "Cette zone chevauche une autre. Veuillez la redessiner.",
        "71003": "La surtaxe dynamique doit être un objet polygonal.",
        "71004": "Surtaxe dynamique introuvable.",
        "72001": "Le tarif dynamique existe déjà.",
        "72002": "Cette zone chevauche une autre. Veuillez la redessiner.",
        "72003": "Le tarif dynamique doit être un objet polygonal.",
        "72004": "Tarif dynamique introuvable.",
        "74001": "La zone existe déjà.",
        "74002": "Cette zone chevauche une autre. Veuillez la redessiner.",
        "74003": "La zone doit être un objet polygonal.",
        "74004": "Tarif de zone introuvable.",
        "74005": "Tarif de zone introuvable.",
        "80001": "La bannière de l'application existe déjà.",
        "80002": "Bannière de l'application introuvable.",
        "80003": "Seuls les éléments inactifs peuvent être supprimés.",
        "81001": "Le fichier téléchargé est vide.",
        "81002": "La taille du fichier téléchargé dépasse la limite.",
        "82002": "Une erreur s'est produite lors de la configuration de flightaware. Veuillez réessayer plus tard.",
        "90001": "La zone interurbaine existe déjà.",
        "90002": "Cette zone chevauche une autre. Veuillez la redessiner.",
        "90003": "La zone interurbaine doit être un objet polygonal.",
        "90004": "Zone interurbaine introuvable.",
        "90005": "La zone interurbaine est en cours d'utilisation.",
        "91001": "Le tarif interurbain existe déjà.",
        "91002": "Le tarif interurbain est en cours d'utilisation.",
        "91003": "Tarif interurbain introuvable.",
        "92001": "Le nom de l'itinéraire existe déjà.",
        "92002": "Itinéraire introuvable.",
        "92003": "Cet itinéraire existe déjà sur un autre itinéraire, veuillez vérifier et réessayer.",
        "92004": "Il y a un trajet actif sur cet itinéraire.",
        "93001": "La note du chauffeur existe déjà dans le système. Veuillez en entrer une autre.",
        "93002": "Les notes du chauffeur inactives peuvent être supprimées.",
        "93003": "La note du chauffeur est en cours d'utilisation.",
        "93004": "Note du chauffeur introuvable.",
        "94001": "Le nom de la couleur de votre voiture existe déjà dans le système. Veuillez en entrer un autre.",
        "94002": "Couleur de voiture introuvable.",
        "400000": "Numéro de téléphone non valide!",
        "400002": "Une erreur de validation s'est produite.",
        "400003": "Permission refusée.",
        "400005": "Le contenu du fichier est invalide.",
        "400008": "Veuillez entrer le nom de la zone.",
        "500000": "Erreur interne du système.",
        "500001": "Veuillez configurer SMS Twilio.",
        "500002": "Délai de requête dépassé. Veuillez réessayer plus tard.",
        "500004": "Erreur système interne",
        "600001": "Emplacement introuvable.",
        "600002": "Ces coordonnées de longitude et latitude existent déjà dans le système. Veuillez en ajouter d'autres.",
        "610001": "La catégorie existe déjà.",
        "610002": "Catégorie introuvable.",
        "610003": "La catégorie existe déjà dans l'emplacement de l'événement.",
        "700001": "Type is inuse",
        "700002": "mDispatcher not found",
        "700003": "Your mDispatcher type name has been existed on system. Please input another one.",
        "800000": "Ce magasin a été attribué à un autre compte marchand. Veuillez en sélectionner un autre.",
        "800001": "Le compte bancaire du marchand ne peut pas recevoir de fonds.",
        "800002": "Le compte bancaire du marchand ne peut pas recevoir de fonds.",
        "limitMessage": {
            "upgrade": "Upgrade",
            "cancel": "Cancel",
            "driver": {
                "title": "Driver limit reached",
                "description": "Your current subscription allows up to %{limitation} drivers. To add more drivers, please upgrade to the higher plan."
            },
            "vehicle": {
                "title": "Vehicle limit reached",
                "description": "Your current subscription allows up to %{limitation} vehicles. To add more vehicles, please upgrade to the higher plan."
            },
            "operator": {
                "title": "Operator limit reached",
                "description": "Your current subscription allows up to %{limitation} operators. To add more operators, please upgrade to the higher plan."
            }
        },
        "31016_2": "Message : Cet email/téléphone est déjà lié à un autre compte. Veuillez contacter votre gestionnaire de compte pour obtenir de l'aide.",
        "undefined": "Une erreur est survenue avec notre serveur, veuillez réessayer.",
        "completeBooking": {
            "113": "Nous ne pouvons pas authentifier votre méthode de paiement. Veuillez choisir une autre méthode et réessayer.",
            "450": "Le solde est insuffisant pour payer. Veuillez sélectionner une autre méthode.",
            "451": "Le solde est insuffisant pour payer. Veuillez sélectionner une autre méthode.",
            "521": "Le portefeuille ne dispose pas de fonds suffisants."
        },
        "upload_file_fail": "Fichier invalide, veuillez vérifier et réessayer.",
        "upload_photo_fail": "Fichier invalide, veuillez vérifier et réessayer.",
        "missing_some_field": "Champ invalide, veuillez vérifier et réessayer.",
        "validAddress": "Veuillez sélectionner une adresse valide."
    },
    "statusDisplay": {
        "supplierAccepted": "Fournisseur accepté.",
        "pendingAmmendment": "Amendement en attente",
        "supplierAllocated": "Fournisseur attribué",
        "delivery_supplierAccepted": "Fournisseur accepté.",
        "completedWithoutService": "Terminé sans chauffeur.",
        "confirmed": "Réservation confirmée",
        "pending": "En attente",
        "queue": "En cours de dispatch",
        "offered": "En cours de dispatch",
        "booked": "Driver en route",
        "engaged": "P.O.B",
        "droppedOff": "Déposé",
        "inReview": "Nécessite une révision",
        "pre": "En attente",
        "recurrent": "Récurrent",
        "vacant": "",
        "vacantTime": "",
        "arrived": "Arrivé et en attente",
        "completed": "Terminé",
        "canceled": "Annulé",
        "noShow": "Non présentation",
        "driverNoShow": "Non-présentation du conducteur",
        "action": "En attente d'exécution",
        "incident": "Incident",
        "pickupTimeExceeded": "Temps libre",
        "canceledByCC": "Annulé par CC",
        "canceledByPassenger": "Annulé par passenger",
        "canceledByDriver": "Annulé par le chauffeur",
        "canceledByPartner": "Annulé par partner",
        "canceledBymDispatcher": "Annulé par mDispatcher",
        "canceledByCorporateAdmin": "Annulé par l'Administrateur Entreprise",
        "canceledByAPI": "Annulé par API",
        "canceledByWebBooking": "Annulé par reservation web",
        "canceledByTimeout": "Annulé par timeout ",
        "accepted": "Accepté",
        "rejected": "Rejeter",
        "canceledByCorpAd": "Annulé par l'Administrateur Entreprise",
        "started": "Commencé",
        "intransit": "En transit",
        "empty": "Vide",
        "notLive": "Partiel - non actif",
        "live": "Partiel - actif",
        "full": "Complète ",
        "delivering": "En livraison",
        "delivery_booked": "Chauffeur sur le chemin de l'expéditeur",
        "delivery_arrived": "Arrivé et attends l'expéditeur",
        "shopForYou_booked": "Chauffeur en route pour récupérer l'argent",
        "shopForYou_arrived": "Arrivé et en attente de collecte de l'argent",
        "collecting": "Chauffeur en route vers le vendeur",
        "confirmed_delivery": "Confirmé",
        "food_booked": "Chauffeur en route vers le vendeur",
        "food_collecting": "Arrivé et en attente de récupérer l'article",
        "mart_collecting": "Arrivé et en attente de récupérer l'article",
        "otwMerchant": "Chauffeur en route vers le vendeur",
        "arrivedAndWaitingToCollectItem": "Arrivé et en attente de collecte de l'article",
        "canceledByAirlineAdmin": "Annulé par l'administrateur de la compagnie aérienne",
        "partialCompleted": "Partiellement terminé",
        "failed": "Échoué",
        "allocated": "Alloué"
    },
    "tripTypes": {
        "scheduled": "Trajets programmés",
        "requested": "Demandes de trajets",
        "preferred": "Préféré"
    },
    "login": {
        "Username": "Nom d'utilisateur",
        "Password": "Mot de passe",
        "Remember_me": "Se rappeler de moi",
        "Forgot_your_password": "Mot de passe oublié",
        "Login": "S'identifier"
    },
    "invoice": {
        "createBtn": "Créer une facture",
        "searchPlInvoice": "Rechercher un client, un contact, un numéro de facture",
        "searchPl": "Rechercher un client, un contact, un numéro de facture",
        "createInvoice": "Créer une facture",
        "invoicePeriod": "Période de facturation",
        "invoicePeriodNote": "Vous pouvez sélectionner des plages de dates de mois en mois.",
        "viewEdit": "Voir/Modifier",
        "billingContact": "Contact de facturation",
        "memo": "Mémo",
        "memoMessage": "Laisser un message au client",
        "dueDate": "Date d'échéance",
        "updateInvoice": "Mettre à jour la facture",
        "chargeCustomer": "Facturer le client",
        "invoiceNumber": "Numéro de facture",
        "noItem": "Nombre d'articles",
        "issuedDate": "Date d'émission",
        "refId": "Réf #",
        "pickupTime": "Pick Up Time",
        "pickup": "Lieu de prise en charge",
        "destination": "Lieu de dépose",
        "customerName": "Nom du client",
        "totalAmount": "Amount Due",
        "amountDue": "Montant dû",
        "sendInvoice": "Envoyer la facture",
        "copyInvoice": "Copier la facture",
        "downloadPDF": "Télécharger en PDF",
        "paymentLink": "Lien de paiement",
        "deleteInvoice": "Supprimer la facture",
        "onlySave": "Enregistrer la facture",
        "saveSend": "Enregistrer et envoyer la facture",
        "sendEmail": "Envoyer un email",
        "addRecipients": "Ajouter des destinataires",
        "editInvoice": "Modifier la facture",
        "check": "Chèque",
        "wire": "Virement bancaire",
        "digitalWallet": "Portefeuille numérique",
        "cash": "Chèque",
        "completedTime": "Heure de complétion",
        "Status": "Statut",
        "bookingStatus": "Statut de la réservation",
        "chargeBtn": "Facturer {0}",
        "pastDue": "En retard",
        "payCompleted": "Cette facture a été payée avec succès !",
        "Delete": "Supprimer la facture ?",
        "Delete_content": "Cette action supprimera définitivement cette facture. Si nécessaire, vous pouvez en créer une nouvelle pour ces commandes.",
        "viewInvoice": "Voir la facture",
        "pending": "En attente",
        "paid": "Payé",
        "CopyLink": "Copier le lien",
        "partial": "Partiel",
        "corporatePrepaid": "Prépayé entreprise"
    },
    "cue": {
        "bookingServiceType": "Type de service",
        "pointToPoint": "Point à point",
        "fromAirport": "Depuis l'aéroport",
        "toAirport": "Vers l'aéroport",
        "hourly": "Horaire",
        "roundTrip": "Aller-retour",
        "jobVisibility": "Visibilité du travail",
        "jobPubic": "Public",
        "jobPrivate": "Privé",
        "jobSetPubic": "Définir comme public",
        "jobSetPrivate": "Définir comme privé",
        "supplierAccepted": "Fournisseur accepté",
        "pendingAmmendment": "Amendement en attente",
        "supplierAllocated": "Fournisseur attribué",
        "creationTime": "Heure de création",
        "Pax": "# Pax",
        "Luggage": "Bagages",
        "allocated": "Alloué",
        "completedWithoutService": "Terminé sans chauffeur",
        "shuttle": "Navette",
        "farmIn": "Affectation interne",
        "chargeCode": "Code de facturation",
        "clientCaseMatter": "Description du trajet",
        "operatorNote": "Notes internes",
        "farmOut": "Affectation externe",
        "roaming": "Itinérance",
        "FlightUpdate": "Mise à jour du vol",
        "networkType": "Type de réseau",
        "InHouse": "Interne",
        "External": "Externe",
        "carHailing": "VTC",
        "uploadBookings": "Télécharger les réservations",
        "moreActions": "Plus d'actions",
        "rideSharing": "Covoiturage",
        "Rearrange": "Réarranger",
        "GroupId": "ID de groupe #",
        "Active": "Actif",
        "Finished": "Terminé",
        "Home_affiliate": "Ma flotte/Affilié",
        "Booking_type": "Type de réservation",
        "From": "De",
        "balanceWallet": "{0} : {1} restant(s)",
        "partialWallet": "Paiement partiel avec portefeuille numérique",
        "To": "À",
        "Status": "Statut",
        "Migration_Status": "Statut de migration",
        "Migrated": "Migré",
        "Select_Status": "Sectionner un statut",
        "Operator": "Opérateur",
        "Car_types": "Type de véhicule",
        "Service_class": "Classe de service",
        "Booking_from": "Réservé de",
        "All": "Tout",
        "Pending": "En attente",
        "Dispatching": "En cours de dispatch",
        "Waiting_for_process": "En attente d'exécution",
        "Confirmed_reservation": "Réservation confirmée",
        "Driver_on_the_way": "Driver en route",
        "Arrived_and_waiting": "Arrivé et en attente",
        "Passenger_on_board": "Passager à bord",
        "Dropped_off": "Déposé",
        "combobox_select": "Sélectionnez...",
        "Search_here": "Rechercher ici",
        "Bookingid": "Réservation #",
        "Pickup_Drop_Off": "Départ/ Déposé",
        "Pickup_Drop_Off_Crew": "Heure de prise en charge/dépose",
        "Pickup_Drop_Off_Local_Time": "Temps de l'opérateur",
        "Pickup_Location_Destination": "Lieu de départ/ Destination",
        "Passenger": "Passager",
        "Intercity_Route": "Itinéraire interurbain",
        "Airport_Pickup": "Accueil à l'aéroport",
        "Airport_Pickup_Crew": "Aéroport",
        "Flight_Status": "Statut",
        "Payment": "Paiement",
        "Vehicle": "Véhicule",
        "Car_type": "Type de véhicule",
        "Driver": "Chauffeurs",
        "Estimated_Fare": "Tarif estimées",
        "Notes": "Remarques",
        "Note": "Remarque",
        "Type": "Type",
        "Home": "Ma flotte",
        "Affiliate": "Affilié",
        "now": "Maintenant",
        "reservation": "Réservation",
        "recurring": "Recurring (Chauffeur)",
        "No_show": "Non présentation",
        "Canceled_by_CC": "Annulé par CC",
        "Canceled_by_passenger": "Annulé par le passager",
        "Canceled_by_partner": "Annulé par le partenaire",
        "Canceled_by_mDispatcher": "Annulé par le mDispatcher",
        "Canceled_by_Corporate_Admin": "Annulé par l'Administrateur Entreprise",
        "Canceled_by_API": "Annulé par API",
        "canceled_By_Web_Booking": "Annulé par reservation web",
        "canceled_By_Time_Out": "Annulé par timeout ",
        "Canceled": "Annulé",
        "Completed": "Terminé",
        "Incident": "Incident",
        "Payment_Method": "Mode de paiement",
        "No_Phone": "Pas de téléphone",
        "VIP": "VIP",
        "Non_VIP": "Non-VIP",
        "Passenger_type": "Passager type",
        "Error_load_booking": "Impossible de charger la réservation, veuillez réessayer ou actualiser la page !",
        "Edit_total_success": "Edit total successful!",
        "Edit_total_fail": "Le tarif total doit être égal ou supérieur à {0}",
        "Time_out": "Temps dépassé",
        "Ride_Service": "Service de transport",
        "Regulation": "Règlement",
        "Ride_Sharing": "Partage de trajet",
        "Unmatching": "Non correspondant",
        "Matching": "Correspondant",
        "all": "Tout",
        "matching": "Correspondant",
        "unmatching": "Non correspondant",
        "regulation": "Règlement",
        "Support_service": "Service d'assistance",
        "SOS": "SOS",
        "Non_SOS": "Non-SOS",
        "Corporate": "Entreprise",
        "Individual": "Individuel",
        "On_curb": "Sur le trottoir",
        "Meet_Greet": "Accueil personnalisé",
        "Close": "Fermer",
        "auto_refrest_cue": "Actualisation automatique ({0} secondes)",
        "Ride_type": "Type de véhicule",
        "Edit_total_note": "Remarque : le sous-total, les frais techniques, les frais de réservation, la taxe et le pourboire seront mis à jour lors de la modification du montant total",
        "Booking": "Réservation",
        "Edit_fare": "Modifier le tarif",
        "Adjust_price": "Ajuster le prix",
        "Total": "Total",
        "Reason": "Raison",
        "Please_enter_reason": "Veuillez entrer une raison.",
        "Save": "Sauvegarder",
        "Cancel": "Annuler",
        "dmc": "Booking board (DMC)",
        "corp": "Tableau de réservation (CTM)",
        "Zone": "Zone de filtre",
        "dropOffZone": "Zone de dépose",
        "mDispatcher": "Partenaire",
        "streetSharing": "Partage de rue",
        "Driver_No_Job_found": "En attente d'affectations...",
        "expandFilter": "Afficher les filtres",
        "collapseFilter": "Cacher les filtres",
        "clearSelectedItems": "Effacer les éléments sélectionnés",
        "Accepted": "Accepté",
        "Yes": "Oui",
        "No": "Non",
        "Order_accepted": "Commande acceptée",
        "Confirmed": "Confirmé",
        "spotTime": "Heure de repérage",
        "ETA": "ETA",
        "spareTime": "Temps supplémentaire",
        "expectedTime": "Heure de prise en charge prévue",
        "Driver_on_the_way_to_sender": "Chauffeur sur le chemin de l'expéditeur",
        "Driver_on_the_way_to_recipient": "Chauffeur en route vers le destinataire",
        "Driver_on_the_way_to_collect_cash": "Chauffeur en route pour récupérer l'argent",
        "Driver_on_the_way_to_collect_goods": "Le conducteur en route pour collecter les colis",
        "Arrived_waiting_for_sender": "Arrivé et attends l'expéditeur",
        "Arrived_waiting_for_recipient": "Arrivé et en attente du destinataire",
        "Arrived_waiting_to_collect_cash": "Arrivé et en attente de récupérer de l'argent",
        "Arrived_waiting_to_deliver_goods": "Arrivé et en attente de livraison des marchandises",
        "Delivered": "En livraison",
        "delivery": "Livraison",
        "Service": "Un service ",
        "intercity": "Interurbain",
        "Transport": "Chauffeur",
        "About_Sender": "À propos de l'expéditeur",
        "About_Merchant": "À propos du marchand",
        "About_Recipient": "À propos du destinataire",
        "photos": "Photos",
        "listOfItems": "Liste des articles",
        "cashOnPickUp": "COP",
        "Package_information": "Informations sur le colis",
        "otwMerchant": "Chauffeur en route vers le vendeur",
        "arrivedAndWaitingToCollectItem": "Arrivé et en attente de récupérer l'article",
        "Save_Filter": "Enregistrer filtre",
        "add_favorite_filter": "Ajouter un filtre",
        "favorite_filter_name": "Nom",
        "list_favorite_filter": "Gérer les filtres",
        "favorite_filter_actions": "Action",
        "clear_all_filters": "Effacer tous les filtres",
        "Delete_Filter": "Supprimer le filtre",
        "CONFIRM_DELETE_FILTER_TEMPLATE": "Êtes-vous sûr de vouloir supprimer ce filtre ?",
        "batchDelivery": "Livraison en lot",
        "editFare": {
            "creditTransactionFee": "Frais de carte de crédit",
            "preferredAdjustment": "Ajustement préféré",
            "editFareFee": "Modifier le tarif et les frais",
            "markupPrice": "Prix majoré",
            "quotedPrice": "Prix indiqué",
            "basicFare": "Tarif de base",
            "preferredEarning": "Gains préférés",
            "difference": "Différence",
            "rushHourFee": "Taxes ",
            "serviceFee": "Service supplémentaire",
            "otherFees": "Autres frais",
            "subTotal": "Sous-total",
            "airportFee": "Frais d'aéroport",
            "meetDriverFee": "Rencontrer le chauffeur",
            "deliveryFee": "Frais de livraison",
            "tollFee": "Frais de péage",
            "parkingFee": "Frais de stationnement",
            "gasFee": "Frais de carburant",
            "techFee": "Frais techniques",
            "tip": "Pourboire",
            "bookingFee": "Frais de réservation",
            "tax": "Taxe",
            "promoAmount": "Montant promo",
            "etaFare": "Total",
            "fleetService": "Service de flotte",
            "Note_serviceFee": "(pour modifier le service supplémentaire, consultez la liste externe)",
            "startingFee": "Départ",
            "moveFeeInJourney": "En déplacement",
            "waitFeeInJourney": "En attente (en trajet)",
            "total": "Total",
            "totalPayout": "Paiement",
            "updatedTotal": "Total mis à jour",
            "updatedPayout": "Paiement mis à jour",
            "profit": "Profit",
            "extraWaitFee": "Frais d'attente initial",
            "heavyTraffic": "Circulation dense",
            totalWithoutPromo: 'Total before promo',
        },
        "partialCompleted": "Partiellement terminé",
        "failed": "Échec",
        "Recurring": "Récurrence #",
        "DragAndDrop": "Glisser-déposer pour réorganiser les colonnes.",
        "bookingCom": "Booking.com",
        "syncingCompleted": "Synchronisation terminée",
        "groupManifest": "Manifeste de groupe",
        "assignSuppliers": "Attribuer des fournisseurs",
        "viewActions": "Voir les actions",
        "holidaytaxis": "HolidayTaxis",
        "karhoo": "Karhoo",
        "klook": "Klook",
        "transferZ": "TransferZ",
        "pickupTime": "Pick-up time",
        "AssignSupplier": "Attribuer un fournisseur",
        "sharedTransfer": "Transfert partagé (%{id})",
        "batchDeliveryGroup": "Livraison en lot (%{id})",
        "foundersFund": "Fonds des fondateurs",
        "zeroCommission": "Zéro commission",
        "unassignDriver": "Désaffecter le chauffeur",
        "notUnassignDriver": "Impossible de désaffecter le chauffeur, veuillez réessayer",
        "notAssignDriver": "Impossible d'affecter le chauffeur, veuillez réessayer",
        "selectDriver": "Sélectionner un chauffeur",
        "unassignVehicle": "Désaffecter le véhicule",
        "unassignAll": "Tout désaffecter",
        "notUnassignAll": "Impossible de tout désaffecter, veuillez réessayer",
        "unassignAllSuccess": "Le véhicule et le chauffeur ont été détachés avec succès.",
        "unassign_all_partial": "Succès partiel : La désaffectation en lot a échoué pour les trajets suivants (ID de réservation) en raison d'actions en cours : {0}.",
        "notUnassignVehicle": "Impossible de désaffecter le véhicule, veuillez réessayer",
        "notAssignVehicle": "Impossible d'affecter le véhicule, veuillez réessayer",
        "selectVehicle": "Sélectionner un véhicule",
        "confirmUnassign": "Êtes-vous sûr de vouloir désaffecter ?",
        "printMeetingBoard": "Imprimer le tableau de réunion",
        "needReview": "Besoin de révision"
    },
    "trip": {
        "Driver_vehicle": "Véhicule du chauffeur",
        "tripId": "Trajet #",
        "tripTypes": "Types de trajets",
        "Start_Time": "Heure de début",
        "Seats_Status": "Statut des sièges",
        "No_Of_Booking": "Nombre de réservations",
        "Vehicle": "Véhicule du chauffeur",
        "Estimated_Fare": "Tarif",
        "capacityStatus": "Statut des sièges",
        "Trip_Types": "Types de trajets",
        "scheduled": "Trajets programmés",
        "requested": "Demandes de trajets",
        "preferred": "Préféré",
        "All": "Tout",
        "Confirmed": "Confirmé",
        "Started": "Commencé",
        "In_Transit": "En transit",
        "Empty": "Vide",
        "Partial_not_live": "Partiel - non actif",
        "Partial_live": "Partiel - actif",
        "Full": "Complète ",
        "Error_load_trip": "Impossible de charger le trajet, veuillez réessayer ou actualiser la page !"
    },
    "tripDetails": {
        "Trip_ID": "Trajet interurbain",
        "DRIVER_JOB": "Infos sur le conducteur",
        "BOOKINGS": "Réservations",
        "updateTrip": "Mettre à jour le trajet",
        "cancelTrip": "Annuler le trajet",
        "note_cancel": "Veuillez attribuer toutes les réservations à un autre chauffeur avant d'annuler ce trajet.",
        "TRIP_INFORMATION": "Informations sur le trajet",
        "route": "Itinéraire",
        "startTime": "Start Time",
        "distance": "Distance",
        "duration": "Durée",
        "fare": "Tarif",
        "cartype": "Type de voiture interurbaine",
        "seatStatus": "Statut des sièges",
        "started": "Commencé",
        "intransit": "En transit",
        "empty": "Vide",
        "notLive": "Partiel - non actif",
        "live": "Partiel - actif",
        "full": "Complète ",
        "noOfBooking": "Nombre de réservations",
        "luggage": "Bagages",
        "nameDriver": "Nom",
        "vehicleType": "Véhicule",
        "assignDriver": "Attribuer un chauffeur",
        "pickUpAddress": "Pick up",
        "destinationAddress": "Dépose",
        "customerName": "Nom",
        "customerPhone": "Téléphone",
        "customerNumber": "Sièges",
        "customerLuggageNumber": "Bagages",
        "additionalService": "Services supplémentaires",
        "paymentBooking": "Paiement",
        "note": "Remarque",
        "CONFIRM_UPDATE": "Confirmer la mise à jour",
        "CONFIRM_UPDATE_MESSAGE": "Êtes-vous sûr de vouloir mettre à jour ce trajet ?",
        "Yes": "Oui",
        "No": "Non",
        "Update_info": "Oui, mettre à jour les informations"
    },
    "newbooking": {
        "Addon_driver_capability": "This assignment does not fully meet the customer’s service requirements. Missing Requirements ({0})",
        "Search_Vehicle": "Rechercher un véhicule",
        "rideSharing_multi_point": "Une seule prise en charge et un seul point de dépose sont autorisés pour une réservation de covoiturage.",
        "Pick_up_time": "Pick up time",
        "Drop_off_time": "Heure de dépose",
        "All_Suppliers": "Tous les fournisseurs",
        "Recipient": "Destinataire",
        "All": "Tout",
        "New_Booking": "Nouvelle réservation",
        "GoogleMapRoute": "Google Map",
        "BOOKING_INFORMATION": "Informations réservation",
        "TIP_PROMO": "Pourboire - Promo",
        "Pick_up": "Départ",
        "instructions": "Instructions",
        "instructions_placeholder": "Listez vos instructions ici...",
        "Enter_a_location": "Entrez un lieu",
        "Enter_a_location_delivery": "Entrer votre adresse d'expédition",
        "Enter_3rd_party_location": "Emplacement de la 3ème partie",
        "Enter_a_sender": "Saisissez l'information de l'expéditeur",
        "Enter_a_recipient": "Saisissez l'information du destinataire",
        "Vehicle_Selection": "Sélection du service",
        "Destination": "Destination",
        "Pickup_time": "Heure de départ",
        "Note": "Remarques",
        "note_for_driver": "Note au chauffeur",
        "affiliate_note": "Remarque pour l'affilié",
        "affiliate_note_placeholder": "Saisissez les remarques des affiliés pour les opérateurs",
        "operator_note": "Opérateur note",
        "TRAVELER_INFORMATION": "Information du voyageur",
        "Traveler_type": "Type de voyageur",
        "Individual": "Individuel",
        "Corporation": "Entreprise",
        "Phone_number": "Numéros de téléphone",
        "First_name": "Prénom",
        "Last_name": "Nom",
        "Email_address": "Adresse e-mail",
        "Corp_id": "Numéro d'entreprise",
        "Manager_name": "Nom du gestionnaire",
        "Manager_email": "Courriel du directeur",
        "Cost_centre": "Centre de coûts",
        "Department": "Département",
        "Corp_division": "Division d'entreprise",
        "Tip": "Pourboire",
        "Promo_code": "Code promo",
        "Apply": "Appliquer",
        "Promo": "Promo :",
        "DISPATCH": "Expédition",
        "Auto_dispatch": "Dispatch automatique",
        "Assign_driver": "Attribuer Driver",
        "FarmOut": "Sous-traitance",
        "Driver": "Chauffeurs",
        "Driver_Supplier": "Fournisseur/Chauffeur",
        "PAYMENT_METHOD": "Mode de paiement",
        "OPERATOR_NOTE": "Notes internes",
        "TRIP_ESTIMATE": "Estimation du trajet",
        "Choose_a_stored_card": "Choisissez une carte enregistrée",
        "Choose_a_payment_method": "Choisissez un moyen de paiement",
        "Use_new_card": "Utiliser une nouvelle carte",
        "Card_holder": "Nom du titulaire de la carte",
        "Card_number": "Numéro de carte",
        "Expired_date": "Date d'expiration(mm/yy)",
        "ccv": "CVV",
        "Distance": "Distance",
        "Duration": "Durée",
        "Fare": "Tarif",
        "Route": "Routes",
        "Create": "Créer",
        "Cancel": "Annuler",
        "Meet_driver": "Rencontrez Driver",
        "Airline": "Compagnie aérienne",
        "Flight": "Vol #",
        "FLY_INFO": "Informations du vol",
        "Ride_Sharing": "Partage de course",
        "Round_trip": "Aller-retour",
        "Car_type": "Type de véhicule",
        "Address": "Adresse",
        "City": "Ville",
        "State": "Etat",
        "Zip_code": "Code postal",
        "Remove": "Retirer",
        "Client_case_matter": "Description du voyage",
        "Charge_code": "Code de voyage",
        "CANCEL_BOOKING": "Feremer la confirmation de réservation",
        "CANCEL_BOOKING_CONFIRM": "Voulez vous quitter? Les données de réservation seront effacées",
        "Search_here": "Rechercher ici",
        "No_support_location": "Désolé,Il n'y a pas de service de réservation dans cette zone",
        "Closest_driver_message": "Votre chauffeur le plus proche est à {0} minutes",
        "No_cars_available": "Aucun véhicule disponible dans le rayon de dispatch.",
        "processed_by_affiliate": "Vos requêtes seront traitées par nos partenaires affiliés",
        "FlightExample": "Vol#, p. ex. AA1097",
        "Yes": "Oui",
        "No": "Non",
        "dispatch_3rd": "Dispatcher via une 3ème partie",
        "Company": "Entreprise",
        "Card_required": "Veuillez sélectionner ou ajouter une carte!",
        "Tip_value": "N/A",
        "Calendar": "Calendrier",
        "Extra_Destination": "Additional Destination",
        "Driver_credit_limited_balance_warning": "Le solde de ce chauffeur est inférieur ou égal au montant limite",
        "Meet_Greet_option": "Accueil personnalisé",
        "On_Curb_option": "Sur le trottoir",
        "Extra_Services": "Services supplémentaires",
        "Addl_Services": "Add'l Services",
        "Save": "Sauvegarder",
        "Regular": "Régulier",
        "Please_fill_in_all_the_required_fields": "Veuillez remplir tous les champs requis.",
        "Route_names_not_dup": "Les noms de route ne doivent pas être dupliqués.",
        "Please_select_weekdays": "Veuillez sélectionner les jours de répétition pour cette réservation",
        "Flat_rate": "Tarif fixe",
        "All_company": "Toute entreprise",
        "Best_price": "Meilleur prix",
        "PromoTitle": "Promo",
        "Show_more": "Voir plus",
        "Warning_pending_payment": "Ce client a un paiement incomplet pour des réservations précédentes : %{fare}",
        "Warning_outstanding_balance": "Le solde restant sera appliqué à la fin du trajet.",
        "Not_available": "Non disponible",
        "Warning_assigned_rate": "Veuillez configurer et attribuer un tarif au type de voiture sélectionné pour continuer.",
        "PaxLuggageNumber": "Nombre de passagers/bagages",
        "paxNumber": "Passager",
        "luggageNumber": "Bagages",
        "Date": "Date",
        "Single": "Unique",
        "Recurring": "Récurrent",
        "Date_range": "Date Range",
        "WeekDays": "Répéter les jours",
        "Create_Route": "Créer un itinéraire",
        "Pickup_Point": "Prise en charge",
        "Drag_To_Render": "Glisser-déposer pour réorganiser",
        "DropOff_Point": "Points de dépose",
        "Sender": "Expéditeur",
        "Recipients": "Destinataires",
        "Sender_Infomation": "Information de l'expéditeur",
        "Recipient_Infomation": "Information du destinataire",
        "Recipient_Name": "Nom du destinataire*",
        "Recipient_Phone": "Numéro de téléphone*",
        "Room_floor_block": "Code, étage escalier (facultatif)",
        "Details": "Détails",
        "Package_Content": "Contenu du colis*",
        "Order_ID": "Numéro de commande # (ex. numéro de commande Shopify #)",
        "Instructions_for_driver": "Des instructions pour le livreur",
        "Cost_of_Goods": "Montant à collecter chez le client",
        "Enter_amount": "Entrer le montant",
        "Additional_Information": "Informations supplémentaires",
        "Insurance": "Assurance",
        "Special_Care": "Soins spéciaux",
        "Delivery_Fee": "Frais de livraison",
        "Item_fees": "Frais d'article",
        "Tech_Fee": "Frais techniques",
        "Tax": "Taxe",
        "driverNotes": "Note au chauffeur",
        "rejectModal": "Rejeter la réservation",
        "rejectModalBody": "Êtes-vous sûr de vouloir rejeter cette réservation ?",
        "rejectButton": "Rejeter la réservation",
        "acceptModal": "Accepter la réservation",
        "acceptModalBody": "Êtes-vous sûr de vouloir accepter cette réservation ?",
        "ConfirmedTo": "Confirmé à ({0})",
        "proceedAction": "Êtes-vous sûr de vouloir procéder à cette action ?",
        "acceptButton": "Accepter la réservation",
        "denyModal": "Refuser la réservation",
        "denyModalBody": "Êtes-vous sûr de vouloir refuser cette réservation ?",
        "denyButton": "Refuser la réservation",
        "Accept_booking_success": "Cette réservation a été acceptée avec succès !",
        "Deny_booking_success": "Cette réservation a été refusée avec succès !",
        "adjustFare": "Ajuster le tarif",
        "totalFare": "Tarif total",
        "Profit": "Profit",
        "DriverEarning": "Gains du chauffeur",
        "Payout": "Paiement",
        "totalPayout": "Paiement total",
        "DriverPayOut": "Driver Payout",
        "confirmReject": "Confirmer le rejet",
        "confirmCancelMSG": "Êtes-vous sûr de vouloir rejeter cette réservation ? Vous pourriez encourir une pénalité de votre fournisseur.",
        "reasonCancel3rd": "Motif du rejet",
        "welcome_psg": "Bienvenue au passager",
        "AmountDue": "Montant dû",
        "Fleet_Company": "Flotte",
        "Search_driver_hydra": "Nous allons essayer de vous trouver un chauffeur bientôt.",
        "ExternalID": "ID externe",
        "viewRate": "Voir le tarif",
        "PointToPoint": "Point à point",
        "Offer_driver": "Proposer un chauffeur",
        "Assign_driver_vehicle": "Attribuer un chauffeur / véhicule",
        "notify_via_email": "Notifier le client par email",
        "fleetFare": "Tarif de flotte",
        "onlySave": "Enregistrer",
        "saveCharge": "Enregistrer et Charger",
        "saveRefund": "Enregistrer et Rembourser",
        "lateCancelConfirm": "Êtes-vous sûr de vouloir finaliser cette réservation en tant que",
        "canceledDriverConfirm": "Êtes-vous sûr de vouloir annuler cette réservation pour le conducteur ? Des frais de pénalité seront appliqués.",
        "canceledDriverNoChargeConfirm": "Êtes-vous sûr de vouloir annuler cette réservation pour le conducteur ?",
        "canceledCustomerNoChargeConfirm": "Êtes-vous sûr de vouloir marquer ce client comme un",
        "noshowDriverConfirmCharge": "Êtes-vous sûr de vouloir marquer le conducteur comme un no-show ? Des frais de pénalité peuvent être appliqués.",
        "noshowDriverConfirmNoCharge": "Are you should you want to mark this customer as a no show?",
        "NoShowConfirm": "La politique de non-présentation sera appliquée.",
        "completeConfirm": "Êtes-vous sûr de vouloir terminer sans pilote ?",
        "completeChargeConfirm": "Le montant total sera facturé au client. Le conducteur ne recevra aucune commission pour cette réservation.",
        "PricingPlan": "Plan de tarification",
        "editFerviceFees": "pour modifier les frais de service, visitez la liste externe",
        "ungroupAll": "Dégrouper tout",
        "satisfaction": "satisfaction",
        "Reassign": "Réaffecter",
        "addNote": "Ajouter une note",
        "noteMagicSend": "Subject",
        "items": "Articles",
        "PaidAmount": "Montant payé",
        "ExternalPartner": "Partenaire externe",
        "ExternalPartnerNote": "Partenaires indépendants qui gèrent leurs propres conducteurs et véhicules. Les paiements sont effectués directement avec le fournisseur.",
        "InHousePartner": "Partenaire interne",
        "InHousePartnerNote": "Géré directement par votre flotte. Les paiements sont effectués directement aux conducteurs.",
        "Role": "Rôle",
        "Client": "Client",
        "ApplyCancellation": "Appliquer la politique d'annulation",
        "unassigned": "non attribué",
        "bookingSelected": "réservation sélectionnée",
        "Update": "Mise à jour",
        "emailInvoice": "Facture par e-mail",
        "Receipt": "Reçu",
        "addItem": "Ajouter un élément",
        "newCustomer": "Ajouter un nouveau client",
        "forGuest": "Réserver pour un invité",
        "invalid_some_field": "Champ invalide, veuillez vérifier et réessayer.",
        "ExpandCorp": "Développer les détails de l'entreprise",
        "hideCorp": "Cacher les détails de l'entreprise",
        "searchCusPlaceholder": "Rechercher par nom de contact, téléphone, email",
        "CorporationGuest": "Corporation - Invité",
        "IndividualGuest": "Individu - Invité",
        "passInfo": "Informations sur les passagers",
        "noAdjustmentPickupTime": "Aucun ajustement à l'heure de ramassage",
        "whenFlightArrives": "Quand le vol arrive",
        "minAfterArrival": "{0} min après l'arrivée du vol",
        "pickupInstructions": "Instructions de ramassage",
        "selectMeetingPoint": "Choisissez le point de rencontre pour le ramassage",
        "durationTrip": "Durée (Heures)"
    },
    "bookingDetailLogs": {
        "recipient": "Destinataire",
        "updatedInfo": "Informations mises à jour",
        "updatedField": "Champ mis à jour",
        "valueBefore": "Valeur avant",
        "valueAfter": "Valeur après",
        "location": "Emplacement",
        "etaFare": "Tarif",
        "dispatchType": "Dispatching",
        "drvInfo": "Chauffeur",
        "meetingPoint": "Point de rencontre",
        "vehicleTypeRequest": "Demande de véhicule",
        "clientCaseMatter": "Description du trajet",
        "chargeCode": "Code du trajet",
        "driverEarningType": "Type de gains du chauffeur",
        "editedDriverEarning": "Gains du chauffeur",
        "reasonEditFare": "Motif",
        "bookingReference": "ID externe",
        "tip": "Pourboire",
        "type": "Type de service",
        "promo": "Promo",
        "dispatch3rd": "Dispatch tiers",
        "rideSharing": "Covoiturage",
        "notes": "Notes du chauffeur",
        "operatorNote": "Notes internes",
        "welcomeMessage": "Message de bienvenue",
        "flightNumber": "Numéro de vol",
        "fullName": "Nom complet",
        "email": "Email",
        "cardMask": "Masque de carte",
        "paymentType": "Méthode de paiement",
        "recipients": "Destinataires",
        "sender": "Expéditeur",
        "pickupName": "Nom du point de prise en charge",
        "pickupPhone": "Téléphone du point de prise en charge",
        "pickupEmail": "Email du point de prise en charge",
        "supplierEarningType": "Type de paiement",
        "editedSupplierEarning": "Valeur du paiement",
        "route": "Nom de l'itinéraire",
        "markupDifference": "Différence de majoration",
        "selectedDates": "Dates sélectionnées",
        "services": "Services de flotte",
        "destinationAddress": "Emplacement de destination",
        "pickupAddress": "Emplacement de prise en charge",
        "tripType": "Type de trajet",
        "pickUpTime": "Heure de prise en charge",
        "paxNumber": "Passager",
        "luggageNumber": "Bagages",
        "vehicle": "Véhicule",
        "minutesToArrive": "Arrivée prévue du chauffeur",
        "affiliateNote": "Note d'affilié",
        "packageRateName": "Nom du forfait",
        "supplierCompanies": "Entreprise",
        "puPoints": "Emplacement de prise en charge",
        "doPoints": "Emplacement de destination",
        "promoValue": "Valeur promo",
        "packageInfo": "Informations sur le forfait",
        "orderId": "ID de commande",
        "cashOnDelivery": "Paiement à la livraison",
        "externalId": "ID externe",
        "recurring": "Récurrent",
        "batchDelivery": "Livraison en lot",
        "payout": "Paiement",
        "locationDetails": "Détails de l'emplacement",
        "name": "Nom",
        "phone": "Téléphone",
        "address": "Adresse",
        "basicFare": "Tarif de base",
        "airportFee": "Frais d'aéroport",
        "bookingFee": "Frais de réservation",
        "creditTransactionFee": "Frais de carte de crédit",
        "fleetService": "Service de flotte",
        "fleetServices": "Service de flotte",
        "gasFee": "Frais de carburant",
        "meetDriverFee": "Frais de rencontre avec le chauffeur",
        "moveFeeInJourney": "Frais de déplacement",
        "otherFees": "Autres frais",
        "parkingFee": "Frais de stationnement",
        "promoAmount": "Montant promo",
        "rushHourFee": "Frais d'heure de pointe",
        "serviceFee": "Frais de service",
        "startingFee": "Frais de départ",
        "subTotal": "Sous-total",
        "tax": "Taxe",
        "techFee": "Frais technologiques",
        "tollFee": "Frais de péage",
        "waitFeeInJourney": "Frais d'attente (en trajet)",
        "psgPhone": " téléphone du passager",
        "totalAddonFee": "Addon fee",
        "addonServices": "Addon services"
    },
    "bookingdetail": {
        "RefreshFare": "Actualiser le tarif",
        "noShowAction": "Action de non-présentation",
        "noShowClose": "Appliquer No-show & Clore la Réservation",
        "noShowNotClose": "Appliquer Non-présentation & Désassigner",
        "cancelAction": "Annuler l'action",
        "cancelClose": "Appliquer Annuler & Fermer la Réservation",
        "cancelNotClose": "Appliquer Annuler & Désassigner",
        "settings": "Paramètres",
        "updateSuccessJobVisibilitySingle": "Visibilité mise à jour avec succès",
        "updateSuccessJobVisibilityMulti": "%{number} réservations ont été mises à jour avec succès",
        "failApi": "Une erreur s'est produite !",
        "settingsTooltip": "Chauffeur déjà attribué ou trajet actuellement en cours.",
        "shareJobPublicly": "Partager la tâche publiquement",
        "groupOder": "Commande groupée",
        "ExistingGroup": "Groupe existant",
        "NewGroup": "Nouveau groupe",
        "Search_trip": "Rechercher trajet #",
        "All": "Tout",
        "creditTransactionFee": "Frais de carte de crédit",
        "partial_payment": "Paiement partiel",
        "Write_off_debt": "Annuler la dette",
        "Booking_detail": "Détails réservations",
        "Order_detail": "Commande",
        "Completed_Booking": "Réservation terminée",
        "Late_Cancel_Passenger": "Annulation tardive par le passager",
        "Late_Cancel_Driver": "Annulation tardive par le conducteur",
        "No_Show_Passenger": "Non-présentation du passager",
        "No_Show_Driver": "Conducteur non présent",
        "Late_Cancel": "Annulation tardive",
        "Cancel_Driver": "Annulé par le chauffeur",
        "No_Show": "Non-présentation",
        "Without_driver": "Terminé sans chauffeur",
        "Complete_driver": "Terminé avec chauffeur",
        "BOOKING_INFORMATION": "Informations réservation",
        "TIP_PROMO": "Pourboire - Promo",
        "Rearrange_Column": "Réorganiser la colonne",
        "Pick_up": "Départ*",
        "Enter_a_location": "Entrez un lieu",
        "Destination": "Destination",
        "Pickup_time": "Heure de départ",
        "Notes": "Remarques",
        "TRAVELER_INFORMATION": "Information du voyageur",
        "Traveler_type": "Type de voyageur",
        "Individual": "Individuel",
        "Corporation": "Entreprise",
        "Phone_number": "Numéros de téléphone",
        "First_name": "Prénom",
        "Last_name": "Nom",
        "Email_address": "Adresse e-mail",
        "Corp_id": "Numéro d'entreprise",
        "Manager_name": "Nom du gestionnaire",
        "Manager_email": "Courriel du directeur",
        "Cost_centre": "Centre de coûts",
        "Department": "Département",
        "Corp_division": "Division d'entreprise",
        "Tip": "Pourboire",
        "Promo_code": "Code promo",
        "Apply": "Appliquer",
        "Promo": "Promo",
        "DISPATCH": "Dispatching",
        "Auto_dispatch": "Dispatch automatique",
        "Assign_driver": "Attribuer Driver",
        "Driver": "Chauffeurs",
        "PAYMENT_METHOD": "Mode de paiement",
        "Payment_methods": "Méthodes de Paiement",
        "pending_payment": "Paiement en attente",
        "TRIP_ESTIMATE": "Mode de paiement",
        "Choose_a_stored_card": "Choisissez une carte enregistrée",
        "Choose_a_payment_method": "Choisissez un moyen de paiement",
        "OPERATOR_NOTE": "Notes internes",
        "Use_new_card": "Utiliser une nouvelle carte",
        "Card_holder": "Nom du titulaire de la carte",
        "Card_number": "Numéro de carte",
        "Expired_date": "Date d'expiration(mm/yy)",
        "ccv": "CVV",
        "Distance": "Distance",
        "Duration": "Durée",
        "Fare": "Tarif",
        "Route": "Routes",
        "Meet_driver": "Rencontrez Driver",
        "Airline": "Compagnie aérienne",
        "Flight": "Vol #",
        "FLY_INFO": "Informations du vol",
        "Ride_Sharing": "Partage de course",
        "Round_trip": "Aller-retour",
        "Car_type": "Type de véhicule",
        "Address": "Adresse",
        "City": "Ville",
        "State": "Etat",
        "Zip_code": "Code postal",
        "Remove": "Enlever",
        "New_Booking": "Nouvelle réservation",
        "Clone_Booking": "Cloner la réservation",
        "New_Order": "Nouvelle commande",
        "ViewTrackLink": "Voir le suivi de la course",
        "driverLink": "Lien du chauffeur",
        "ClickCopy": "Cliquez pour copier le lien",
        "meetingBoard": "Réunion \n Conseil",
        "ViewLog": "Afficher les historiques des envois",
        "Message": "Message",
        "Update_Booking": "Mise à jour Réservation",
        "Cancel_Booking": "Annuler Réservation",
        "Complete_with_payment": "Finaliser la commande",
        "Incident": "Incident",
        "CONFIRM_CANCEL": "Confirmer l'annulation",
        "CONFIRM_CANCEL_MESSAGE": "Veuillez cliquer sur 'D'accord' pour annuler cette réservation.Si vous ne voulez pas, cliquez sur 'Annuler' pour fermer cette boîte de dialogue",
        "CONFIRM_UPDATE": "Confirmer la mise à jour",
        "CONFIRM_UPDATE_MESSAGE": "Voulez-vous vraiment mettre à jour cette réservation?",
        "CONFIRM_RESET_EDIT_FARE_MESSAGE": "Votre tarif modifié a été réinitialisé, veuillez vérifier avant de continuer.",
        "Close": "Fermer",
        "Update_info": "Mettre à jour les infos",
        "Update_info_dispatch": "Mettre à jour les infos et le dispatch",
        "Update_info_tooltip": "Si vous allez réaffecter cette réservation à un nouveau chauffeur, veuillez choisir \"Oui, mettre à jour les informations et envoyer",
        "BOOKING": "Réservation",
        "DROPPED_OFF": "Déposé",
        "Payment_Type": "Type de paiement",
        "Total": "Total",
        "Next": "Suivant",
        "Pay_here": "Payez ici",
        "Complete_booking": "Finaliser la commande",
        "Complete_booking_tooltip": "Veuillez cliquer sur \"Mettre à jour la réservation\" pour enregistrer vos modifications avant de continuer.",
        "Cancel": "Annuler",
        "Back": "Retour",
        "Tax": "Taxe",
        "Booking_fees": "Frais de réservation",
        "Tech_fees": "Frais de Technique",
        "Subtotal": "Sous-total",
        "Other_fees": "Autres frais",
        "Waiting_fee": "Frais d'attente",
        "Toll_fees": "Frais de péage",
        "Heavy_traffic": "Circulation dense",
        "Rush_hour": "Heure de pointe",
        "Basic_fare": "Tarif de base",
        "Ok": "D'accord",
        "Input_reason": "Saisir une raison",
        "Client_case_matter": "Dossier client / Description du trajet",
        "Charge_code": "Code de facturation / Code du trajet",
        "Enter_3rd_party_location": "Saisir l'emplacement du tiers",
        "Company": "Entreprise",
        "Check_promo_error": "Erreur de vérification du code promo !",
        "Add_new_credit_error": "Erreur lors de l'ajout d'un nouveau crédit !",
        "Can_not_get_fare_setting": "Impossible d'obtenir les paramètres de tarif !",
        "Can_not_get_affilate_fare_setting": "Impossible d'obtenir les paramètres de tarif des affiliés !",
        "Can_not_check_commisson": "Impossible de vérifier la commission !",
        "No_flight_info": "Aucune information sur le vol !",
        "Socket_server_disconnected": "Serveur de socket déconnecté !",
        "Please_reload_page_or_check_your_connection": "Désolé. Votre demande ne peut pas être traitée. Veuillez réessayer.",
        "View_Logs": "Voir les actions",
        "Bookingid": "Réservation #",
        "Calendar": "Calendrier",
        "Extra_Destination": "Additional Destination",
        "Meet_Greet_option": "Accueil personnalisé",
        "On_Curb_option": "Sur le trottoir",
        "Credit_Card": "Carte de crédit",
        "Charge": "Facturer",
        "No_charge": "Pas de frais",
        "QR_Code_method_not_allow_error_message": "Veuillez sélectionner un autre type de paiement, car le QR Code n'est pas disponible pour payer sur le tableau de bord !",
        "change_payment_method_note": "Si vous souhaitez modifier la méthode de paiement, veuillez revenir au formulaire de réservation.",
        "Airport_Fee": "Frais d'aéroport",
        "Addi_service": "Services supplémentaires",
        "Additional_Services": "Services supplémentaires",
        "Minimum": "Minimum",
        "Search_here": "Rechercher ici",
        "No_Driver_Yet": "Aucun chauffeur attribué pour le moment",
        "Personal_Card": "Carte Personnelle",
        "Reject_booking": "Rejeter la réservation",
        "Confirm_reject": "Confirmer le rejet",
        "Confirm_reject_message": "Êtes-vous sûr de vouloir rejeter cette réservation ?",
        "Confirm_reject_booking_with_charge": "Vous serez facturé {0}% du tarif indiqué selon notre politique d'annulation. Êtes-vous sûr de vouloir rejeter cette réservation ?",
        "Yes": "Oui",
        "No": "Non",
        "shortTrip": "Trajet court",
        "Add_new_card": "Ajouter une nouvelle carte",
        "Require_customer_info": "Veuillez saisir les informations client pour continuer.",
        "Require_corp_info": "Veuillez entrer les informations de l'entreprise pour continuer.",
        "Require_corp_customer_info": "Besoin d'informations utilisateur pour créer une nouvelle carte.",
        "confirm_force_overlap": "Confirmation",
        "confirm_force_overlap_message": "Cette réservation chevauche les réservations acceptées par le chauffeur. Êtes-vous sûr de vouloir l'attribuer à ce chauffeur ?",
        "select": "Sélectionner",
        "PICKUP_TIME_RANGE": "Prise en charge estimée à {0}",
        "food": "Aliments ",
        "mart": "Marché ",
        "Order_summary": "Résumé de la commande",
        "addOnPrice": "Prix ajusté",
        "applicableFee": "Total (applicable)",
        "itemValue": "Valeur de l'article",
        "promotion_note_paymentMethod": "Cette commande applique un code promo avec une méthode de paiement limitée : %{method}.",
        "promotion_note_minimum_fare": "Cette commande applique un code promo avec un tarif minimum limité : %{fare}.",
        "promotion_note_schedules": "Cette commande applique un code promo avec une heure de prise en charge limitée.",
        "edited_fare_note": "Ceci est un journal d'ajustement des tarifs à titre de référence uniquement. Veuillez consulter les rapports pour vérifier le tarif et les frais finaux.",
        "view_good_receipt": "Voir la quittance des articles",
        "confirmRemoveGroupTransport": "Êtes-vous sûr de vouloir supprimer cette réservation du manifeste ?",
        "confirmRemoveGroupDelivery": "Êtes-vous sûr de vouloir supprimer cette réservation du groupe ?",
        "confirmUngroupTransport": "Êtes-vous sûr de vouloir dissocier toutes les réservations de ce manifeste ?",
        "confirmUngroupDelivery": "Êtes-vous sûr de vouloir dissocier toutes les réservations de ce groupe ?",
        "view_delivery_receipt": "Voir la photo de la livraison",
        "select_time": "Sélectionner l'heure",
        "InputReason": "Saisir la raison",
        "viewOrder": "Voir la commande",
        "markFailed": "Marquer comme échoué",
        "corporateName": "Nom de l'entreprise",
        "sendMessage": "Envoyer un message",
        "AmountDueBefore": "Montant dû avant",
        "AmountDueAfter": "Montant dû après",
        "chargeCustomer": "Facturer le client",
        "pending": "Non payé",
        "refundPayment": "Rembourser le paiement",
        "refundableAmount": "Montant remboursable",
        "refundReason": "Ajouter une raison de remboursement",
        "refundBtn": "Rembourser {0}",
        "partial": "Partiel",
        "paid": "Payé",
        "ViewPaymentLogs": "View payment logs",
        "pmActivity": "Activité des paiements",
        "paidStatus": "Statut payé",
        "paymentLog": "Journal des paiements",
        "extraWaitFee": "Frais d'attente initial",
        "extraWaitTime": "Temps d'attente (initial)",
        "copied": "Copié",
        "warnningCancelCorporate": "Veuillez noter que vous pourriez être facturé d'un montant conformément à notre politique d'annulation.",
        "customerAdjustments": "Ajustements client",
        "customerAdjustmentsTooltip": "Ajustements client",
        "supplierDriverAdjustments": "Ajustements fournisseur/chauffeur",
        "updateSummary": "Mettre à jour le résumé",
        "orderDetails": "Détails de la commande",
        "saveAndSendEmail": "Enregistrer et envoyer le reçu électronique",
        "pastDetacted": "Réservation passée détectée",
        "pastDetactedContent": "Vous êtes sur le point de créer une réservation dans le passé",
        "DriverSupplier": "Conducteur/Fournisseur",
        "supplierCancelCharge": "Avertissement : Pénalité d'annulation",
        "supplierCancelNoCharge": "Confirmer l'annulation",
        "supplierCancelChargeBody": "Êtes-vous sûr de vouloir annuler la réservation ?",
        "willChargedPenalty": "Vous serez facturé d'une pénalité de {0}.",
        "noChargedPenalty": "Ceci est une annulation gratuite, aucune pénalité ne sera facturée.",
        "errorGetToken": "Impossible d'obtenir le jeton, veuillez réessayer plus tard",
        "unlinkFlight": "Dissocier le vol",
        "unlinkFlightBody": "Attention ! Changer l'heure de prise en charge déconnectera les détails de votre vol et supprimera le numéro de vol."
    },
    "map": {
        "AWS_map_hint": "Indice : Appuyez sur Entrée ou Échap pour terminer le dessin.",
        "Apple_map_hint": "Indice : Appuyez et maintenez pour faire glisser et redimensionner le polygone.",
        "Enter_a_location": "Entrez un lieu",
        "All_company": "Toute les flottes",
        "All_cars": "Tout les services",
        "Show_all_cars": "Montrer tout les services",
        "Hide_all_cars": "Cacher tout les services",
        "Vacant": "Disponible ",
        "Dispatching": "En cours de dispatch",
        "Driver_on_the_way": "Driver en route",
        "Arrived_and_waiting": "Arrivé et en attente",
        "P_O_B": "P.A.B",
        "Dropped_off": "Déposé",
        "Waiting_for_process": "En attente d'exécution",
        "Unavailable": "Indisponible",
        "Total_Drivers": "Total Chauffeurs",
        "Estimate": "Estimées",
        "Destination": "Destination",
        "Pickup": "Prise en charge",
        "Start_point": "Point de départ",
        "Passenger": "Passager",
        "Driver_name": "Nom du Driver",
        "Search_car_here": "Rechercher véhicule ici",
        "Error_load_booking": "Impossible de charger la réservation, veuillez réessayer ou actualiser la page !",
        "Show_all": "Tout montrer",
        "BookCardInfo": "Informations sur la carte de réservation",
        "drvPhoneNo": "Numéro de téléphone du conducteur",
        "vhcPhoneNo": "Numéro de téléphone du véhicule",
        "driversLiveMap": "Carte des chauffeurs",
        "heatMap": "Carte de la demande",
        "Trip": "Trajet",
        "traffic": "Trafic",
        "bicyclingLayers": "Vélo",
        "layer": "Couche",
        "trafficBicycling": "Trafic, Vélo",
        "All_airline": "Toutes les compagnies aériennes"
    },
    "customer": {
        "Customers": "Clients",
        "Points": "Points",
        "Migration_Status": "Statut de migration",
        "ADD_CUSTOMER": "Ajouter client",
        "EDIT_CUSTOMER": "Modifier client",
        "Add": "Ajouter",
        "Activate": "Activer",
        "Deactivate": "Désactiver",
        "Delete": "Effacer",
        "Import": "Importer",
        "Download_template": "Téléchargez le modèle",
        "View_Message": "Message",
        "Send_Message": "Message",
        "Export_to_excel": "Exporter vers Excel",
        "Filter": "Filtrer",
        "Apply": "Appliquer",
        "Clear": "Clair",
        "Name": "Nom",
        "Phone_Number": "Numéro De Téléphone",
        "Email": "Email",
        "Vip": "Vip",
        "companies": "Entreprise",
        "File": "Fichier",
        "Number_successful_imports": "Nombre d'importations réussies:",
        "Number_skipped": "Nombre de sautés :",
        "Number_duplicate_phone_numbers": "Nombre de numéros de téléphone identiques:",
        "Number_wrong_phone_numbers": "Nombre de numéros de téléphone erronés:",
        "Corporate_Name": "Entreprise",
        "Registered_From": "Enregistré À Partir De",
        "Registration_Date": "Date D'enregistrement",
        "Registration_date_from": "Date d'inscription de",
        "Registration_date_to": "Date d'inscription à",
        "IOS_Last_Login_Version": "Version IOS Lors De La Dernière Connexion",
        "Android_Last_Login_Version": "Version Android Lors De La Dernière Connexion",
        "Last_Active_Date": "Dernière date d'activation",
        "Verification": "Vérification",
        "Support_ID": "ID de support",
        "Days_Since_Last_Active": "Jours depuis la dernière activité",
        "Completed_Bookings": "Réservation terminées",
        "Outstanding_amount": "Montant impayé",
        "Status": "Statut",
        "Actions": "Actions",
        "Action": "action",
        "Inactive": "Inactif",
        "Active": "Actif",
        "Edit": "Modifier",
        "View": "Voir",
        "ALERT_SELECT_ACTIVATE": "Veuillez sélectionner un client à activer",
        "ALERT_SELECT_DEACTIVATE": "Veuillez sélectionner un client à désactiver",
        "ALERT_SELECT_DELETE": "Veuillez sélectionner un client à supprimer",
        "CONFIRM_DELETE": "Êtes-vous sûr de vouloir supprimer ce compte? Le client peut créer un nouveau profil avec des données vides après la suppression du compte.",
        "CONFIRM_DELETE_MULTI": "Voulez-vous supprimer ces clients?",
        "CONFIRM_DEACTIVATE_MULTI": "Voulez-vous désactiver ces clients?",
        "CONFIRM_ACTIVATE_MULTI": "Voulez-vous activer ces clients?",
        "CONFIRM_EXPORT_TO_EXCEL": "Etes vous sûr de vouloir exporter toutes les données dans un fichier .xls?",
        "Add_card_top_up_success": "La carte prépayée a été rechargée avec succès",
        "Add_card_success": "La carte a été ajoutée avec succès!",
        "Add_customer_success": "Un nouveau client a été créé avec succès",
        "Update_customer_success": "Le client a été mis à jour avec succès",
        "Deleted_customer_success": "Le client a été supprimé avec succès",
        "Create_customer_fail": "Échec de la création du client",
        "Update_customer_fail": "Échec de la mise à jour du client",
        "ERROR_EXISTED_PHONE": "Ce téléphone existe déjà sur le système. Veuillez en saisir un autre.",
        "ERROR_INPUT_FIRSTNAME": "Veuillez saisir le prénom.",
        "ERROR_INPUT_PHONE": "Veuillez saisir le numéro de téléphone",
        "ERROR_INPUT_VALIDPHONE": "Veuillez spécifier un numéro de téléphone valide",
        "ERROR_INPUT_VALIDEMAIL": "Veuillez spécifier un numéro de email valide",
        "CONFIRM_DELETE_CARD": "Etes vous sûr de vouloir effacer cette carte?",
        "First_name": "Prénom",
        "Last_name": "Nom",
        "Phone_number": "Numéro de téléphone",
        "Email_address": "Adresse e-mail",
        "Notes": "Remarques",
        "Account": " Compte",
        "Card_management": "Gestion de carte",
        "Home": "Ma flotte",
        "Affiliate": "Affilié",
        "SHOW_PERSONAL_CARD": "Carte personnel",
        "ADD_PERSONAL_CARD": "Ajouter une carte personnelle",
        "SHOW_mDISPATCHER_CARD": "Show mdispatcher card",
        "ADD_mDISPATCHER_CARD": "Ajouter la carte mDispatcher",
        "Personal_card": "Carte Personnelle",
        "mDispatcher_card": "Carte mDispatcher",
        "Card_holder": "Titulaire de la carte ",
        "Card_number": "Numéro de carte",
        "Credit_type": "Type de crédit",
        "Credit_code": "Code de crédit",
        "Sms_verification": "Vérification par SMS",
        "Sms_verification_placeholder": "Saisir le code de vérification",
        "Expired_date": "Date d'expiration",
        "CVV": "CVV",
        "Address": "Adresse",
        "Country": "Pays",
        "City": "Ville",
        "State": "Etat",
        "Zip_code": "Code postal",
        "postal_code": "Code postal",
        "Required_fields": "Champs requis",
        "Cancel": "Annuler",
        "Save": "Sauvegarder",
        "ERROR_INPUT_CARD_HOLDER": "Veuillez entrer le titulaire de la carte",
        "ERROR_INPUT_CARD_NUMBER": "Veuillez entrer le numéro de carte",
        "ERROR_INPUT_EXPIRED_DATE": "Date d'expiration non valide",
        "ERROR_VAILD_EXPIRED_DATE": "La date d'expiration n'est pas valide",
        "ERROR_INPUT_CVV": "Veuillez entrer le CVV",
        "ERROR_INPUT_ADDRESS": "Veillez entrer l'adresse",
        "ERROR_INPUT_CITY": "Veuillez entrer la ville",
        "ERROR_INPUT_ZIPCODE": "Veuillez entrer le code postal",
        "ERROR_INPUT_COUNTRY": "Veuillez choisir un pays",
        "Info_edit_error": "Veuillez!",
        "Gender": "Genre",
        "Select_Gender": "Sélectionner genre",
        "Select_Idtype": "Select",
        "Male": "Mâle",
        "Female": "Femme",
        "Other": "Autre",
        "Date_of_birth": "Date de naissance",
        "Street_address": "adresse de rue",
        "Select_Zone": "Sélectionner une zone",
        "ERROR_GET_GATEWAYS": "Error !!! Get Gateways",
        "Require_email": "Veuillez entrer l'email avant d'ajouter une nouvelle carte",
        "Require_lastName": "Veuillez entrer le nom de famille avant d'ajouter une nouvelle carte",
        "Require_phone_number": "Veuillez entrer le numéro de téléphone du voyageur avant de faire une réservation avec une carte de crédit",
        "IMPORT_CUSTOMER_SUCCESS": "Importation des clients réussie",
        "No_card": "Pas de carte trouvée",
        "No_Support": "L'ajout d'une nouvelle carte n'est actuellement pas pris en charge dans cette zone",
        "Card_Management": "Gestion de carte",
        "Emergency_contacts": "Contact d'urgence",
        "DETAIL_CUSTOMER": "Détails du client",
        "Select_Country": "Choisissez un pays",
        "Customer_ID": "ID# / Carte d'identité nationale #",
        "Credit_balance": "Solde créditeur",
        "required_email_payment": "L'email du client est requis. Veuillez mettre à jour le profil pour continuer.",
        "Yes": "Oui",
        "No": "Non",
        "WriteOffDebt": "Radier la dette",
        "selectPayment": "Veuillez sélectionner un mode de paiement pour fermer toutes les réservations en attente de paiement.",
        "writeOffDebtSuccess": "Annulation de la dette réussie",
        "writeOffDebtNotes": "Remarque : Cette action d'annulation de dette ne doit être confirmée qu'après le paiement intégral du montant dû.",
        "totalCustomer": "Clientes totals",
        "Personal_Card": "Carte personnelle",
        "INFO_ADD_BALANCE_SUCCESS": "Le solde du passager a été mis à jour avec succès",
        "INFO_UPDATE_POINT_SUCCESS": "Les points du passager ont été mis à jour avec succès",
        "currency": "Devise",
        "balance": "Solde",
        "changeBalance": "Modification du solde",
        "change": "Modifier",
        "WALLET_DEPOSIT": "Portefeuille",
        "AccessDenied": "Vous n'avez pas la permission d'accéder à ce module !",
        "referral_code": "code de parrainage",
        "loginMethod": "Méthode de connexion",
        "searchCustomerPlaceholder": "Rechercher par nom de contact, téléphone, email, entreprise, ID de support"
    },
    "importBookings": {
        "no": "N°",
        "status": "Statut",
        "pickupDate": "Date de prise en charge",
        "pickup": "Adresse de prise en charge",
        "dropoff": "Adresse de dépose",
        "passenger": "Passager",
        "phone": "Numéro de téléphone",
        "seats": "Sièges",
        "luggages": "Bagages",
        "rideSharing": "Covoiturage",
        "flightNumber": "Numéro de vol",
        "notes": "Notes",
        "externalId": "ID externe",
        "operatorNote": "Notes internes",
        "clientCaseMatter": "Description du trajet",
        "chargeCode": "Code du trajet",
        "price": "Prix",
        "payout": "Paiement",
        "paymentType": "Paiement",
        "vehicleTypeRequest": "Type de voiture",
        "importBookings": "Importer des réservations",
        "corporation": "Entreprise",
        "clickOrDropCsvFile": "Cliquez ou déposez un fichier .csv",
        "importingFileForReview": "Importation du fichier pour examen...",
        "import": "Importer",
        "submit": "Soumettre",
        "downloadTemplate": "Télécharger le modèle",
        "learnMore": "En savoir plus",
        "total": "Total",
        "valid": "Valide",
        "invalid": "Invalide",
        "failed": "Échec",
        "processing": "En cours de traitement",
        "success": "Succès",
        "confirm": "Confirmer",
        "confirmMessage": "Des commandes seront créées. Êtes-vous sûr de vouloir continuer ?",
        "create": "Créer",
        "cancel": "Annuler",
        "close": "Fermer",
        "leavingConfirmMessage": "Votre travail n'est pas enregistré ! Êtes-vous sûr de vouloir quitter ?",
        "resultMessage": "${success} réservation(s) ont été créées avec succès, ${failed} ont échoué.",
        "limitExceededBookings": "Taille maximale du fichier d'importation : 100 réservations",
        "delivery": {
            "no": "#",
            "pickupDate": "Date de prise en charge",
            "senderName": "Nom de l'expéditeur",
            "senderPhone": "Téléphone de l'expéditeur",
            "senderMail": "Email de l'expéditeur",
            "senderAddress": "Adresse de l'expéditeur",
            "recipients": "Destinataires",
            "senderDistrictOptional": "District",
            "senderLocationDetails": "Détails de l'emplacement",
            "recipientName": "Nom du destinataire",
            "recipientPhone": "Téléphone du destinataire",
            "recipientAddress": "Adresse du destinataire",
            "recipientDistrictOptional": "District",
            "recipientLocationDetailsOptional": "Détails de l'emplacement",
            "packageContent": "Contenu du colis",
            "orderNumber": "Numéro de commande #",
            "instructions": "Instructions pour le chauffeur",
            "cod": "Valeur de l'article en paiement à la livraison",
            "rideShare": "Covoiturage",
            "paymentType": "Type de paiement",
            "carType": "Type de voiture",
            "recipientLocationDetails": "Détails de l'emplacement",
            "operatorNote": "Notes internes",
            "rideSharing": "Livraison en lot"
        }
    },
    "merchant": {
        "INFO_ADD_BALANCE_SUCCESS": "Le solde du marchand a été mis à jour avec succès",
        "ADD_MERCHANT_USER": "Ajouter un compte de marchand",
        "EDIT_MERCHANT_USER": "Modifier le compte marchand",
        "MERCHANT_USER_DETAILS": "Détails du compte marchand",
        "CASH_WALLET": "Portefeuille en espèces",
        "CREDIT_WALLET": "Portefeuille de crédit",
        "ADD_MERCHANT": "Ajouter un marchand",
        "ACCOUNT_INFO": "infos de compte",
        "BILLING_ADDRESS": "Informations bancaires",
        "user": {
            "fullName": "Utilisateur marchand",
            "Phone_Number": "Numéro de téléphone",
            "Email": "Email",
            "storeName": "Vendeur",
            "status": "Statut",
            "actions": "action",
            "First_name": "Prénom",
            "Last_name": "Nom de famille",
            "Select_store": "Sélectionner un marchand",
            "accountHolder": "Nom du titulaire du compte",
            "First_M_Last": "Prénom M. Nom",
            "accountNumber": "Numéro de compte",
            "ibanNumber": "Numéro IBAN",
            "bankName": "Nom de la banque",
            "IDtype": "Type d'identifiant",
            "IDnumber": "ID# / Carte d'identité nationale #",
            "routingNumber": "Numéro de routage/transit/agence",
            "checkNumber": "Numéro de chèque",
            "ssn": "Numéro de sécurité sociale / Numéro d'identification nationale",
            "sortCode": "Code de tri",
            "transitNumber": "Numéro de transit",
            "institutionNumber": "Numéro d'institution",
            "birthDay": "Date de naissance",
            "address": "Adresse",
            "city": "Ville",
            "state": "Etat",
            "postalCode": "Code postal",
            "beneficiaryIDIC": "ID du bénéficiaire # / Carte d'identité #",
            "relationshipOtherName": "Relation avec un autre ?",
            "verificationDocumentFront": "Document de vérification (recto)",
            "verificationDocumentBack": "Document de vérification (verso)",
            "Verification_document_tooltip": "Formes d'identification acceptables :\n- Passeport\n- Permis de conduire\n- Carte de résident\n- Carte de citoyen\n- Carte d'identité",
            "additionalDocumentFront": "Document supplémentaire (recto)",
            "additionalDocumentBack": "Document supplémentaire (verso)",
            "Additional_document_tooltip": "Formes acceptables de vérification d'adresse :\n- Permis de conduire\n- Facture de services publics\n- Lettre émise par le gouvernement\n- Relevé d'une institution financière\n- Inscription au registre électoral",
            "please_select": "Veuillez sélectionner",
            "commission": "Commission",
            "ERROR_INPUT_VALIDPHONE": "Veuillez entrer un numéro de téléphone valide.",
            "ERROR_EXISTED_PHONE": "Ce numéro de téléphone existe déjà dans le système. Veuillez en entrer un autre.",
            "Activate": "Activer",
            "Deactivate": "Désactiver",
            "ALERT_SELECT_ACTIVATE": "Veuillez sélectionner un utilisateur à activer.",
            "ALERT_SELECT_DEACTIVATE": "Veuillez sélectionner un utilisateur à désactiver.",
            "CONFIRM_ACTIVATE_MULTI": "Voulez-vous activer ces utilisateurs ?",
            "CONFIRM_DEACTIVATE_MULTI": "Voulez-vous désactiver ces utilisateurs ?",
            "RESET_PASSWORD": "Voulez-vous réinitialiser le mot de passe ?",
            "CONFIRM_RESET_PASSWORD": "Voulez-vous réinitialiser le mot de passe ?",
            "REMOVE_BANK_INFO": "Confirmer la suppression des informations bancaires",
            "CONFIRM_REMOVE_BANK_INFO": "Voulez-vous supprimer les informations bancaires ?",
            "note_account_password_default": "Remarque: Pour un nouveau compte de marchand, le mot de passe par défaut est « 12345678 ».",
            "Cash_Balance": "Solde de trésorerie",
            "Credit_Balance": "Solde créditeur"
        },
        "Update_merchant_user_success": "L'utilisateur marchand a été mis à jour avec succès",
        "Update_merchant_user_fail": "Échec de la mise à jour de l'utilisateur marchand",
        "Create_merchant_user_success": "Un nouvel utilisateur marchand a été créé avec succès",
        "Create_merchant_user_fail": "Échec de la création de l'utilisateur marchand",
        "Update_merchant_user_status_success": "L'utilisateur marchand a été mis à jour avec succès",
        "Update_merchant_user_status_fail": "Échec de la mise à jour de l'utilisateur marchand",
        "Reset_password_merchant_user_success": "Réinitialisation du mot de passe réussie",
        "Reset_password_merchant_user_fail": "Échec de la réinitialisation du mot de passe",
        "Deleted_merchant_bank_info_success": "Suppression des informations bancaires réussie",
        "Deleted_merchant_bank_info_fail": "Échec de la suppression des informations bancaires"
    },
    "table_header": {
        "Items_per_page": "Eléments par page",
        "Page": "Page",
        "Search_here": "Rechercher ici",
        "Shown_Active": "%{start} - %{end} de %{total} Affiche ",
        "Active": "%{active} Actif ",
        "OF": "de"
    },
    "driver": {
        "Driver": "Chauffeur",
        "Add": "Ajouter",
        "addDriver": "Ajouter un chauffeur",
        "Detail": "Détail",
        "detailDriver": "Détails du chauffeur",
        "addNewVehicle": "Ajouter un véhicule",
        "serviceType": "Type de service",
        "transport": "Transport",
        "delivery": "Livraison",
        "stripeConnect": "Stripe Connect",
        "stripeConnectDes": "Ajouter un compte Stripe Connect pour faciliter les paiements",
        "bankAccount": "Informations bancaires",
        "bankAccountDes": "Informations bancaires des chauffeurs pour gérer les paiements",
        "supplierComission": "Commission du fournisseur",
        "supplierComissionDes": "Set commissions the supplier earns for every complete order.",
        "fleetCommission": "Commission de la flotte/fournisseur",
        "fleetCommissionDes": "Définir les commissions que la flotte ou le fournisseur gagne pour chaque commande complétée. Si le chauffeur appartient à un fournisseur, la commission sera déduite des gains du fournisseur.",
        "operationZones": "Zones d'opération",
        "operationZonesDes": "Zones à partir desquelles les fournisseurs peuvent recevoir des missions :",
        "notes": "Notes",
        "notesDes": "Notes internes sur ce chauffeur :",
        "searchNotes": "Ajouter des notes pour le chauffeur",
        "marketplace": "Marché",
        "marketplaceDes": "Permettre aux chauffeurs d'accepter les missions qu'ils souhaitent effectuer.",
        "otherSettings": "Autres paramètres",
        "topDriver": "Chauffeur TOP",
        "topDriverDes": "Prioriser les meilleurs chauffeurs avec le tag \"Top Driver\", garantissant qu'ils obtiennent plus de trajets.",
        "walletTransferBetweenDriver": "Transferts de portefeuille entre chauffeurs",
        "walletTransferBetweenDriverDes": "Permettre aux chauffeurs de transférer des fonds directement entre leurs portefeuilles, facilitant la distribution des crédits par les chefs d'équipe ou les ambassadeurs.",
        "rideSharing": "Covoiturage",
        "rideSharingDes": "Permettre aux chauffeurs d'effectuer des missions de covoiturage. Contactez votre gestionnaire de compte pour cette fonctionnalité avancée.",
        "individual_vehicle": "Véhicule individuel",
        "company_vehicle": "Véhicule d'entreprise",
        "ContactInfo": "Informations de contact",
        "name": "Nom",
        "expiryDate": "Date d'expiration",
        "action": "Action",
        "editDocument": "Modifier le document",
        "documentToUpload": "Document à télécharger",
        "addFiles": "Cliquez ou glissez un fichier dans cette zone pour le télécharger.",
        "fileSize": "Taille maximale du fichier : 10 Mo",
        "fileSizeDes": "L'extension du fichier doit être .jpg, .jpeg, .png, .doc, .docx, .xls, .xlsx, .pdf, .7z, .rar, .zip",
        "removeOldFile": "Veuillez supprimer l'ancien fichier avant d'en télécharger un nouveau.",
        "maxLengthFiles": "Veuillez télécharger un seul fichier au maximum.",
        "maxSizeFiles": "Veuillez télécharger un fichier de moins de 10 Mo.",
        "typeFiles": "Veuillez télécharger un fichier de type .jpg, .jpeg, .png, .doc, .docx, .xls, .xlsx, .pdf, .7z, .rar, .zip",
        "maxAvatarSizeFiles": "Veuillez télécharger un avatar de moins de 8 Mo.",
        "IFSCCode": "Code IFSC",
        "Drivers": "Chauffeurs",
        "default": "Par défaut",
        "customize": "Personnalisé",
        "Activate": "Activer",
        "Stripe_connect": "STRIPE CONNECT",
        "status_stripe": "Statut : {0}",
        "stripeConnectStatus": "Stripe Connect",
        "stripeStatus": "Statut du compte Stripe",
        "Deactivate": "Désactiver",
        "Delete": "Effacer",
        "acceptInDay": "Nombre maximal de réservations qu'un chauffeur peut accepter par jour",
        "acceptATime": "Nombre total de réservations qu'un chauffeur peut accepter à la fois",
        "Commission": "Définir la commission de la flotte",
        "Title_Commission": "Définir la commission de flotte pour tous les conducteurs",
        "Confirm_Set_Commission": "Êtes-vous sûr de vouloir définir cette valeur de commission pour tous les pilotes?",
        "Commission_Successfully": "La commission du chauffeur a été mise à jour avec succès",
        "Apply": "Appliquer",
        "Type": "Type",
        "Currency": "Devise",
        "View_Message": "Message",
        "Send_Message": "Envoyer le message",
        "Driver_Name": "Nom Du Driver",
        "Driver_ID": "ID# / Carte d'identité nationale #",
        "Phone_Number": "Numéro de téléphone",
        "Driver_Type": "Type De Driver",
        "TOP": "TOP",
        "Company": "Compagnie",
        "City": "Ville",
        "Driver_License_Number": "Numéro De Permis De Conduire",
        "License_Plate": "Plaque D'immatriculation",
        "Car_Type": "Type De Véhicule",
        "Zone": "Zone de filtre",
        "Registered_From": "Enregistré À Partir De",
        "Registration_Date": "Date D'enregistrement",
        "IOS_Last_Login_Version": "Version IOS Lors De La Dernière Connexion",
        "Android_Last_Login_Version": "Version Android Lors De La Dernière Connexion",
        "Last_Active_Date": "Dernière date d'activité",
        "Days_Since_Last_Active": "Nombre de jurs depuis la dernière activation",
        "Completed_bookings": "Réservations terminées",
        "Status": "Statut",
        "Actions": "Actions",
        "Action": "action",
        "Inactive": "Inactif",
        "Active": "Actif",
        "Edit": "Modifier",
        "View": "Voir",
        "ALERT_SELECT_ACTIVATE": "Veuillez sélectionner un Driver à activer.",
        "ALERT_SELECT_DEACTIVATE": "Veuillez sélectionner un Driver à désactiver",
        "ALERT_SELECT_DELETE": "Veuillez sélectionner un Driver à supprimer",
        "CONFIRM_DELETE": "Voulez-vous supprimer ce Driver?",
        "CONFIRM_DEACTIVATE_MULTI": "Voulez-vous vraiment désactiver le (s) chauffeur (s) sélectionné (s)? Le (s) compteur (s) physique (s) connecté (s) sera également désactivé. Seuls le(s) conducteur(s) qui n'a pas de trajet actuel ou de réservation en cours peuvent être désactivés.",
        "CONFIRM_ACTIVATE_MULTI": "Voulez-vous pour activer ces Drivers? Seuls les chauffeurs qui sont complètement configurés pour le fonctionnement peuvent être activés.",
        "CONFIRM_DELETE_MULTI": "Voulez-vous supprimer ces Drivers? Seul un Driver qui a un statut d'inactif peut être supprimé.",
        "CONFIRM_REMOVE_BANKING_INFOR": "Êtes-vous sûr de vouloir supprimer les informations bancaires ?",
        "REMOVE_BANKING_INFOR": "Supprimer les informations bancaires",
        "ADD_DRIVER": "Ajouter driver",
        "Avatar": "Avatar",
        "Individual_Driver": "Driver individuel",
        "Owner_Operator": "Gérant de flotte",
        "deliveryCompany": "Livraison - Véhicule d'entreprise",
        "deliveryIndividual": "Livraison - Véhicule individuel",
        "CONTACT_INFO": "Infomations de contact",
        "Home_address": "Adresse du domicile",
        "Username": "Nom d'utilisateur",
        "First_name": "Prénom",
        "Last_name": "Nom",
        "Phone_number": "Numéro de téléphone",
        "Email_address": "Adresse e-mail",
        "Select_city": "Sélectionner une ville",
        "State": "Etat",
        "Zip_code": "Code postal",
        "Date_of_birth": "Date de naissance",
        "placeholderDate": "mm/jj/aaaa",
        "City_driver_want_to_drive": "Ville dans laquelle le Driver veut exercer",
        "Driver_license_number": "Numéro de permis de conduire",
        "Driver_license_state": "Pays du permis de conduire",
        "Driver_license_expiry": "Expiration du contrôle technique",
        "FOR_INSPECTOR": "Pour l'inspecteur",
        "Document": "Document",
        "Document_Id": "ID du document",
        "Link": "Lien",
        "Notes": "Remarques",
        "UPLOAD_DOCUMENT": "Télécharger le document",
        "Click_here_to_download": "Cliquer ici pour télécharger.",
        "Click_here_to_view": "Cliquez pour voir",
        "EXTENSION_REQUIREMENT": "L'extension du fichier doit être .jpg, .png, .doc, .docx, .xls, .xlsx, .pdf, .7z, .rar, .zip et la taille maximale est 5Mb",
        "Invalid_file": "Fichier non valide",
        "File_size_larger_than_5Mb": "La taille du fichier doit être supérieure à 5 Mo",
        "BANK_ACCOUNT": "Compte bancaire",
        "Name_of_bank": "Nom de la banque",
        "Name_of_account": "Nom de compte",
        "First_M_Last": "Prénom M. Nom",
        "RTBnumber": "Numéro du routage / de la correspondance / de la succursale",
        "bankName": "Nom de la banque",
        "Select_a_bank": "Sélectionner une banque",
        "Account_number": "Numéro de compte",
        "IBAN_number": "Numéro de IBAN",
        "Check_number": "Numéro de vérification",
        "Swift_code_number": "Numéro de code Swift",
        "SSNNI": "SSNNI",
        "sortCode": "Code de tri",
        "Verification_document": "Document de vérification (recto)",
        "Additional_document": "Document supplémentaire (recto)",
        "Verification_document_back": "Document de vérification (verso)",
        "Additional_document_back": "Document supplémentaire (verso)",
        "others": "Autres",
        "signedW9Form": "Formulaire W-9 signé",
        "driverLicense": "Permis de conduire",
        "Verification_document_tooltip": "Acceptable forms for identification: \n  - Passport \n  - Permis de conduire \n  - Resident permit ID \n  - Citizen Card \n  - ID card",
        "Additional_document_tootip": "Acceptable forms of address verification: \n  - Permis de conduire \n  - Utility bill \n  - Government issued letter \n  - Statement from a financial institution \n  - Electoral Register entry",
        "isBankAccountOwner": "Est-ce votre compte ?",
        "yes": "Oui",
        "no": "Non",
        "beneficiary_name": "Nom du bénéficiaire",
        "beneficiary_idic": "ID/Carte d'identité du bénéficiaire",
        "relationship": "Relation",
        "select_relationship": "Sélectionner le statut de la relation",
        "spouse": "Époux/Épouse",
        "daughterOrSon": "Fille/Fils",
        "brotherOrSister": "Frère/Sœur",
        "relative": "Parent",
        "friends": "Amis",
        "other": "Autre",
        "relationshipOtherName": "Relation avec un autre ?",
        "OPERATION": "Opération",
        "CAR_INSURANCE": "Assurance voiture",
        "Policy_number": "Numéro de police",
        "Effective_date": "Date d'effet",
        "Expired_date": "Date dépassée",
        "Select_company": "Sélectionner une compagnie",
        "All_company": "Toutes les entreprises",
        "All_Car_Type": "Tous types de véhicules",
        "Car": "Véhicule",
        "Existing_car": "Véhicule existant",
        "New_car": "Nouveau véhicule",
        "License_plate": "Plaque d'immatriculation",
        "Select_license_plate": "Sélectionnez la plaque d'immatriculation",
        "Select_Car_Type": "Veuillez sélectionner le type de véhicule",
        "vehicleOwner": "Nom du propriétaire du véhicule",
        "Make": "Marque",
        "Select_Car_Make": "Sélectionner marque de véhicule",
        "Model": "Modèle",
        "Select_Car_Model": "Sélectionner le modèle de véhicule",
        "Year": "Année",
        "Select_Year": "Sélectionnez l'année",
        "Color": "Couleur",
        "Passengers": "Passagers",
        "Luggage": "Colis",
        "License_expiry": "Expiration de la licence",
        "Shift": "Horraires",
        "Select_Shift_Template": "Sélectionner un modèle Shift",
        "Fleet_commission": "Commission de la Flotte (rapport)",
        "Company_commission": "Commission de l'entreprise (rapport)",
        "rideHailing": "Hélage de rue",
        "intercity": "Interurbain",
        "food": "Aliments ",
        "mart": "Marché ",
        "streetSharing": "Partage de rue",
        "Shuttle": "Navette",
        "parcel": "Colis ",
        "driverInsurance": "Assurance du chauffeur",
        "Percentage": "Pourcentage",
        "Amount": "Montant",
        "transaction": "transaction",
        "Terminal_ID": "Identification de terminal",
        "Auth_key": "Clé d'authentification",
        "CREDIT_DEPOSIT": "Portefeuille de crédit",
        "Credit_Balance": "Balance de crédit",
        "Balance": "Équilibre",
        "Change_balance": "Modification du solde",
        "Select_balance": "Sélectionner le solde",
        "Adjust_amount": "Ajuster le montant",
        "Adjust_value": "Ajuster la valeur",
        "New_balance": "Nouveau solde ",
        "New_point": "Nouveau point",
        "Enter_reason": "Entrer la raison",
        "ERROR_INPUT_BALANCE": "Veuillez sélectionner l'équilibre.",
        "ERROR_INPUT_AMOUNT": "Veuillez entrer cette valeur",
        "ERROR_INPUT_REASON": "Veuillez entrer la raison.",
        "ERROR_INPUT_VALID_AMOUNT": "Veuillez entrer une valeur supérieure ou égale à 0.",
        "INFO_ADD_BALANCE_SUCCESS": "Le solde du pilote a été mis à jour avec succès",
        "INFO_ADD_CASH_BALANCE_SUCCESS": "Le solde en espèces du chauffeur a été mis à jour avec succès",
        "Force_meter": "Force_meter",
        "Force_meter_tooltip": "L'appli chauffeur doit être connectée au compteur avant d'être utilisée. Appliqué pour les compteurs Pulsar & Centrodyne",
        "ERROR_EXISTED_PHONE": "Ce téléphone existe déjà sur le système. Veuillez en saisir un autre.",
        "TOP_driver": "TOP¨chauffeur",
        "Ride_sharing": "Partage de course",
        "Note_password": "Remarque: Après la création du compte, veuillez saisir \"12345678\" comme mot de passe par défaut pour vous connecter",
        "Required_fields": "Champs requis",
        "Cancel": "Annuler",
        "Save": "Sauvegarder",
        "SaveAndInProgress": "Enregistrer & En cours",
        "SaveAndDeactivate": "Enregistrer & Désactiver",
        "ERROR_REQUIRE_": "Veuillez entrer",
        "ERROR_INPUT_AVATAR": "Veuillez télécharger un avatar.",
        "ERROR_INPUT_DRIVER_TYPE": "Veuillez sélectionner le type de chauffeur.",
        "ERROR_INPUT_DOCUMENT": "Veuillez télécharger",
        "ERROR_INPUT_USERNAME": "Veuillez entrer un nom d'utilisateur.",
        "ERROR_INPUT_VALID_USERNAME": "Le nom d'utilisateur ne peut contenir que des lettres minuscules et des chiffres et doit comporter entre 3 et 20 caractères",
        "ERROR_INPUT_PHONE": "Veuillez spécifier un numéro de téléphone valide.",
        "ERROR_INPUT_VALID_EMAIL": "Veuillez entrer un email valide",
        "ERROR_INPUT_EMAIL": "Veuillez saisir l'email.",
        "ERROR_INPUT_FIRSTNAME": "Veuillez saisir le prénom.",
        "ERROR_INPUT_LASTNAME": "Veuillez saisir un nom de famille.",
        "ERROR_INPUT_ADDRESS": "Veuillez saisir l'adresse postale.",
        "ERROR_INPUT_CITY": "Veuillez entrer la ville.",
        "ERROR_INPUT_STATE": "Veuillez saisir l'état.",
        "ERROR_INPUT_ZIPCODE": "Veuillez saisir le code postal.",
        "ERROR_INPUT_BIRTHDAY": "Veuillez entrer la date de naissance.",
        "ERROR_INPUT_NAME_OF_BANK": "Veuillez saisir le nom de la banque.",
        "ERROR_INPUT_NAME_OF_ACCOUNT": "Veuillez entrer le nom du compte.",
        "ERROR_INPUT_ROUTING_NUMBER": "Veuillez saisir le numéro de routage.",
        "ERROR_INPUT_BANK_NAME": "Veuillez sélectionner une banque.",
        "ERROR_INPUT_ACCOUNT_NUMBER": "Veuillez saisir le numéro de compte.",
        "ERROR_INPUT_CHECK_NUMBER": "Veuillez entrer le numéro de vérification.",
        "ERROR_INPUT_SSN": "Veuillez saisir le Numéro de Sécurité sociale.",
        "ERROR_INPUT_DocumentId": "Veuillez entrer l'ID du document.",
        "ERROR_INPUT_SORTCODE": "Veuillez entrer le code de tri.",
        "ERROR_INPUT_COMPANY": "Veuillez sélectionner une compagnie à activer.",
        "ERROR_INPUT_LICENSE_PLATE": "Veuillez choisir une plaque d'immatriculation.",
        "ERROR_INPUT_ZONE": "Veuillez sélectionner une zone à activer.",
        "ERROR_INPUT_SHIFT": "Veuillez sélectionner un shift à activer.",
        "ERROR_ACCOUNT_NUMBER_ONLY_NUMBERS": "Ne doit contenir que des nombres.",
        "ERROR_SSN_ONLY_NUMBERS": "Ne doit contenir que des nombres.",
        "ERROR_SSN_LENGTH": "Le SSN doit comporter au moins 4 caractères",
        "ERROR_COMMISSION_NUMBERS": "S'il vous plait, entrez un nombre valide",
        "INFO_DEACTIVAED_SUCCESS": "Les {0} chauffeurs sélectionnés ont bien été désactivés.",
        "INFO_ACTIVAED_SUCCESS": "Les {0} chauffeurs sélectionnés ont bien été activés.",
        "INFO_DEACTIVAED_SUCCESS_BUT_HARDWARE": "Le chauffeur a été désactivé mais le compteur intégré ne peut pas être désactivé pour des raisons imprévues.",
        "INFO_MULTIDEACTIVAED_SUCCESS": "Les {0} chauffeurs sélectionnés ont été désactivés avec succès.",
        "INFO_MULTIDEACTIVAED_HARDWARE_SUCCESS": "Les {0} chauffeurs sélectionnés ont été désactivés avec succès. {1} compteur (s) connecté (s) ont été désactivés.",
        "INFO_MULTIDEACTIVAED_SUCCESS_BUT_HARDWARE": "Les {0} pilotes sélectionnés ont bien été désactivés. {1} compteur (s) connecté (s) ont été désactivés. {2} ne l'ont pas été à cause de raisons imprévues.",
        "INFO_MULTIACTIVAED_SUCCESS": "Les {0} chauffeurs sélectionnés ont été activés avec succès.",
        "DRIVER_UPDATE_SUCCESS": "Le Driver a bien été mis à jour.",
        "DRIVER_CREATE_SUCCESS": "Les informations sur le pilote ont été ajoutées avec succès",
        "Expiry_Date": "Date d'expiration ",
        "Case_number": "Numéro de dossier",
        "Export_to_csv": "Exporter en CSV",
        "CONFIRM_EXPORT_TO_CSV": "Are you sure you want to export all data as a .csv file?",
        "Ride_sharing_tooltip": "Le partage de course est une fonctionnalité avancée, veuillez contacter notre équipe de support pour avoir plus d’informations.",
        "In_Review": "En revue",
        "Reset_password_success": "Réinitialisation du mot de passe réussie",
        "Topup_note": "Il est permis de recharger le solde de votre pilotes après avoir activé le pilotes",
        "cash_balance": "Solde",
        "cash_wallet": "Porte-monnaie",
        "total_balance": "Solde total",
        "total_cash_balance": "Solde de caisse total",
        "total_credit_balance": "Solde créditeur total",
        "banking_status": "Statut bancaire",
        "bankingStatus": {
            "verified": "Vérifié",
            "not_verified": "Non vérifié",
            "inComplete": "Incomplet",
            "connected": "Connecté",
            "disconnected": "Déconnecté"
        },
        "INVALID_FILE_SIZE": "La taille du fichier doit être inférieure à 8 Mo.",
        "totalDrivers": "Nombre de conducteur",
        "profileStatus": "Statut du profil",
        "profile_completed": "Profil complet",
        "profile_incomplete": "Profil incomplet",
        "profile_inProgress": "Profil en cours",
        "in_review_completed": "En cours de révision (profil complété)",
        "in_review_incomplete": "En cours de révision (profil incomplet)",
        "in_review_inProgress": "En cours de révision (profil en cours)",
        "CASH_WALLET_DEPOSIT": "Portefeuille en espèces",
        "payoutSelect": "Paiement (une notification et un email seront envoyés au chauffeur après le paiement)",
        "Confirm_update_cash_balance": "Modifier le solde en espèces",
        "Confirm_update_cash_balance_msg": "Êtes-vous sûr de vouloir modifier le solde du chauffeur ?",
        "cashBalance": "Solde de trésorerie",
        "cashBalance_unavailable": "0,00",
        "cashBalance_active": "actif",
        "cashBalance_negative": "Négatif",
        "creditBalance": "Solde de crédit",
        "ERROR_INPUT_DOCUMETID": "Veuillez entrer l'ID du document.",
        "ERROR_INPUT_EXPIRYDATE": "Veuillez entrer la date d'expiration.",
        "driverType": "Type de conducteur",
        "tooltip_in_review_completed": "Envoyer un message aux conducteurs 'en cours de traitement' qui n'ont pas complété leur profil.",
        "tooltip_in_review_incomplete": "Envoyer un message aux conducteurs  'en cours de traitement' qui n'ont pas complété leur profil.",
        "tooltip_in_review_inProgress": "Envoyer un message aux conducteurs 'en cours de traitement' qui ont complété leur profil.",
        "tooltip_active": "Envoyer un message aux conducteurs 'actifs' .",
        "tooltip_inactive": "Envoyer un message aux conducteurs dont le compte a été réactivé.",
        "active": "Activer",
        "inactive": "Désactiver",
        "inReviewInProgress": "En cours de traitement",
        "Market_place": "Marché",
        "Market_place_tooltip": "Permettre aux chauffeurs de choisir d'accepter des trajets à la demande ou des réservations",
        "selectDriverType": "Sélectionner le type de chauffeur",
        "PlsSelectDriverType": "Veuillez sélectionner le type de chauffeur",
        "emergencyContacts": "Contacts d'urgence",
        "switchVehicle": "Passer à n'importe quel véhicule",
        "switchVehicleNote": "Permettre au chauffeur de passer à n'importe quel véhicule de son entreprise fournisseur assignée.",
        "vehicleModel": "Modèle",
        "licensePlateNumber": "Plaque du véhicule",
        "addVehicle": "Ajouter un véhicule",
        "newVehicle": "Nouveau véhicule",
        "linkVehicle": "Lier un véhicule",
        "modal": "Modal",
        "selectVehicle": "Sélectionner un véhicule",
        "selectVehicleNote": "Permettre au chauffeur de sélectionner ou de changer de véhicule pour une réservation.",
        "Warning_change_company": "Avertissement : Réaffecter ce chauffeur à une autre entreprise dissociera tous les véhicules associés.",
        "searchDriverPlaceholder": "Rechercher par nom, téléphone, email, nom d'utilisateur, plaque d'immatriculation",
        "please_select_a_name_of_bank": "Veuillez sélectionner un nom de banque."
    },
    "corporate": {
        "User_Name": "Nom d'utilisateur",
        "Edit_Balance": "Éditer le solde",
        "Corporates": "Entreprises",
        "Supplier": "Fournisseur",
        "CarTypes": "Types de voitures",
        "Add": "Ajouter",
        "Balance": "Solde",
        "Activate": "Activer",
        "Deactivate": "Désactiver",
        "Delete": "Effacer",
        "Company_Name": "Nom de la société",
        "Admin_Name": "Nom de l'administrateur",
        "Username": "Nom d'utilisateur",
        "Phone_Number": "Numéro De Téléphone",
        "importBooking": "Possibilité d'importer des réservations",
        "Email": "Email",
        "Registered_From": "Enregistré À Partir De",
        "Registration_Date": "Date D'enregistrement",
        "Status": "Statut",
        "Actions": "Actions",
        "Action": "action",
        "Inactive": "Inactif",
        "Active": "Actif",
        "In_Review": "En revue",
        "Edit": "Modifier",
        "View": "Voir",
        "ADD_CORPORATE_CARD": "Ajouter une carte d'entreprise",
        "selectCountry": "Sélectionnez un pays",
        "CONFIRM_DELETE_CARD": "Etes vous sûr de vouloir effacer cette carte?",
        "ALERT_SELECT_ACTIVATE": "Veuillez sélectionner l'entreprise à activer.",
        "ALERT_SELECT_DEACTIVATE": "Veuillez sélectionner l'entreprise à désactiver.",
        "ALERT_SELECT_DELETE": "Veuillez sélectionner l'entreprise à supprimer.",
        "CONFIRM_DELETE": "Voulez-vous supprimer cette entreprise?",
        "CONFIRM_DELETE_USER": "Voulez-vous supprimer cet utilisateur entreprise?",
        "CONFIRM_DEACTIVATE_MULTI": "Voulez-vous désactiver ces entreprises?",
        "CONFIRM_ACTIVATE_MULTI": "Voulez-vous activer ces entreprises?",
        "CONFIRM_DELETE_MULTI": "Voulez-vous supprimer ces entreprises?\n ** Seules les sociétés inactives peuvent être supprimées.",
        "ERROR_INPUT_PHONE": "Veuillez saisir le numéro de téléphone",
        "ERROR_INPUT_VALIDPHONE": "Veuillez spécifier un numéro de téléphone valide",
        "ERROR_EXISTED_PHONE": "Ce téléphone existe déjà sur le système. Veuillez en saisir un autre.",
        "Account": "Compte",
        "Corp_traveler": "Utilisateurs",
        "Payment_methods": "Moyens de paiement",
        "Corp_operators": "Opérateurs Corporate",
        "Pricing": "Tarification",
        "COMPANY_INFORMATION": "Informations sur la société",
        "Company_name": "Nom de la société",
        "Company_ID": "Compagnie ID (pour l'inscription d'un utilisateur)",
        "Company_address": "Adresse de la société",
        "Invoice_email": "Email de facture",
        "Confirmation_email": "Email de confirmation",
        "colorCodeBooking": "Code couleur",
        "ADMIN_ACCOUNT": "Compte admin",
        "First_name": "Prénom",
        "Last_name": "Nom",
        "Commission": "Commission",
        "commissionBooking": "Appliquer une commission pour les réservations effectuées à partir de l'application",
        "Required_fields": "Champs requis",
        "Save": "Sauvegarder",
        "Cancel": "Annuler",
        "Reset_password": "Réinitialiser le mot de passe",
        "Employee_Name": "Nom De L'employé",
        "Created_Date": "\tCréer Date",
        "Add_corporate_card": "Ajouter une carte d'entreprise",
        "Corp_Users": "Utilisateurs Entreprise",
        "Pricing_Default": "Modèle de tarif entreprise",
        "Pricing_Discount": "Pourcentage de réduction (appliqué pour les passagers de la société)",
        "Markup_By_Percent": "Majoration en pourcentage (appliquée uniquement aux voyageurs corp)",
        "Pricing_Discount_new": "Remise en pourcentage",
        "Markup_By_Percent_new": "Majoration en pourcentage",
        "Pricing_Add_different_rates": "Ajouter des tarifs différents",
        "ERROR_INPUT_COMPANYNAME": "Veuillez saisir le nom de l'entreprise.",
        "ERROR_INPUT_USERNAME": "Veuillez saisir le nom d'utilisateur",
        "ERROR_INPUT_FIRSTNAME": "Veuillez saisir le prénom.",
        "ERROR_INPUT_EMAIL": "Veuillez saisir l'email",
        "ERROR_INPUT_VALID_EMAIL": "Veuillez entrer un l'email valide .",
        "ERROR_INPUT_VALID_NUMBER": "Veuillez entrer un nombre valide",
        "ERROR_INPUT_VALID_RANGE_AMOUNT": "Veuillez entrer une valeur entre {0} et {1}.",
        "INFO_ADD_CORPORATE_SUCCESS": "Le compte {0} a bien été créé. Veuillez vérifier le mail {1} pour les détails de certificat",
        "INFO_UPDATE_CORPORATE_SUCCESS": "La société a bien été mise à jour.",
        "INFO_UPDATE_PRICING_SUCCESS": "Mettre à jour la tarification avec succès",
        "INFO_RESET_PASSWORD_SUCCESS": "Le compte {0} a été réinitialisé avec succès. Veuillez vérifier l'email {1} pour les détails des identifiants de connexion.",
        "COMFIRM_RESET_PASSWORD": "Voulez-vous réinitialiser le mot de passe?",
        "Traveler_signature": "Signature du voyageur",
        "Parcel_Delivery": "Activer la livraison de colis",
        "Tracking_log": "Journal de suivi",
        "Rating": "Évaluation",
        "Email_address": "Adresse e-mail",
        "Assistant_email": "Email de l'assistant",
        "Corp_PO": "Bon de commande entreprise",
        "Cost_centre": "Centre de coûts",
        "Corp_division": "Division d'entreprise",
        "Corp_id": "Numéro d'entreprise",
        "Department": "Département",
        "Manager_email": "Mail du directeur",
        "Manager_name": "Nom du gestionnaire",
        "Corporate_card": "Carte entreprise ",
        "Direct_invoicing": "Facturation directe",
        "Corporate_Prepaid": "Payé via Wallet ",
        "Cash": "Paiement à bord",
        "Car_Type_ID": "Identification Du Type De Véhicule",
        "App_Display_Name": "Nom De L'affichage De L'application",
        "Normal_Fare": "Régulier",
        "Flat_Fare": "Forfait",
        "Hourly_Daily_Rate": "Horaire / quotidien",
        "Delivery_Rate": "Livraison",
        "Assign_rate": "Attribuez tarif",
        "Zone": "Zone de filtre",
        "Rate": "Tarif",
        "Zone_Rate": "Zone - Tarif",
        "Please_select_rate": "Veuillez sélectionner un tarif",
        "Paid_by": "Payé par",
        "Enter_new_credit_card": "Entrez une nouvelle carte de crédit",
        "TOP_UP": "Réapprovisionnement",
        "Top_up": "Recharger",
        "Topup_amount": "Montant du rechargement",
        "Currency": "Devise",
        "ERROR_INPUT_AMOUNT": "Veuillez entrer un montant valide",
        "VAT_number": "Numéro de TVA",
        "Gender": "Genre",
        "Select_Gender": "Sélectionner genre",
        "Male": "Homme",
        "Female": "Femme",
        "Date_of_birth": "Date de naissance",
        "Street_address": "adresse de rue",
        "City": "Ville",
        "State": "Etat",
        "Zip_code": "Code postal",
        "Country": "Pays",
        "adding_new_card": "Vous ajoutez une nouvelle carte pour utiliser le service dans la zone %{zoneName}",
        "No_Support": "L'ajout d'une nouvelle carte n'est actuellement pas pris en charge dans cette zone",
        "Job_title": "Titre du poste",
        "required_phone_number_payment": "Le numéro de téléphone de l'entreprise est requis. Veuillez mettre à jour le profil pour continuer.",
        "Yes": "Oui",
        "No": "Non",
        "AddCardBeforeTopup": "Aucune carte de crédit trouvée. Veuillez ajouter une nouvelle carte pour continuer.",
        "flightNumber": "Numéro de vol",
        "Company_Type": "Type d'entreprise",
        "Standard": "Défaut",
        "Airline": "Compagnie aérienne",
        "Branding": "Image de marque",
        "bgImage": "Image d'arrière-plan (1600x900)",
        "logoImage": "Image du logo",
        "aliasTitle": "Paramètre alias (URL)",
        "importChauffeurBooking": "Autorisé à importer des réservations de transport",
        "isCorporateVip": "VIP entreprise",
        "isCorporateVipToolTip": "Activez ce paramètre pour attribuer automatiquement le statut VIP à tous les voyageurs d'entreprise lors de leur création. Vous pouvez le désactiver pour chaque utilisateur individuellement.",
        "qrTitle": "Lien de réservation Web QR",
        "qrNote": "Votre lien de réservation partenaire personnalisé est ici ! Affichez-le bien en évidence dans les bars, les réceptions d'hôtel, les chambres d'invités et sur votre site Web—partout où vos clients pourraient avoir besoin d'un trajet ou d'une livraison. Pensez à concevoir des présentoirs avec votre code QR unique, permettant aux clients de réserver rapidement et facilement leur voyage !",
        "PricingLegacy": "Tarification (ancienne version)",
        "defaultTemplate": "Modèle par défaut",
        "Select_Rate_Template": "Sélectionner un modèle de tarif"
    },
    "airline": {
        "Airlines": "Compagnies aériennes",
        "Add": "Ajouter ",
        "Activate": "Activer",
        "Deactivate": "Désactiver",
        "Delete": "Supprimer",
        "Company_Name": "Nom de l'entreprise",
        "Admin_Name": "Nom de l'administrateur",
        "Username": "Nom d'utilisateur",
        "Phone_Number": "Numéro de téléphone",
        "Email": "Email",
        "Registered_From": "Inscrit depuis",
        "Registration_Date": "Date d'inscription",
        "Status": "Statut",
        "Actions": "Actions",
        "Action": "action",
        "Inactive": "Inactif",
        "Active": "actif",
        "In_Review": "En cours de traitement",
        "Edit": "Modifier",
        "View": "Voir",
        "ADD_CORPORATE_CARD": "Ajouter une carte de compagnie aérienne",
        "selectCountry": "Sélectionnez un pays",
        "CONFIRM_DELETE_CARD": "Êtes-vous sûr de vouloir supprimer cette carte ?",
        "ALERT_SELECT_ACTIVATE": "Veuillez sélectionner une compagnie aérienne à activer.",
        "ALERT_SELECT_DEACTIVATE": "Veuillez sélectionner une compagnie aérienne à désactiver.",
        "ALERT_SELECT_DELETE": "Veuillez sélectionner une compagnie aérienne à supprimer.",
        "CONFIRM_DELETE": "Voulez-vous supprimer cette compagnie aérienne ?",
        "CONFIRM_DELETE_USER": "Voulez-vous supprimer cet utilisateur de compagnie aérienne ?",
        "CONFIRM_DEACTIVATE_MULTI": "Êtes-vous sûr de vouloir désactiver cette entreprise ?",
        "CONFIRM_ACTIVATE_MULTI": "Êtes-vous sûr de vouloir activer cette entreprise ?",
        "CONFIRM_DELETE_MULTI": "Êtes-vous sûr de vouloir supprimer cette entreprise ? \n** Seules les entreprises inactives peuvent être supprimées.",
        "ERROR_INPUT_PHONE": "Veuillez spécifier un numéro de téléphone valide.",
        "ERROR_INPUT_VALIDPHONE": "Veuillez entrer un numéro de téléphone valide.",
        "ERROR_EXISTED_PHONE": "Ce numéro de téléphone existe déjà dans le système. Veuillez en entrer un autre.",
        "Airline": "Compagnie aérienne",
        "Crew": "Équipage",
        "Payment_methods": "Méthodes de Paiement",
        "Airline_operators": "Opérateurs de compagnie aérienne",
        "Pricing": "Tarification",
        "COMPANY_INFORMATION": "Informations sur l'entreprise",
        "Company_name": "Nom de l'entreprise",
        "Company_ID": "ID de l'entreprise",
        "Company_address": "Adresse de l'entreprise",
        "Invoice_email": "Email de facturation",
        "Confirmation_email": "Email de confirmation",
        "colorCodeBooking": "Code couleur",
        "ADMIN_ACCOUNT": "Compte administrateur",
        "First_name": "Prénom",
        "Last_name": "Nom de famille",
        "Commission": "Commission",
        "Required_fields": "Champs obligatoires",
        "Required_fields_crews": "Remarque : Pour un nouveau compte équipage, le mot de passe par défaut est \"12345678",
        "Save": "Enregistrer",
        "Cancel": "Annuler",
        "Reset_password": "Réinitialiser le mot de passe",
        "Crew_Name": "Équipage",
        "Created_Date": "Date de création",
        "Add_corporate_card": "Ajouter une carte de compagnie aérienne",
        "Corp_Users": "Opérateurs",
        "Pricing_Default": "Défaut",
        "Pricing_Discount": "Remise en pourcentage",
        "Markup_By_Percent": "Majoration en pourcentage",
        "Pricing_Add_different_rates": "Ajouter différents tarifs",
        "ERROR_INPUT_COMPANYNAME": "Veuillez entrer le nom de l'entreprise.",
        "ERROR_INPUT_USERNAME": "Veuillez entrer un nom d'utilisateur.",
        "ERROR_INPUT_FIRSTNAME": "Veuillez entrer un prénom.",
        "ERROR_INPUT_EMAIL": "Veuillez entrer un email.",
        "ERROR_INPUT_VALID_EMAIL": "Veuillez entrer une adresse email valide.",
        "ERROR_INPUT_VALID_NUMBER": "Veuillez entrer un numéro valide.",
        "ERROR_INPUT_VALID_RANGE_AMOUNT": "Veuillez entrer une valeur entre {0} et {1}.",
        "INFO_ADD_CORPORATE_SUCCESS": "Le compte {0} a été créé avec succès.",
        "INFO_UPDATE_CORPORATE_SUCCESS": "Les informations ont été mises à jour avec succès.",
        "INFO_UPDATE_PRICING_SUCCESS": "Tarification mise à jour avec succès.",
        "INFO_RESET_PASSWORD_SUCCESS": "Le compte {0} a été réinitialisé avec succès.",
        "COMFIRM_RESET_PASSWORD": "Voulez-vous réinitialiser le mot de passe ?",
        "Traveler_signature": "Signature du voyageur",
        "Tracking_log": "Journal de suivi",
        "Rating": "Étoile",
        "Email_address": "Adresse e-mail",
        "Assistant_email": "E-mail de l'assistant",
        "Corp_PO": "Bon de commande entreprise",
        "Cost_centre": "Centre de coûts",
        "Corp_division": "Division entreprise",
        "Corp_id": "ID entreprise",
        "Department": "Département",
        "Manager_email": "E-mail du responsable",
        "Manager_name": "Nom du responsable",
        "Corporate_card": "Carte de compagnie aérienne",
        "Direct_invoicing": "Facture directe",
        "Corporate_Prepaid": "Prépayé compagnie aérienne",
        "Cash": "En espèces",
        "Car_Type_ID": "ID du type de voiture",
        "App_Display_Name": "Nom affiché dans l'application",
        "Normal_Fare": "Régulier",
        "Flat_Fare": "Tarif fixe",
        "Hourly_Daily_Rate": "Horaire / Journalier",
        "Delivery_Rate": "Livraison",
        "Assign_rate": "Attribuer un tarif",
        "Zone": "Zone de filtre",
        "Rate": "Avis",
        "Zone_Rate": "Zone - Tarif",
        "Please_select_rate": "Veuillez sélectionner un tarif",
        "Paid_by": "Payé par",
        "Enter_new_credit_card": "Saisir une nouvelle carte de crédit",
        "TOP_UP": "RECHARGER",
        "Top_up": "Recharger",
        "Topup_amount": "Montant du rechargement",
        "Currency": "Devise",
        "ERROR_INPUT_AMOUNT": "Veuillez entrer un montant valide.",
        "VAT_number": "Numéro de TVA",
        "Gender": "Genre",
        "Select_Gender": "Sélectionner",
        "Male": "Homme",
        "Female": "Femme",
        "Date_of_birth": "Date de naissance",
        "Street_address": "Adresse de rue",
        "City": "Ville",
        "State": "Etat",
        "Zip_code": "Code postal",
        "Country": "Pays",
        "adding_new_card": "Vous ajoutez une nouvelle carte pour utiliser le service dans la zone %{zoneName}",
        "No_Support": "L'ajout d'une nouvelle carte n'est actuellement pas pris en charge dans cette zone",
        "Job_title": "Titre du poste",
        "required_phone_number_payment": "Le numéro de téléphone de l'entreprise est requis. Veuillez mettre à jour le profil pour continuer.",
        "Yes": "Oui",
        "No": "Non",
        "AddCardBeforeTopup": "Aucune carte de crédit trouvée. Veuillez ajouter une nouvelle carte pour continuer."
    },
    "message": {
        "Add": "Ajouter",
        "Delete": "Effacer",
        "Items_per_page": "Eléments par page",
        "Page": "Page",
        "Search_here": "Rechercher ici",
        "Shown_Active": "{0} - {1} de {2} Affiche",
        "Date": "Date",
        "Subject": "Sujet",
        "To": "À",
        "Type": "Type",
        "Result": "Résultat",
        "Actions": "Actions",
        "New_message": "Nouveau message",
        "MESSAGE_DETAILS": "Détails du message",
        "All": "Tout",
        "Company": "Compagnie",
        "Active": "Actif",
        "In_Active": "Inactif",
        "In_Review": "En revue",
        "Send_to": "Envoyer à",
        "All_drivers": "Tous les driver",
        "All_customers": "Tous les clients",
        "All_merchants": "Tous les marchands",
        "Customized_driver": "Chauffeur personnalisé",
        "Customized_customer": "Client personnalisé",
        "Customized_merchant": "Personnalisation Marchand",
        "Receiver_list": "Liste de destinataires",
        "Content": "Contenu",
        "Required_fields": "Champs requis",
        "Search_driver_name_driver_phone_number": "Rechercher nom du chauffeur, numéro de téléphone du chauffeur",
        "Search_category_name": "Rechercher le nom de la catégorie",
        "Search_customer_name_customer_phone_number": "Rechercher le nom du client, le numéro de téléphone du client",
        "Search_merchant_name_merchant_phone_number": "Rechercher le nom du marchand, le numéro de téléphone du marchand",
        "Search_car_type": "Rechercher le type de voiture",
        "Searching": "Recherche...",
        "No_results": "Aucun résultat",
        "Send": "Envoyer",
        "Cancel": "Annuler",
        "SMS_failed_Inbox_succeeded": "L'envoi de SMS a échoué, le message a été envoyé par inbox",
        "Failed": "Échoué",
        "Succeeded": "Réussi",
        "CONFIRM_DELETE": "Voulez-vous supprimer ce message?",
        "CONFIRM_DELETE_MULTI": "Voulez-vous supprimer ces messages?",
        "ALERT_SELECT_DELETE": "Veuillez sélectionner un message à supprimer",
        "ERROR_INPUT_RECEIVERLIST": "Veuillez choisir au moins un Driver pour envoyer un message",
        "ERROR_INPUT_CUSTOMER_RECEIVERLIST": "Veuillez choisir au moins un client pour envoyer un message",
        "ERROR_INPUT_SUBJECT": "Veuillez saisir le sujet",
        "ERROR_INPUT_CONTENT": "Veuillez saisir le contenu",
        "ERROR_INPUT_LEAST_ONE_SUBJECT_CONTENT": "Veuillez configurer au moins une langue pour continuer",
        "ERROR_INPUT_SUBJECT_MULTI_LANGUAGE": "Veuillez entrer un sujet pour la langue {0}",
        "ERROR_INPUT_CONTENT_MULTI_LANGUAGE": "Veuillez entrer le contenu pour la langue {0}",
        "ERROR_INPUT_URL_MULTI_LANGUAGE": "Veuillez entrer l'URL pour la langue {0}",
        "ERROR_INPUT_TITLE_MULTI_LANGUAGE": "Veuillez entrer le titre pour la langue {0}",
        "ERROR_INPUT_BODY_MULTI_LANGUAGE": "Veuillez entrer le corps du texte pour la langue {0}",
        "import_fail_success_driver": "%{success} chauffeur(s) ont été importés avec succès, %{fail} ont échoué.",
        "import_fail_success_passenger": "%{success} client(s) ont été importés avec succès, %{fail} ont échoué.",
        "import_fail_success_merchant": "%{success} marchand(s) ont été importés avec succès, %{fail} ont échoué.",
        "CONFIRM_SEND_SUCCESS": "Votre message a été envoyé. Cela peut prendre plusieurs minutes. Veuillez patienter pendant que le système traite votre demande.",
        "Load_message_and_sms_fail": "Des erreurs sont survenues lors du chargement des détails de messages et SMS",
        "Update_message_and_sms_fail": "Des erreurs sont survenues lors de la mise à jour des détails de messages et SMS",
        "Update_message_and_sms_success": "Les détails des messages et des SMS ont bien été mis à jour",
        "Driver_List": "Liste de chauffeurs",
        "Car_Type_List": "Liste de catégories de véhicule",
        "Search_vehicle_type_name": "Rechercher le nom du type de véhicule",
        "ALERT_PROCESSING_DELETE": "Votre demande est en cours de traitement. Cela peut prendre quelques secondes",
        "Customer": "Client",
        "Driver": "Chauffeurs",
        "StatusOfCustomer": "Statut du client",
        "StatusOfDriver": "Statut du conducteur",
        "StatusOfMerchant": "Statut du marchand",
        "SendTo": "Envoyer à",
        "DownloadReceiverList": "Télécharger la liste des destinataires",
        "warningInputChangeOver": "Il y a un changement relatif de plus de 20% entre les 2 entrées récentes. Veuillez considérer!",
        "NoteDownloadReveverList": "Après 1 mois, le téléchargement de la liste des récepteurs sera désactivé.",
        "Load_voip_fail": "Des erreurs sont survenues lors du chargement des détails VOIP.",
        "Update_voip_success": "Les détails VOIP ont été mis à jour avec succès.",
        "Update_voip_fail": "Des erreurs sont survenues lors de la mise à jour des détails VOIP.",
        "expiryDate": "Envoyer au nouvel utilisateur jusqu'à",
        "expiryDate_placeholder": "Expiry Date (mm/dd/yyyy)",
        "NA": "N/A",
        "PleaseSelectStatusOfDriver": "Veuillez sélectionner le statut du chauffeur",
        "versionApp": "Version de l'appli",
        "platform": "Plateforme",
        "contentType": "Type de contenu",
        "url": "URL",
        "title": "Titre",
        "contentId": "ID du contenu",
        "body": "Corps",
        "image_notification": "Image",
        "platformItem": {
            "all": "Tout",
            "iOS": "iOS",
            "android": "Android"
        },
        "comparisonVersionApp": {
            "is": "Est",
            "is_not": "N'est pas",
            "is_one_of": "Est l'un des",
            "is_not_one_of": "N'est pas l'un des",
            "greater_or_equal": "Supérieur ou égal",
            "less_or_equal": "Inférieur ou égal"
        },
        "contentTypeItem": {
            "html": "HTML",
            "link": "Lien"
        },
        "Please_input": "Ce champ est requis"
    },
    "fleetInfo": {
        "Fleet_name": "Nom de la flotte",
        "Phone_number": "Numéro de téléphone",
        "Email_address": "Adresse e-mail",
        "Country": "Pays",
        "Time_zone": "Fuseau horaire",
        "Address": "Adresse",
        "Website": "Site Internet",
        "Currency": "Devise",
        "Distance_unit": "Unité de distance",
        "Load_fleet_info_fail": "Des erreurs sont survenues lors du chargement des informations de la flotte"
    },
    "surchargePolicy": {
        "Surchage_Policy": "Politique de surtaxe",
        "SurgePolicy": "Politique de surtaxe dynamique",
        "surgeType": "Type de surtaxe",
        "bookingTimeCoverage": "Couverture du temps de réservation",
        "Delete_surcharge": "Êtes-vous sûr de vouloir supprimer la surtaxe sélectionnée ?",
        "Delete_surcharge_item": "Êtes-vous sûr de vouloir supprimer l'élément de surtaxe sélectionné ?",
        "Delete_surcharge_item_success": "La surtaxe a été désactivée avec succès",
        "Delete_surcharge_item_fail": "Des erreurs sont survenues lors de la désactivation de l'élément de surtaxe",
        "linkNewPolicy": "Lier une nouvelle politique",
        "Link": "Lien",
        "ViewPolicy": "Voir la politique",
        "Unlink": "Dissocier",
        "Create_Surcharge_Item_success": "L'élément de surtaxe a été créé avec succès",
        "Create_Surcharge_Item_fail": "Des erreurs sont survenues lors de la création de l'élément de surtaxe",
        "Update_Surcharge_Item_success": "L'élément de surtaxe a été mis à jour avec succès",
        "Update_Surcharge_Item_fail": "Des erreurs sont survenues lors de la mise à jour de l'élément de surtaxe",
        "single": "Jour unique",
        "yearly": "Annuel",
        "weekly": "Jour de la semaine",
        "Please_select_at_least_one_day": "Veuillez sélectionner au moins un jour",
        "Booking_lead_time": "Délai de réservation",
        "Start_date_must_be_before_end_date": "The start date must be before the end date"
    },
    "penaltyPolicy": {
        "penaltyPolicy": "Politique de pénalité",
        "Reservation": "Réservation",
        "onDemand": "À la demande",
        "noShow": "Non-présentation",
        "driverNoShow": "Non-présentation du conducteur",
        "freeCancellation": "Période d'annulation gratuite",
        "fieldExclusions": "Champs inclus",
        "penaltyActive": "Durée d'annulation - avant l'heure de prise en charge",
        "penaltyType": "Type de pénalité",
        "Compensation": "Compensation fournisseur/chauffeur",
        "Create_penalty_success": "Le modèle de pénalité a été créé avec succès",
        "Create_penalty_fail": "Des erreurs sont survenues lors de la création du modèle de pénalité",
        "Update_penalty_success": "Le modèle de pénalité a été mis à jour avec succès",
        "Update_penalty_fail": "Des erreurs sont survenues lors de la mise à jour du modèle de pénalité",
        "confirmDelete": "Confirmer la suppression",
        "confirmDeleteContent": "Êtes-vous sûr de vouloir supprimer cette politique de pénalité ? La suppression de cette politique la dissociera de tous les tarifs de réservation.",
        "Delete_success": "Le modèle de pénalité a été supprimé avec succès",
        "Delete_fail": "Des erreurs sont survenues lors de la suppression du modèle de pénalité",
        "payoutPolicy": "Politique de paiement",
        "commission": "Pourcentage de pénalité client",
        "commissionPayout": "Pourcentage de paiement fournisseur",
        "fixAmount": "Montant",
        "amount": "Montant",
        "amount_driver": "Montant",
        "percent": "Percent",
        "percent_driver": "Pourcentage basé sur le tarif",
        "basedOnPayout_driver": "Pourcentage basé sur le paiement",
        "percentPayout": "% du paiement",
        "percentFare": "% du tarif",
        "penaltyFee": "Frais d'annulation",
        "commissionType": "Type de compensation",
        "commissionFee": "Compensation",
        "tax": "Taxe",
        "techFee": "Frais technologiques",
        "minute": "minute",
        "hour": "heure",
        "setDefaultSuccess": "La politique de pénalité par défaut a été définie avec succès.",
        "setDefaultFail": "Les erreurs se sont produites lors de la définition de la politique de pénalité par défaut."
    },
    "rateTemplates": {
        "Rate_Templates": "Modèles de tarification",
        "newRate": "Nouveau modèle de tarification",
        "placeHolderName": "Saisir le nom du modèle de tarification",
        "Assign_Rate": "Attribuer un tarif",
        "carTypeName": "Nom du type de voiture",
        "appDisplayName": "Nom affiché dans l'application",
        "assign_rate_success": "Le type de voiture a été attribué avec succès",
        "assign_rate_fail": "Des erreurs sont survenues lors de l'attribution du tarif",
        "confirmDeleteTitle": "Confirmer la suppression",
        "confirmDelete": "Êtes-vous sûr de vouloir supprimer ce modèle ? La suppression de ce modèle le dissociera de tous les partenaires/entreprises auxquels il est lié.",
        "setDefaultSuccess": "Le modèle de tarification par défaut a été défini avec succès",
        "setDefaultFail": "Des erreurs sont survenues lors de la définition du modèle de tarification par défaut",
        "Delete_rate_template_success": "Le modèle de tarification a été supprimé avec succès",
        "Delete_rate_template_fail": "Des erreurs sont survenues lors de la suppression du modèle de tarification",
        "setDefault": "Définir comme par défaut",
        "Regular": "Tarif régulier",
        "Sharing": "Tarif de partage de rue",
        "Flat": "Tarif fixe",
        "Hourly": "Horaire / Journalier",
        "Delete_default": "Si vous essayez de supprimer le modèle par défaut, nous ne devrions pas autoriser cela tant qu'un autre modèle par défaut n'est pas défini."
    },
    "supplierPlan": {
        "Supplier_Plan": "Plan fournisseur",
        "rateTemplate": "Schéma de tarification",
        "rateTemplateNote": "Le calcul du tarif utilisé pour déterminer le montant payé au chauffeur ou au fournisseur.",
        "percent": "Commission de la flotte",
        "percentNote": "Le pourcentage facturé par la flotte sur chaque réservation.",
        "amount": "Montant fixe",
        "amountNote": "Le montant que la flotte déduit pour chaque réservation.",
        "supplierPenaltyId": "Politique de pénalité fournisseur",
        "payoutType": "Type",
        "Select_penalty_policy": "Sélectionner une politique de pénalité",
        "Select_corporate": "Select Corporate",
        "Select_supplier_plan": "Sélectionner un plan fournisseur",
        "Create_supplier_plan_success": "Le plan fournisseur a été créé avec succès",
        "Create_supplier_plan_fail": "Des erreurs sont survenues lors de la création du plan fournisseur",
        "Update_supplier_plan_success": "Le plan fournisseur a été mis à jour avec succès",
        "Update_supplier_plan_fail": "Des erreurs sont survenues lors de la mise à jour du plan fournisseur",
        "Payout_Plan": "Plan de paiement",
        "Payout_Plan_note": "Définir le montant payé au fournisseur.",
        "default": "Par défaut",
        "custom": "Plan personnalisé",
        "cannotSetPayout": "Impossible de définir un plan de paiement pour le chauffeur d'un partenaire externe."
    },
    "stopSales": {
        "stopSales": "Arrêt de vente",
        "confirm_delete": "Êtes-vous sûr de vouloir supprimer cette police ?",
        "Create_stop_sales_success": "L'arrêt des ventes a été créé avec succès.",
        "Create_stop_sales_fail": "Les erreurs se sont produites lors de la création des arrêts de vente.",
        "Update_stop_sales_success": "La vente arrêtée a été mise à jour avec succès.",
        "Update_stop_sales_fail": "Les erreurs se sont produites lors de la mise à jour des arrêts de vente.",
        "Delete_success": "La vente arrêtée a été supprimée avec succès.",
        "Delete_fail": "Les erreurs se sont produites lors de la suppression des ventes à l'arrêt.",
        "allVehicle": "Tous les véhicules",
        "allZone": "Tous les Zones"
    },
    "generalSetting": {
        "alertNotifications": {
            "title": "Notifications d'alerte",
            "emails": "Emails",
            "emailsPlaceholder": "Saisir un email",
            "slack": "Canal Slack (Instructions)",
            "slackPlaceholder": "URL de publication Slack",
            "discord": "Canal Discord (Instructions)",
            "discordPlaceholder": "Saisir le canal Discord",
            "telegram": "Canal Telegram (Instructions)",
            "telegramPlaceholder": "Saisir le canal Telegram"
        },
        "showFare": {
            "title": "Afficher le tarif au chauffeur",
            "totalFare": "Tarif total",
            "estimateGross": "Estimation du revenu brut"
        },
        "carHailing": "Hélage de rue",
        "regular": "Régulier",
        "cancelTimeout": "Annuler automatiquement les réservations expirées",
        "allowStripePaymentLink": "Autoriser la génération d'un lien de paiement Stripe",
        "flat": "Fixe",
        "techFee": "Frais de technologie par transaction",
        "customizeLogo": "Personnaliser le logo du tableau de bord",
        "logo": "Logo",
        "customerApp": "Application client",
        "hourly": "Horaire",
        "shuttle": "Navette",
        "parcel": "Colis ",
        "freeCancelTime": "Nombre d'annulations gratuites par jour",
        "AM": "Matin",
        "PM": "Après-midi",
        "RUSH_HOUR": "Surtaxe",
        "Name": "Nom",
        "Date": "Date",
        "Mon": "Lun",
        "Tue": "Mar",
        "Wed": "Mer",
        "Thu": "Jeu",
        "Fri": "Ven",
        "Sat": "Sam",
        "Sun": "Dim",
        "Time_range": "Intervalle de temps",
        "From": "De",
        "To": "À",
        "Rush_hour_time_calculation": "Calcul d'heure de pointe",
        "Rush_hour_surcharge": "Heure de pointe",
        "Required_fields": "Champs requis",
        "Save": "Sauvegarder",
        "Cancel": "Annulé",
        "MDISPATCHER_CANCELLATION": "Annulation de réservation web/passagers/mDispatcher",
        "Book_now": "Réserver maintenant",
        "MDISPATCHER_CANCELLATION_TOOLTIP": "Annulation de réservation Pax / Partenaire / Web",
        "Book_now_toolTip": "Des frais d'annulation sont applicables si les réservations à la demande sont annulées dans les",
        "Book_later_toolTip": "Des frais d'annulation sont applicables si une réservation est annulée dans les avant l'heure de prise en charge",
        "Drv_Book_now_toolTip": "Des frais d'annulation s'appliquent si les réservations à la demande sont annulées dans le délai défini, à partir du moment de l'acceptation",
        "Drv_Book_later_toolTip": "Des frais d'annulation s'appliquent si les réservations anticipées sont annulées dans le délai défini, avant l'heure de prise en charge prévue",
        "Free_cancel": "Durée d'annulation gratuite",
        "Hide_cancel_btn": "Masquer le bouton d'annulation après les délais définis",
        "Driver_cancellation": "Annulation par le chauffeur",
        "Time_day": "Nombre de fois par jour",
        "Duration": "Durée",
        "Times": "Fois",
        "Book_later": "Réserver plus tard",
        "Intercity": "Interurbain",
        "Intercity_tooltip": "Des frais d'annulation s'appliquent si une réservation interurbaine est annulée dans le délai défini, avant l'heure de prise en charge.",
        "MDISPATCHER_NO_SHOW": "Non présentation",
        "AIRPORT_FEE": "Frais Aéroport",
        "From_airport": "De l'aéroport",
        "To_airport": "Vers l'aéroport",
        "MEET_DRIVER": "Rencontrez Driver",
        "On_curb": "Sur le trottoir",
        "Meet_Greet": "Accueil personnalisé",
        "Add": "Ajouter",
        "Edit": "Modifier",
        "DELETE_SURCHARGE": "Supprimer la surtaxe",
        "DELETE_SERVICE": "Supprimer le service",
        "CHANGE_APPLY_SERVICE_FEES": "Modifier l'application des frais de service",
        "DELETE_CONFIRM": "Do you want to delete this item?",
        "DELETE_SURCHARGE_CONFIRM": "Êtes-vous sûr de vouloir supprimer la surtaxe sélectionnée ?",
        "DELETE_ADDITIONAL_SERVICES_CONFIRM": "Êtes-vous sûr de vouloir supprimer le service sélectionné ?",
        "CHANGE_APPLY_SERVICE_FEES_CONFIRM_CUSTOM": "Êtes-vous sûr de demander des frais différents pour les zones séparées?",
        "CHANGE_APPLY_SERVICE_FEES_CONFIRM_ALL": "Êtes-vous sûr de vouloir appliquer les mêmes frais pour toutes les zones?",
        "EDIT_SERVICE_FEES": "Modifier les frais de service",
        "EDIT_SERVICE_FEES_CONFIRM": "Êtes-vous sûr de vouloir partir sans enregistrer les paramètres de %{currentZone}?",
        "HEAVY_TRAFFIC": "Circulation dense",
        "Heavy_traffic_surcharge": "Supplément pour circulation dense",
        "TOLL_FEE": "Frais de péage",
        "parkingFee": "Frais de stationnement",
        "gasFee": "Frais de carburant",
        "OTHER_FEES": "Autres frais",
        "Can_edit": "Capable de modifier",
        "Can_add_note": "Capable de Ajouter une note",
        "Other_fees_amount": "Montant des autres frais",
        "TAX": "Taxe",
        "Tax_surcharge": "Supplément de taxe",
        "TIP": "Pourboire",
        "Default_tip": "Pourboire par défaut",
        "RESERVATION_REMINDER": "Rappel de réservation",
        "Driver_app_SMS_alert_before": "Application Chauffeur - SMS & alerte avant",
        "notifyWhenDriverFailStartTrip": "Notifier l'opérateur si le chauffeur ne démarre pas le trajet avant l'heure de prise en charge",
        "notifyWhenDriverFailStartTripTooltip": "Les notifications seront affichées dans la section des notifications de la plateforme. Vous pouvez également configurer des alertes à envoyer par e-mail, Slack, Discord ou Telegram pour des mises à jour en temps réel.",
        "Pax_app_alert_before": "Application utilisateur - alerter avant",
        "Confirm_driver_info_via_email_before": "Envoyer une confirmation de réservation par e-mail/SMS au client avant",
        "Confirm_driver_info_via_email_before_hint": "Le système enverra une confirmation de réservation au client en fonction du délai défini, avant l'heure de prise en charge.",
        "Show_request_tab_on_driver_app": "Afficher l'onglet \"Demande\" sur l'application chauffeur",
        "Show_preferred_tab_on_driver_app": "Afficher l'onglet \"Préféré\" sur l'application chauffeur",
        "Sound_notification": "Notification sonore",
        "Advance_information": "Information avancée du voyageur d'entreprise",
        "Load_general_fail": "Des erreurs sont survenues lors du chargement des réglages généraux",
        "Update_general_success": "Les réglages généraux ont bien été mis à jour",
        "Update_general_fail": "Des erreurs sont survenues en mettant à jour les réglages généraux",
        "Time_over_lap": "Les intervalles de temps ne doivent pas se chevaucher les uns avec les autres",
        "Allow_passenger_to_register_as_corp_traveler": "Permettre au passager de s'inscrire comme voyageur de corp",
        "Not_Allow_Make_Booking_Without_Assign_Fare": "Ne pas permettre aux clients de faire une réservation si le tarif de base = 0.00",
        "Not_Allow_show_car_type_on_cc": "Ne pas afficher le type de voiture sur CC si aucun tarif n'est attribué",
        "Disable_Direct_Invoicing_Receipt_Email": "Désactiver l'e-mail de réception de facture directe",
        "Additional_services": "Services supplémentaires",
        "Edit_additional_services": "Modifier les services supplémentaires",
        "Service_Fee_By_Currencies": "Frais de service",
        "Service_type": "Type de service",
        "Optional": "Facultatif",
        "Compulsory": "Obligatoire",
        "Vehicle_type": "Type de véhicule",
        "Adding_additional_service_success": "Add Service success",
        "Update_additional_service_success": "Update service success",
        "Delete_additional_service_success": "Le service a été supprimé avec succès",
        "Adding_additional_service_fail": "Add Service fail",
        "Update_additional_service_fail": "Update service fail",
        "Other_settings": "Autres réglages",
        "Operator_assign_error": "Operator assign errors",
        "Create_surcharge_success": "Create surcharge success",
        "Update_surcharge_success": "Update surcharge success",
        "Delete_surcharge_success": "Delete surcharge success",
        "Create_surcharge_fail": "Create surcharge failed",
        "Update_surcharge_fail": "Update surcharge failed",
        "Delete_surcharge_fail": "Delete surcharge failed",
        "Get_surcharge_detail_fail": "Get surcharge detail failed",
        "Repeat": "Répéter",
        "DayOfWeek": "Jour de la semaine",
        "SingleDay": "Une seule fois",
        "Yearly": "Tous les ans",
        "Backup_phone_number": "Backup phone number",
        "Backup_phone_number_hint": "Rediriger vers ce numéro lorsque le chauffeur et le passager sont hors des zones d'opération",
        "Apply_countdown_clock": "Appliquer le compte à rebours",
        "No_show_duration_tooltip": "Configurez l’intervalle de durée entre le moment où le chauffeur clique sur « Arrivé » et l’affichage du bouton « No Show »",
        "Limit_radius": "Rayon limite",
        "Limit_radius_tooltip": "Le conducteur peut signaler une réservation comme non-présentation dans ce rayon",
        "Limit_radius_arrive_pickup": "Rayon limite d'arrivée et de prise en charge du conducteur pour la réservation du transport",
        "Booking_validation": "Validation des réservations",
        "Invalid_period_of_time": "Période de temps invalide",
        "hide_Provider_Filter_From_Corporate_Board": "Cacher le filtre des fournisseurs au conseil d'administration de l'entreprise",
        "customer_email_is_optional": "L'email du client est facultatif sur l'application client",
        "disable_hourly_rate": "Désactiver le taux horaire lorsque le taux horaire et le taux fixe sont tous deux disponibles.",
        "customer_gender_is_compulsory": "Le numéro d'identification du client / numéro d'identification national est obligatoire sur l'application pour les clients.",
        "SHOW_MAP_STATUS": "Afficher l'état de la carte",
        "Pay_to": "Payer à",
        "EMERGENCY_SOS": "SOS d'urgence",
        "customer_address_is_compulsory": "Le sexe du client est obligatoire sur l'application clients",
        "customer_id_is_compulsory": "L'ID# / Carte d'identité nationale du client est obligatoire sur l'application passager",
        "allowPassengerToUploadDocument": "Permettre au client de télécharger le document ID# / National IC#.",
        "compulsoryNationalIcDocumentInPaxApp": "Le document ID# / Carte d'identité nationale du client est obligatoire sur l'application Pax",
        "doNotAllowAddDriverWhenNationalIdDuplicated": "Ne pas autoriser l'opérateur à ajouter un conducteur lorsque la carte d'identité nationale est dupliquée.",
        "forceCustomerToUseLiveLocation": "Obliger le client à utiliser la localisation en direct",
        "disableMarketPlace": "Désactiver le marché pour les nouveaux chauffeurs",
        "dontShowSecondStageImmediately": "Masquer l'inscription de l'étape 2",
        "dontAddCarMM": "Ne pas permettre au conducteur d'ajouter une nouvelle marque/modèle de voiture.",
        "dontEditCapability": "Do not allow Driver to edit Driver Capability",
        "compulsoryCarInsurance": "L'assurance automobile du chauffeur est obligatoire",
        "marketPlace": "Marché",
        "Enable": "Activer",
        "Disable": "Désactiver",
        "showTotalFareWithoutPromotionOnDriverApp": "Afficher le tarif total sans promotion sur l'application conducteur",
        "showTotalFareWithoutPromotionOnDriverApp_hint": "Transport : appliquer ce paramètre avant que le chauffeur effectue le paiement. <br/> - Livraison & Interurbain : appliquer ce paramètre avant que le chauffeur commence la mission.",
        "hideFareOnPaxAppForAllCorporateBookings": "Masquer le tarif sur l'application Pax pour toutes les réservations d'entreprise",
        "hidePaxNameAvatarOnDispatchScreen": "Cacher les informations client sur l'application conducteur avant le début du trajet",
        "showFullCustomerNameOnDriverApp": "Afficher le nom complet du client sur l'application chauffeur",
        "hideDriverLogoutBtn": "Masquer le bouton de déconnexion du chauffeur sur l'application chauffeur",
        "showMeetAndGreetButtonForEveryBooking": "Afficher le bouton \"Accueil personnalisé\" pour chaque réservation",
        "showEcontract": "Afficher le bouton E-Contract",
        "isShowConfirmationCode": "Afficher le code de confirmation de réservation",
        "showIncidentReportButton": "Afficher le bouton d'incident",
        "inReviewStatus": "Statut en révision",
        "inReviewStatusTooltip": "Marque une réservation comme « En révision ». Le voyage reste actif jusqu'à ce que l'opérateur le clôture.",
        "incidentBtnDrvApp": "Afficher le bouton \"Incident\" dans l'application Driver",
        "incidentBtnDrvAppTooltip": "Ajoute un bouton sur les trajets actifs pour que les conducteurs signalent des incidents, que l'opérateur peut ensuite examiner et clôturer.",
        "fareChangeTolerance": "Tolérance de changement de tarif",
        "fareChangeToleranceTooltip": "Les changements de tarif supérieurs à ce % nécessitent une approbation manuelle par l'opérateur.",
        "groupManifest": "Manifeste de groupe",
        "JobOrderedBy": "Travail commandé par",
        "optional": "Optionnel",
        "pickupTime": "Heure de ramassage",
        "route": "Route",
        "settings": "Réglages",
        "Default_value": "Valeur par défaut",
        "limitTopupAmount": {
            "valueByCurrencies": "Montant d'alerte",
            "minimumByCurrencies": "Montant minium pour recharger",
            "maximumByCurrencies": "Montant minium pour recharger",
            "title": "Montant minimum et maximum de rechargement"
        },
        "driverApp": "Application conducteur ",
        "passengerApp": "Application Clients",
        "Default_Topup_Values": "Valeurs de recharge par défaut",
        "service_fees": "Frais de service",
        "commission_fleet": "commission flotte",
        "apply_all": "La même chose pour toutes les zones d'opération",
        "apply_custom_zone": "Séparé dans chaque zone d'opération",
        "apply": "Appliquer",
        "tollFeeDriverCanInput": "Limiter le montant que le conducteur peut saisir",
        "unlimited": "Illimité ",
        "limited": "Limité ",
        "sameFee": "Même tarif",
        "customizedAirportfee": "Personnaliser les frais",
        "noteAirportFeeModal": "Remarque : Les frais d'aéroport ne sont appliqués qu'aux aéroports figurant sur la liste.",
        "intercity_schedule_trip_time_range": "Pour garantir l'ordre chronologique des réservations, veuillez vous assurer que la plage horaire des trajets préférés/demandés est plus grande que celle des trajets programmés.",
        "airportFee": {
            "tooltipApply": "Les frais d'aéroport par défaut seront appliqués à chaque trajet depuis/vers l'aéroport. Si les frais d'aéroport sont personnalisés, les nouveaux frais seront appliqués à cet endroit.",
            "titleSearchAiportZone": "Veuillez rechercher votre aéroport et ajouter vos frais",
            "airport": "Aéroport",
            "currency": "Devise",
            "fromAirportFee": "Frais depuis l'aéroport",
            "toAirportFee": "Frais vers l'aéroport",
            "action": "Actions"
        },
        "Yes": "Oui",
        "No": "Non",
        "tipPaymentMethod": "Méthodes de paiement disponibles pour que le client fasse basculer son chauffeur après le trajet",
        "allowPaxUpdateTip": "Autoriser le passager à mettre à jour le pourcentage du pourboire pendant le trajet",
        "tipDefaultValues": "Astuce par défaut après le trajet",
        "creadit": "Credit card (Carte personnelle / Corporate card)",
        "wallet": "Portefeuille",
        "tnGeWallet": "Portefeuille électronique TnG",
        "vippseWallet": "Vipps",
        "DurationRegularBooking": "Duration (for regular bookings)",
        "googlePay": "Google Pay",
        "applePay": "Apple Pay",
        "DurationRegularBookingToolTip": "No show\" button will be displayed in after the driver taps on \"Arrived\" button on Driver app.",
        "noShowCountDown": {
            "customizedNoShow": "Personnalisation pour des lieux spéciaux (aéroport, par exemple)",
            "customizedNoShowTitle": "Appliquer la durée du compte à rebours pour les lieux spéciaux (par exemple, un aéroport, etc.)"
        },
        "maxWaitTime": "Temps d'attente supplémentaire maximal",
        "maxWaitTimeToolTip": "Il s'agit du temps d'attente supplémentaire maximal qui sera facturé au client. Vous avez la possibilité de personnaliser les frais par minute dans vos paramètres de tarification.",
        "maxWaitTimePlaceholder": "Temps d'attente facturé maximal",
        "HEAT_MAP": "Carte de la demande",
        "heatMap": {
            "defaultMode": "Mode par défaut",
            "radius": "Rayon",
            "intensity": "Intensité",
            "opacity": "Opacité",
            "requestedBookings": "Réservations demandées",
            "activePassengers": "Passagers actifs",
            "completedBookings": "Modification du solde",
            "timeoutBookings": "Réservations expirées",
            "tooltipRadius": "Le rayon d'influence de chaque point de données, en pixels.",
            "tooltipIntensity": "L'intensité maximale de la carte thermique.",
            "tooltipOpacity": "L'opacité de la carte thermique, exprimée sous forme d'un nombre entre 0 et 1."
        },
        "schedule_trip": "Programmer un trajet",
        "driver_starts_trip_before_set_time": "Le chauffeur commence le trajet avant l'heure définie",
        "request_trip": "Demander un trajet",
        "preferred_trip": "Trajet préféré",
        "time_range": "Plage horaire pour les trajets demandés et préférés",
        "working_time": "Temps de travail",
        "hour": "heure",
        "hours": "heures",
        "minutes": "minutes",
        "indicate_pickup_time_in_advance_to_customer": "Indiquer l'heure de prise en charge à l'avance au client.",
        "customers_can_select_start_time_and_request_intercity_trip": "Les clients peuvent sélectionner l'heure de départ et demander un trajet interurbain. Les chauffeurs peuvent également créer leur trajet préféré selon leur propre planning. Exemple : une plage horaire de 1 heure permettra aux clients et aux chauffeurs de créer un trajet interurbain commençant entre 8h00 - 9h00, 9h00 - 10h00 ou 10h00 - 11h00.",
        "this_setting_limits_customers_to_create_request_trip_within_working_hours_only": "Ce paramètre limite les clients à créer des demandes de trajet uniquement pendant les heures de travail.",
        "face_mask_verify": "Vérification du port du masque",
        "faceMask_allZones": "Toutes les zones",
        "faceMask_customized": "Zone personnalisée",
        "turn_on_verify": "Activer la vérification",
        "force_to_wear_face_mask": "Obliger à porter un masque",
        "time_range_to_verify": "Ne pas revérifier dans",
        "customizedFaceMaskZone": "Vérification personnalisée du port du masque",
        "zoneOperation": "Zone d'opération",
        "FaceMaskCustomized": "Personnalisé",
        "time": "heure",
        "day": "jour",
        "days": "jours",
        "allow_driver_to_skip_verification_after": "Autoriser le chauffeur à ignorer la vérification après",
        "driver_need_to_verify": "Quand le chauffeur doit vérifier",
        "open_app": "Ouvrir l'application",
        "start_reservation": "Commencer la réservation",
        "choose_at_least_one": "Vous devez sélectionner au moins une action pour continuer.",
        "face_mask_customized_fail": "Vous devez sélectionner au moins une action pour continuer ({0}).",
        "vehicleAgeLimit": "Limite d'âge des véhicules",
        "vehicleAgeLimit_years": "années",
        "founderFund_firstBooking": "Founder's Fund : première réservation uniquement",
        "distance_diversity": "Diversité des distances",
        "Add_Surcharge_Distance": "Ajouter",
        "from": "De ",
        "to": "À ",
        "surchargeValue": "Taxes ",
        "actions": "action",
        "please_enter_distance_range_valid": "La distance %{name} est invalide !",
        "please_enter_distance_to": "Veuillez entrer la distance \"Vers",
        "please_enter_surchargeValue": "Veuillez entrer la distance \"Surtaxe\" pour la plage de distance %{name}",
        "please_enter_surchargeValue_is_number": "Veuillez entrer un nombre valide pour \"Surtaxe\" pour la plage de distance %{name}",
        "Update_service_fee_success": "Les frais de service ont été mis à jour avec succès",
        "Update_service_fee_fail": "Des erreurs sont survenues lors de la mise à jour des frais de service",
        "Update_fleet_commission_success": "La commission de flotte par défaut a été mise à jour avec succès",
        "Update_fleet_commission_fail": "Des erreurs sont survenues lors de la mise à jour de la commission de flotte par défaut",
        "RESERVATION_POLICY": "Politique de réservation",
        "default_expected_pickup_time": "Heure de prise en charge prévue par défaut",
        "default_expected_pickup_time_hint": "La valeur par défaut à laquelle vous attendez qu'un chauffeur arrive à partir de l'heure de prise en charge.",
        "same_original_pickup_time": "Identique à l'heure de prise en charge initiale",
        "quarter_before": "15 min avant",
        "half_before": "30 min avant",
        "quarter_after": "15 min après",
        "half_after": "30 min après",
        "custom": "Personnalisé",
        "min_before": "min avant",
        "min_after": "min après",
        "TransactionFee": "Frais de transaction",
        "creditCardPercent": "Carte de crédit / prépayée",
        "directBilling": "Facturation directe",
        "externalCard": "External Card",
        "zoneIds": "Emplacements",
        "vehicles": "Véhicules",
        "default_expected_pickup_time_airport": "Temps de ramassage prévu par défaut (Arrivées aéroport)",
        "expectedPickupTooltip": "Si un numéro de vol est fourni, ce tampon par défaut sera appliqué pour calculer automatiquement l'heure de prise en charge. Cela s'applique uniquement aux réservations créées via le tableau de bord administrateur."
    },
    "social": {
        "pax_app": "Application passager",
        "driver_app": "Application chauffeur",
        "default": "Par défaut",
        "customized": "Personnalisé",
        "html": "HTML",
        "about": "À propos",
        "email": "Support par e-mail",
        "enablePhone": "Numéro de téléphone",
        "phone": "",
        "policy": "Lien vers la politique de confidentialité",
        "termOfUse": "Lien vers les conditions d'utilisation",
        "site": "Site web",
        "logoDriverIOS": "Logo - iOS",
        "logoDriverAndroid": "Logo - Android",
        "htmlUrl": "Fichier HTML",
        "Update_fail": "Des erreurs sont survenues lors de la mise à jour des réseaux sociaux",
        "Update_success": "Les réseaux sociaux ont été mis à jour avec succès"
    },
    "user": {
        "Show_per_page": "Eléments par page",
        "Page": "Page",
        "Search_here": "Rechercher ici",
        "show_pages": "{0} - {1} de {2} Affiche",
        "Username": "Nom D'utilisateur",
        "Name": "Nom",
        "Phone_number": "Numéro De Téléphone",
        "Email": "Email",
        "Permission": "Permission",
        "Status": "Statut",
        "Actions": "Actions",
        "Active": "Actif",
        "Inactive": "Inactif",
        "Edit": "Modifier",
        "Deactivate": "Désactiver",
        "Delete": "Effacer",
        "Add": "Ajouter",
        "ADD_USER": "Ajouter un utilisateur",
        "First_name": "Prénom",
        "Last_name": "Nom",
        "AgendId": "Utilisateur #",
        "Email_address": "Adresse e-mail ",
        "Address": "Adresse",
        "Required_fields": "Champs requis ",
        "Save": "Sauvegarder",
        "Cancel": "Annuler",
        "EDIT_USER": "Modifier l'utilisateur",
        "Yes": "Oui",
        "DELETE_USER": "Effacer l'utilisateur",
        "DETAIL_USER": "Infos utilisateur",
        "DELETE_CONFIRM": "Êtes-vous sûr de supprimer l'utilisateur?",
        "Update_user_fail": "Des erreurs sont survenues lors de la mise à jour de l'utilisateur",
        "Update_user_success": "L'utilisateur a bien été mis à jour",
        "Create_user_fail": "Des erreurs sont survenues lors de la création de l'utilisateur",
        "Create_user_success": "Le compte {0} a bien été créé. Veuillez vérifier le mail {1} pour les détails de certificat",
        "Load_user_fail": "Des erreurs sont survenues lors du chargement de l'utilisateur",
        "Update_user_status_fail": "Des erreurs sont survenues lors de la mise à jour du statut de l'utilisateur",
        "Delete_user_fail": "Des erreurs sont survenues lors de la suppression de l'utilisateur",
        "Delete_user_success": "L'utilisateur a bien été supprimé",
        "CONFIRM_RESET_PASSWORD": "Voulez-vous réinitialiser le mot de passe?",
        "RESET_PASSWORD": "Voulez-vous réinitialiser le mot de passe?",
        "Reset_password": " Réinitialiser le mot de passe",
        "Select_permission": "Sélectionnez Permission ",
        "Reset_password_success": "Réinitialisation de mot de passe effectuée"
    },
    "report": {
        "query": {
            "errorMessage": {
                "bookFrom": "Veuillez sélectionner le moyen de réservation",
                "paymentMethod": "Veuillez sélectionner un mode de paiement",
                "bookingType": "Veuillez sélectionner un type de réservation",
                "ratingType": "Veuillez sélectionner un type de tarification",
                "stars": "Veuillez sélectionner un type de tarification",
                "type": "Type",
                "transactionType": "Veuillez sélectionner un type de transaction",
                "serviceType": "Veuillez sélectionner un type de service",
                "rideService": "Veuillez sélectionner un service de transport",
                "invalidEmail": "Veuillez spécifier un numéro de email valide"
            },
            "search": {
                "driverReferalPax": "Recherche : Nom du chauffeur, Numéro de téléphone",
                "passengerRefersPassengers": "Recherche : Nom du client, Numéro de téléphone",
                "driverReferalPaxDetail": "Recherche : Nom du passager",
                "bookingDetails": "Rechercher: Numéro de réservation, Opérateur, Téléphone client, Nom du client, Nom du chauffeur, ID/ Permis du chauffeur, Plaque d'immatriculation, Zone de file, Note",
                "financial": "Rechercher: Nom du chauffeur, Téléphone",
                "completedTime": "Temps de finalisation",
                "collectedTime": "Temps de collecte",
                "financialDriver": "Rechercher: Numéro de réservation, Nom du chauffeur, ID/ Permis du chauffeur",
                "carActivity": "Rechercher: Plaque d'immatriculation",
                "affiliation": "Rechercher: Numéro de réservation",
                "prepaidTopUp": "Rechercher: Nom de la compagnie, ID d'approvisionnement, ID transaction",
                "operatorLogs": "Rechercher: Nom de l'Opérateur, nom d'utilisateur",
                "corporate": "Rechercher: Numéro de réservation, Nom du chauffeur, Voyageur d'entreprise, Référence du client, Code de frais",
                "bookingLogs": "Rechercher: Numéro de réservation, Nom du client, Nom du chauffeur, ID/ Permis du chauffeur",
                "rating": "Rechercher: Numéro de réservation, Numéro du client, Nom du client",
                "mDispatcher": "Rechercher: Numéro de réservation, Nom du mDispatcher",
                "totalAdjustment": "Rechercher: Numéro de réservation",
                "incidentCancellation": "Rechercher: Numéro de réservation, Numéro du client, Nom du client",
                "acceptanceCancellationRate": "Recherche : Nom du chauffeur, Numéro de téléphone",
                "revenueDriver": "Rechercher: Nom du chauffeur",
                "dailyDriver": "Rechercher: Numéro du chauffeur, Nom du chauffeur, ID du chauffeur/Permis",
                "dailyCar": "Rechercher: Plaque d'immatriculation, Permission",
                "dailyDriverCar": "Rechercher: Numéro du chauffeur, Nom du chauffeur, ID du chauffeur/Permis, Plaque d'immatriculation",
                "driverLoginStatus": "Rechercher: Numéro du chauffeur, Nom du chauffeur, ID du chauffeur/Permis, Plaque d'immatriculation",
                "bookingSummary": "Rechercher: Nom de l'Opérateur, nom d'utilisateur, numéro de réservation",
                "creditWallet": "Rechercher: Nom de la compagnie, Driver name, Booking ID, Operator",
                "cashWallet": "Rechercher: Nom de la compagnie, Driver name, Booking ID, Phone number",
                "SupplierWallet": "Recherche : Nom de l'entreprise, ID de réservation",
                "settlement": "Rechercher: Nom du chauffeur, ID/Permis du chauffeur",
                "driverRating": "Rechercher: Numéro de réservation, Numéro du client, Nom du client",
                "driverWithdrawal": "Driver name, Phone, Company, ID de la transaction, Reference #",
                "penaltyCompensation": "Recherche : ID de réservation, Nom du chauffeur, Nom du passager",
                "incompletePayment": "Recherche : ID de réservation, ID du support, Nom du client",
                "passengerWallet": "Search: Booking ID, Customer Name",
                "driverDeposit": "Rechercher: Nom de la compagnie, Driver name, Booking ID, Operator",
                "refund": "Search: Booking ID, Trip Id, Customer name",
                "driverRefersCustomerBookings": "Search: Referral code",
                "driverHistory": "Recherche : ID de paiement",
                "merchantHistory": "Recherche : ID de paiement",
                "firstWillWin": "Recherche : Nom du client, Téléphone du client, ID du client",
                "firstWillWinDriver": "Recherche : Nom du chauffeur, Téléphone du chauffeur, Nom d'utilisateur",
                "merchant": "Recherche : Magasin",
                "merchantCashTransactionHistory": "Search: Booking ID, ID de la transaction, Merchant name",
                "merchantCreditTransactionHistory": "Search: Booking ID, ID de la transaction, Merchant name",
                "deleteAccountRequest": "Recherche : Téléphone",
                "affiliationPayoutHistory": "Recherche : ID de paiement",
                "thirdPartyBooking": "Recherche : ID de réservation, ID externe"
            },
            "common": {
                "all": "Tous"
            },
            "today": "Aujourd'hui",
            "sendDownloadLink": "Adresse e-mail du destinataire",
            "generaltingYourExcel": "Veuillez noter que la génération de votre fichier Excel peut prendre du temps. Nous vous l'enverrons par e-mail dès qu'il sera prêt.",
            "messageSuccess": "Fichier en cours de traitement. Vous recevrez un e-mail lorsqu'il sera prêt. Suivez la progression ou téléchargez-le directement",
            "thisMonth": "Ce mois-ci",
            "lastMonth": "Le mois dernier",
            "past30Days": "Depuis 30 jours",
            "thisYear": "Cette année",
            "custom": "Personnalisé",
            "customize": "Personnalisez",
            "thisWeek": "Cette semaine",
            "past7Days": "7 derniers jours",
            "weekly": "Hebdomadaire",
            "monthly": "Mensuel",
            "allTime": "Toutle temps",
            "tomorrow": "Demain",
            "nextWeek": "Semaine prochaine",
            "lastWeek": "La semaine dernière",
            "nextMonth": "Mois prochain",
            "next7Day": "Les 7 prochains jours",
            "yesterday": "Hier",
            "fromDate": "A partir de la date",
            "toDate": "Jusqu'à",
            "driver": "Pilotes: %{name}",
            "customer": "Client : %{name}",
            "referralCode": "Code de parrainage : %{name}",
            "referer": "Referer: %{name}",
            "referee": "Parrainé : %{name}",
            "usedPromoCode": "Promotion : %{name}",
            "voucherCode": "Code : %{name}",
            "city": "Ville",
            "company": "Compagnie",
            "company_report": "Compagnie: %{name}",
            "companySupplier_report": "Fournisseur/Entreprise : %{name}",
            "supplier_report": "Fournisseur : %{name}",
            "corporate_report": "Entreprise : %{name}",
            "campaign_report": "rapport de campagne: %{name}",
            "operator": "Opérateur ",
            "farmType": "Type de ferme",
            "carLicensePlate": "Plaque d'immatriculation du véhicule: %{name}",
            "settlementType": "Type",
            "bookingService": "Type de réseau",
            "payoutOption": "Option de paiement",
            "currency": "Devise",
            "bookingFrom": "Réservé de",
            "Provider": "Fournisseur",
            "thirdPartyAction": "Action",
            "paymentMethod": "Mode de paiement",
            "paymentStatus": "Statut de paiement",
            "bookingType": "Type de réservation",
            "adjustPrice": "Ajuster le prix",
            "intercityRoute": "Itinéraire interurbain",
            "ratingType": "Type d'évaluation",
            "stars": "Étoile",
            "driverRating": "Évaluation du chauffeur",
            "vehicleRating": "Évaluation du véhicule",
            "mDispatcherType": "Type mDispatcher",
            "mDispatcher": "Dispatcher name",
            "campaign": "Campagne",
            "promocode": "Code promo",
            "canceledBy": "Annulé par",
            "timezone": "Fuseau horaire",
            "month": "Mois",
            "year": "Année",
            "view": "Voir",
            "action": "action",
            "status": "Statut",
            "module": "Module",
            "driverType": "Type",
            "vehicleType": "Type de véhicule",
            "serviceType": "Type de service",
            "expireDate": "Date d'expiration",
            "rideSharing": "Partage de course",
            "rideService": "Service de transport",
            "transactionType": "Type de transaction",
            "completeFromCC": "Complété depuis CC",
            "withDrawalTransactionType": "Type de transaction",
            "bookingStatus": "Statut de réservation",
            "withdrawalStatus": "Statut",
            "originalStatus": "État du paiement initial",
            "currentStatus": "État actuel du paiement",
            "tip": "Pourboire",
            "type": "Type",
            "userType": "Type d'utilisateur",
            "eventType": "Type d'événement",
            "eventState": "État de l'événement",
            "eventName": "Nom de l'événement",
            "merchantType": "Type de marchand",
            "merchantService": "Service marchand",
            "storeName": "Magasin",
            "merchant": "Vendeur",
            "event": "Nom de l'événement : %{name}",
            "store": "Nom du magasin : %{name}",
            "selectedMerchant": "Marchand : %{name}",
            "associatedApps": "Applications associées",
            "settlement": "Règlement",
            "rideServiceItem": {
                "all": "Tous",
                "regulation": "Règlement",
                "rideSharing": "Partage de course"
            },
            "actionItem": {
                "all": "Tous",
                "login": "S'identifier",
                "logout": "Se déconnecter",
                "bookIn": "Disponible",
                "bookOff": "Indisponible",
                "deny": "Refuser",
                "ignore": "Ignorer",
                "accept": "Accepter",
                "startTrip": "En route",
                "updateBooking": "Mettre à jour",
                "arrive": "Arrivé",
                "pickup": "Pris en charge",
                "drop": "Déposer",
                "complete": "Terminer",
                "noShow": "Non présentation",
                "driverNoShow": "Absence du conducteur",
                "rqJob": "En dispatch",
                "cancel": "Annuler"
            },
            "loginStatusItem": {
                "all": "Tous",
                "online": "Connexion",
                "offline": "Déconnecté"
            },
            "payoutType": "Type de paiement",
            "affiliationPayoutTypeItem": {
                "auto": "Paiement automatique",
                "manual": "Paiement manuel"
            },
            "affiliationSettlementItem": {
                "payable": "Payable",
                "receivable": "Recevable"
            },
            "affiliationPaymentMethod": {
                "online": "En ligne",
                "directInvoicing": "Facturation directe"
            },
            "payoutPaymentStatusItem": {
                "paid": "Payé",
                "pending": "En attente"
            },
            "farmTypeItem": {
                "all": "Tous",
                "farmIn": "Ferme en",
                "farmOut": "Ferme hors",
                "roaming": "Itinérance",
                "affiliationOwner": "Propriétaire de l'affiliation",
                "farmInAndAffiliationOwner": "Ferme en & propriétaire de l'affiliationr",
                "farmOutAndAffiliationOwner": "Ferme hors & propriétaire de l'affiliation"
            },
            "settlementDriverTypeItem": {
                "all": "Tous les Driver",
                "individual": "Conducteur individuel"
            },
            "shortTrip": {
                "all": "Tout",
                "shortTrip": "Court trajet",
                "nonShortTrip": "Trajet non court"
            },
            "paymentMethodItem": {
                "B2BTerminal": "Terminal B2B",
                "webBooking": "Réservation en ligne",
                "pendingPayment": "Paiement en attente",
                "all": "Tous",
                "cash": "Paiement à bord",
                "cashBySender": "Payé par l'expéditeur",
                "cashByRecipient": "Cash par le destinataire",
                "personalCard": "Carte bleue",
                "corporateCard": "Carte d'entreprise",
                "qrCodePayment": "Paiement par code QR",
                "directBilling": "Facturation directe",
                "externalCard": "Carte externe",
                "mDispatcherCard": "Carte Concierge",
                "corporatePrepaid": "Payé via Wallet ",
                "canceled": "Annulé",
                "noShow": "Non présentation",
                "driverNoShow": "Non-présentation du conducteur",
                "incident": "Incident",
                "fleetCard": "Carte externe",
                "applePay": "Apple Pay",
                "creditCardExternal": "Carte de crédit",
                "paxWallet": "Portefeuille",
                "tngeWallet": "Portefeuille électronique TnG",
                "vippseWallet": "Vipps",
                "zainCash": "ZainCash",
                "xendit": "Xendit",
                "exAlipay": "Alipay",
                "FIB": "FIB",
                "SantimPay": "SantimPay",
                "gCash": "GCash",
                "completedWithoutService": "Terminé sans chauffeur",
                "BankOfGeorgia": "Banque de Géorgie",
                "partialCompleted": "Partiellement terminé",
                "failed": "Échec",
                "googlePay": "Google Pay",
                "paymentLink": "Lien de paiement",
                "easyPaisa": "Easy Paisa",
                "jazzCash": "Jazz Cash",
                "samsung_pay": "Samsung Pay",
                "kakao_pay": "Kakao Pay",
                "naver_pay": "Naver Pay",
                "wechat_pay": "WeChat Pay",
                "alipay": "Alipay",
                "paynow": "PayNow",
                "grabpay": "GrabPay",
                "cashapp": "Cash App Pay"
            },
            "paymentStatusItem": {
                "all": "Tout",
                "fullPayment": "Règlement de la totalité",
                "partialPayment": "Paiement partiel",
                "pendingPayment": "En attente de paiement",
                "partialRefund": "Remboursement partiel",
                "fullRefund": "Remboursement complet"
            },
            "companySettlementTypeItem": {
                "all": "Tout",
                "fleetOweCompany": "La flotte doit à l'entreprise",
                "companyOweFleet": "L'entreprise doit à la flotte"
            },
            "bookingStatusItem": {
                "all": "Tout",
                "completed": "Terminé",
                "incident": "Incident",
                "paxNoShow": "Non-présentation du passager",
                "driverNoShow": "Conducteur no show",
                "rejected": "Rejeter",
                "canceledByTimeOut": "Annulé par timeout ",
                "canceledByTimeOutRejected": "Annulé par expiration (rejeté)",
                "canceledByBookingBoard": "Annulé par le tableau de réservation",
                "canceledByCustomer": "Annulé par le client",
                "canceledBySupplier": "Annulé par le fournisseur"
            },
            "bookingFromItem": {
                "all": "Tous",
                "paxApp": "Pplication passager",
                "mDispatcher": "MDispatcher",
                "kiosk": "Kioske",
                "cc": "Centre de commandes",
                "webBooking": "Réservation en ligne",
                "carHailing": "Héler un véhicule",
                "streetSharing": "Partage de rue",
                "dashboard": "Tableau de réservation",
                "corp": "Tableau de réservation (CTM)",
                "dmc": "Tableau de réservation (DMC)",
                "Boost_web_link": "Lien Web Boost"
            },
            "thirdPartyActionItem": {
                "all": "Tout",
                "searched": "Recherché",
                "allocated": "Alloué",
                "updated": "Mis à jour",
                "cancelled": "Annulé"
            },
            "bookingTypeItem": {
                "batchDelivery": "Livraison en lot",
                "all": "Tous",
                "now": "Maintenant",
                "reservation": "Réservation",
                "intercity": "Interurbain",
                "delivery": "Livraison",
                "shuttle": "Navette"
            },
            "adjustPrices": {
                "all": "Tout",
                "normalPrice": "Prix normal",
                "addonPrice": "Prix supplémentaire"
            },
            "bookingServiceItem": {
                "all": "Tous",
                "roaming": "Itinérance",
                "homeFleet": "Ferme hors",
                "localBooking": "Ma flotte",
                "farmIn": "Ferme en",
                "farmInAndAffiliationOwner": "Ferme en & propriétaire de l'affiliation",
                "provideService": "Ferme en"
            },
            "ratingTypeItem": {
                "all": "Tout",
                "like": "Satisfait",
                "dislike": "Non satisfait"
            },
            "starsItem": {
                "all": "Tous",
                "star1": "1 Étoile",
                "star2": "2 Étoiles",
                "star3": "3 Étoiles",
                "star4": "4 Étoiles",
                "star5": "5 Étoiles"
            },
            "incidentCanceledTypes": {
                "all": "Tout",
                "incident": "Incident",
                "canceled": "Annulé"
            },
            "canceledByItem": {
                "all": "Tout",
                "CorpAD": "Admin Entreprise",
                "passenger": "Passager",
                "driver": "Client",
                "merchant": "Marchand",
                "CC": "Carte de crédit",
                "mDispatcher": "MDispatcher",
                "Partner": "Partenaire",
                "webBooking": "Réservation en ligne",
                "timeout": "Expiration"
            },
            "incidentStatusItem": {
                "RESOLVED": "Résolu",
                "DISPUTED": "Controversé"
            },
            "bookingSummaryActionItem": {
                "all": "Tout",
                "create": "Créer",
                "update": "Mettre à jour",
                "cancel": "Annuler",
                "complete": "Terminer",
                "incident": "Incident"
            },
            "transactionTypeItem": {
                "DriverFees": "Driver Fees",
                "bookingAdjustment": "Ajustement de réservation",
                "bankAccount": "Transféré vers un compte bancaire",
                "sentToCustomer": "Envoyé au client",
                "receivedFromDriver": "Reçu du chauffeur",
                "sentToDriver": "Envoyé au chauffeur",
                "creditWallet": "Transféré vers le portefeuille de crédit",
                "netEarning": "Revenu net",
                "referralEarning": "Gains de parrainage",
                "all": "Tout",
                "topUp": "Recharger",
                "editBalance": "Éditer le solde",
                "bookingDeduction": "Déduction de réservation",
                "bookingPromo": "Promotion de réservation",
                "topUpGCash": "Recharger par Gcash",
                "cashWallet": "Porte-monnaie",
                "topUpMOLPay": "Rechargé via Razer Pay",
                "topUpQRIS": "Recharger par QRIS",
                "topUpZainCash": "Rechargé via ZainCash",
                "topUpXendit": "Rechargé via Xendit",
                "topUpalipayExternal": "Recharger par Alipay",
                "topUpFIB": "Rechargé via FIB",
                "topUpSantimPay": "Rechargé via SantimPay",
                "topUpTelebirr": "Rechargé via Telebirr",
                "topUpKsher": "Rechargé via Ksher",
                "topUpWallet": "Rechargé via {0}",
                "TnG": "Rechargé via TnG",
                "credit": "Rechargé via carte de crédit",
                "ride": "Trajet",
                "tipAfterCompleted": "Tip après tour",
                "debtWriteOff": "Annulation de dette",
                "refund": "Remboursement",
                "excessOffsetAmount": "Crédit en espèces excédentaire",
                "excessDeductionAmount": "Débit de trésorerie excédentaire",
                "cashExcess": "Débit de trésorerie excédentaire",
                "gateway": "Rechargé depuis la passerelle",
                "driverTopUpForPax": "Débit de trésorerie excédentaire",
                "updatedBalance": "Solde mis à jour",
                "partialEarning": "Gains",
                "payout": "Payout manual",
                "payoutManual": "Paiement manuel",
                "payoutDriver": "Paiement ",
                "itemValue": "Valeurs des articles",
                "redeemVoucher": "Code de remboursement #",
                "topUpReferrer": "Récompense de parrainage",
                "driverInsurance": "Assurance du chauffeur",
                "cancellationPenalty": "Pénalité d'annulation",
                "WingBank": "Transferts vers un compte Wingbank",
                "customerDebt": "Dette client",
                "googlePay": "Rechargé via Google Pay",
                "applePay": "Rechargé via Apple Pay",
                "samsung_pay": "Recharger par Samsung Pay",
                "kakao_pay": "Recharger par Kakao Pay",
                "naver_pay": "Recharger par Naver Pay",
                "wechat_pay": "Recharger par WeChat Pay",
                "alipay": "Recharger par Alipay",
                "paynow": "Recharger par PayNow",
                "grabpay": "Recharger par GrabPay",
                "cashapp": "Recharger par Cash App Pay",
                "merchantCommission": "Commission du marchand",
                "eWallet": "Transféré vers un portefeuille électronique externe",
                "reversed": "Retrait annulé",
                "driverNoShow": "Absence du conducteur",
                "noShowPenalty": "Non-présentation du conducteur",
                "bookingEarning": "Revenu net"
            },
            "moduleItem": {
                "all": "Tout",
                "bookings": "Réservations",
                "customers": "Clients",
                "dispatch": "Dispatching",
                "general": "Général",
                "promotion": "Promotion",
                "quest": "Recherche",
                "rate": "Avis",
                "car": "Véhicule",
                "city": "Ville",
                "company": "Compagnie",
                "drivers": "Chauffeurs",
                "driverSettlement": "Règlement du conducteur",
                "login": "Connexion",
                "logout": "Déconnexion",
                "mDispatcher": "mDispatcher",
                "mDispatcherType": "Type mDispatcher",
                "operation": "Opération",
                "partners": "Partenaires",
                "permission": "Permission",
                "queuingArea": "Zone de file d'attente",
                "report": "Rapport",
                "shift": "Horraires",
                "user": "Utilisateur",
                "voiceSms": "Voix et SMS",
                "intercityZone": "Zone (interurbain)",
                "Payout": "Paiement",
                "code#": "Code #",
                "ApiManagement": "Gestion de l'API"
            },
            "serviceTypeItem": {
                "all": "Tous",
                "oneWay": "Aller simple",
                "fromAirport": "De l'aéroport",
                "toAirport": "À l'aéroport",
                "hourly": "Horaire/jour",
                "roundTrip": "Aller et retour",
                "fromAirportHourlyDaily": "Depuis l'aéroport - toutes les heures/quotidiennement",
                "fromAirportRoundTrip": "Depuis l'aéroport - aller-retour",
                "toAirportHourlyDaily": "Vers l'aéroport - toutes les heures/quotidiennement",
                "toAirportRoundTrip": "Vers l'aéroport - aller-retour"
            },
            "merchantTransactionTypeItem": {
                "all": "Tout",
                "editBalance": "Éditer le solde",
                "payout": "Paiement ",
                "earning": "Gains",
                "itemValue": "Valeur de l'article",
                "orderDeduction": "Déduction de commande"
            },
            "withdrawalTransactionType": {
                "WingBank": "Transféré vers un compte Wingbank",
                "bankAccount": "Transférer vers le compte bancaire",
                "cashWallet": "Transféré vers le portefeuille en espèces",
                "creditWallet": "Tranférer vers le porte-monnaie"
            },
            "payoutDriver": {
                "driversHaveBankAccount": "Les chauffeurs ont un compte bancaire",
                "driversDontHaveBankAccount": "Les chauffeurs n'ont pas de compte bancaire",
                "payoutEndTime": "Heure de fin du paiement",
                "driverHaveInvalidBankAccount": "Les chauffeurs ont un compte bancaire invalide"
            },
            "payoutMerchant": {
                "HaveBankAccount": "Les marchands ont un compte bancaire",
                "DontHaveBankAccount": "Les marchands n'ont pas de compte bancaire",
                "HaveInvalidBankAccount": "Les marchands ont un compte bancaire invalide",
                "payoutEndTime": "Heure de fin du paiement"
            }
        },
        "error": {
            "23005": "Pour des raisons de performance du système, vous ne pouvez consulter les rapports que sur %{interval} %{unitLabel}, veuillez ajuster votre plage de dates"
        },
        "result": {
            "idPermitType": "Type d'ID",
            "noResultFound": "Aucun résultat trouvé",
            "page": "Page",
            "itemsPerPage": "Eléments par page",
            "showPages": "Affiche %{from} - %{to} de %{total}",
            "exportToExcel": "Exporter vers Excel",
            "exportToCSV": "Exporter en CSV",
            "exportToPaymentFile": "Exporter vers un fichier de paiement",
            "pay": "Payé",
            "paySelected": "Payer les sélectionnés",
            "payAll": "Tout payer",
            "invalidBankAccount": "Compte bancaire invalide",
            "validBankAccount": "Compte bancaire valide",
            "bookingDetails": {
                "customerAdjustmentsFee": "Ajustement client",
                "supplierDriverAdjustmentsFee": "Ajustement fournisseur/chauffeur",
                "supplierPayout": "Paiement fournisseur",
                "driverPayout": "Paiement chauffeur",
                "profit": "Profit",
                "successSendMessage": "Votre message a été envoyé",
                "packageName": "Nom du forfait",
                "transactionId": "ID de la transaction",
                "proofOfFailure": "Preuve d'échec",
                "recipientsNumber": "Nombre de destinataires",
                "recipientsInfo": "Informations du destinataire",
                "creditTransactionFee": "Frais de carte de crédit",
                "carTypeRequest": "Type de voiture demandé",
                "bookingId": "Réservation #",
                "bookingStatus": "Statut de réservation",
                "tripId": "Trajet #",
                "bookFrom": "Réservé de",
                "bookingService": "Type de réseau",
                "bookingType": "Type de réservation",
                "serviceType": "Type de service",
                "operator": "Opérateur",
                "customerPhone": "Numéro de téléphone du passager",
                "customerName": "Nom du passager",
                "customerIdNumber": "ID du passager / Carte d'identité #",
                "corpDivision": "Division",
                "corpDept": "Département",
                "chargeCode": "Code de facturation",
                "tripDescription": "Description du trajet",
                "rideSharing": "Partage de course",
                "queueName": "Zone de file d'attente",
                "bookingTime": "Heure de réservation",
                "pickupTime": "Heure de prise en charge",
                "expectedPickupTime": "Heure de prise en charge prévue",
                "dispatchTime": "Temps de dispatch",
                "onBoardTime": "Heure à bord",
                "droppedOffTime": "Heure d'arrivée",
                "onBoardDuration": "Durée à bord",
                "dispatch": "Expédition #",
                "completedTime": "Heure de fin",
                "driverName": "Nom du Driver",
                "driverIdPermit": "ID# / Carte d'identité nationale #",
                "driverLicenseNumber": "Numéro de permis de conduire",
                "companyName": "Compagnie",
                "carType": "Type de véhicule",
                "licensePlate": "Plaque d'immatriculation",
                "intercityRoute": "Itinéraire interurbain",
                "pickupLocation": "Lieu de prise en charge",
                "geoPickup": "Lat/long de l'emplacement de prise en charge",
                "extraDestination": "Destinations supplémentaires",
                "originDestination": "Destination d'origine",
                "originEstDistance": "Distance originale estimée",
                "destination": "Destination",
                "geoDestination": "Lat/long de l'emplacement de prise en charge",
                "pickupFrom": "Emplacement de prise en charge de",
                "distanceTour": "Distance Passager A Bord",
                "internalNotes": "Notes internes",
                "notes": "Remarques",
                "basicFareCalculator": "Calculateur du prix de base",
                "basicFare": "Tarif de base",
                "editFare": "Editer le prix de base",
                "oldBasicFare": "Ancien prix de base",
                "airportFee": "Frais d'aéroport",
                "meetDriver": "Rencontrer le chauffeur",
                "rushHour": "Heure de pointe",
                "surchargeParameter": "Supplément dynamique",
                "dynamicFare": "Tarif dynamique",
                "heavyTraffic": "Circulation dense",
                "tollFee": "Frais de péage",
                "parkingFee": "Frais de stationnement",
                "gasFee": "Frais de carburant",
                "otherFees": "Autres frais",
                "subtotal": "Sous-total",
                "subTotalFF": "Sous-total FF",
                "techFee": "Frais de Technique",
                "serviceFee": "Add'l services",
                "fleetServiceFee": "Services de flotte",
                "bookingFee": "Frais de réservation",
                "salesTax": "TVA",
                "tipAmt": "Montant du pourboire",
                "promoCode": "Code promo",
                "promoAmt": "Montant de la promo",
                "requestedTotalAmount": "OTA Price",
                "total": "Montant total",
                "totalNotRounded": "Tour (amt total)",
                "actualReceived": "Montant réel reçu",
                "differenceAmt": "Différence (reçue)",
                "customerDebt": "Dette client",
                "markupDifference": "Différence de majoration",
                "receivedWhenDropOff": "Reçu au moment de la livraison",
                "refundAmount": "Montant remboursé",
                "requestedPaymentMethod": "Mode de paiement demandé",
                "paidBy": "Payé par",
                "splitPayment": "Paiement fractionné",
                "paidByWallet": "Payé par portefeuille",
                "paidByOtherMethod": "Payé par une autre méthode",
                "cashReceived": "Espèces reçues",
                "transferredChangeByWallet": "Transfert de monnaie via portefeuille",
                "returnedChangeByCash": "Rendu de monnaie en espèces",
                "instructions": "Instructions",
                "additionalServiceName": "Nom",
                "additionalServiceValue": "Valeur",
                "sendReceiptHeader": "",
                "sendReceipt": "Envoyer facture",
                "send": "Envoyer",
                "cancel": "Annuler",
                "sentReceiptSuccess": "La facture a bien été envoyée",
                "sentReceiptFailed": "La facture ne peut pas être envoyée",
                "coRider": "Co-passager",
                "coriderName": "Nom",
                "stopAddress": "Additional Destination",
                "stopGeo": "Lat/long",
                "addonPrice": "Ajustement du prix par le client",
                "oldSubTotal": "Sous-total avant ajustement",
                "view_good_receipt": "Reçu de colis",
                "view_delivery_receipt": "Photo de livraison",
                "view": "Voir",
                "tipAfterCompletedDetails": "Transféré : {0}{1} ; Frais de transaction : {0}{2}",
                "fleetMarkup": "Profit",
                "editedDriverEarning": "Gains du chauffeur modifiés",
                "driverEarning": "Gains du chauffeur",
                "supplierAmount": "Gains du fournisseur",
                "currencyISO": "Devise",
                "pickUpZoneName": "Zone de prise en charge",
                "dynamicFactor": "Tarif dynamique (facteur)",
                "supplierEarning": "Gains du fournisseur",
                "passengerName": "Nom du passager",
                "totalPayout": "Paiement total",
                "numberOfTrips": "Nombre de trajets",
                "psgLocation": "Emplacement du passager (lat/long)",
                "psgIp": "IP du passager",
                "DeviceImei": "IMEI de l'appareil",
                "otaDiscount": 'OTA Discount',
            },
            "financial": {
                "supplierPayout": "Paiement fournisseur",
                "driverPayout": "Paiement chauffeur",
                "profit": "Profit",
                "currencyISO": "Devise",
                "supplierAmount": "Gains du fournisseur",
                "driverEarning": "Gains du chauffeur",
                "supplierEarning": "Gains du fournisseur",
                "passengerName": "Nom du passager",
                "totalPayout": "Paiement total",
                "numberOfTrips": "Nombre de trajets",
                "driverName": "Nom du Driver",
                "driverPhone": "Numéro de téléphone",
                "driverUserName": "Nom d'utilisateur",
                "companyName": "Compagnie",
                "bookingList": "Liste de réservations",
                "totalFare": "Prix total sans la promo",
                "netEarning": "Résultat net",
                "showBookingList": "Montrer",
                "referralEarning": "Gain par parrainage",
                "totalEarningNet": "Total des gains (net)",
                "totalEarningNetTooltip": "Argent gagné après retour de tous les frais à la flotte. Gains totaux (nets) = Gains nets + Pourboire après le trajet",
                "totalEarningNetTooltipRefferal": "Argent gagné après retour de tous les frais à la flotte. Gains totaux (nets) = Gains de parrainage + Gains nets + Pourboire après le trajet",
                "totalEarningGross": "Revenu total (brut)",
                "totalEarning": "Gains totaux",
                "totalEarningGrossTooltip": "Argent gagné à partir du tarif de réservation et des pourboires. Gains totaux (bruts) = Gains bruts + Pourboire après le trajet",
                "totalEarningGrossTooltipRefferal": "Argent gagné à partir du tarif de réservation et du pourboire. Gains totaux (bruts) = Gains de parrainage + Gains bruts + Pourboire après le trajet",
                "note": "Remarque",
                "shortTrip": "Court trajet",
                "deduction": "Déduction",
                "totalDriverEarning": "Gains totaux du chauffeur",
                "totalDriverEarningTooltip": "Inclut les réservations avec paiement en ligne et hors ligne",
                "totalDriverPayout": "Paiement total du chauffeur",
                "totalDriverPayoutTooltip": "N'inclut pas les réservations avec paiement en espèces ou hors ligne"
            },
            "financialDriver": {
                "supplierAmount": "Commission du fournisseur",
                "payoutType": "Type de paiement",
                "date": "Date",
                "driverTipAfterCompleted": "Tip après tour",
                "bookingId": "Réservation #",
                "paidBy": "Payé par",
                "bookFrom": "Réservé de",
                "bookingType": "Type de réservation",
                "companyName": "Compagnie",
                "driverName": "Chauffeurs",
                "driverIdPermit": "CNI du chauffeur / permis de conduire",
                "totalFare": "Prix total sans la promo",
                "subtotal": "Sous-total",
                "airportFee": "Frais d'aéroport",
                "meetDriver": "Accueil",
                "tollFee": "Frais de péage",
                "parkingFee": "Frais de stationnement",
                "gasFee": "Frais de carburant",
                "rushHour": "Heure de pointe",
                "transactionFee": "Frais de transaction",
                "techFee": "Frais de Technique",
                "salesTax": "TVA",
                "tipAmt": "Montant du pourboire",
                "bookingFee": "Frais de réservation",
                "commission": "Commission",
                "deduction": "Déduction",
                "promoAmt": "Montant de la promo",
                "ridePayment": "Paiement de la course",
                "driverTax": "Taxe du chauffeur",
                "grossEarning": "Revenus bruts",
                "driverDeduction": "Déduction du chauffeur",
                "netEarning": "Résultat net",
                "payToDriver": "Payez au conducteur",
                "payToFleet": "Paiement à la flotte",
                "totalNotRounded": "Tour (amt total)",
                "fleetServiceFee": "Frais de service de la flotte",
                "editedDriverEarning": "Gains du chauffeur modifiés",
                "stripeFee": "Frais Stripe",
                "currencyISO": "Devise"
            },
            "financialCompany": {
                "companyName": "Compagnie",
                "homeFleetNetEarning": "Gain net total de la flotte",
                "affiliateNetEarning": "Gain Net de l'Affilié",
                "totalNetEarning": "Total pilotes net des gains",
                "status": "Statut",
                "companyAmount": "Company profit",
                "numberOfTrips": "Nombre de trajets"
            },
            "companySettlement": {
                "companyName": "Entreprise",
                "pendingSettlement": "Règlement en attente",
                "viewDetails": "Voir les détails",
                "settlementType": "Type"
            },
            "companySettlementDetails": {
                "bookId": "ID de réservation",
                "dateTime": "Date et heure",
                "originalPaymentStatus": "Statut de paiement initial",
                "subTotal": "Sous-total",
                "fleetAmount": "Montant de la flotte",
                "driverAmount": "Montant du chauffeur",
                "companyAmount": "Montant de l'entreprise",
                "companyOweFleet": "L'entreprise doit à la flotte",
                "fleetOweCompany": "La flotte doit à l'entreprise",
                "notes": "Remarques"
            },
            "financialProfit": {
                "profit": "Bénéfices",
                "bookingId": "Réservation #",
                "subTotal": "Total",
                "subTotalFF": "Sous-total FF",
                "fleetCommission": "Commission de la flotte",
                "techFee": "Frais techniques",
                "promotion": "Promotion",
                "markupDifference": "Différence de majoration",
                "Profit": "Profit",
                "currency": "Devise",
                "fleetServiceFee": "Service de flotte (prise de flotte)",
                "fleetServiceFeeTooltip": "Montant que la flotte prend en commission sur les frais de service"
            },
            "promotion": {
                "date": "Date",
                "promoCode": "Code promo",
                "users": "# Utilisateurs",
                "uses": "# Utilisations",
                "checked": "Vérifié",
                "applied": "Appliqué",
                "totalPromoAmount": "Total du montant des promos",
                "totalReceipt": "Total du montant des factures with promo excluded",
                "numberOfUsers": "Nombre d'utilisateurs",
                "numberOfPromoCodeAppliance": "Nombre de code promo",
                "numberOfSuccessfulBookings": "Nombre de réservations réussies",
                "numberOfCompletedBookings": "Nombre de réservations finalisées",
                "numberOfCompletedUsers": "Nombre d'utilisateurs ayant terminé",
                "numberOfUsersApplyPromotion": "Nombre d'utilisateurs appliquant la promotion",
                "numberOfUsersApplyPromotionAndCompleteBooking": "Nombre d'utilisateurs appliquant la promotion et finalisant la réservation",
                "numberOfPromoCodeApplianceTooltip": "Nombre de codes promotionnels utilisés par tous les utilisateurs",
                "numberOfSuccessfulBookingsTooltip": "Nombre de réservations créées avec succès avec le code de promotion",
                "numberOfCompletedBookingsTooltip": "Nombre de réservations effectuées avec application du code promotionnel"
            },
            "export": {
                "createdDate": "Date",
                "sessionName": "Nom de la session",
                "download": "Télécharger",
                "delete": "Supprimer",
                "percent": "Percent",
                "status": "Statut",
                "name": "Nom du module"
            },
            "redeemed": {
                "date": "Date",
                "code": "Code",
                "customers": "Client",
                "phone": "Numéro de téléphone",
                "value": "Valeur",
                "currency": "Devise",
                "campaignName": "Campagne"
            },
            "carActivity": {
                "plateNumber": "Plaque d'immatriculation du véhicule",
                "vehicleType": "Type de voiture",
                "companyName": "Compagnie",
                "day1st": "1er",
                "day2nd": 2,
                "day3rd": 3,
                "day4th": 4,
                "day5th": 5,
                "day6th": 6,
                "day7th": 7,
                "day8th": 8,
                "day9th": 9,
                "day10th": 10,
                "day11th": 11,
                "day12th": 12,
                "day13th": 13,
                "day14th": 14,
                "day15th": 15,
                "day16th": 16,
                "day17th": 17,
                "day18th": 18,
                "day19th": 19,
                "day20th": 20,
                "day21st": 21,
                "day22nd": 22,
                "day23rd": 23,
                "day24th": 24,
                "day25th": 25,
                "day26th": 26,
                "day27th": 27,
                "day28th": 28,
                "day29th": 29,
                "day30th": 30,
                "day31st": 31,
                "operationDays": "Jours travaillés",
                "activeCars": "Total des véhicules actifs:"
            },
            "carActivityLogsTitle": "Journaux",
            "carActivityLogs": {
                "licensePlate": "Plaque d'immatriculation du véhicule",
                "companyName": "Compagnie",
                "bookingId": "Réservation #",
                "driverName": "Nom du Driver",
                "driverIDNumber": "ID du chauffeur",
                "date": "Heure d'acceptation",
                "bookFrom": "Réservé de"
            },
            "affiliation": {
                "date": "Heure de prise en charge",
                "bookingId": "Réservation #",
                "bookingType": "Type de réservation",
                "homeFleet": "Ma flotte",
                "providerFleet": "Fournisseur de la flotte",
                "driver": "Chauffeurs",
                "passenger": "Passager",
                "paidBy": "Payé par",
                "airportFee": "Frais Aéroport",
                "meetDriver": "Rencontre avec le chauffeur",
                "rushHour": "Heure de pointe",
                "tollFee": "Frais de péage",
                "parkingFee": "Frais de stationnement",
                "gasFee": "Frais de carburant",
                "heavyTraffic": "Circulation dense",
                "otherFees": "Autres frais",
                "provider": "Fournisseur",
                "basicFareProvider": "Fournisseur de tarif de base",
                "subTotalProvider": "Fournisseur de sous-total",
                "techFeeProvider": "Fournisseur de frais technologiques",
                "bookingFeeProvider": "Fournisseur de frais de réservation",
                "taxValueProvider": "Fournisseur de valeur de taxe",
                "tipProvider": "Fournisseur de pourboire",
                "totalFareProvider": "Fournisseur de tarif total",
                "basicFare": "Tarif de base",
                "subtotal": "Sous-total",
                "techFee": "Frais de Technique",
                "bookingFee": "Frais de réservation",
                "tax": "Taxe",
                "tip": "Pourboire",
                "totalFare": "Tarif total",
                "payoutInLocalCurrency": "Gains du trajet en devise locale",
                "payoutInUSD": "Gains du trajet en USD",
                "fleetCommInUSD": "Commission de la flotte en USD",
                "bookingFeeInUSD": "Frais de réservation en USD",
                "totalPayoutInUSD": "Paiement total en USD",
                "subTotal": "Sous-total",
                "bookingStatus": "Statut de réservation",
                "vehicle": "Véhicule",
                "customerPhone": "Numéro de téléphone du client",
                "driverPhone": "Numéro de téléphone du chauffeur",
                "total": "Total",
                "totalInUSD": "Tarif total (USD)",
                "supplierPayout": "Paiement fournisseur",
                "supplierPayoutInUSD": "Paiement fournisseur (USD)",
                "buyerPayout": "Commission acheteur",
                "buyerPayoutInUSD": "Commission (USD)",
                "buyerCommission": "Commission",
                "buyerCommissionInUSD": "Commission (USD)",
                "receivableInUSD": "Montant à recevoir (USD)",
                "payableInUSD": "Montant à payer (USD)",
                "fleetMarkupInUSD": "Profit (USD)",
                "paymentMethod": "Mode de paiement",
                "paymentStatus": "Statut du paiement"
            },
            "prepaidTopUp": {
                "date": "Date & heure",
                "topUpId": "Numéro de réapprovisionnement",
                "transactionId": "ID de la transaction",
                "name": "Nom",
                "company": "Compagnie",
                "paidBy": "Payé par",
                "amount": "Montant",
                "newAmount": "Nouveau solde ",
                "transactionType": "Type de transaction"
            },
            "operatorLogs": {
                "date": "Date",
                "operator": "Opérateur",
                "username": "Nom d'utilisateur",
                "module": "Module",
                "description": "Description"
            },
            "corporate": {
                "date": "Date",
                "bookingId": "Réservation #",
                "operatorName": "Opérateur corp",
                "corporateName": "Compagnie",
                "corpTraveler": "Voyageur entreprise",
                "travelerSignature": "Signature du voyageur",
                "corpId": "Numéro d'entreprise",
                "corpDivision": "Division d'entreprise",
                "costCentre": "Centre de coûts",
                "corpPO": "Bon de commande corp",
                "managerName": "Nom du gestionnaire",
                "managerEmail": "Mail du directeur",
                "title": "Titre",
                "department": "Département",
                "clientCaseMatter": "Affaire client/ Description du voyage",
                "chargeCode": "Code de charge/  Code de voyage",
                "driverName": "Chauffeurs",
                "pickupLocation": "Lieu de prise en charge",
                "destination": "Destination",
                "total": "Montant total",
                "subtotal": "Sous-total",
                "subTotalFF": "Sous-total FF",
                "commission": "Commission",
                "commissionBooking": "Appliquer une commission pour les réservations effectuées à partir de l'application",
                "paidBy": "Payé par",
                "statusDisplay": "Statut",
                "flightNumber": "Numéro de vol"
            },
            "bookingLogs": {
                "bookingId": "Réservation #",
                "bookingService": "Type de réseau",
                "bookingType": "Type de réservation",
                "driverName": "Chauffeurs",
                "driverIdPermit": "CNI du chauffeur / permis de conduire",
                "customerName": "Passager",
                "pickupTime": "Heure de prise en charge",
                "onBoardTime": "Heure à bord",
                "droppedOffTime": "Heure d'arrivée",
                "pickupLocation": "Lieu de prise en charge",
                "destination": "Destination",
                "dispatchHistory": "Historique du dispatch",
                "otwDistance": "Distance O.T.W",
                "distanceTour": "Distance",
                "duration": "Durée",
                "paidBy": "Payé par",
                "bookFrom": "Réservé de",
                "map": "Carte",
                "showDispatchHistory": "Montrer",
                "showMap": "Montrer",
                "paymentActivities": "Activités de paiement"
            },
            "rating": {
                "date": "Date",
                "bookingId": "Réservation #",
                "driverName": "Chauffeurs",
                "driverIdPermit": "CNI du chauffeur / permis de conduire",
                "customerName": "Nom du passage",
                "customerPhone": "Numéro de téléphone du passager",
                "like": "Satisfait",
                "dislike": "Non satisfait",
                "notes": "Commentaire",
                "stars": "Évaluation",
                "vehicleRating": "Évaluation du véhicule",
                "driverRating": "Évaluation du conducteur",
                "plateNumber": "Numéro de plaque"
            },
            "mDispatcher": {
                "date": "Date",
                "bookingId": "Réservation #",
                "mDispatcherName": "Dispatcher name",
                "mDispatcherType": "Type mDispatcher",
                "subtotal": "Sous-total",
                "commission": "Commission",
                "paidBy": "Payé par"
            },
            "totalAdjustment": {
                "date": "Date",
                "bookingId": "Réservation #",
                "oldAmount": "Ancien montant",
                "type": "Type",
                "markupDifference": "Différence de majoration",
                "newAmount": "Nouveau montant",
                "username": "Nom d'utilisateur",
                "reason": "Raison"
            },
            "incidentCancellation": {
                "date": "Date",
                "bookingId": "Réservation #",
                "customerName": "Nom du passage",
                "customerPhone": "Numéro de téléphone du passager",
                "bookFrom": "Réservé de",
                "canceledBy": "Annulé par",
                "type": "Type",
                "reason": "Raison",
                "reasonCode": {
                    "0": "J'ai trouvé un autre moyen de déplacement",
                    "1": "Chauffeur trop éloigné",
                    "2": "J'ai entré une adresse eronnée",
                    "3": "J'ai attendu trop longtemps",
                    "4": "Le chauffeur a annulé",
                    "5": "J'ai changé mes plans",
                    "6": "Je voulais changer de lieu",
                    "101": "La plupart ou tous les articles sont indisponibles",
                    "102": "Nous sommes trop occupés en ce moment",
                    "103": "Nous sommes fermés en ce moment",
                    "104": "Nous fermons bientôt"
                },
                "canceller": "Annulé par",
                "incidentStatus": "Statut de l'incident"
            },
            "acceptanceCancellationRate": {
                "companyId": "ID de l'entreprise",
                "driverId": "ID du conducteur",
                "driverName": "Nom du conducteur",
                "phoneNumber": "Numéro de téléphone",
                "company": "Entreprise",
                "acceptanceRate": "Taux d'acceptation",
                "cancellationRate": "Taux d'annulation",
                "rating": "Étoile"
            },
            "revenueFleet": {
                "date": "Date",
                "fareRevenue": "Tarif de revenu",
                "trip": "# Course",
                "avgFareTrip": "Tarif Moyen/ course",
                "drivers": "# Chauffeurs",
                "avgTripPerDriver": "Course moyenne/ Driver",
                "dispatcher": "# Dispatcheur"
            },
            "revenueDriver": {
                "date": "Date",
                "driverName": "Chauffeurs",
                "fareRevenue": "Tarif de revenu",
                "trip": "# Course",
                "avgFareTrip": "Tarif Moyen/ course"
            },
            "revenueMonthly": {
                "month": "Mois",
                "trip": "Trajets terminés",
                "subtotal": "Sous-total",
                "tipAmt": "Pourboire",
                "techFee": "Frais de Technique",
                "salesTax": "Taxe",
                "partnerCommission": "Commission du partenaire/ ODD",
                "totalFare": "Prix total sans la promo",
                "netEarning": "Résultat net",
                "fleetServiceFee": "Frais de service de flotte"
            },
            "dailyDriver": {
                "driverName": "Nom du Driver",
                "driverIDPermit": "CNI du chauffeur / permis de conduire",
                "driverPhone": "Numéro de téléphone",
                "companyName": "Compagnie",
                "workingHoursOnline": "En ligne (h)",
                "workingHoursAvailable": "Disponible (h)",
                "driverWorkingHours": "Heures de travail du conducteur",
                "distance": "Distance parcourue par le conducteur",
                "CC_activity": "Activité CC",
                "fare_summary": "Résumé des tarifs",
                "workingHoursNotAvailable": "Non disponible (h)",
                "workingHoursPob": "Passager A Bord (h)",
                "workingHoursPobToolTip": "Durée du passager à bord",
                "workingHoursAccepted": "Accepté",
                "workingHoursReject": "Refuser",
                "workingHoursIgnore": "Ignorer",
                "workingHoursCancel": "Annuler",
                "completedTripsTotal": "Total",
                "completedTripsCc": "Du Centre de Commandes",
                "completedTripsCarHailing": "Hélé dans la rue",
                "completedTripsStreetSharing": "Depuis Street Sharing",
                "completedTripsPaxApp": "De l'application client",
                "completedTripsWebBooking": "De la réservation web",
                "completedTripsMDispatcher": "De mDispatcher",
                "completedTripsKiosk": "Depuis le Kioske",
                "completedTripsApi": "Depuis l'API",
                "ccActivityDispatchedTrips": "Trajets dispatchés",
                "ccActivityAccepted": "Accepté",
                "ccActivityReject": "Refuser",
                "ccActivityIgnore": "Ignorer",
                "ccActivityCancelByPassenger": "Annulé par passager",
                "ccActivityCancelByDriver": "Annulé par le chauffeur",
                "ccActivityCancelByCc": "Annulé par CC",
                "ccActivityCancelByAPI": "Annulé par l'API",
                "ccActivityNoShow": "Non présentation",
                "fareSummaryTotalCash": "Paiement à bord",
                "fareSummaryTotalCreditCard": "Carte de crédit",
                "fareSummaryTotalExternalCard": "Carte externe",
                "fareSummaryTotalPaxWallet": "Portefeuille",
                "fareSummaryTotalDirectBilling": "Facturation directe",
                "fareSummaryTotalQrCode": "Code QR",
                "fareSummaryTotalPrePaid": "Portefeuille Entreprise",
                "fareSummaryTotalApplePay": "Apple Pay",
                "fareSummaryTotalTngeWallet": "TNG eWallet",
                "fareSummaryTotalVippseWallet": "Vipps",
                "fareSummaryTotal": "Total",
                "ratingNotes": "Nombre de notes",
                "ratingDislike": "Nombre de \"je n'aime pas",
                "ratingLike": "Nombre de \"j'aime",
                "fareDetailsBasicFare": "Tarif de base",
                "fareDetailsAirportFee": "Frais d'aéroport",
                "fareDetailsRushHour": "Heure de pointe",
                "fareDetailsHeavyTraffic": "Trafic dense",
                "fareDetailsOtherFees": "Autres frais",
                "fareDetailsSubTotal": "Sous-total",
                "fareDetailsSubTotalFF": "Sous-total FF",
                "fareDetailsTechFee": "Frais de Technique",
                "fareDetailsBookingFee": "Frais de réservation",
                "fareDetailsSalesTax": "Taxe",
                "fareDetailsTip": "Montant du pourboire",
                "fareDetailsPromoAmount": "Montant de la prom",
                "fareDetailsTotalAmt": "Montant total",
                "availableDistance": "Disponible ",
                "otwDistance": "Sur le chemin",
                "otwDistanceToolTip": "Distance en route",
                "pobDistance": "P.O.B",
                "pobDistanceToolTip": "Distance du passager à bord",
                "ratingStars1": "No. 1 Étoile",
                "ratingStars2": "No. 2 Étoile",
                "ratingStars3": "No. 3 Étoile",
                "ratingStars4": "No. 4 Étoile",
                "ratingStars5": "No. 5 Étoile",
                "ratingAvg": "Moyenne",
                "ssnNumber": "Numéro de sécurité sociale #",
                "driverEmail": "Adresse e-mail",
                "driverAddress": "Adresse du domicile",
                "fareDetailsAddonPrice": "Ajustement du prix client",
                "fareDetailsOldSubTotal": "Sous-total avant ajustement"
            },
            "dailyCar": {
                "carInfo": "Info véhicule",
                "fareDetails": "Détails du tarif",
                "completedTrips": "Trajets terminés",
                "carInfoCompanyName": "Compagnie",
                "carInfoPermission": "Autorisation",
                "carInfoVehiclePlateNumber": "Plaque d'immatriculation",
                "carInfoVhcId": "Voiture #",
                "carInfoCarType": "Type de voiture",
                "completedTripsTotal": "Total",
                "completedTripsCc": "Du Centre de Commandes",
                "completedTripsCarHailing": "Hélé dans la rue",
                "completedTripsStreetSharing": "Du partage de la rue",
                "completedTripsPaxApp": "De l'application client",
                "completedTripsWebBooking": "De la réservation web",
                "completedTripsMDispatcher": "De mDispatcher",
                "completedTripsKiosk": "Depuis le Kioske",
                "completedTripsAPI": "Depuis l'API",
                "fareDetailsBasicFare": "Tarif de base",
                "fareDetailsAirportFee": "Frais d'aéroport",
                "fareDetailsMeetDriver": "Rencontre avec le chauffeur",
                "fareDetailsRushHour": "Heure de pointe",
                "fareDetailsHeavyTraffic": "Circulation dense",
                "fareDetailsTollFee": "Frais de péage",
                "fareDetailsParkingFee": "Frais de stationnement",
                "fareDetailsGasFee": "Frais d'essence",
                "fareDetailsOtherFees": "Autres frais",
                "fareDetailsSubTotal": "Sous-total",
                "fareDetailsSubTotalFF": "Sous-total FF",
                "fareDetailsTechFee": "Frais de Technique",
                "fareDetailsBookingFee": "Frais de réservation",
                "fareDetailsSalesTax": "Taxe",
                "fareDetailsTip": "Montant du pourboire",
                "fareDetailsPromoAmount": "Montant de la promo",
                "fareDetailsTotalAmt": "Montant total",
                "fareDetailsAddonPrice": "Ajustement du prix client",
                "fareDetailsOldSubTotal": "Sous-total avant ajustement"
            },
            "dailyDriverCar": {
                "driverInfo": "Informations du pilote",
                "driverName": "Nom du Driver",
                "driverIDPermit": "CNI du chauffeur / permis de conduire",
                "driverPhone": "Numéro de téléphone",
                "companyName": "Compagnie",
                "actionInfo": "Actions",
                "date": "Date",
                "action": "action",
                "bookingId": "Réservation #",
                "carInfo": "Infos sur la voiture",
                "permission": "Autorisation",
                "licensePlate": "Plaque d'immatriculation",
                "carId": "Voiture #",
                "carType": "Type de voiture"
            },
            "driverLoginStatus": {
                "driver": "Chauffeurs",
                "driverIdPermit": "CNI du chauffeur / permis de conduire",
                "phone": "Numéro de téléphone",
                "username": "Nom d'utilisateur",
                "company": "Compagnie",
                "carType": "Type de voiture",
                "licensePlate": "Plaque d'immatriculation",
                "status": "Statut"
            },
            "bookingSummary": {
                "date": "Date",
                "operator": "Opérateur",
                "username": "Nom d'utilisateur",
                "action": "action",
                "bookingId": "Réservation #"
            },
            "cashWallet": {
                "bankAccount": "Transféré sur compte bancaire",
                "creditWallet": "Transféré sur portefeuille de crédit",
                "tipAfterCompleted": "Pourboire après achèvement",
                "netEarning": "Revenu net",
                "referralEarning": "Revenu de parrainage",
                "receiverAccount": "Compte du destinataire",
                "dateAndTime": "Date & heure",
                "driverName": "Nom du Driver",
                "phoneNumber": "Numéro de téléphone",
                "userName": "Nom d'utilisateur",
                "company": "Compagnie",
                "type": "Type",
                "bookingId": "Réservation #",
                "operator": "Opérateur",
                "reason": "Raison",
                "amount": "Montant",
                "newAmount": "Nouveau solde ",
                "currency": "Devise",
                "topUpGCashReason": "Recharger par Gcash",
                "topUpReason": "Recharger à partir d'une carte de crédit *{0}",
                "cashWalletReason": "Recharge depuis le porte-monnaie",
                "topUpMOLPayReason": "Razer Pay [ {0} ]",
                "chargedAmount": "Montant facturé",
                "differentPercent": "Remise / Supplément (%)",
                "operatorName": "Opérateur ",
                "sendPayout": "action",
                "sendPayoutTitle": "Renvoyer l'email de paiement",
                "payoutReason": "{0} (Paiement {1} {2})"
            },
            "creditWallet": {
                "receiverType": "Type de destinataire",
                "receiverName": "Nom du destinataire",
                "receiverPhone": "Numéro de téléphone du destinataire",
                "senderPhone": "Numéro de téléphone de l'expéditeur",
                "senderName": "Nom de l'expéditeur",
                "sentToCustomer": "Envoyer au client",
                "sentToDriver": "Envoyer au conducteur",
                "dateAndTime": "Date & heure",
                "driverName": "Nom du Driver",
                "phoneNumber": "Numéro de téléphone",
                "userName": "Nom d'utilisateur",
                "company": "Compagnie",
                "type": "Type",
                "bookingId": "Réservation #",
                "operator": "Opérateur",
                "reason": "Raison",
                "amount": "Montant",
                "newAmount": "Nouveau solde ",
                "currency": "Devise",
                "transactionId": "ID de la transaction",
                "topUpGCashReason": "Recharger par Gcash",
                "topUpReason": "Recharger à partir d'une carte de crédit *{0}",
                "cashWalletReason": "Recharge depuis le porte-monnaie",
                "topUpMOLPayReason": "Razer Pay [ {0} ]",
                "topUpWalletReason": "{0} [ {1} ]",
                "chargedAmount": "Montant de la charge",
                "differentPercent": "Remise / Frais supplémentaires (%)",
                "cashExcessReason": "Le client doit payer {0}; Espèces reçues {1}",
                "referralEarningReason": "Le client {0} {1} a complété sa première réservation {2}",
                "referralEarningReason_2": "Le client {0} {1} a complété la réservation {2}",
                "insurance": "Assurance conducteur"
            },
            "passengerWallet": {
                "dateTime": "Date et heure ",
                "customerName": "Nom du client",
                "phoneNumber": "Numéro de téléphone",
                "type": "Type",
                "bookingId": "Réservation #",
                "changedAmount": "Montant modifié",
                "amount": "Montant modifié",
                "newBalance": "Nouveau solde ",
                "currency": "Devise",
                "transactionId": "ID de la transaction",
                "Note": "Remarque",
                "credit": "*Recharge par carte de crédit {0}",
                "TnG": "Recharge par TnG #{0}",
                "MOLPay": "Recharge depuis [RazerPay - #{0}]",
                "gatewayName": "Recharge depuis [{0} - #{1}]",
                "cashExcess": "Le client doit payer {0}, Espèces données {1}",
                "editBalance": "Éditer le solde",
                "ride": "Course",
                "topUp": "Recharge",
                "topUpReferee": "Récompense de parrainage ({0})",
                "topUpReferrer": "Nouveau filleul (#{0}) : {1} ({2})"
            },
            "recipientsInfo": {
                "order": "N°",
                "orderId": "Commande #",
                "name": "Nom du destinataire",
                "phone": "Numéro de téléphone du destinataire",
                "address": "Adresse du destinataire",
                "deliveryFee": "Frais de livraison",
                "ItemValue": "Valeur de l'article (COD)",
                "status": "Statut",
                "Performer": "Exécutant",
                "Reason": "Raison",
                "proofOfFailure": "Preuve d'échec",
                "referenceNumber": "Numéro de référence"
            },
            "dispatchHistory": {
                "performer": "Exécutant",
                "name": "Nom",
                "action": "action",
                "date": "Date",
                "location": "Localisation du chaufferu",
                "estimate": "Estimation de durée entre le véhicule et le lieu de prise en charge",
                "passenger": "Client",
                "detachVehicle": "Détacher véhicule",
                "assignVehicle": "Attribuer véhicule"
            },
            "payToDriver": {
                "driverName": "Nom du Driver",
                "totalUnsettledTransactions": "Total des transactions non réglées",
                "totalUnsettledAmount": "Montant total non réglé",
                "actions": "Actions",
                "pay": "Payé",
                "remove": "Enlever",
                "clearSuccess": "Les gains du chauffeur selectionné ont bien été effacées",
                "clearFailed": "Echec de l'effacement des données de gain de chauffeur. Veuillez réessayer.",
                "selectDriver": {
                    "title": "",
                    "body": "Veuillez sélectionner un chauffeur à payer.",
                    "buttonTitle": "D'accord"
                },
                "confirmClear": {
                    "title": "",
                    "body": "Etes vous sûr de vouloir effacer les données de gains de ce chauffeur? Cette action ne peut pas être annulée.",
                    "buttonTitle": "Oui",
                    "closeButtonText": "Non"
                },
                "confirmPay": {
                    "body": "Êtes-vous sûr de vouloir payer le(s) chauffeur(s) sélectionné(s) ?",
                    "buttonTitle": "Oui",
                    "closeButtonText": "Non"
                },
                "paymentSuccessfully": "Paiement effectué",
                "ProcessPayout": "Traitement du paiement"
            },
            "customerQuest": {
                "name": "Nom",
                "phoneNumber": "Numéro de téléphone",
                "supportId": "ID de support",
                "ranking": "Classement",
                "points": "Points",
                "numberOfReservation": "Nombre de réservations",
                "driver": "Client",
                "customer": "Client",
                "firstWillWin": "Le premier gagnera",
                "firstWillWinLuckyDraw": "Le premier gagnera (tirage au sort)",
                "largestWillWin": "Le plus grand gagnera (classement)",
                "qualified": "Qualifié",
                "notQualified": "Non qualifié",
                "userName": "Nom d'utilisateur",
                "completedDate": "Date de réalisation",
                "isQualified": "Statut",
                "ticket": "Billet",
                "numOfComplete": "Nombre de réalisations",
                "bookingDistance": "Distance P.O.B",
                "numberOfIntercity": "Nombre d'interurbains",
                "numberOfDelivery": "Nombre de livraisons",
                "pleaseSelectEventName": "Veuillez sélectionner le nom de l'événement.",
                "numberOfQualifiedSetting": "Nombre de qualifiés (paramètre) :",
                "numberOfActualQualified": "Nombre de qualifiés réels :",
                "driverRating": "Évaluation du conducteur",
                "acceptanceRating": "Taux d'acceptation",
                "cancellationRating": "Taux d'annulation",
                "period": "Période :"
            },
            "payoutToDriver": {
                "IFSCCode": "Code IFSC",
                "payoutID": "ID de paiement",
                "driverName": "Client",
                "driverPhone": "Numéro de téléphone",
                "companyName": "Entreprise",
                "period": "Période",
                "driverId": "ID# / Carte nationale d'identité",
                "cashWalletBalance": "Solde du portefeuille en espèces",
                "creditBalance": "Solde créditeur",
                "holdAmount": "Montant en attente",
                "minPayout": "Paiement minimum",
                "enterMinimumPayoutAmount": "Entrez le montant minimum de paiement",
                "payoutAmount": "Montant du paiement",
                "payoutDate": "Date de paiement",
                "actions": "Actions",
                "pay": "Payer",
                "remove": "Retirer",
                "payoutEndTime": "Heure de fin du paiement",
                "clearSuccess": "Le gain du chauffeur sélectionné a été effacé avec succès.",
                "clearFailed": "Échec de l'effacement des données de gain du chauffeur. Veuillez réessayer.",
                "amountKeepInDriverCashWallet": "Montant conservé dans le portefeuille en espèces du chauffeur",
                "selectDriver": {
                    "title": "",
                    "body": "Veuillez sélectionner le chauffeur à payer.",
                    "buttonTitle": "Ok"
                },
                "confirmClear": {
                    "title": "",
                    "body": "Êtes-vous sûr de vouloir effacer les données de gain de ce chauffeur ? Cette action ne peut pas être annulée.",
                    "buttonTitle": "Oui",
                    "closeButtonText": "Non"
                },
                "confirmPay": {
                    "body": "Êtes-vous sûr de vouloir payer le(s) chauffeur(s) sélectionné(s) ? <br> - Nombre de chauffeurs: <b>%{drivers}</b> <br> - Paiement minimum pour chaque chauffeur: %{currency} <b>%{min}</b> <br> - Montant en attente: %{currency}<b> %{hold}</b> <br> - Total du paiement: %{currency} <b>%{total}</b>",
                    "buttonTitle": "Oui",
                    "closeButtonText": "Non"
                },
                "paymentSuccessfully": "Paiements réglés avec succès aux chauffeurs",
                "paymentCompleted": "Paiement terminé : <br> - Paiement réussi : %{success} <br> - Échec : %{failed} <br> - Total payé avec succès : %{currency} %{total}",
                "noteSelectDrivers": "Remarque : sélectionnez les chauffeurs qui ont un compte bancaire pour effectuer le paiement.",
                "sendPayout": "Envoyer une notification de paiement réussi à l'adresse e-mail",
                "accountNumber": "Numéro de compte",
                "iBanNumber": "Numéro IBAN",
                "accountHoldName": "Nom du titulaire du compte",
                "bankName": "Nom de la banque",
                "selelctedDriverHasBeenPaid": "Le(s) chauffeur(s) sélectionné(s) a(ont) été payé(s)",
                "selelctedDriverHasBeenFailed": "Le(s) chauffeur(s) sélectionné(s) a(ont) échoué",
                "selelctedDriverHasBeenUpdateAsInvalid": "Le(s) chauffeur(s) sélectionné(s) a(ont) été mis à jour comme 'Compte bancaire invalide'",
                "selelctedDriverHasBeenUpdateAsValid": "Le(s) chauffeur(s) sélectionné(s) a(ont) été mis à jour comme 'Compte bancaire valide'",
                "isBankAccountOwner": "Bénéficiaire identique au chauffeur",
                "isBankAccountOwner_true": "Oui",
                "isBankAccountOwner_false": "Non",
                "beneficiaryIDIC": "ID# / IC# du bénéficiaire",
                "bankRelationship": "Relation",
                "bankRelationship_1": "Époux/Épouse",
                "bankRelationship_2": "Fils/Fille",
                "bankRelationship_3": "Frère/Sœur",
                "bankRelationship_4": "Parent",
                "bankRelationship_5": "Ami(e)s",
                "bankRelationship_6": "Autre : {0}",
                "bankStatus": "État de la banque",
                "emailStatement": "Déclaration par e-mail",
                "viewStatement": "Voir l'état",
                "downloadStatement": "Télécharger en PDF",
                "emailStatementSuccess": "Déclaration par e-mail envoyée avec succès",
                "NumberDriver": "Nombre de conducteurs",
                "NumberSupplier": "Numéro de fournisseur",
                "sendMailPayout": "Envoyer une notification de paiement réussi à l'adresse e-mail suivante :",
                "confirmPayoutTitle": "Êtes-vous sûr de vouloir payer les utilisateurs sélectionnés ?",
                "phoneOfBank": "Téléphone de la banque"
            },
            "payoutToMerchant": {
                "payoutId": "ID de paiement",
                "merchantName": "Nom du commerçant",
                "phone": "Numéro de téléphone",
                "accountNumber": "Numéro de compte",
                "iBanNumber": "Numéro IBAN",
                "bankAccountHolder": "Nom du titulaire du compte",
                "bankName": "Nom de la banque",
                "pendingAmount": "Montant en attente",
                "payoutAmount": "Montant du paiement",
                "payoutDate": "Date de paiement",
                "holdAmount": "Montant en attente",
                "minPayout": "Paiement minimum",
                "selelctedMerchantHasBeenPaid": "Le(s) commerçant(s) sélectionné(s) a(ont) été payé(s)",
                "selelctedMerchantHasBeenFailed": "Le(s) commerçant(s) sélectionné(s) a(ont) échoué",
                "pay": "Payer",
                "selectMerchant": {
                    "title": "Avertissement",
                    "body": "Veuillez sélectionner un commerçant à payer.",
                    "buttonTitle": "D'accord"
                },
                "confirmPay": {
                    "body": "Êtes-vous sûr de vouloir payer le(s) commerçant(s) sélectionné(s) ? <br> - Nombre de commerçants : <b>%{merchants}</b> <br> - Paiement minimum pour chaque chauffeur : %{currency} <b>%{min}</b> <br> - Montant en attente : %{currency}<b> %{hold}</b> <br> - Total du paiement : %{currency} <b>%{total}</b>",
                    "buttonTitle": "Oui",
                    "closeButtonText": "Non"
                },
                "sendPayout": "Envoyer une notification de paiement réussi à l'adresse e-mail",
                "HasBeenUpdateAsInvalid": "Le(s) commerçant(s) sélectionné(s) a(ont) été mis à jour comme 'Compte bancaire invalide'",
                "HasBeenUpdateAsValid": "Le(s) commerçant(s) sélectionné(s) a(ont) été mis à jour comme 'Compte bancaire valide'"
            },
            "payoutSupplier": {
                "selelctedSupplierHasBeenUpdateAsValid": "Le(s) fournisseur(s) sélectionné(s) a(ont) été mis à jour en tant que 'Compte bancaire valide'",
                "selelctedSupplierHasBeenUpdateAsInvalid": "Le(s) fournisseur(s) sélectionné(s) a été mis à jour en tant que 'Compte bancaire invalide'",
                "selelctedSupplierHasBeenFailed": "Le(s) fournisseur(s) sélectionné(s) a(ont) échoué",
                "selelctedSupplierHasBeenPaid": "Le(s) fournisseur(s) sélectionné(s) a(ont) été payé(s)",
                "confirmPay": {
                    "body": "Êtes-vous sûr de vouloir payer aux fournisseurs sélectionnés ? <br> - Nombre de fournisseurs : <b>%{drivers}</b> <br> - Montant minimum à payer pour chaque fournisseur : %{currency} <b>%{min}</b> <br> - Montant retenu : %{currency}<b> %{hold}</b> <br> - Montant total à payer : %{currency} <b>%{total}</b>",
                    "buttonTitle": "Oui",
                    "closeButtonText": "Non"
                },
                "agentName": "Nom de l'agent",
                "walletBalance": "Solde du portefeuille",
                "newAmount": "Nouveau Montant"
            },
            "settlementHistory": {
                "date": "Date",
                "driverName": "Nom du Driver",
                "dateRange": "Plage de dates",
                "totalTransaction": "Total des transactions réglées",
                "paidAmount": "Montant total réglé"
            },
            "settlement": {
                "driverName": "Chauffeurs",
                "driverIdPermit": "CNI du chauffeur / permis de conduire",
                "totalBookings": "Réservation totale",
                "total": "Montant total",
                "approved": "Approuvé",
                "acct": "ACCT",
                "gross": "GROSS",
                "percent": 0.03,
                "net": "NET"
            },
            "documentExpiry": {
                "driverName": "Nom du driver",
                "driverPhone": "Numéro de téléphone",
                "company": "Compagnie",
                "documentName": "Document",
                "expiredDate": "Date d'expiration",
                "status": "Statut",
                "statusStr": {
                    "NA": "N/A",
                    "expired": "Expiré ",
                    "active": "actif",
                    "expireSoon": "Expire bientôt"
                }
            },
            "referralDetail": {
                "bookingId": "Réservation #",
                "completedDate": "Heure de réalisation",
                "paidBy": "Payé par",
                "bookFrom": "Réservation à partir de",
                "driverName": "Nom du chauffeur",
                "driverIdPermit": "ID# / Carte nationale d'identité",
                "companyName": "Entreprise",
                "Passenger": "Passager",
                "Customer": "Client",
                "subtotal": "Sous-total",
                "subTotalFF": "Sous-total FF",
                "subtotalWithPromo": "Sous-total avec promotion",
                "referralEarning": "Gain de parrainage",
                "Amount": "Montant ",
                "Note": "Remarque",
                "Currency": "Devise",
                "PercentOfSubTotal": "{0}% du sous-total",
                "max": "max {0}",
                "referrerInfo": "Le chauffeur parraine un client",
                "phoneReferral": "Téléphone du chauffeur #",
                "driverNumber": "ID# / Carte nationale d'identité",
                "referralCode": "Code de parrainage",
                "reference": "Reference"
            },
            "referralHistory": {
                "driverName": "Nom du chauffeur",
                "phoneNumber": "Numéro de téléphone",
                "companyName": "Entreprise",
                "referralCode": "Code de parrainage",
                "commission": "Commission",
                "expectedReferralEarning": "Gain de parrainage attendu",
                "activePaxTooltip": "Passagers ayant échangé le code de référence auprès du conducteur avec au moins une réservation effectuée avec succès.",
                "referredPaxTooltip": "Les passagers qui ont échangé le code de référence auprès du conducteur mais qui n’ont encore effectué aucune réservation.",
                "activePax": "Nombre total de passagers actifs",
                "referredPax": "Nombre total de passagers référés",
                "detailFields": {
                    "passengerId": "ID du passager",
                    "passengerName": "Nom du passager",
                    "firstBookingDate": "1ère date de réservation complétée",
                    "firstBookingDateGMT": "Date de la première réservation complétée (GMT)",
                    "passengerPhone": "Numéro de téléphone du client",
                    "appliedDate": "Date de parrainage",
                    "referredByDriver": "Parrainé par le chauffeur",
                    "driverPhone": "Numéro de téléphone du chauffeur",
                    "referralCode": "Code de parrainage"
                },
                "showDetail": "Afficher",
                "detail": "Détail"
            },
            "paxReferralHistory": {
                "customerName": "Nom du client",
                "phoneNumber": "Numéro de téléphone",
                "referralCode": "Code de parrainage",
                "commission": "Commission totale",
                "activePaxTooltip": "Passagers ayant utilisé le code de parrainage avec au moins une réservation réussie.",
                "referredPaxTooltip": "Passagers ayant utilisé le code de parrainage mais n'ayant pas encore effectué de réservation.",
                "activePax": "Total des clients actifs",
                "referredPax": "Total des clients parrainés",
                "detailFields": {
                    "passengerId": "ID du passager",
                    "passengerName": "Nom du passager",
                    "firstBookingDate": "Date de la première réservation complétée",
                    "firstBookingDateGMT": "Date de la première réservation complétée (GMT)"
                },
                "showDetail": "Afficher",
                "detail": "Détail"
            },
            "driverRefersDriver": {
                "companyName": "Entreprise",
                "phoneNumber": "Numéro de téléphone",
                "username": "Nom d'utilisateur",
                "referralCode": "Code de parrainage",
                "referrer": "Parrain",
                "numberOfReferees": "Nombre de filleuls",
                "activeReferees": "Filleuls actifs",
                "referee": "Filleul",
                "refereePhone": "Numéro de téléphone du filleul",
                "refereeUsername": "Nom d'utilisateur du filleul",
                "referredDate": "Date de parrainage",
                "activatedDate": "Date d'activation",
                "referrerByDriver": "Parrain",
                "referrerPhone": "Numéro de téléphone du parrain",
                "referralStatus": "Statut du parrainage",
                "lifeTimeBookings": "Réservations à vie",
                "inReview": "En cours de révision",
                "activated": "Activé"
            },
            "driverWithdrawal": {
                "transferToEWallet": "Transféré vers un portefeuille électronique externe *{0}",
                "channelCode": "Code du canal",
                "channelName": "Nom du canal",
                "reversed": "Annulé",
                "currentBalanceTooltip": "Le solde actuel du portefeuille en espèces du conducteur avant la demande de retrait",
                "paymentTime": "Délais de réglement",
                "requestTime": "Demande de temps",
                "referenceId": "Référence #",
                "transactionId": "ID de la transaction",
                "description": "Description",
                "transferAmount": "Montant du transfert",
                "currency": "Devise",
                "approved": "Approuver",
                "rejected": "Rejeter",
                "failed": "Échec",
                "reason": "Raison"
            },
            "penaltyCompensation": {
                "penaltyAmount": "Peine",
                "totalCollect": "Besoin de payer en monnaie locale",
                "totalCollectInUSD": "Besoin de payer en USD",
                "compensationAmount": "Compensation",
                "compensationAmountInUSD": "Compensation (USD)",
                "penaltyReason": "Raison de la pénalité",
                "estimatedPrice": "Prix estimé",
                "estimatedPriceInUSD": "Prix estimé (USD)",
                "penaltyAmountInUSD": "Peine (USD)",
                "amount": "Montant",
                "amountInUSD": "Montant (USD)"
            },
            "imcompletePayment": {
                "bookingId": "ID de réservation",
                "bookFrom": "Réservation à partir de",
                "bookingTime": "Date/heure de réservation",
                "completedTime": "Date/heure de terminaison de la réservation",
                "customerName": "Nom du client",
                "requestedPaymentMethod": "Méthode de paiement demandée",
                "originalPaymentStatus": "État du paiement initial",
                "currentPaymentStatus": "État actuel du paiement",
                "updatedDateTime": "Date / heure mise à jour",
                "totalAmt": "Montant total",
                "originalOutstandingAmount": "Encours d'origine",
                "currentOutstandingAmount": "Encours courant",
                "outstandingAmountPaidBy": "Montant en souffrance payé par",
                "writeOffDebtMethod": "Écrire la méthode deb",
                "reason": "Raison",
                "customerPhone": "Numéro de téléphone",
                "amountCollected": "Montant collecté",
                "partialPaymentAmount": "Paiement partiel lors du dépôt"
            },
            "driverDeposit": {
                "dateAndTime": "Date & heure",
                "userName": "Nom d'utilisateur",
                "type": "Type",
                "newAmount": "Nouveau solde ",
                "topUpGCashReason": "Recharger par Gcash",
                "topUpReason": "Recharger à partir d'une carte de crédit *{0}",
                "cashWalletReason": "Recharge depuis le porte-monnaie",
                "topUpMOLPayReason": "Razer Pay [ {0} ]"
            },
            "refund": {
                "fullRefund": "Remboursement total",
                "partialRefund": "Remboursement partiel",
                "tripId": "ID du trajet",
                "route": "Itinéraire",
                "refundAmount": "Montant du remboursement",
                "refundTime": "Heure du remboursement",
                "paymentStatus": "Statut du paiement"
            },
            "merchant": {
                "store": "Magasin",
                "name": "Nom",
                "phoneNumber": "Numéro de téléphone",
                "bookingId": "Réservation #",
                "totalOrders": "Total des commandes",
                "completedOrders": "Commandes complétées",
                "canceledOrders": "Commandes annulées",
                "incidentOrders": "Incident",
                "revenue": "Revenu",
                "commission": "Commission",
                "earning": "Gain",
                "food": "Aliments ",
                "mart": "Marché ",
                "preferredMerchant": "Commerçant préféré",
                "regularMerchant": "Commerçant régulier",
                "companyName": "Entreprise"
            },
            "merchantCashTransactionHistory": {
                "companyName": "Entreprise",
                "dateTime": "Date et heure ",
                "merchantUserName": "Utilisateur marchand",
                "merchantUserPhone": "Numéro de téléphone",
                "merchantUserEmail": "Email",
                "merchantName": "Vendeur",
                "transactionType": "Type",
                "bookId": "Réservation #",
                "transactionId": "ID de la transaction",
                "operatorName": "Opérateur ",
                "reason": "Raison",
                "amount": "Montant ",
                "newBalance": "Nouveau solde ",
                "currencyISO": "Devise"
            },
            "merchantCreditTransactionHistory": {
                "dateTime": "Date et heure ",
                "merchantUserName": "Utilisateur marchand",
                "merchantUserPhone": "Numéro de téléphone",
                "merchantUserEmail": "Email",
                "merchantName": "Vendeur",
                "transactionType": "Type",
                "bookId": "Réservation #",
                "transactionId": "ID de la transaction",
                "operatorName": "Opérateur ",
                "reason": "Raison",
                "amount": "Montant ",
                "newBalance": "Nouveau solde ",
                "currencyISO": "Devise"
            },
            "deleteAccountRequest": {
                "date": "Date",
                "phone": "Téléphone",
                "username": "Nom d'utilisateur",
                "supportId": "ID de support",
                "requestFrom": "Demande de",
                "associatedApps": "Applications associées",
                "reason": "Raison"
            },
            "affiliationPayoutHistory": {
                "payoutId": "ID de paiement",
                "dateTime": "Date et heure",
                "payoutType": "Type",
                "accountHolderName": "Nom du titulaire du compte",
                "bankName": "Nom de la banque",
                "accountNumber": "Numéro de compte",
                "totalPayout": "Paiement total (USD)",
                "viewDetails": "Voir les détails",
                "notes": "Remarque",
                "bookId": "Réservation #",
                "transactionType": "Type de transaction",
                "transactionId": "ID de transaction (transfert automatique)",
                "settlement": "Règlement",
                "paymentMethod": "Type",
                "networkType": "Type de réseau"
            },
            "thirdPartyBooking": {
                "date": "Date",
                "bookingId": "ID de réservation",
                "externalId": "ID externe",
                "psgPhone": "Numéro de téléphone du passager",
                "psgName": "Nom du passager",
                "pickupLocation": "Lieu de prise en charge",
                "pickupLocationLatLong": "Latitude/Longitude du lieu de prise en charge",
                "dropoffLocation": "Lieu de dépôt",
                "dropoffLocationLatLong": "Latitude/Longitude du lieu de dépôt",
                "pickupTime": "Heure de prise en charge",
                "numOfPassenger": "Nombre de passagers",
                "action": "Action"
            },
            "external": "Fournisseur externe",
            "inHouse": "Fournisseur interne",
            "negative": "Négatif",
            "positive": "Positif",
            "supplierType": "Type de fournisseur",
            "supplierCompany": "Fournisseur/Entreprise",
            "invalidOrNoBank": "Invalide",
            "BankInfo": "Informations bancaires",
            "BankStatusConnect": "État de la passerelle",
            "payManually": "Paiement manuel",
            "payViaGateway": "Payez via %{gateway}",
            "payConfirmModal_manual": "Confirmation de paiement manuel",
            "payConfirmModal_manual_note": "Vous êtes sur le point de traiter un <b>paiement manuel</b> pour le %{type} sélectionné. Cela mettra à jour le solde du portefeuille de chaque %{type} et générera un rapport de paiement pour le traitement bancaire.",
            "payConfirmModal_auto": "Confirmation de Paiement Automatique",
            "payConfirmModal_auto_note": "Vous êtes sur le point de traiter des <b>paiements automatiques</b> au %{type} sélectionné via <b>%{gateway}</b>. Les paiements seront envoyés directement sur leurs comptes bancaires enregistrés.",
            "Eligible": "Éligible pour le paiement automatique",
            "EligibleNote": "Seuls %{value} fournisseurs sont éligibles pour le paiement automatique. Veuillez vérifier et mettre à jour les coordonnées bancaires des autres fournisseurs."
        }
    },
    "zoneSetting": {
        "Add": "Ajouter",
        "Import": "Importer",
        "Name": "Nom",
        "Status": "Statut",
        "Active": "Actif",
        "Inactive": "Inactif",
        "Deactivate": "Désactiver",
        "Activate": "Activer",
        "Delete": "Effacer",
        "Cancel": "Annuler",
        "Input_zone_name": "Entrer un nom de zone",
        "Save_zone": "Enregistrer la zone",
        "Clear_draw": "Effacer le dessin",
        "Edit": "Modifier",
        "Delete_zone_success": "La zone a bien été supprimée",
        "Delete_zone_fail": "Des erreurs sont survenues lors de la suppression de la zone",
        "Update_zone_fail": "Des erreurs sont survenues lors de la mise à jour de la zone",
        "Update_zone_success": "La nouvelle zone a bien été mise à jour",
        "Create_zone_fail": "Des erreurs sont survenues lors de la création de la zone",
        "Create_zone_success": "La nouvelle zone a bien été créée",
        "Draw_zone": "Veuillez dessiner la zone sur la carte",
        "Import_zones_successful": "Importation des zones réussie",
        "Import_zones_fail": "Import zones fail",
        "DELETE_ZONE": "Supprimer la zone",
        "ZONE_CONFIRM": "Do you want to delete zone ?",
        "Name_zone_required": "Name and Zone is required!",
        "Select_file": "Sélectionner un fichier",
        "No": "Non",
        "Yes": "Oui",
        "Import_zones_intercity_successful": "[{0}] zone(s) ont été importées avec succès, [{1}] ont échoué.",
        "Import_zones_intercity_successful_failed": "[{0}] zone(s) ont été importées avec succès, [{1}] ont échoué.",
        "Flat_zone": "Zone fixe",
        "Json_file": "Fichier JSON",
        "Import_zones": "Importer des zones",
        "timezone": "Fuseau horaire"
    },
    "companySetting": {
        "DELETE_COMPANY": "Supprimer l'entreprise",
        "DELETE_CONFIRM": "Do you want to delete company!",
        "DETAIL_COMPANY": "Detail company",
        "commissionValue": "Commission de l'entreprise",
        "connectStatus": "Stripe Connect",
        "connectStripe": "Connecter",
        "stripeConnectId": "ID du compte Stripe",
        "loginStripe": "Tableau de bord",
        "disconnectStripe": "Déconnecter",
        "Yes": "Oui",
        "No": "Non",
        "Cancel": "Annuler",
        "EDIT_COMPANY": "Modifier une compagnie",
        "ADD_COMPANY": "Ajouter une compagnie",
        "Name": "Nom",
        "Required_fields": "Champs requis",
        "Save": "Sauvegarder",
        "Actions": "Actions",
        "Edit": "Modifier",
        "Add": "Ajouter",
        "Show_per_page": "Eléments par page",
        "Page": "Page",
        "show_pages": "{0} - {1} de {2} Affiche",
        "Create_company_success": "La nouvelle compagnie a bien été créée",
        "Create_company_fail": "Des erreurs sont survenues en créant la compagnie",
        "Update_company_success": "La compagnie a bien été mise à jour",
        "Update_company_fail": "Des erreurs sont survenues en mettant à jour la compagnie",
        "Load_company_fail": "Des erreurs sont survenues en chargeant la compagnie",
        "Delete_company_success": "La compagnie a bien été supprimée",
        "Delete_company_fail": "Des erreurs sont survenues en supprimant la compagnie",
        "hideFare": "Toujours masquer le tarif",
        "Broadcast_orders": "Diffuser toutes les commandes",
        "paymentMethodsApply": "Méthode de paiement prise en charge",
        "emailsNotification": "Notification par e-mail",
        "CopySignUpLink": "Copier le lien d'inscription",
        "operationZone": "Zone d'opération",
        "delayBroadcast": "Afficher la commande après",
        "releaseTime": "Heure de libération",
        "advanceBookingVisibility": "Visibilité de la réservation anticipée",
        "advanceBookingVisibilityTooltip": "Définir le nombre de jours avant la date de prise en charge qu'un fournisseur peut voir la réservation. Cela garantit que les réservations sont libérées aux chauffeurs en temps opportun, en fonction de chaque fournisseur."
    },
    "dispatchSetting": {
        "Cut_off_time_range": "Date limite de réservation après les heures d'ouverture",
        "Cut_off_time_range_tooltip": "Si la fenêtre de coupure est de 22h à 6h, les clients peuvent toujours réserver avant 22h pour des ramassages après 22h. Cependant, si l'heure actuelle est entre 22h et 6h, le premier ramassage autorisé est après 6h + délai de préavis.",
        "GENERAL": "Général",
        "Offer_interval": "Intervalle d'offre",
        "Offer_interval_merchant": "Intervalle d'offre (commerçant)",
        "Offer_interval_merchant_toolTip": "Temps maximum pour qu'un commerçant accepte une commande",
        "Offer_interval_toolTip": "Délai maximum pour qu'un chauffeur accepte une réservation",
        "soundMarketplace": "Son",
        "sound": "Son",
        "Auto_re_dispatch_interval_toolTip": "Temps de pause entre 2 tours d'envoi",
        "Maximum_auto_dispatch_duration_toolTip": "Délai maximum d'envoi d'une réservation aux chauffeurs",
        "Seconds": "Secondes",
        "Auto_re_dispatch_interval": "Re-dispatch automatique intervalle",
        "Maximum_auto_dispatch_duration": "Durée maximale d'auto-dispatch",
        "Time_out": "Temps libre",
        "mins": "minutes",
        "minTimeBeforeReservation": "Ne pas autoriser le pilote à démarrer la réservation avant",
        "IN_ADVANCE": "En avance",
        "Assign_reservation_to_driver": "Assigner la réservation à un chauffeur",
        "Dispatcher_confirms_job_for_driver": "Le dispatcher confirme la course pour le chauffeur",
        "Dispatcher_confirms_job_for_offline_driver": "Le dispatcher confirme la réservation du chauffeur hors ligne",
        "Broadcast_orders": "Diffuser les commandes à toutes les entreprises",
        "Broadcast_orders_tooltip_1": "Activez ce paramètre si vous souhaitez simplement diffuser tous les trajets à tous les fournisseurs d'entreprise. Gardez à l'esprit que vous devez activer le mode de diffusion dans le profil de chaque entreprise.",
        "Minimum_book_ahead": "Minimum de temps d'avance pour la réservation",
        "Maximum_book_ahead": "Délai maximal de réservation en avance",
        "Maximum_period_recurring_oders_fleet": "Période maximale pour les commandes récurrentes (opérateur de flotte)",
        "Maximum_period_recurring_oders_corp": "Période maximale pour les commandes récurrentes (entreprise)",
        "Day": "Jour",
        "Week": "Semaines",
        "Month": "Mois",
        "hrs": "heures",
        "Driver_cancellation_duration": "Durée d'annulation du Driver",
        "Mins": "minutes",
        "Maximum_Day": "Le conducteur de réservations maximum peut accepter en une journée.",
        "Maximum_Accept_Reservation": "Le conducteur de réservations maximum peut accepter à la fois.",
        "jobRTDriver": "Temps de libération de l'emploi au conducteur (avant le ramassage)",
        "jobRTDriverDes": "Définir quand le travail devient visible pour le conducteur assigné dans son application avant l'heure de ramassage. - par exemple, 24 heures avant le ramassage.",
        "Local_notification_before": "Notification locale avant",
        "Dispatch_mode": "Mode de dispatch",
        "Manual": "Manuel",
        "Immediate_auto_dispatch": "Auto-dispatch immédiat",
        "Delayed_auto_dispatch": "Auto-dispatch retardé",
        "Auto_dispatch_before_pickup_time": "Auto-dispatch avant l'heure de départ",
        "Auto_Reassign_Before_Pickup_Time": "Réattribution automatique avant l'heure de ramassage",
        "Auto_Reassign_Before_Pickup_Time_Tooltip": "Réaffecte automatiquement le travail si le conducteur assigné n'a pas commencé le trajet X minutes avant l'heure de prise en charge. Remarque : Cela s'applique uniquement aux conducteurs fournisseurs internes.",
        "Required_fields": "Champs requis",
        "Shuttle": "NAVETTE",
        "Shuttle_Dispatch_mode": "Mode de répartition",
        "Dispatch_setting_Shuttle_Dispatch_mode_tooltip": "- Manual mode: Reservation will be saved and stayed on Cue of your Command Center under “Pending” status once reservation is created. After clicking on “Update booking” at the booking detail, reservation will be dispatched to your assigned drivers or to all drivers in case of no driver assigning. It will be integrated into driver device calendar and reminder will be available. <br>- Delayed mode:Reservation will be saved and stayed on Cue of your Command Center under “Pending” status once reservation is created. Reservation will be automatically dispatched before “time value at “Process in advance”” from pick up time to the assigned driver or the nearest available one in case of no driver assigning. <br>- Immediate auto-dispatch mode: Reservation will be automatically dispatched to all drivers once reservation is created. It will be integrated into driver device calendar and reminder will be available.",
        "Save": "Sauvegarder",
        "Process_in_advance": "Exécuté en avance",
        "Save_dispatch_success": "Le dispatch a bien été mis à jour",
        "Save_dispatch_fail": "Des erreurs sont survenues en mettant à jour le dispatch",
        "Dispatch_setting_general_tooltip": "Postuler pour réservation à la demande, réservation en avance avec un auto-dispatch retardé",
        "Dispatch_setting_Assign_reservation_to_driver_tooltip": "La réservation est assignée et acceptée automatiquement si cette option est activée",
        "Dispatch_setting_Driver_cancellation_duration_tooltip": "La durée est l'intervalle de temps entre l'heure de départ et le moment où le Driver annule la réservation",
        "Dispatch_setting_Dispatch_mode_tooltip": "- Mode manuel: La réservation sera enregistrée et restera sur Cue de votre Command Center sous le statut «en attente»  lorsque la réservation est créée. Après avoir cliqué sur \"Mise à jour de la réservation\" au détail de réservation, la réservation sera envoyée à vos Drivers affectés ou à tous les Drivers en cas de non attribution du Driver. Il sera intégré dans le calendrier du Driver,l et un rappel sera disponible. - Mode Retardement: la réservation sera enregistrée et restera sur Cue de votre Command Center sous le statut «en attente» lorsque la réservation est créée. La réservation sera envoyée automatiquement avant \"valeur temps au Processus à l'avance\" de l'heure de départ au Driver affecté ou du Driver le plus proche en cas de non attribution du Driver. - Mode auto-dispatch immédiat:la réservation sera automatiquement envoyée à tous les Drivers une fois la réservation créée. Elle sera intégrée dans le calendrier du Driver et un rappel sera disponible.",
        "Notification_nearby_drivers_before_pickup_time": "Notification des conducteurs à proximité avant l'heure de prise en charge",
        "Dispatch_setting_Maximum_Day_tooltip": "Cela permet de limiter le nombre de réservations qu'un chauffeur peut avoir le même jour. Applicable pour Marketplace et Interurbain.",
        "Maximum_Accept_Reservation_tooltip": "Le nombre de réservations acceptées par un chauffeur ne peut pas dépasser ce nombre. Cela limite le chauffeur à accepter trop de réservations à la fois. Applicable pour Marketplace et Interurbain.",
        "Notification_nearby_drivers_before_pickup_time_tooltip": "Si la réservation d'un client n'a pas été acceptée par un chauffeur avant l'heure définie, avant l'heure de prise en charge, le système notifiera les chauffeurs à proximité. Cela les incitera à vérifier le marché pour accepter la réservation.",
        "marketPlace": "MARCHÉ",
        "howFarDriverSeeBookingMarketplace": "Jusqu'à quelle distance le chauffeur peut voir les réservations sur le marché",
        "shortNoticeOrder": "Commande à court préavis",
        "shortNoticeOrderTooltip": "Définir le délai pour que les réservations soient considérées comme urgentes et visibles immédiatement pour tous les niveaux."
    },
    "voiceSMSSetting": {
        "ACCOUNT_SETTINGS": "Paramètres de compte",
        "Account_SID": "Compte SID",
        "Auth_Token": "Jeton d'autorisation",
        "Application_ID": "Identifiant d'application",
        "SMS_number_1": "Numéro de SMS 1",
        "SMS_number_2": "Numéro de SMS 2",
        "SMS_SETTINGS": "PARAMÈTRES SMS",
        "MASKED_PHONE_SETTINGS": "PARAMÈTRES DU TÉLÉPHONE MASQUÉ",
        "SMS_MARKETING_SETTINGS": "PARAMÈTRES DE MARKETING SMS",
        "Phone_number": "Numéro de téléphone",
        "Save": "Sauvegarder",
        "voiceSMS": "TWILIO",
        "DRIVER_APP": "Application conducteur ",
        "PASSENGER_APP": "Application Clients",
        "allowDriverToCallCC": "Permettre au chauffeur d'appeler le service d'assistance via :",
        "allowDriverToCallHelpdesk": "Permettre au chauffeur d'appeler le service d'assistance via :",
        "allowDriverToCallPassenger": "Permettre au chauffeur d'appeler le passager via :",
        "allowPassengerToCallCC": "Permettre au passager d'appeler le service d'assistance via :",
        "allowPassengerToCallHelpdesk": "Permettre au passager d'appeler le service d'assistance via :",
        "allowPassengerToCallDriver": "Permettre au passager d'appeler le chauffeur via :",
        "voip": "VOIP",
        "mobile": "Mobile",
        "bookingSMS": "Modèle de message",
        "bookingSMSTemplate": {
            "name": "Nom",
            "content": "Contenu",
            "action": "Action",
            "DELETE": "Supprimer le modèle de message",
            "DELETE_CONFIRM": "Êtes-vous sûr de vouloir supprimer le modèle de message sélectionné ?",
            "EDIT": "Modifier le modèle de message",
            "ADD": "Ajouter un modèle de message",
            "DETAIL": "Détail du modèle de message",
            "Update_success": "Le modèle de message a été mis à jour avec succès",
            "Create_success": "Le modèle de message a été créé avec succès",
            "Delete_success": "Le modèle de message a été supprimé avec succès",
            "Delete_fail": "Des erreurs sont survenues lors de la suppression du modèle de message",
            "Load_fail": "Des erreurs sont survenues lors du chargement du modèle de message",
            "Update_fail": "Des erreurs sont survenues lors de la mise à jour du modèle de message",
            "Create_fail": "Des erreurs sont survenues lors de la création du modèle de message"
        },
        "bookingSMSModal": {
            "title": "Ajouter un modèle de SMS",
            "save": "Enregistrer",
            "cancel": "Annuler",
            "titleMessage": "Envoyer un message",
            "template": "Modèle",
            "phoneNumber": "Numéro de téléphone",
            "content": "Contenu",
            "messageType": "Type de message",
            "inbox": "Boîte de réception",
            "sms": "SMS",
            "sendTo": "Envoyé à",
            "passenger": "Passager",
            "driver": "Chauffeur"
        }
    },
    "regularSetting": {
        "extraWaitTimeTooltip": "Fee to compensate the driver when he has to wait additional time for the customer till they are onboard.",
        "fareWaitTimeLater": "Tarif par minute (Réservation)",
        "fareWaitTimeNow": "Tarif par minute (Maintenant)",
        "transport": "Transport",
        "delivery": "Livraison",
        "Fer_Stop": "Frais par arrêt",
        "First_Stop": "Frais pour le premier arrêt",
        "Each_Stop": "Frais pour chaque arrêt supplémentaire",
        "Name": "Nom",
        "Pay_to_driver_Cash": "Paiement au fournisseur/chauffeur (Réservation en espèces)",
        "Last_Update": "Dernière Mise À Jour",
        "Status": "Statut",
        "Required_fields": "Champs requis",
        "Yes": "Oui",
        "No": "Non",
        "Cancel": "Annuler",
        "Save": "Sauvegarder",
        "Actions": "Actions",
        "Edit": "Modifier",
        "Add": "Ajouter",
        "Show_per_page": "Eléments par page",
        "Page": "Page",
        "show_pages": "{0} - {1} de {2} Affiche",
        "DELETE_CONFIRM": "Voulez-vous supprimer cet élément?",
        "ADD_REGULAR_RATE": "Ajouter tarif normal",
        "EDIT_REGULAR_RATE": "Modifier tarif de base",
        "DETAIL_REGULAR_RATE": "Détail taux régulier",
        "DELETE_REGULAR_RATE": "Supprimer le tarif normal",
        "Delete_confirm_regular_rate": "Voulez-vous supprimer cet élément?",
        "STARTING": "Prise en charge",
        "Starting_Now": "Prise en charge (instantané)",
        "Starting_Reservation": "Prise en charge (réservation)",
        "FIRST_DISTANCE_FEE": "TARIF PREMIÈRE DISTANCE",
        "First_distance_fee": "Première distance",
        "From": "Distance De",
        "To": "A`",
        "Fee_for_first_distance": "Frais pour la première distance",
        "SECOND_DISTANCE_FEE": "Tarif 2ème distance",
        "Second_distance_fee": "2ème distance",
        "AFTER_SECOND_DISTANCE": "Après la 2ème distance",
        "Fee_after_second_distance": "Frais de 2ème distance",
        "PER_MINUTE": "Par minute",
        "Fee_per_minute": "Tarif par minute",
        "mi": "Mi",
        "hour": "heure",
        "MINIMUM": "Minimum",
        "Minimum_Now": "Minimum (maintenant)",
        "Minimum_Reservation": "Minimum (réservation)",
        "PAX_MDISPATCHER_CANCELLATION": "Annulation du passager",
        "On_demand": "Immédiat",
        "Penalty": "Pénalité",
        "In_advance": "En avance",
        "PAX_MDISPATCHER_NO_SHOW": "No show du passager",
        "Driver_cancel_demand": "Politique d'annulation du chauffeur - à la demande",
        "Driver_cancel_advance": "Politique d'annulation du chauffeur - à l'avance",
        "Assign_car_type": "Attribuer type de véhicule",
        "Select_car_type": "Sélectionner le type de véhicule",
        "Active": "Actif",
        "Inactive": "Inactif",
        "Deactivate": "Désactiver",
        "DELETE_FLATE_RATE": "Supprimer forfait",
        "Delete_confirm_flat_rate": "Voulez-vous supprimer cet élément?",
        "EDIT_FLAT_RATE": "MODIFIER PRIX FORFAITAIRE",
        "ADD_FLAT_RATE": "Ajouter tarif forfaitaire",
        "DELETE_FLAT_RATE": "Supprimer le tarif fixe",
        "DELETE_HOURLY_RATE": "Supprimer tarif de mise a disposition",
        "Delete_confirm_hour_rate": "Voulez-vous supprimer cet élément?",
        "EDIT_HOURLY_RATE": "Editer un tarif de mise à disposition",
        "ADD_HOURLY_RATE": "Ajouter un tarif de mise à disposition",
        "DELETE_FLAT_ROUTE": "Supprimer l'itinéraire fixe",
        "DELETE_ROUTE_CONFIRM": "Êtes-vous sûr de vouloir supprimer l'itinéraire ?",
        "EDIT_ROUTE": "Modifier l'itinéraire ",
        "ADD_ROUTE": "Ajouter itinéraire",
        "Route_name": "Nom de l'itinéraire",
        "Route_type": "Type d'itinéraire",
        "Zone_to_zone": "Zone à zone",
        "Zipcode_to_zipcode": "Code postal vers code postal",
        "First_location": "Point de départ",
        "Second_location": "Arrivée",
        "First_location_zip_note": "* Remarques: Vous pouvez entrer plusieurs codes postaux en même temps en utilisant le symbole ','. Pour les codes consécutifs, utilisez le symbole '->' au lieu d'entrer un par un (ex: 90001 -> 90099, 90101, 90102, 90103, 90174, 90185)",
        "Second_location_zip_note": "* Remarques: Vous pouvez entrer plusieurs codes postaux en même temps en utilisant le symbole ','. Pour les codes consécutifs, utilisez le symbole '->' au lieu d'entrer un par un (ex: 90001 -> 90099, 90101, 90102, 90103, 90174, 90185)",
        "SINGLE_TRIP_SETUP": "Réglage du tarif aller simple",
        "Route_1": "Trajet 1 (Premier emplacement -> Second emplacement)",
        "Route_2": "Trajet 2 (Second emplacement ->  Premier emplacement)",
        "Limitation": "Limitation",
        "Unlimited": "Illimité",
        "Limited": "Limité",
        "Time_coverage": "Couverture temporelle",
        "Extra_time": "Temps supplémentaire",
        "ROUND_TRIP_SETUP": "Réglage du tarif aller-retour",
        "Round_trip": "Aller-retour",
        "ROUTES": "Routes",
        "Route_1_Fare": "Tarif du trajet 1",
        "Route_2_Fare": "Tarif du trajet 2",
        "Round_Trip_Fare": "Tarif de l'aller-retour",
        "Select_a_zone": "Sélectionnez une zone",
        "minute": "Minute",
        "VIEW_REGULAR_RATE": "Voir le tarif régulier en détail",
        "VIEW_FLAT_RATE": "Voir le tarif fixe",
        "VIEW_HOURLY_RATE": "Voir le tarif horaire",
        "HOURLY_PACKAGE_RATE": "Tarif horaire",
        "Package_name": "Nom Du Package",
        "Package_duration": "Durée Du Package",
        "PackageId": "ID du forfait",
        "Base_rate": "Taux De Base",
        "Distance_coverage": "Couverture de distance",
        "Extra_duration": "Durée Supplémentaire",
        "Extra_distance": "Distance Supplémentaire",
        "DELETE_HOURLY_PACKAGE": "Supprimer le forfait horaire",
        "DELETE_PACKAGE_CONFIRM": "Voulez-vous supprimer le tarif du forfait ?",
        "EDIT_PACKAGE": "Modifier le package",
        "VIEW_PACKAGE": "DÉTAIL DU PACKAGE",
        "ADD_PACKAGE": "Ajouter un package",
        "Fee_per_extra_duration": "Tarif par durée supplémentaire",
        "Fee_per_extra_distance": "Frais par distance supplémentaire",
        "hours": "Hour(s)",
        "days": "Day(s)",
        "Update_flat_rate_success": "Les tarifs au forfait ont bien été mis à jour",
        "Update_flat_rate_fail": "Des erreurs sont survenues en mettant jour les tarifs au forfait",
        "Created_flat_rate_success": "Les tarifs au forfait ont bien été créés",
        "Created_flat_rate_fail": "Des erreurs sont survenues en créant les tarifs au forfait",
        "Update_flat_rate_route_success": "Le tarif au forfait a bien été mis à jour ",
        "Update_flat_rate_route_fail": "Des erreurs sont survenues en mettant à jour le tarif au forfait",
        "Created_flat_rate_route_success": "Le tarif au forfait a bien été créé",
        "Created_flat_rate_route_fail": "Des erreurs sont survenues en créant le tarif au forfait",
        "Loading_flat_rate_fail": "Des erreurs sont survenues en chargeant les détails du tarif au forfait",
        "Delete_flat_rate_route_fail": "Des erreurs sont survenues en supprimant un tarif au forfait",
        "Delete_flat_rate_success": "Les tarifs au forfait ont bien été supprimée",
        "Delete_flat_rate_fail": "Des erreurs sont survenues en supprimant un tarif au forfait",
        "Update_intercity_rate_success": "Le tarif interurbain a été mis à jour avec succès",
        "Update_intercity_rate_fail": "Des erreurs sont survenues lors de la mise à jour du tarif interurbain",
        "Created_intercity_rate_success": "Le tarif interurbain a été créé avec succès",
        "Created_intercity_rate_fail": "Des erreurs sont survenues lors de la création du tarif interurbain",
        "Update_intercity_rate_route_success": "L'itinéraire du tarif interurbain a été mis à jour avec succès",
        "Update_intercity_rate_route_fail": "Des erreurs sont survenues lors de la mise à jour de l'itinéraire du tarif interurbain",
        "Created_intercity_rate_route_success": "L'itinéraire du tarif interurbain a été créé avec succès",
        "Created_intercity_rate_route_fail": "Des erreurs sont survenues lors de la création de l'itinéraire du tarif interurbain",
        "Loading_intercity_rate_fail": "Des erreurs sont survenues lors du chargement des détails du tarif interurbain",
        "Delete_intercity_rate_route_fail": "Des erreurs sont survenues lors de la suppression de l'itinéraire du tarif interurbain",
        "Delete_intercity_rate_success": "Le tarif interurbain a été supprimé avec succès",
        "Delete_intercity_rate_fail": "Des erreurs sont survenues lors de la suppression du tarif interurbain",
        "Update_regular_rate_success": "Les tarifs normaux ont bien été mis à jour",
        "Update_regular_rate_fail": "Des erreurs sont survenues lors de la mise à jour des tarifs normaux",
        "Create_regular_rate_success": "Un nouveau tarif normal a bien été créé",
        "Create_regular_rate_fail": "Des erreurs sont survenues lors de la création du tarif normal",
        "Update_hourly_rate_success": "Les tarifs de mise à disposition ont bien été mis à jour",
        "Update_hourly_rate_fail": "Des erreurs sont survenues en mettant jour les tarifs de mise à disposition",
        "Create_hourly_rate_success": "Les tarifs de mise à disposition ont bien été créés",
        "Create_hourly_rate_fail": "Des erreurs sont survenues en créant les packages de mise à disposition",
        "Update_hourly_rate_package_success": "Les packages de mise à disposition ont bien été mis à jour",
        "Update_hourly_rate_package_fail": "Des erreurs sont survenues en mettant jour les packages de mise à disposition",
        "Create_hourly_rate_package_success": "Les packages de mise à disposition ont bien été créés",
        "Create_hourly_rate_package_fail": "Des erreurs sont survenues en créant les packages de mise à disposition",
        "Load_hourly_rate_fail": "Des erreurs sont survenues lors du chargement des détails de tarifs de mise à disposition",
        "Update_hourly_status": "Des erreurs sont survenues en mettant à jour le statut de tarif de mis à disposition",
        "Delete_hourly_fail": "Des erreurs sont survenues en supprimant des tarifs de mise à disposition",
        "Delete_hourly_success": "Le tarif de mise à disposition a bien été supprimé",
        "Loading_regular_rate_fail": "Des erreurs sont survenues lors du chargement du tarif normal",
        "Update_regular_status_fail": "Des erreurs sont survenues lors de la mise à jour du statut du tarif normal",
        "Delete_regular_rate_success": "Le tarif normal a bien été supprimé",
        "Delete_regular_rate_fail": "Des erreurs sont survenues lors de la suppression du tarif normal",
        "Please_go_to_Car_Type_settings": "Veuillez aller dans les paramètres de types de véhicule pour appliquer ce tarif à des types de véhicule",
        "Car_type_filter": "Filtre de type de voiture",
        "Delete_package_error": "Delete package error!",
        "Pax_mDispatcher_cancellation_tooltip": "Politique d'annulation appliquée pour les passagers",
        "Penalty_tooltip": "Montant facturé",
        "Pax_mDispatcher_no_show_tooltip": "Politique de non-présentation appliquée pour les passagers. Ces frais seront facturés si les Drivers cliquent \"Non Présentation\" lorsque le passager n'est pas au point de départ",
        "detail_route": "Détail de l'itinéraire",
        "detail_package": "Détail du forfait",
        "THIRD_DISTANCE_FEE": "Frais de troisième distance",
        "AFTER_DISTANCE_FEE": "Après les frais de troisième distance",
        "Loading_delivery_rate_fail": "Des erreurs sont survenues lors du chargement des détails du tarif de livraison",
        "Update_delivery_rate_fail": "Des erreurs sont survenues lors de la mise à jour du tarif de livraison",
        "Update_delivery_rate_success": "Le tarif de livraison a été mis à jour avec succès",
        "Created_delivery_rate_success": "Le tarif de livraison a été créé avec succès",
        "Created_delivery_rate_fail": "Des erreurs sont survenues lors de la création du tarif de livraison",
        "Starting_fee": "Frais de départ",
        "First_distance": "Première distance",
        "Second_distance": "Deuxième distance",
        "Third_distance": "Troisième distance",
        "Fee_for_second_distance": "Frais pour la deuxième distance",
        "Fee_for_third_distance": "Frais pour la troisième distance",
        "Fee_after_third_distance": "Frais après la troisième distance",
        "Assign_rate_to_car_type": "Attribuer un tarif au type de voiture",
        "car_type": "Type de voiture",
        "PRICE_ADJUSTABLE": "Prix ajustable",
        "Amount_Step": "Prix ajustable",
        "Tax": "Taxe",
        "TechFee": "Frais techniques",
        "Pay_to_driver": "Payez au conducteur",
        "Pay_to_driver_tooltip": "Options pour compenser les chauffeurs :\n- Montant fixe : Un montant fixe que le chauffeur recevra.\n- Commission : La commission définie du chauffeur appliquée au montant de la pénalité",
        "Fix_amount": "Montant fixe",
        "Commission": "Commission",
        "fareFlat": "Tarif fixe",
        "flatRoute": "Itinéraire fixe",
        "Mode": "Mode",
        "speedThresholdKM": "Seuil de vitesse (km/h)",
        "speedThresholdMI": "Seuil de vitesse (mi/h)",
        "timeAndMileage": "Temps et distance",
        "timeOrMileage": "Temps ou distance",
        "perDistanceKM": "Par kilomètre",
        "perDistanceMI": "Par mile",
        "perTime": "Par minute",
        "regularRates": "Tarifs réguliers",
        "newRate": "Nouveau tarif",
        "enterName": "Entrer le nom du tarif",
        "actualMode": "Tarif réel",
        "estimatedMode": "Tarif estimé",
        "feePerStop": "Frais par arrêts supplémentaires",
        "extraWaitTime": "Temps d'attente supplémentaire",
        "startingFee": "Départ",
        "minimumFee": "Minimum",
        "minAppend": "/min",
        "kmAppend": "/km",
        "miAppend": "/mi",
        "kmhrAppend": "km/h",
        "mihrAppend": "mi/h",
        "feePerKm": "Par kilomètre",
        "feePerMi": "Par mile",
        "feeSpeedThreshold": "Seuil de vitesse",
        "serviceType": "Type de service",
        "fareMode": "Formule",
        "calculationMode": "Mode de calcul",
        "timeChangeMode": "Mode de facturation du temps",
        "minimum_Percent_Adjust": "% minimum du tarif estimé",
        "maximum_Percent_Adjust": "% maximum du tarif estimé",
        "AllowAdjustPrice": "Permettre au client d'ajuster le prix",
        "Calculation": "Calcul",
        "distanceTier": "Niveau de distance",
        "perKm": "Frais par km",
        "perMi": "Frais par mi",
        "flatFee": "Frais fixe",
        "defaultRate": "Tarif par défaut",
        "timeRange": "Plage horaire",
        "bookingType": "Type de réservation",
        "rateDetail": "Détail du tarif",
        "subRate": "Sous-tarif",
        "specialRates": "Tarifs spéciaux",
        "surcharge": "Supplément",
        "penalty": "Pénalité",
        "basedOriginMode": "Basé sur l'heure de prise en charge initiale",
        "basedDriverMode": "Basé sur l'heure de prise en charge du chauffeur",
        "hourlyRate": "Tarif horaire",
        "flat_Fare": "Tarif fixe",
        "flatFeeOption": "Frais fixe",
        "fareModeTooltip": "Le temps ou la distance ne s'applique qu'aux tarifs clients, cela ne s'appliquera pas au tarif de paiement du fournisseur/chauffeur.",
        "cloneRate": "Taux de clonage",
        "rateName": "Nom du tarif",
        "Infinity": "Infinity",
        "Fee": "Frais",
        "headerTile": "Saisir le titre de l'en-tête",
        "enterFooter": "Saisir le titre du pied de page",
        "invoiceNo": "Facture N°",
        "paidOn": "Payé le",
        "amountPaid": "Montant payé",
        "isFeePerSeatActive": "Frais par passager",
        "minSeat": "Nombre minimum de passagers",
        "minSeatTooltip": "Ceci est le nombre minimum de sièges à facturer pour une réservation.",
        "dropOffZoneIds": "Zones de dépôt",
        "applyGeniusDiscount": "Booking.com : Appliquer la réduction Genius (5 %)"
    },
    "flatRateSettings": {
        "flatZoneNote": "Les zones que vous créez ici sont uniquement utilisées pour configurer vos tarifs fixes."
    },
    "deliverySetting": {
        "Name": "Nom",
        "Last_Update": "Dernière mise à jour",
        "Status": "Statut",
        "Actions": "Actions"
    },
    "sharingSetting": {
        "EDIT_RATE": "Modifier le tarif de partage de rue",
        "ADD_RATE": "Ajouter un tarif de partage de rue",
        "VIEW_RATE": "Voir le tarif de partage de rue",
        "Name": "Nom",
        "startingFee": "Tarif de départ",
        "minimumFee": "Tarif minimum",
        "Update_streetSharing_rate_fail": "Des erreurs sont survenues lors de la mise à jour du tarif de partage de rue",
        "Update_streetSharing_rate_success": "Le tarif de partage de rue a été mis à jour avec succès",
        "Created_streetSharing_rate_success": "Le tarif de partage de rue a été créé avec succès",
        "Created_streetSharing_rate_fail": "Des erreurs sont survenues lors de la création du tarif de partage de rue",
        "Loading_streetSharing_rate_fail": "Des erreurs sont survenues lors du chargement des détails du tarif de partage de rue",
        "Delete_streetSharing_rate_success": "Le tarif de partage de rue a été supprimé avec succès",
        "Delete_streetSharing_rate_fail": "Des erreurs sont survenues lors de la suppression du tarif de partage de rue",
        "Delete_streetSharing_rate": "Supprimer le tarif de partage de rue",
        "Assign_Car": "Attribuer un type de voiture"
    },
    "carTypeSetting": {
        "ID": "ID de type de carte",
        "newService": "Nouveau service",
        "editService": "Modifier le service",
        "serviceInfo": "Informations sur le service",
        "name": "Nom",
        "namePH": "Nom du type de voiture",
        "enterNumber": "Entrer un numéro",
        "appDisplayName": "Nom affiché dans l'application",
        "shortDescription": "Courte description",
        "maxPassengers": "Nombre maximal de passagers",
        "maxLuggage": "Nombre maximal de bagages",
        "vehiclePhoto": "Photos du véhicule",
        "iconShowList": "Icône à afficher dans la liste",
        "imageShowWeb": "Image à afficher sur le web",
        "carPinOnMap": "PIN de la voiture sur la carte",
        "recommendedSize": "Taille recommandée :",
        "serviceSetting": "Paramètres du service",
        "serviceType": "Type de service",
        "reservation": "Réservation",
        "onDemand": "À la demande",
        "destinationSetting": "Paramètre de destination",
        "requireDestination": "Exiger une destination",
        "extraDestination": "Destination supplémentaire",
        "calculatorFareMode": "Mode de calcul du tarif",
        "hideDestinationOnDemand": "À la demande",
        "meteredFare": "Tarif au compteur",
        "quotedFare": "Tarif estimé",
        "availableZones": "Zones disponibles",
        "dispatchAssociation": "Association de répartition",
        "Save": "Enregistrer",
        "Edit": "Modifier",
        "Cancel": "Annuler",
        "validateName": "Veuillez entrer un nom",
        "validateAppDisplayName": "Veuillez entrer un nom d'affichage dans l'application",
        "validateSelectImage": "Veuillez sélectionner une image",
        "updateSuccess": "Mise à jour réussie",
        "createSuccess": "Création réussie",
        "failApi": "Quelque chose s'est mal passé !",
        "validateRequire": "Veuillez spécifier le nombre de passagers et vérifier les bagages."
    },
    "carSetting": {
        "Details": "Détails",
        "vehicleInfo": "Informations sur le véhicule",
        "Documents": "Documents",
        "vehicle": "Véhicule",
        "addVehicle": "Ajouter un véhicule",
        "detailVehicle": "Détails du véhicule",
        "additionalVehicleTitle": "Informations supplémentaires sur le véhicule",
        "Phone_Number_Tooltip": "Entrer un numéro de téléphone spécifique au véhicule pour l'utilisation du client. Si non fourni, les appels seront redirigés vers le numéro personnel du chauffeur. Idéal pour les fournisseurs équipant les véhicules de téléphones dédiés.",
        "discardChange": "Annuler les modifications",
        "model_name_is_required": "Le nom du modèle est requis",
        "DELETE_CAR": "Ajouter",
        "DELETE_CONFIRM": "Voulez-vous supprimer le véhicule sélectionnée?",
        "Yes": "Oui",
        "Cancel": "Annuler",
        "EDIT_CAR": "Modifier",
        "CREATE_CAR": "Ajouter",
        "Plate_Number": "Numéro De La Plaque",
        "Car_Type": "Type De Véhicule",
        "Select_car_type": "Sélectionner le type de véhicule",
        "Make": "Marque",
        "Select_car_make": "Sélectionner marque de véhicule",
        "Model": "Modèle",
        "Select_a_car_model": "Sélectionner modèle de véhicule",
        "Year": "Année",
        "Select_year": "Sélectionnez l'année",
        "Hardware_Meter": "Compteur Physique",
        "VIN": "Numéro d'identification du véhicule (NIV)",
        "Company": "Compagnie",
        "Select_company": "Sélectionner une compagnie",
        "Max_Passengers": "Nbe maximum de passagers",
        "Max_Luggage": "Nbe maximum de bagages",
        "Color": "Couleur",
        "License_expiry": "Expiration du contrôle technique",
        "Required_fields": "Champs requis",
        "Save": "Sauvegarder",
        "Add": "Ajouter",
        "Car_Model": "Modèle De Véhicule",
        "Created_Date": "Créer Date",
        "Status": "Statut",
        "Actions": "Actions",
        "Show_per_page": "Eléments par page",
        "Page": "Page",
        "show_pages": "{0} - {1} de {2} Affiche",
        "Active": "Actif",
        "activeVehicle": "Véhicule actif",
        "Inactive": "Inactif",
        "Edit": "Modifier",
        "Deactivate": "Désactiver",
        "Activate": "Activer",
        "Delete": "Effacer",
        "Name": "Nom",
        "MODEL_LIST": "Modèle",
        "Model_Name": "Modèle De Véhicule",
        "Add_Model": "Ajouter un modèle de véhicule",
        "DELETE_CAR_MODEL": "Supprimer le modèle de voiture",
        "DELETE_CONFIRM_MODEL": "Voulez-vous supprimer le modèle de voiture ?",
        "DELETE_CAR_MAKE": "Supprimer la marque de voiture",
        "DELETE_CONFIRM_CAR_MAKE": "Voulez-vous supprimer cette marque de voiture ?",
        "EDIT_CAR_MAKE": "Modifier marque de véhicule",
        "CREATE_CAR_MAKE": "Ajouter marque de véhicule",
        "Assign_Rate": "Attribuez tarif",
        "ASSIGN_RATE": "Attribuez tarif",
        "Car_type_ID": "Identification Du Type De Véhicule",
        "App_Display_Name": "Nom De L'affichage De L'application",
        "Affiliate_car_type": "Type De Véhicule Affilié",
        "Regular_rate": "Tarif normal",
        "Zone": "Zone de filtre",
        "Rate": "Tarif",
        "Zone_Rate": "Zone - Tarif",
        "Flat_Fare": "Forfait",
        "Flat_Delivery": "Tarif fixe de livraison",
        "Select_flat_rate": "Sélectionnez forfait.",
        "Hourly_daily_rate": "Horaire / quotidien",
        "Dispatch_To": "Dispatch À",
        "Normal_Fare": "Régulier",
        "Upload_an_image": "Aucune image sélectionnée",
        "DETAIL_CAR": "Détail de la voiture",
        "DELETE_MULTI_CAR": "Supprimer les voitures sélectionnées",
        "DELETE_MULTI_CAR_CONFIRM": "Voulez-vous supprimer ces véhicules ? Seuls les véhicules inactifs peuvent être supprimés.",
        "DETAIL_CAR_MAKE": "Detail Car Make",
        "Car_Make": "Marque du véhicule",
        "Create_car_success": "Un nouveau véhicule a bien été créé",
        "Update_car_success": "Ce véhicule a bien été mis à jour",
        "Update_car_fail": "Des erreurs sont survenues lors de la mise à jour de la voiture",
        "Create_car_fail": "Les erreurs se sont produites lors de la création du véhicule",
        "Load_car_fail": "Des erreurs sont survenues en chargeant le véhicule",
        "Delete_car_fail": "Des erreurs sont survenues en supprimant les véhicules",
        "Delete_car_success": "Le véhicule a bien été supprimé",
        "Change_cars_status_success": "Tous les statuts des véhicules ont bien été modifiés",
        "Change_cars_status_fail": "Des erreurs sont survenues en changeant les statuts des véhicules",
        "Delete_cars_success": "Tous les véhicules sélectionnés ont bien été supprimé",
        "Delete_cars_fail": "Des erreurs sont survenues en supprimant les véhicules",
        "Update_car_type_success": "Les catégories de véhicules ont bien été mis à jour",
        "Update_car_type_fail": "Des erreurs sont survenues en mettant à jour les catégories de véhicules",
        "Load_car_type_details_fail": "Les erreurs se sont produites lors du chargement des détails du type de véhicule",
        "Update_car_make_fail": "Des erreurs sont survenues lors de la mise à jour des marques de véhicules",
        "Update_car_make_success": "Les marques de véhicules ont bien été mises à jour",
        "Create_car_make_fail": "Des erreurs sont survenues lors de la création de marques de véhicules",
        "Create_car_make_success": "Une nouvelle marque de véhicule a bien été créée",
        "Update_car_model_fail": "Des erreurs sont survenues lors de la mise à jour des modèles de véhicules",
        "Update_car_model_success": "Les modèles de véhicules ont bien été mises à jour",
        "Create_car_model_fail": "Des erreurs sont survenues lors de la création de modèles de véhicules",
        "Create_car_model_success": "Un nouveau modèle de véhicule a bien été créée",
        "Loading_car_model_fail": "Des erreurs sont survenues lors du chargement du modèle de véhicule",
        "Delete_car_make_success": "La marque de véhicule a bien été supprimée",
        "Delete_cat_make_fail": "Des erreurs sont survenues lors de la suppression de la marque de véhicule",
        "Delete_regular_rate_success": "Suppression du tarif régulier réussie",
        "Delete_regular_rate_fail": "Erreur de suppression du tarif régulier",
        "Update_status_error": "Erreur de mise à jour du statut",
        "Case_number": "Numéro de dossier",
        "Phone_Number": "Numéro de téléphone",
        "ERROR_INPUT_VALIDPHONE": "Veuillez spécifier un numéro de téléphone valide",
        "Car_type_filter": "Filtre de type de véhicule",
        "No": "Non",
        "Intercity_Rate": "Tarif interurbain",
        "Select_intercity_rate": "Sélectionner le tarif interurbain",
        "Delivery_Rate": "Tarif de livraison",
        "Select_delivery_rate": "Sélectionner le tarif de livraison",
        "vehicleOwner": "Nom du propriétaire du véhicule",
        "EDIT_CAR_COLOR": "Modifier la couleur de la voiture",
        "DETAIL_CAR_COLOR": "Détail de la couleur de la voiture",
        "CREATE_CAR_COLOR": "Ajouter la couleur du véhicule",
        "Car_Color": "Couleur de la voiture",
        "Update_car_color_fail": "Des erreurs sont survenues lors de la mise à jour de la couleur de la voiture.",
        "Update_car_color_success": "La couleur de la voiture a été mise à jour avec succès.",
        "Create_car_color_fail": "Des erreurs sont survenues lors de la création de la couleur de la voiture.",
        "Create_car_color_success": "Nouvelle couleur de voiture créée avec succès",
        "Delete_car_color_success": "La couleur de la voiture a été supprimée avec succès.",
        "Delete_car_color_fail": "Des erreurs sont survenues lors de la suppression de la couleur de la voiture.",
        "DELETE_CAR_COLOR": "Supprimer la couleur de la voiture",
        "DELETE_CONFIRM_CAR_COLOR": "Voulez-vous supprimer cette couleur de voiture ?",
        "sharing_Rate": "Tarif de partage de rue",
        "bookingAffiliate": "Type de voiture affilié à Booking.com",
        "streetSharing": "Partage de rue",
        "colorCode": "Code couleur",
        "selectColorCode": "Sélectionner le code couleur"
    },
    "operationSetting": {
        "Driver": "Chauffeurs",
        "Search_driver_name": "Rechercher par nom de pilote",
        "Company": "Compagnie",
        "License_plate": "Plaque d'immatriculation",
        "Select_license_plate": "Sélectionnez la plaque d'immatriculation",
        "Shift": "Horraires",
        "Zone": "Zone de filtre",
        "Required_fields": "Champs requis",
        "Save": "Sauvegarder",
        "No": "Non.",
        "Car_Type": "Type De Véhicule",
        "Plate_Number": "Numéro De La Plaque",
        "Unassign": "Annuler l'attribution",
        "Please_choose_driver": "Veuillez choisir un pilote.",
        "Please_choose_company": "Veuillez choisir une entreprise.",
        "Please_license_plate": "Veuillez choisir un plaque d'immatriculation.",
        "Please_choose_shift": "Veuillez choisir un shift",
        "Please_choose_zone": "Veuillez choisir une zone.",
        "CONFIRM_UNASSIGN": "Voulez-vous annuler l'attribution de ce pilote?",
        "Assign_success": "L'opération a été assigné avec succès",
        "Unassign_success": "Le pilote a bien été affecté"
    },
    "paymentMethod": {
        "cash": "Paiement à bord",
        "easyPaisa": "Easy Paisa",
        "jazzCash": "Jazz Cash",
        "cashBySender": "Payé par l'expéditeur",
        "cashByRecipient": "Cash par le destinataire",
        "personalCard": "Carte bleue",
        "corporateCard": "Carte d'entreprise",
        "qrCodePayment": "Paiement par code QR",
        "directBilling": "Facturation directe",
        "externalCard": "Carte externe",
        "mDispatcherCard": "Carte Concierge",
        "corporatePrepaid": "Payé via Wallet ",
        "fleetCard": "Carte externe",
        "applePay": "Apple Pay",
        "creditExternalCard": "Carte de crédit",
        "googlePay": "Google Pay",
        "wallet": "Portefeuille",
        "BankOfGeorgia": "Banque de Géorgie",
        "tnGeWalletlet": "TnG eWallet",
        "paymentMethod_1": "Paiement à bord",
        "paymentMethod_2": "Carte bleue",
        "paymentMethod_3": "Carte Concierge",
        "paymentMethod_4": "Carte d'entreprise",
        "paymentMethod_5": "Facturation directe",
        "paymentMethod_6": "Carte externe",
        "paymentMethod_7": "Payé via Wallet ",
        "paymentMethod_8": "Paiement par code QR",
        "paymentMethod_9": "Apple Pay",
        "paymentMethod_11": "Airpay",
        "paymentMethod_12": "Carte de crédit",
        "paymentMethod_13": "Portefeuille",
        "paymentMethod_14": "TnG eWallet",
        "paymentMethod_16": "Payé par l'expéditeur",
        "paymentMethod_17": "Cash par le destinataire",
        "paymentMethod_19": "Boost eWallet",
        "paymentMethod_20": "Vipps",
        "paymentMethod_21": "ZainCash",
        "paymentMethod_23": "Google Pay",
        "paymentMethod_25": "Easy Paisa",
        "paymentMethod_27": "Samsung Pay",
        "paymentMethod_28": "Kakao Pay",
        "paymentMethod_29": "Naver Pay",
        "paymentMethod_30": "WeChat Pay",
        "paymentMethod_31": "Alipay",
        "paymentMethod_32": "PayNow",
        "paymentMethod_33": "GrabPay",
        "paymentMethod_34": "Cash App Pay",
        "vippseWallet": "Vipps",
        "paymentMethod_credit": "Carte personnelle",
        "paymentMethod_razerPay": "RazerPay",
        "paymentMethod_gCash": "GCash",
        "paymentMethod_zainCash": "ZainCash",
        "paymentMethod_xenDit": "Xendit",
        "paymentMethod_alipayExternal": "Alipay",
        "paymentMethod_FIB": "FIB",
        "paymentMethod_SantimPay": "SantimPay",
        "paymentMethod_ksher": "Ksher",
        "paymentMethod_paydunya": "PayDunya",
        "paymentMethod_fawry": "Fawry",
        "paymentMethod_BankOfGeorgia": "Banque de Géorgie",
        "paymentLink": "Lien de paiement",
        "paymentMethod_xendit": "Xendit",
        "paymentMethod_easyPaisa": "Easy Paisa",
        "paymentMethod_jazzCash": "Jazz Cash",
        "paymentMethod_flooz": "Flooz",
        "paymentMethod_tmoney": "Tmoney",
        "paymentMethod_samsung_pay": "Samsung Pay",
        "paymentMethod_kakao_pay": "Kakao Pay",
        "paymentMethod_naver_pay": "Naver Pay",
        "paymentMethod_wechat_pay": "WeChat Pay",
        "paymentMethod_alipay": "Alipay",
        "paymentMethod_paynow": "PayNow",
        "paymentMethod_grabpay": "GrabPay",
        "paymentMethod_cashapp": "Cash App Pay"
    },
    "changePassword": {
        "Change_password": "Changer le mot de passe",
        "Current_password": "Mot de passe actuel",
        "New_password": "Nouveau mot de passe",
        "Confirm_password": "Confirmez le mot de passe",
        "ERROR_INPUT_PASSWORD": "Veuillez saisir le mot de passe",
        "ERROR_INPUT_VALID_PASSWORD": "Le mot de passe doit contenir au moins 8 caractères, un chiffre et un caractère spécial",
        "ERROR_INPUT_MATCH_PASSWORD": "Le mot de passe ne correspond pas. Veuillez réessayer",
        "Save": "Sauvegarder",
        "Cancel": "Annuler"
    },
    "userProfile": {
        "My_account": "Mon compte",
        "Username": "Nom d'utilisateur",
        "First_name": "Prénom",
        "Last_name": "Nom de famille",
        "Phone_number": "Numéro de téléphone",
        "Email_address": "Adresse e-mail",
        "Address": "Adresse",
        "Save": "Sauvegarder",
        "Edit_profile": "Changer le mot de passe",
        "Change_password": "Changer le mot de passe",
        "ERROR_INPUT_USERNAME": "Veuillez saisir le nom d'utilisateur.",
        "ERROR_INPUT_FIRSTNAME": "Veuillez saisir le prénom.",
        "ERROR_INPUT_VALID_EMAIL": "Veuillez entrer un email valide",
        "Required_fields": "Champs requis"
    },
    "General": {
        "widgetChat": "Support / Chat",
        "searchQueuingDriver": "Rechercher : Nom du chauffeur, Numéro de téléphone",
        "search": "Chercher",
        "User": "Utilisateur ",
        "My_Account": "Mon compte",
        "Product_Discovery": "Découverte de produit",
        "Sign_out": "Se déconnecter",
        "My_site": "Mon site",
        "Command_center": "Centre de contrôle",
        "Notifications": "Notifications",
        "Show_all": "Tout afficher",
        "SOS_Notifications": "Notifications SOS",
        "You_dont_have_any_message": "You dont have any message",
        "Mon": "Lun",
        "Tue": "Mar",
        "Wed": "Mer",
        "Thu": "Jeu",
        "Fri": "Ven",
        "Sat": "Sam",
        "Sun": "Dim",
        "Now": "Maintenant",
        "NowComplete": "Maintenant (Heure de prise en charge réelle)",
        "hrs": "Heures",
        "patmentMethod_1": "Paiement à bord",
        "patmentMethod_2": "Carte bleue",
        "patmentMethod_3": "mDispatch card",
        "patmentMethod_4": "Carte d'entreprise",
        "patmentMethod_5": "Facturation directe",
        "patmentMethod_6": "Carte externe",
        "patmentMethod_7": "Payé via Wallet ",
        "patmentMethod_8": "Paiement par code QR",
        "patmentMethod_9": "Apple Pay",
        "patmentMethod_10": "Apple Pay",
        "patmentMethod_12": "Carte de crédit",
        "patmentMethod_13": "Portefeuille",
        "patmentMethod_14": "TnG eWallet",
        "patmentMethod_16": "Payé par l'expéditeur",
        "patmentMethod_17": "Payé par le destinataire",
        "patmentMethod_19": "Boost",
        "patmentMethod_20": "Vipps",
        "patmentMethod_23": "Google Pay",
        "patmentMethod_24": "Lien de paiement",
        "patmentMethod_25": "Easy Paisa",
        "patmentMethod_26": "Jazz Cash",
        "patmentMethod_27": "Samsung Pay",
        "patmentMethod_28": "Kakao Pay",
        "patmentMethod_29": "Naver Pay",
        "patmentMethod_30": "WeChat Pay",
        "patmentMethod_31": "Alipay",
        "patmentMethod_32": "PayNow",
        "patmentMethod_33": "GrabPay",
        "patmentMethod_34": "Cash App Pay",
        "patmentMethod_ZainCash": "ZainCash",
        "patmentMethod_Xendit": "Xendit",
        "patmentMethod_FIB": "FIB",
        "patmentMethod_SantimPay": "SantimPay",
        "patmentMethod_GCash": "GCash",
        "patmentMethod_cash": "En espèces",
        "patmentMethod_credit": "Carte personnelle",
        "patmentMethod_mDispatcher": "Partner card",
        "patmentMethod_corpCredit": "Carte d'entreprise",
        "patmentMethod_directBilling": "Facture directe",
        "patmentMethod_fleetCard": "Carte externe",
        "patmentMethod_prepaid": "Prépayé d'entreprise",
        "patmentMethod_QRCode": "Code QR",
        "patmentMethod_applePay": "Apple Pay",
        "patmentMethod_easyPaisa": "Easy Paisa",
        "patmentMethod_jazzCash": "Jazz Cash",
        "patmentMethod_prePaid": "Prépayé d'entreprise",
        "patmentMethod_GooglePay": "Google Pay",
        "patmentMethod_creditCardExternal": "Carte de crédit",
        "patmentMethod_exXendit": "QRIS",
        "patmentMethod_PaxWallet": "Portefeuille",
        "patmentMethod_TnGeWallet": "TnG eWallet",
        "patmentMethod_boosteWallet": "Boost",
        "patmentMethod_Vipps": "Vipps",
        "patmentMethod_exZainCash": "ZainCash",
        "patmentMethod_exGCash": "GCash",
        "patmentMethod_exPayTM": "PayTM",
        "patmentMethod_exFlooz": "Flooz",
        "patmentMethod_exTmoney": "Tmoney",
        "patmentMethod_exTelebirr": "GCash",
        "paymentMethod_exzainCash": "ZainCash",
        "paymentMethod_exXendit": "Xendit",
        "paymentMethod_exalipay": "Alipay",
        "paymentMethod_exFIB": "FIB",
        "paymentMethod_exSantimPay": "SantimPay",
        "patmentMethod_exKsher": "Ksher",
        "paymentMethod_paydunya": "PayDunya",
        "paymentMethod_exfawry": "Fawry",
        "patmentMethod_exBankOfGeorgia": "Banque de Géorgie",
        "patmentMethod_exPayDunya": "PayDunya",
        "patmentMethod_21": "ZainCash",
        "patmentMethod_paymentLink": "Lien de paiement",
        "patmentMethod_card": "Carte personnelle",
        "patmentMethod_corporateCard": "Carte d'entreprise",
        "patmentMethod_paxWallet": "Portefeuille",
        "patmentMethod_externalWallet": "Portefeuille externe",
        "patmentMethod_googlePay": "Google Pay",
        "patmentMethod_manual": "Manuel",
        "patmentMethod_samsung_pay": "Samsung Pay",
        "patmentMethod_kakao_pay": "Kakao Pay",
        "patmentMethod_naver_pay": "Naver Pay",
        "patmentMethod_wechat_pay": "WeChat Pay",
        "patmentMethod_alipay": "Alipay",
        "patmentMethod_paynow": "PayNow",
        "patmentMethod_grabpay": "GrabPay",
        "patmentMethod_cashapp": "Cash App Pay",
        "patmentMethod_online": "Carte/Paiement en ligne",
        "patmentMethod_check": "Vérifier",
        "patmentMethod_wire": "Fil",
        "patmentMethod_digitalWallet": "Portefeuille numérique",
        "patmentMethod_bankTransfer": "Virement bancaire",
        "patmentMethod_offlineMethod": "Paiement hors ligne",
        "patmentAirlineMethod_5": "Facture directe",
        "patmentAirlineMethod_4": "Carte aérienne",
        "patmentAirlineMethod_7": "Prépayé aérien",
        "Name": "Nom",
        "Delete": "Effacer",
        "App_SOS_dialog_form_message_1": "{0} Urgence SOS !",
        "App_SOS_dialog_form_message_2": "J'ai besoin d'aide à",
        "App_SOS_dialog_form_message_3": "Réservation : {0}, Chauffeur : {1}, Passager : {2}, Plaque d'immatriculation : {3} ({4})",
        "mins": "minutes",
        "Credit_Card": "Carte de crédit",
        "ALL": "Tout",
        "NotFound": "La page que vous avez demandée est introuvable",
        "ServerError": "Une erreur s'est produite",
        "AccessDenied": "Vous n'avez pas la permission d'accéder à ce module !",
        "Retry": "Réessayer",
        "Can_not_get_data": "Impossible d'obtenir les données"
    },
    "shiftSettings": {
        "Add": "Ajouter",
        "Show_per_page": "Eléments par page",
        "Page": "Page",
        "Name": "Nom",
        "Time_Range": "Intervalle de temps",
        "Actions": "Actions",
        "show_pages": "{0} - {1} sur {2} affichés",
        "Edit": "Modifier",
        "Delete": "Effacer",
        "EDIT_SHIFT_SETTING": "Modifier Shift",
        "ADD_SHIFT_SETTING": "Ajouter Shift",
        "DETAIL_SHIFT_SETTING": "Réglage du décalage de détail",
        "DELETE_SHIFT_SETTING": "SUPPRIMER LES PARAMETRES DE SHIFT",
        "Delete_confirm_shift_setting": "Voulez-vous supprimer cet élément?",
        "Required_fields": "Champs requis",
        "Save": "Enregistrer",
        "Cancel": "Annuler",
        "From": "De",
        "To": "A",
        "Edit_shift_template": "Modifier modèle de Shift",
        "Add_shift_template": "Ajouter Shift de référence",
        "Detail_shift_template": "Modèle de décalage de détail",
        "Delete_shift_template": "Supprimer le modèle de poste",
        "Delete_confirm_shift_template": "Voulez-vous supprimer cet élément?",
        "Working_time": "Temps de travail",
        "Create_shift_settings_success": "Le nouveau paramètre de shift  a été créé avec succès",
        "Create_shift_settings_fail": "Les erreurs se sont produites lors de la création du shift",
        "Update_shift_settings_success": "Le paramètre de shift a été mis à jour avec succès",
        "Update_shift_settings_fail": "Les erreurs se sont produites lors de la mise à jour du shift",
        "Delete_shift_settings_success": "Le paramètre de shift a été supprimé avec succès",
        "Delete_shift_settings_fail": "Les erreurs sont survenues lors de la suppression du paramètre de shift",
        "Create_shift_template_success": "Le nouveau modèle de shift a été créé avec succès",
        "Create_shift_template_fail": "Les erreurs sont survenues lors de la création du modèle de shift",
        "Update_shift_template_success": "Le modèle de shift a été mis à jour avec succès",
        "Update_shift_template_fail": "Les erreurs se sont produites lors de la mise à jour du modèle de shift",
        "Delete_shift_template_success": "Le modèle de shift a été supprimé avec succès",
        "Delete_shift_template_fail": "Les erreurs se sont produites lors de la suppression du modèle de shift",
        "Yes": "Oui",
        "No": "Non"
    },
    "promotionSettings": {
        "Detail_campaign": "Campagne détaillée",
        "Edit_campaign": "Modifier campagne",
        "Add_campaign": "Ajouter campagne",
        "Delete_campaign": "Supprimer la campagne",
        "Delete_confirm_campaign": "Voulez-vous supprimer la campagne sélectionnée?",
        "Add": "Ajouter",
        "Corporate_list": "Liste des entreprises",
        "permittedCorporate": "Liste des entreprises autorisées",
        "CorporateCustomers": "Clients d'entreprise",
        "auto_add_corporate": "Ajout automatique à la liste de promotion des utilisateurs d'entreprise",
        "Show_per_page": "Eléments par page",
        "Page": "Page",
        "Name": "Nom",
        "Actions": "Actions",
        "Private": "Privé",
        "show_pages": "{0} - {1} sur {2} affichés",
        "Edit": "Modifier",
        "Delete": "Effacer",
        "Send_to_inbox": "Envoyer à la boîte de reception",
        "Save": "Sauvegarder",
        "Duplicate": "Dupliquer",
        "Cancel": "Annuler",
        "Required_fields": "Champs requis",
        "Promotion_code": "Code promo",
        "Promotion_type": "Type de promotion",
        "Campaign": "Campagne",
        "Type": "Type",
        "Value": "Valeur",
        "keepMinFee": "Le tarif total après promotion doit être supérieur au tarif minimum",
        "Zone": "Zones",
        "paymentMethodsApply": "Méthodes de Paiement",
        "schedules": "Horaires",
        "minimumEstFareApply": "Estimation minimale du tarif total pour appliquer le code",
        "quantityLimitPerYear": "Utilisations maximales/utilisateur/année",
        "termAndCondition": "Termes et conditions",
        "Valid_from": "Valide à partir de",
        "Valid_to": "Valide jusqu'à",
        "Total_uses_user": "Total utilisations/ utilisateur",
        "Released_quantity": "Quantité distribuée",
        "Number_of_sending_inbox": "Nombre de boîtes d'envoi",
        "Status": "Statut",
        "Activate": "Activer",
        "Deactivate": "Désactiver",
        "Add_promotion_code": "Ajouter code de promotion",
        "Edit_promotion_code": "Modifier le code promo",
        "Detail_promotion_code": "Code de promotion détaillé",
        "Delete_promotion_code": "Supprimer le code promo",
        "Delete_confirm_promotion_code": "Voulez-vous supprimer le code promo sélectionné?",
        "New_customer": "Nouveau client",
        "Budget_per_user": "Budget/utilisateur (pour toute la période de promotion)",
        "Budget_per_user_day": "Budget/utilisateur/jour",
        "Budget_per_user_month": "Budget/utilisateur/mois",
        "Budget_per_user_year": "Budget/utilisateur/année",
        "Unlimited": "Illimité",
        "Limited": "Limité",
        "Total_uses_per_user": "Total utilisations/ utilisateur",
        "Send_an_in_box_automatically_to_new_customers": "Envoyer un message automatiquement pour un nouveau client",
        "Notes": "Notes",
        "Public": "Publique",
        "Create_campaign_success": "Une nouvelle campagne a été créée avec succès",
        "Create_campaign_fail": "Les erreurs se sont produites lors de la création de la campagne",
        "Update_campaign_success": "La campagne a été mise à jour avec succès",
        "Update_campaign_fail": "Les erreurs se sont produites lors de la mise à jour",
        "Delete_campaign_success": "La campagne a été supprimée avec succès",
        "Delete_campaign_fail": "Des erreurs sont survenues lors de la suppression de la campagne",
        "Loading_campaign_fail": "Les erreurs se sont produites lors du chargement de la campagne",
        "Update_campaign_status_success": "Le statut de la campagne a été mis à jour avec succès",
        "Update_campaign_status_fail": "Les erreurs se sont produites lors de la mise à jour du statut",
        "Loading_promotion_code_fail": "Des erreurs sont survenues lors du chargement du code promotionnel",
        "Select_campaign": "Sélectionner campagne",
        "Create_promotion_code_success": "Le nouveau code de promotion a été créé avec succès",
        "Create_promotion_code_fail": "Les erreurs se sont produites lors de la création du code de promotion",
        "Update_promotion_code_status_success": "L'état du code promo a été mis à jour avec succès",
        "Update_promotion_code_status_fail": "Les erreurs se sont produites lors de la mise à jour du code promo",
        "Delete_promotion_code_confirmation": "Do you want to deactivate these promotion codes?\n",
        "Just_delete_inactive": " ** Seul un code promo qui a un statut d'inactif peut être supprimé.",
        "Send_inbox_confirmation": "Etes vous sûr de vouloir envoyer ce code promo à la boîte de réception du passager?",
        "Send_inbox_success": "Le code promo a bien été envoyé.",
        "Send_inbox_fail": "L'envoi du code promo a échoué.Veuillez réessayer!",
        "Confirmation": "Confirmation",
        "Delete_promotion_codes_success": "Le code promotionnel a été supprimé avec succès",
        "Delete_promotion_codes_fail": "Des erreurs sont survenues lors de la suppression du code promotionnel",
        "Delete_multiple_promotion_codes_success": "Les codes promo ont été supprimés avec succès",
        "Delete_multiple_promotion_codes_fail": "Des erreurs sont survenues lors de la suppression des codes promotionnels",
        "Delete_promotion_code_success": "Le code promotionnel a été supprimé avec succès",
        "Delete_promotion_code_fail": "Des erreurs sont survenues lors de la suppression du code promotionnel",
        "Update_multiple_promotion_code_status_success": "Les statuts du code promo ont été mis à jour avec succès",
        "Update_multiple_promotion_code_status_fail": "Des erreurs sont survenues lors de la suppression des statuts du code promotionnel",
        "Search_here": "Rechercher ici",
        "Please_input_campaign_name": "Veuillez saisir le nom de la campagne.",
        "Please_input_promotion_code": "Veuillez saisir le code promo",
        "Please_input_promotion_code_at_least_4_characters": "Veuillez entrer au moins 4 caractères.",
        "Please_select_campaign": "Veuillez sélectionner une campagne",
        "Please_input_value": "Veuillez saisir une valeur",
        "Please_select_date": "Veuillez sélectionner une date",
        "Please_add_schedules": "Veuillez ajouter un horaire",
        "Please_add_corporate": "Veuillez ajouter une entreprise",
        "Please_choose_at_least_one_customer": "Veuillez choisir au moins un client",
        "This_campaign_name_has_been_existing_on_the_system_Please_input_another_one": "Ce nom de campagne a déjà existé sur le système. Veuillez saisir un autre.",
        "This_promotion_code_has_been_existing_on_the_system_Please_input_another_one": "Ce code promo existe déjà sur le système. Veuillez en saisir un autre.",
        "Invalid_file": "Le contenu du fichier est invalide",
        "File_size_larger_than_5Mb": "La taille du fichier est supérieure à 5 Mo",
        "Import_promotions_success": "Le fichier a été importé avec succès",
        "Import_Promotions": "Importer un fichier",
        "Number_successful_imports": "Éléments importés",
        "Number_skipped": "Éléments ignorés",
        "File": "Fichier",
        "Phone_Numbers": "Numéro(s) de téléphone",
        "Import_Promotion_code_success": "Le code promo <b>{0}</b> a bien été importé",
        "Import_Promotion_code_fail": "Le code promo <b>{0}</b> n'a pas pu être importé. Veuillez réessayer",
        "Customer_type": "Type de client",
        "All": "Tout",
        "Referred_customers": "Clients parrainés",
        "Common_customers": "Clients habituels",
        "Operation_zone": "Zones d'opération",
        "totalUsesLimitPerDay": "Utilisations maximales/utilisateur/jour",
        "quantityLimitPerDay": "Quantité maximale/jour",
        "quantityLimitPerMonth": "Quantité maximale / utilisateur / mois",
        "applyVerifiedCustomers": "Appliquer pour les clients malaisiens vérifiés uniquement",
        "applyWhenBudgetLimit": "L'utilisateur peut appliquer le code jusqu'à épuisement du budget",
        "applyVerifiedCustomersTooltip": "Cette promotion s'applique aux Malaisiens qui ont vérifié leur identité nationale et téléchargé leur carte d'identité sur le système uniquement",
        "valueLimitPerUse": "Valeur/utilisation maximale (s'applique à l'application v48 et plus)",
        "Promotion_Services": "Un service ",
        "transport": "Transport",
        "shuttle": "Navette",
        "parcel": "Colis ",
        "food": "Aliments ",
        "mart": "Marché ",
        "intercity": "Interurbain",
        "addSchedule": "Ajouter un horaire",
        "editSchedule": "Modifier un horaire",
        "date": "Date",
        "Time_range": "Plage horaire",
        "startTime": "Heure de début",
        "endTime": "Heure de fin",
        "applyForOtherDays": "Appliquer aux autres jours",
        "scheduleTimeOverlap": "Les horaires ne doivent pas se chevaucher",
        "schedule_startDate_greater_than_endDate": "La date de début est supérieure à la date de fin",
        "scheduleTimeDuplicate": "Les horaires ne doivent pas être dupliqués",
        "promoIcon": "Icône de promo",
        "bannerImage": "Image de bannière",
        "Upload_an_image": "Aucune image sélectionnée",
        "Click_here_to_view": "Cliquez ici pour voir."
    },
    "quest_event": {
        "name": "Nom",
        "userType": "Type d'utilisateur",
        "carType": "Type de voiture",
        "operationZones": "Zone d'opération",
        "type": "Type d'événement",
        "isLuckyDraw": "Tour de tirage au sort",
        "start_date": "Date de début",
        "end_date": "Date de fin",
        "numOfQualify": "Nombre de qualifiés",
        "event_progress": "Progression de l'événement",
        "isActive": "Statut",
        "Actions": "Actions",
        "passenger": "Client",
        "driver": "Client",
        "first_will_win": "Le premier gagnera",
        "largest_will_win": "Le plus grand gagnera (classement)",
        "not_start": "Non commencé",
        "active": "actif",
        "closed": "Fermé",
        "event_details": "Détails de la quête",
        "add_event": "Ajouter une quête",
        "limited": "Limité ",
        "unlimited": "Illimité ",
        "eventImage": "Image de l'événement",
        "sharedImage": "Image partagée",
        "qualifiedImage": "Image qualifiée",
        "expiredImage": "Image expirée",
        "luckyDrawImage": "Image du tirage au sort",
        "Upload_an_image": "Aucune image sélectionnée",
        "Required_Image": "Extensions d'image (.jpg, .png, .gif)",
        "ok": "D'accord",
        "eventId": "ID de l'événement",
        "passengerMetric": {
            "booking_distance": "Distance de réservation",
            "booking_time": "Heure de réservation",
            "booking_amount_spent": "Montant dépensé pour la réservation",
            "num_of_ondemand": "Nombre de demandes immédiates",
            "num_of_reservation": "Nombre de réservations",
            "num_of_intercity": "Nombre de trajets interurbains",
            "num_of_delivery": "Nombre de livraisons",
            "num_of_referral": "Nombre de parrainages",
            "num_of_sharing": "Nombre de partages",
            "topup_wallet_amount": "Montant de la recharge du portefeuille",
            "num_of_complete_wallet": "Nombre de réservations complètes (portefeuille)",
            "num_of_complete_booking_by_referee": "Nombre de réservations complètes (par le parrainé)",
            "number_of_complete_booking": "Nombre de réservations complètes",
            "number_of_food_mart": "Nombre de commandes de nourriture / supérette"
        },
        "driverMetric": {
            "booking_distance": "Distance de la tâche",
            "booking_time": "Durée de la tâche",
            "num_of_referral": "Nombre de parrainages",
            "num_of_complete": "Nombre de réservations complètes (client unique)",
            "num_of_referral_driver": "Nombre de parrainages (conducteur)",
            "num_of_accept": "Nombre de réservations acceptées",
            "num_of_receive": "Nombre de réservations reçues",
            "num_of_cancel": "Nombre de réservations annulées par le conducteur",
            "sum_of_rating": "Nombre total d'étoiles de notation",
            "total_rating": "Nombre total de notations",
            "earnings_amount": "Montant des gains",
            "num_of_complete_wallet": "Nombre de réservations complètes (portefeuille)",
            "num_of_complete_booking_by_referee": "Nombre de réservations complètes (par le parrainé)",
            "available_time": "Temps en ligne"
        },
        "Click_here_to_view": "Cliquez ici pour voir.",
        "view": "Cliquez ici pour voir.",
        "metricType": "Type",
        "task": "Tâche",
        "value": "Valeur",
        "quantity": "Quantité",
        "quests_list": "Quêtes",
        "rankImages": "Image de rang (point)",
        "qualifiedPrizeOrder": "Prix qualifiés",
        "luckyDrawPrizeOrder": "Prix de tirage au sort",
        "reward": "Élément",
        "from": "De ",
        "to": "À ",
        "image": "Image",
        "Add_Prize": "Ajouter ",
        "bannerText": "Texte de la bannière",
        "buttonText": "Texte du bouton",
        "bannerLink": "Lien de la bannière",
        "shortLink": "Lien court",
        "buttonLinkDesktop": "Lien du bouton (Desktop)",
        "buttonLinkAndroid": "Lien du bouton (Android)",
        "buttonLinkiOS": "Lien du bouton (iOS)",
        "termsURL": "Lien des termes et conditions",
        "metadataTitle": "Titre des métadonnées",
        "metadataDescription": "Description des métadonnées",
        "isDarkMode": "Mode sombre",
        "isActive_details": "actif",
        "Required_fields": "Champs obligatoires",
        "change": "Modifier",
        "Please_input_name": "Veuillez entrer un nom",
        "Please_select_date": "Veuillez sélectionner une date",
        "endDate_invalid": "Date de fin invalide",
        "startDate_greater_than_endDate": "La date de début est supérieure à la date de fin",
        "Please_input_termsURL": "Veuillez entrer le lien des termes et conditions",
        "Please_input_metadataTitle": "Veuillez entrer le titre des métadonnées",
        "Please_input_metadataDescription": "Veuillez entrer la description des métadonnées",
        "Please_input_bannerText": "Veuillez entrer le texte de la bannière",
        "Please_input_buttonText": "Veuillez entrer le texte du bouton",
        "Please_input_bannerLink": "Veuillez entrer le lien de la bannière",
        "Please_input_shortLink": "Veuillez entrer le lien court",
        "Please_input_buttonLinkDesktop": "Veuillez entrer le lien du bouton (Desktop)",
        "Please_input_buttonLinkAndroid": "Veuillez entrer le lien du bouton (Android)",
        "Please_input_buttonLinkiOS": "Veuillez entrer le lien du bouton (iOS)",
        "the_range_1_to_5": "Veuillez entrer une valeur comprise entre 1 et 5 pour %{name} !",
        "the_range_1_to_100": "Veuillez entrer une valeur comprise entre 1 et 100 pour %{name} !",
        "task_is_empty": "Veuillez entrer une tâche pour %{name} !",
        "task_limit_50_characters": "La longueur maximale de la tâche est de 50 caractères pour %{name} !",
        "please_input_points": "Veuillez entrer des points pour %{name} !",
        "please_input_value": "Veuillez entrer une valeur pour %{name} !",
        "value_is_invalid": "%{name}, la valeur doit être un nombre",
        "please_upload_image": "Veuillez télécharger une image pour l'élément %{name} !",
        "rank_invalid": "Le rang %{name} est invalide !",
        "rank_invalid_to": "Le rang \"To\" doit être un nombre",
        "deepLink": "Lien profond",
        "point_per_task": "Points par tâche",
        "points": "Points",
        "points_per_some_think": "Points par %{unit}",
        "criterias": "Critères (optionnel)",
        "criterias_list": "Critères",
        "criteriaType": "Type",
        "criteriaValue": "Valeur",
        "acceptance_rating": "Évaluation d'acceptation (supérieure ou égale)",
        "cancellation_rating": "Évaluation d'annulation (inférieure ou égale)",
        "driver_rating": "Évaluation du conducteur (supérieure ou égale)",
        "please_upload_image_rank": "Veuillez télécharger une image pour le rang %{name} !",
        "Update_event_success": "La quête a été mise à jour avec succès",
        "Update_event_fail": "Des erreurs se sont produites lors de la mise à jour de la quête",
        "Create_event_success": "Une nouvelle quête a été créée avec succès",
        "Create_event_fail": "Des erreurs se sont produites lors de la création de la quête",
        "suspend_list": "Liste suspendue"
    },
    "voucherSettings": {
        "Search_here": "Rechercher ici",
        "Voucher_code": "Code #",
        "Campaign": "Campagne",
        "Type": "Type",
        "Value": "Valeur",
        "Valid_from": "Valide à partir de",
        "Valid_to": "Valide jusqu'à",
        "isActive": "Statut",
        "Activate": "Activer",
        "Deactivate": "Désactiver",
        "Actions": "Actions",
        "Active": "actif",
        "Inactive": "Inactif",
        "redeemed": "Utilisé",
        "expired": "Expiré ",
        "Add_Voucher_code": "Ajouter un code",
        "Add": "Ajouter ",
        "Show_per_page": "Articles par page",
        "Page": "Page",
        "Name": "Nom",
        "show_pages": "{0} - {1} sur {2} affiché",
        "Edit": "Modifier",
        "Delete": "Supprimer",
        "Save": "Modifier",
        "Duplicate": "Enregistrer",
        "Cancel": "Dupliquer",
        "Required_fields": "Annuler",
        "Detail_voucher_code": "Champs obligatoires",
        "Delete_voucher_code": "Détails du code du bon",
        "Confirmation": "Supprimer le code du bon",
        "Delete_confirm_voucher_code": "Confirmation",
        "Delete_voucher_code_confirmation": "Voulez-vous supprimer ces codes de bon ?",
        "Just_delete_inactive": "Seuls les codes de bon au statut inactif peuvent être supprimés.",
        "Loading_voucher_code_fail": "Des erreurs se sont produites lors du chargement du code du bon",
        "Select_campaign": "Sélectionner une campagne",
        "Create_voucher_code_success": "Un nouveau code de bon a été créé avec succès",
        "Create_voucher_code_fail": "Des erreurs se sont produites lors de la création du code du bon",
        "Update_voucher_code_status_success": "Le statut du code du bon a été mis à jour avec succès",
        "Update_voucher_code_status_fail": "Des erreurs se sont produites lors de la mise à jour du statut du code du bon",
        "Delete_voucher_codes_success": "Le code du bon a été supprimé avec succès",
        "Delete_voucher_codes_fail": "Des erreurs se sont produites lors de la suppression du code du bon",
        "Delete_multiple_voucher_codes_success": "Les codes de bon ont été supprimés avec succès",
        "Delete_multiple_voucher_codes_fail": "Des erreurs se sont produites lors de la suppression des codes de bon",
        "Delete_voucher_code_success": "Le code du bon a été supprimé avec succès",
        "Delete_voucher_code_fail": "Des erreurs se sont produites lors de la suppression du code du bon",
        "Update_multiple_voucher_code_status_success": "Les statuts des codes de bon ont été mis à jour avec succès",
        "Update_multiple_voucher_code_status_fail": "Des erreurs se sont produites lors de la suppression des statuts de code de bon",
        "Please_input_voucher_code": "Veuillez entrer le code du bon",
        "Please_input_voucher_code_at_least_4_characters": "Veuillez entrer au moins 4 caractères.",
        "Please_select_campaign": "Veuillez sélectionner une campagne",
        "Please_input_value": "Veuillez entrer une valeur",
        "Please_select_date": "Veuillez sélectionner une date",
        "Invalid_file": "Le contenu du fichier est invalide",
        "File_size_larger_than_5Mb": "La taille du fichier est supérieure à 5 Mo",
        "Import_vouchers_success": "Le fichier a été importé avec succès",
        "Import_vouchers": "Importer un fichier",
        "Number_successful_imports": "Articles importés",
        "Number_skipped": "Ignorer les articles",
        "File": "Fichier",
        "Phone_Numbers": "Numéro(s) de téléphone",
        "Import_voucher_code_success": "Le code du bon <b>{0}</b> a été importé avec succès",
        "Import_voucher_code_fail": "Le code du bon <b>{0}</b> n'a pas pu être importé. Veuillez réessayer",
        "All": "Tout"
    },
    "pointConfig": {
        "point_config": "Configuration des points",
        "Convert_spent_amount_to_points": "Convertir le montant dépensé en points",
        "Convert_topup_amount_to_points": "Convertir le montant de recharge en points",
        "Redeem_points_to_voucher": "Échanger des points contre un bon",
        "others": "Autres",
        "Online_Payment": "Paiement en ligne",
        "transport": "Transport",
        "parcel": "Colis ",
        "food": "Aliments ",
        "mart": "Marché ",
        "delivery": "Livraison",
        "intercity": "Intercité",
        "applyCash": "Demander du liquide",
        "point": "Point",
        "vourcherName": "Nom",
        "pointsToRedeem": "Points à échanger",
        "vourcherValue": "Valeur du bon",
        "validTime": "Durée de validité",
        "month": "Mois",
        "day": "Jour(s)",
        "termAndCondition": "Conditions générales",
        "Actions": "Actions",
        "add_voucher": "Ajouter ",
        "instructionURL": "Lien d'instruction",
        "displayName": "Afficher le nom sur la super application",
        "isActive": "actif",
        "EDIT_VOUCHER": "Mettre à jour le bon",
        "DETAIL_VOUCHER": "Détails du bon",
        "CREATE_VOUCHER": "Ajouter un bon",
        "update_successfully": "La configuration des points a été mise à jour avec succès",
        "Create_voucher_successfully": "Un nouveau bon a été créé avec succès",
        "Create_voucher_fail": "Des erreurs se sont produites lors de la création du bon",
        "Update_voucher_successfully": "Le bon a été mis à jour avec succès",
        "Update_voucher_fail": "Des erreurs se sont produites lors de la mise à jour du bon",
        "Delete_voucher_successfully": "Le bon a été supprimé avec succès",
        "Delete_voucher_fail": "Des erreurs se sont produites lors de la suppression du bon",
        "Confirmation": "Confirmation",
        "Delete_voucher_confirmation": "Voulez-vous supprimer ce bon ?",
        "Please_enter_value_least_one": "Le taux de conversion est requis ! Définissez un montant dépensé ou un montant de recharge pour continuer.",
        "Please_enter_value_is_number_spentAmount": "Veuillez entrer un montant valide pour le service \"Convertir le montant dépensé\" \"{0}\".",
        "Please_enter_value_is_number_topUp": "Veuillez entrer un montant valide pour la méthode \"Convertir le montant de recharge\" \"{0}\"."
    },
    "resetPassword": {
        "New_Password": "Nouveau mot de passe",
        "New_Comfirm_Password": "Confirmez le mot de passe",
        "Save": "Enregistrer",
        "INFO_SUCCESS": "Un lien de réinitialisation de mot de passe a été envoyé à votre email ",
        "TOKEN_EXPIRED": "Votre jeton de réinitialisation du mot de passe a expiré",
        "Back_To_Login_Page": "Retour à la page de connexion"
    },
    "permission": {
        "editBooking": "Modifier les réservations sous-traitées",
        "companyOperator": "Opérateur de la société",
        "Third_Party_Integration_Booking": "Intégration tiers (Booking.com)",
        "Third_Party_Integration_HolidayTaxis": "Intégration tiers (HolidayTaxis)",
        "supplierPermission": "Autorisation du fournisseur",
        "Hint_edit_booking": "Permettre aux entreprises/fournisseurs de modifier les réservations sous-traitées par le propriétaire de la flotte.",
        "View": "Vue",
        "Actions": "Actions",
        "EditFare": "Modifier le tarif",
        "EditDriverEarning": "Modifier les gains du conducteur",
        "EditTotal": "Modifier le total",
        "ImportBookings": "Importer les réservations de transport",
        "ImportDeliveryBookings": "Importer les réservations de livraison",
        "ShowFare": "Afficher le tarif",
        "delete_permission": "Supprimer l'autorisation",
        "DELETE_CONFIRM": "Do you want to delete permission!",
        "Yes": "Oui",
        "No": "Non",
        "Cancel": "Annuler",
        "DRIVERS": "Chauffeurs",
        "Driver_list": "Liste de Pilotes",
        "Enter_to_search": "Entrer pour rechercher",
        "Permitted_driver_list": "Liste des Pilotes autorisés",
        "Save": "Enregistrer",
        "CAR": "Véhicule",
        "Car_list": "Liste des véhicules",
        "Permitted_car_list": "Liste des véhicules autorisés",
        "Edit_permission": "Modifier Permission",
        "Add_permission": "Ajouter Permission",
        "Detail_permission": "Autorisation détaillée",
        "Name": "Nom",
        "Driver_Car": "Chauffeur/ Véhicule",
        "All": "Tous",
        "Company": "Compagnie",
        "By_specific": "Par spécificité",
        "Drivers": "Chauffeurs",
        "Cars": "Véhicules",
        "Show_per_page": "Eléments par page",
        "Page": "Page",
        "show_pages": "Page {0} - {1} sur {2} affichée",
        "Delete": "Effacer",
        "Edit": "Modifier",
        "Status": "Statut",
        "Action": "action",
        "Inactive": "Inactif",
        "Active": "Actif",
        "Update_status_error": "Erreur de mise à jour du statut",
        "All_tooltip": "Tous les chauffeurs seront affichés sur la Carte, Cue, Chauffeurs, Opération et Rapports. Tous les véhicules seront affichés dans la Gestion de Véhicules",
        "Company_tooltip": "Les chauffeurs autorisés pour cette entreprise seront affichés dans les sections Carte, Cue, Chauffeurs,, Opérations et Rapports. Les véhicules autorisés de cette entreprise seront affichés dans la Gestion de Véhicules",
        "By_specific_tooltip": "Les chauffeurs autorisés de cette liste seront affichés dans les sections Carte, Cue, Chauffeurs,, Opérations et Rapports. Les véhicules autorisés de cette liste seront affichés dans la Gestion de Véhicules",
        "Full_permissions": "Permissions complètes",
        "Balance": "Changer de solde",
        "ChangeBalance": "Modifier le solde du crédit",
        "ChangeCashBalance": "Modifier le solde en liquide",
        "TotalBalance": "Solde total",
        "WriteOffDebt": "Radier la dette",
        "topupPaxWallet": "Modification du solde",
        "SeFleetCommission": "Set fleet commission",
        "EditFleetCommission": "Modifier la commission de la flotte",
        "EditBalance": "Modifier le solde",
        "ViewHeatMap": "Afficher les cartes thermiques",
        "Delete_permission_success": "L'autorisation a été supprimée avec succès",
        "Delete_permission_fail": "Des erreurs se sont produites lors de la suppression de l'autorisation",
        "Create_permission_fail": "Des erreurs se sont produites lors de la création de la nouvelle autorisation",
        "Create_permission_success": "Une nouvelle autorisation a été créée avec succès",
        "Update_permission_fail": "Des erreurs se sont produites lors de la mise à jour de l'autorisation",
        "Update_permission_success": "L'autorisation a été mise à jour avec succès",
        "No_action_selected": "Veuillez cocher au moins une action dans la liste des actions",
        "Required_fields": "Champs requis",
        "sendSMS": "Envoyer un message (SMS)",
        "sendInbox": "Envoyer un message (Boîte de réception)",
        "PayToDriver": "Voir 'Paiement au conducteur'",
        "PayoutHistory": "Voir 'Historique des paiements'",
        "Pay": "Payer le conducteur",
        "ActivateDriver": "Activer le conducteur",
        "Export": "Exporter",
        "Export_csv": "Exporter .csv",
        "Street-sharing_rate": "Tarif de partage de rue"
    },
    "thirdPartySettings": {
        "category": "Catégorie",
        "Not_over_limit_subs": "Vous ne pouvez pas créer plus de 10 sous-emplacements",
        "Show_per_page": "Eléments par page",
        "Page": "Page",
        "show_pages": "Page {0} - {1} sur {2} affichée",
        "Delete": "Actions",
        "Edit": "Effacer",
        "Status": "Modifier",
        "Actions": "Statut",
        "Action": "Site Web",
        "Inactive": "action",
        "Active": "Inactif",
        "website": "Actif",
        "Check_Google_Address": "Vérifier l'adresse Google à partir de la latitude et de la longitude",
        "Delete_Category_success": "Vérifier l'adresse Google de la latitude et de la longitude",
        "Delete_category_fail": "Des erreurs se sont produites lors de la suppression de la catégorie",
        "availableTime": "Temps disponible",
        "Please_choose_at_least_one_category": "Veuillez choisir au moins une catégorie",
        "Please_input_category_name": "Veuillez entrer le nom de la catégorie",
        "Create_category_success": "La catégorie a été créée avec succès",
        "Create_category_fail": "Des erreurs se sont produites lors de la création de la catégorie",
        "Update_third_party_success": "L'emplacement a été mis à jour avec succès.",
        "Update_category_fail": "L'emplacement a été mis à jour avec succès",
        "All_Category": "Toutes les catégories",
        "Delete_Category": "Modifier la catégorie",
        "Edit_Category": "Modifier la catégorie",
        "Add_Category": "Ajouter une catégorie",
        "Add_Third_Party_location": "Ajouter",
        "Add": "Ajouter",
        "Edit_Third_Party_location": "Modifier l'emplacement de la 3ème partie",
        "Location_Not_Found": "L'emplacement est invalide.",
        "Create_third_party_success": "L'emplacement a été créé avec succès",
        "Create_third_party_fail": "Les erreurs sont survenues lors de la création du lieu",
        "Update_third_party_fail": "Les erreurs sont survenues lors de la mise à jour",
        "Alias": "Alias",
        "Address": "Adresse",
        "Latitude": "Latitude",
        "Longitude": "Longitude",
        "Please_input_address": "Veuillez entrer l'adresse",
        "Please_input_name": "Veuillez entrer le nom du lieu",
        "Please_input_latitude": "Veuillez entrer la latitue",
        "Please_input_longitude": "Veuillez entrer la longitude",
        "Save": "Sauvegarder",
        "Cancel": "Annuler",
        "Required_fields": "Champs requis",
        "Last_update": "Dernière mise à jour",
        "Username": "Nom d'utilisateur",
        "locationType": "LocationType",
        "single": "Emplacement unique",
        "multiple": "Plusieurs emplacements",
        "AddMore": "Ajouter plus",
        "locationList": "Liste des lieux",
        "instructionLink": "Lien d'instruction",
        "location": "Localisation",
        "checkOnMap": "Vérifiez sur la carte",
        "Remove": "Retirer",
        "all": "Tout",
        "PU": "Prise en charge",
        "DO": "Dépose",
        "namePlaceholder": "p.ex. Terminal 1",
        "instructionLinkPlaceholder": "Page HTML avec des instructions complètes",
        "instructionLinkTooltip": "Veuillez entrer un lien pour la page d'instruction. Le passager peut suivre les instructions sur ce lien pour trouver le lieu de prise en charge.",
        "longitudePlaceholder": "108.18379690000006",
        "latitudePlaceholder": "16.0393381",
        "Error_message_lat_in_range": "La latitude doit être comprise entre -90.0 et 90.0",
        "Error_message_lng_in_range": "La longitude doit être comprise entre -180.0 et 180.0",
        "Delete_third_party_success": "L'emplacement a été supprimé avec succès",
        "Delete_third_party_fail": "Les erreurs se sont produites lors de la suppression de l'emplacement",
        "Delete_location": "Supprimer le lieu",
        "Note_guide": "Remarque : lors de la recherche sur la carte, votre emplacement sera rapidement marqué avec une épingle.",
        "PostalCode": "Code postal",
        "meetZonesTooltip": "Zone de réunion : Définit la zone qui comprend tous les points de réunion désignés. Utile pour des lieux comme les aéroports où des points de prise en charge et de dépose spécifiques doivent être clairement identifiés.",
        "instructions": "Instructions de ramassage",
        "pickupMode": "Type de ramassage",
        "tripSegment": "Segment de voyage",
        "buildingLevel": "Niveau du bâtiment",
        "instructionType": "Type d'instruction",
        "instructionUrl": "URL d'instruction",
        "instructionImage": "Images d'instruction",
        "imageInstructions": "Instructions pour l'image de récupération",
        "addMultipleInstructions": "Ajoutez plusieurs instructions de ramassage.",
        "maximum3Images": "Maximum 3 images.",
        "image": "Image",
        "uploadImage": "Télécharger une image",
        "description": "Description",
        "descriptionPlaceholder": "Le nom du point de rencontre.",
        "altText": "Texte alternatif",
        "altTextPlaceholder": "Le nom du point de rencontre.",
        "addImage": "Ajouter une image",
        "imageCount": "Nombre d'images",
        "viewEditImages": "Voir/Modifier les images",
        "addMeetingZone": "Ajouter une zone de réunion"
    },
    "city": {
        "DELETE_CITY": "Supprimer la ville",
        "DELETE_CONFIRM": "Do you want to delete city?",
        "Yes": "Oui",
        "No": "Non",
        "Cancel": "Annuler",
        "EDIT_CITY": "Modifier la Ville",
        "ADD_CITY": "Ajouter Une Ville",
        "Name": "Nom De La Ville",
        "Required_fields": "Champs requis",
        "Save": "Enregistrer",
        "Add": "Ajouter",
        "Show_per_page": "Eléments par page",
        "Page": "Page",
        "show_pages": "{0} - {1} sur {2} affiché",
        "Delete": "Effacer",
        "Edit": "Modifier",
        "DETAIL_CITY": "Détail de la ville",
        "Update_city_success": "La ville a été mise à jour avec succès",
        "Create_city_success": "Une nouvelle ville a été créée avec succès",
        "Delete_city_success": "La ville a été supprimée avec succès",
        "cityName": "Nom de la ville",
        "Service": "Un service ",
        "serviceTransportation": "Transport",
        "serviceAssistant": "Assistant",
        "serviceDelivery": "Livraison",
        "isShowDriverSignUp": "Afficher dans l'inscription du fournisseur",
        "note_isShowDriverSignUp": "(S'applique au nouveau module d'inscription à partir de 4.6.46 et plus)"
    },
    "blockPassenger": {
        "Imei": "IMEI",
        "EditImei": "Modifier le bloc IMEI",
        "AddImei": "Ajouter le bloc IMEI",
        "DetailImei": "Bloc de détails IMEI",
        "Update_Imei_success": "Le blocage IMEI a été mis à jour avec succès.",
        "Update_Imei_Fail": "Les erreurs se sont produites lors de la mise à jour du Bloc IMEI",
        "Create_Imei_success": "Le nouveau bloc IMEI a été créé avec succès",
        "Create_Imei_Fail": "Les erreurs se sont produites lors de la création du Bloc IMEI",
        "Delete_Imei_success": "Le blocage de l'IMEI a été supprimé avec succès.",
        "Delete_Imei_fail": "Les erreurs se sont produites lors de la suppression du Bloc IMEI",
        "DELETE_IMEI": "Supprimer le bloc IMEI",
        "DELETE_CONFIRM": "Êtes-vous sûr de vouloir supprimer le Block IMEI sélectionné ?"
    },
    "jobTab": {
        "DELETE_JOBTAB": "Supprimer l'onglet des tâches",
        "DELETE_CONFIRM": "Êtes-vous sûr de vouloir supprimer l'onglet des tâches sélectionné ?",
        "Yes": "Oui",
        "No": "Non",
        "Cancel": "Annuler",
        "EDIT_JOBTAB": "Modifier l'onglet des tâches",
        "ADD_JOBTAB": "Ajouter un onglet des tâches",
        "Name": "Nom",
        "Required_fields": "Champs obligatoires",
        "Save": "Enregistrer",
        "Add": "Ajouter",
        "Show_per_page": "Articles par page",
        "Page": "Page",
        "show_pages": "Page {0} - {1} sur {2} affichée",
        "Delete": "Supprimer",
        "Edit": "Modifier",
        "DETAIL_JOBTAB": "Détails de l'onglet des tâches",
        "Update_JOBTAB_success": "L'onglet des tâches a été mis à jour avec succès",
        "Create_JOBTAB_success": "Un nouvel onglet des tâches a été créé avec succès",
        "Delete_JOBTAB_success": "L'onglet des tâches a été supprimé avec succès",
        "JOBTABName": "Nom de l'onglet des tâches",
        "jobsLink": "Lien"
    },
    "driverNote": {
        "name": "Note du conducteur",
        "DELETE": "Supprimer la note du conducteur",
        "DELETE_CONFIRM": "Êtes-vous sûr de vouloir supprimer la note du conducteur sélectionnée ?",
        "EDIT": "Modifier la note du conducteur",
        "ADD": "Ajouter une note du conducteur",
        "DETAIL": "Détails de la note du conducteur",
        "Update_success": "La note du conducteur a été mise à jour avec succès",
        "Create_success": "Une nouvelle note du conducteur a été créée avec succès",
        "Delete_success": "La note du conducteur a été supprimée avec succès",
        "Delete_fail": "Des erreurs se sont produites lors de la suppression de la note du conducteur",
        "Load_fail": "Des erreurs se sont produites lors du chargement de la note du conducteur",
        "Update_fail": "Des erreurs se sont produites lors de la mise à jour de la note du conducteur",
        "Create_fail": "Des erreurs se sont produites lors de la création de la note du conducteur"
    },
    "flightIntegration": {
        "Username": "Nom d'utilisateur",
        "provider": "Fournisseur de vol",
        "Key": "Clé API",
        "apiKeys": "Clés API",
        "apiId": "ID API",
        "Save": "Enregistrer",
        "Update_flight_integration_success": "L'intégration du vol a été mise à jour avec succès",
        "Update_flight_integration_fail": "Des erreurs se sont produites lors de la mise à jour de l'intégration du vol"
    },
    "smsIntegration": {
        "provider": "Fournisseur de SMS",
        "apiToken": "Jeton API",
        "subAccountId": "ID du sous-compte",
        "senderIdSource": "ID de l'expéditeur (source) :",
        "apiKey": "Clé API",
        "username": "Nom d'utilisateur",
        "shortCode": "Code court",
        "key": "Clé",
        "webService": "Service Web",
        "bearerToken": "Jeton de porteur",
        "keyId": "ID de clé",
        "email": "E-mail",
        "appKey": "Clé de l'application",
        "sender": "Expéditeur",
        "password": "Mot de passe",
        "maskedPhone": "Numéro de téléphone masqué",
        "senderId": "ID de l'expéditeur",
        "webservice": "Service Web",
        "brandname": "Nom de marque",
        "appSecret": "Secret de l'application",
        "consumerKey": "Clé du consommateur",
        "requestUrl": "URL de demande",
        "authId": "ID d'authentification",
        "authToken": "Jeton d'authentification",
        "authKey": "Clé d'authentification",
        "templateId": "ID de modèle",
        "templateKey": "Clé de modèle",
        "phloId": "ID PHLO",
        "dlcNumber": "Numéro 10DLC",
        "app_key": "Clé de l'application",
        "api_key": "Clé API",
        "accountSID": "SID du compte",
        "applicationId": "ID de l'application",
        "phoneNumber": "Numéro SMS 1",
        "phoneNumber2": "Numéro SMS 2",
        "SenderID_1": "ID de l'expéditeur 1",
        "SenderID_2": "ID de l'expéditeur 2",
        "smsMarketingNumber": "Numéro de téléphone marketing SMS",
        "updateSMSSuccess": "The sms integration has been updated successfully",
        "Deleted_success": "Le SMS a été supprimé avec succès",
        "receiverCountries": "Pays destinataires",
        "error": {
            "ERROR_CREATE": "Des erreurs se sont produites lors de la création du SMS",
            "COUNTRY_EXISTED": "Le pays existe déjà dans le système",
            "ERROR_DELETE": "Échec de la suppression du SMS",
            "ERROR_UPDATE": "Échec de la mise à jour du SMS"
        },
        "identifierId": "ID d'identifiant"
    },
    "mDispatcher": {
        "mDispatchers": "mDispatchers",
        "Active": "Actif",
        "Inactive": "Inactif",
        "Deactivate": "Désactiver",
        "Activate": "Activer",
        "Delete": "Effacer",
        "Save": "Enregistrer",
        "Edit": "Modifier",
        "ADD_MDISPATCHER": "Ajouter un mDispatcher",
        "EDIT_MDISPATCHER": "Modifier un mDispatcher",
        "Phone_number": "Numéro de téléphone",
        "first_name": "Prénom",
        "last_name": "Nom",
        "email": "E-mail",
        "address": "Adresse",
        "mDispatcher_type": "Type mDispatcher",
        "mDispatcher_type_toolTip": "Pour ajouter d'autres types de partenaires, accédez à Paramètres> Type de partenaire",
        "queuing_area_toolTip": "Pour ajouter d'autres zones de file d'attente, veuillez aller dans le menu Zone de file d'attente.",
        "mDispatcher": "mDispatcher",
        "card_management": "Gestion des cartes",
        "Select_mDispatcher_type": "Sélectionner le type mDispatcher",
        "Amount": "Montant",
        "Percent": "Pour cent",
        "Yes": "Oui",
        "Required_fields": "Champs requis",
        "Cancel": "Annuler",
        "commission_type": "Type de Commission",
        "commission_value": "Montant de la Commission",
        "Name": "Nom",
        "Phone_Number": "Numéro de téléphone",
        "queuing_area": "Zone de file d'attente",
        "mdispatcher_type": "Type mDispatcher",
        "registered_from": "Enregistré à partir de",
        "registration_date": "Date d'enregistrement",
        "status": "Statut",
        "actions": "Actions",
        "Select_queue_area": "Sélectionner la zone de file d'attente",
        "for_new_mDipatcher_account_password_default_is_password": "Pour un nouveau compte mDispatcher, le mot de passe par défaut est \"12345678",
        "Create_mDispatcher_success": "Le nouveau mDipatcher a été créé avec succès",
        "Create_mDispatcher_fail": "Les erreurs sont survenues lors de la création de mDispatcher",
        "Load_mDispatcher_fail": "Les erreurs sont survenues lors du chargement de mDispatcher",
        "Update_mDispatcher_success": "mDipatcher a été mis à jour avec succès",
        "Update_mDispatcher_fail": "Les erreurs sont survenues lors de la mise à jour de mDispatcher",
        "Update_mDispatcher_status_success": "Le statut de mDipatcher a été mis à jour avec succès",
        "Update_mDispatcher_status_fail": "Les erreurs se sont produites lors de la mise à jour de l'état de mDispatcher",
        "Update_mDispatcher_statuses_success": "Les statuts de mDipatcher ont été mis à jour avec succès",
        "Update_mDispatcher_statuses_fail": "Les erreurs se sont produites lors de la mise à jour des statuts de mDispatcher",
        "Delete_mDispatcher_success": "mDipatcher a été supprimé avec succès",
        "Delete_mDispatcher_fail": "Les erreurs se sont produites lors de la suppression de mDispatcher",
        "Delete_mDispatchers_success": "mDipatchers a été supprimé avec succès",
        "Delete_mDispatchers_fail": "Les erreurs se sont produites lors de la suppression de mDispatchers",
        "Do_you_want_to_delete_these_mDipatchers": "Do you want to delete these mDipatchers?",
        "Only_mDistcher_in_the_inactive_status_can_be_deleted": "***Seuls les mDistcher en statut inactif peuvent être supprimés",
        "No_card": "Pas de carte trouvée",
        "Reset_Password": "Réinitialiser le mot de passe",
        "Reset_password_success": "mDispatcher password has been reset successfully",
        "Reset_password_fail": "Les erreurs se sont produites lors de la réinitialisation du mot de passe mDispatchers",
        "Do_you_want_to_reset_password": "Voulez-vous réinitialiser le mot de passe ?",
        "ERROR_EXISTED_PHONE": "Ce téléphone existe déjà sur le système. Veuillez en saisir un autre.",
        "ERROR_INPUT_VALIDPHONE": "Veuillez spécifier un numéro de téléphone valide",
        "Partner_detail": "DETAIL MDISPATCHER TYPE",
        "ALERT_SELECT_ACTIVATE": "Veuillez sélectionner le mDispatcher à activer",
        "ALERT_SELECT_DEACTIVATE": "Veuillez sélectionner le mDispatcher à désactiver",
        "CONFIRM_DEACTIVATE_MULTI": "Voulez-vous supprimer ces mDispatcher?",
        "CONFIRM_ACTIVATE_MULTI": "Voulez-vous activer ces mDispatcher?",
        "ERROR_COMMISSION_NUMBERS": "S'il vous plait, entrez un nombre valide",
        "No_Support": "L'ajout de nouvelles cartes n'est actuellement pas pris en charge dans cette zone",
        "Add": "Ajouter",
        "Default_zone": "Zone par défaut",
        "required_email_payment": "L'e-mail du partenaire est requis. Veuillez mettre à jour votre profil pour continuer.",
        "titleGuestQR": "Lien QR invité du partenaire",
        "questQRContent": "Votre lien de réservation partenaire personnalisé est ici ! Affichez-le bien en vue dans les bars, les réceptions d'hôtel, les chambres et sur votre site web—partout où vos clients pourraient avoir besoin d'un transport ou d'une livraison. Pensez à concevoir des présentoirs avec votre code QR unique, permettant aux clients de scanner rapidement et facilement pour réserver leur trajet !",
        "View_Guest_QR": "Voir le QR invité"
    },
    "mDispatcherType": {
        "Name": "Nom De La Ville",
        "Required_fields": "Champs requis",
        "Save": "Enregistrer",
        "Cancel": "Annuler",
        "No": "Non",
        "Add": "Ajouter",
        "Show_per_page": "Eléments par page",
        "Page": "Page",
        "show_pages": "Page {0} - {1} sur {2} affichée",
        "Delete": "Effacer",
        "Edit": "Modifier",
        "DELETE_MDISPATCHER_TYPE": "Effacer Type mDispatcher",
        "DELETE_CONFIRM": "Are you sure to delete mDispatcher Type?",
        "Yes": "Oui",
        "EDIT_MDISPATCHER_TYPE": "Modifier Type mDispatcher",
        "ADD_MDISPATCHER_TYPE": "Ajouter Type mDispatcher",
        "DETAIL_MDISPATCHER_TYPE": "Détail mDispatcher Type",
        "Actions": "Actions",
        "Delete_mDispatcherType_success": "Le type mDispatcher a été supprimé avec succès",
        "Delete_mDispatcherType_fail": "Les erreurs se sont produites lors de la suppression du type mDispatchers",
        "Load_mDispatcherType_fail": "Les erreurs se sont produites lors du chargement du type mDispatchers",
        "Create_mDispatcherType_success": "Le nouveau type mDispatcher a été créé avec succès",
        "Create_mDispatcherType_fail": "Les erreurs se sont produites lors de la création du type mDispatchers",
        "Update_mDispatcherType_success": "Le type mDispatcher a été mis à jour avec succès",
        "Update_mDispatcherType_fail": "The errors occurred while updating mDispatchers type"
    },
    "queuingArea": {
        "queuing_area_info": "Informations sur la zone de file d'attente",
        "queuingDrivers": "Conducteurs actifs",
        "Name": "Nom",
        "Required_fields": "Champs requis",
        "Save": "Enregistrer",
        "Cancel": "Annuler",
        "Yes": "Oui",
        "No": "Non",
        "Add": "Ajouter",
        "Show_per_page": "Eléments par page",
        "Enter_to_search": "Entrer pour rechercher",
        "Page": "Page",
        "show_pages": "Page {0} - {1} sur {2} affichée",
        "Delete": "Effacer",
        "Edit": "Modifier",
        "Active": "Actif",
        "Inactive": "Inactif",
        "Deactivate": "Désactiver",
        "Activate": "Activer",
        "drivers": {
            "order": "Ordre",
            "Driver_name": "Nom du conducteur",
            "Phone_Number": "Numéro de téléphone",
            "driverLicenseNumber": "Plaque d'immatriculation",
            "Car_Type": "Type de voiture",
            "checkInTime": "Heure d'arrivée",
            "duration": "Durée",
            "timestampScore": "Score d'horodatage",
            "changeOrderDriver": "Change l'ordre",
            "detailOrderDriver": "Ordre du conducteur",
            "Yes": "Oui",
            "No": "Non",
            "insert": "Insérer",
            "refresh": "Rafraîchir",
            "insertDriver": "Insérez un pilote dans la file d'attente",
            "orderDriver": "Commande #",
            "reason": "Raison",
            "removeDriver": "Retirer le conducteur de la file d'attente",
            "removeDriverConfirm": "Voulez-vous supprimer ce pilote de la file d'attente?",
            "driverNotStay": "Le pilote n'est pas dans la zone de file d'attente. Veuillez réessayer plus tard.",
            "overOrder": "Le numéro d'ordre ne peut pas être supérieur au nombre total de conducteurs dans la file d'attente.",
            "noDriverFound": "Aucun conducteur trouvé",
            "driverUpdateErrRs": "Le conducteur n'est pas dans la zone de file d'attente. Veuillez réessayer plus tard.",
            "orderUpdateErrRs": "Le numéro d'ordre ne peut pas être supérieur au nombre total de conducteurs dans la file d'attente.",
            "removeDriverSuccess": "Le conducteur a été retiré avec succès de la zone de file d'attente.",
            "removeDriverFail": "Une erreur s'est produite lors du retrait du conducteur de la file d'attente.",
            "operationInsertFailRs": "Le conducteur n'existe pas ou n'est pas disponible.",
            "versionInsertFailRs": "Pour appliquer cette fonctionnalité, le pilote doit mettre à niveau son application de pilote vers la dernière version",
            "queueInsertFailRs": "La file d'attente n'existe pas ou le conducteur n'est pas dans la zone de file d'attente. Veuillez réessayer plus tard.",
            "vehicleInsertFailRs": "La file d'attente ne prend pas en charge le type de véhicule du conducteur.",
            "orderInsertFailRs": "Le numéro d'ordre ne peut pas être supérieur au nombre total de conducteurs dans la file d'attente.",
            "positionInsertFailRs": "Une erreur s'est produite lors de l'insertion du conducteur dans la file d'attente.",
            "insertDriverSuccess": "Le conducteur a été inséré avec succès dans la file d'attente.",
            "changeOrderSuccess": "La position du conducteur a été modifiée avec succès.",
            "insertDriverFail": "Une erreur s'est produite lors de l'insertion du conducteur dans la zone de file d'attente.",
            "changeOrderFail": "Une erreur s'est produite lors de la modification de la position du conducteur dans la zone de file d'attente.",
            "selectToInsert": "Rechercher : Nom du conducteur, Numéro de téléphone",
            "updateBy": "Mis à jour par l'opérateur",
            "changeOrder": "Changer l'ordre",
            "remove": "Retirer"
        },
        "keepDriverPlaceCancelNoShow": "Gardez la place du conducteur lorsque la réservation est annulée / non-présentation",
        "keepDriverPlaceUnavailable": "Gardez la place du conducteur lorsque le pilote n'est pas disponible ou hors ligne",
        "range": "Plage de file d'attente",
        "queueRangeTooltip": "Voici comment les conducteurs verront leur numéro de position de mise en file d'attente sur l'application du conducteur. Par exemple:\nDéfinition de la plage de file d'attente à 1: les conducteurs verront leur position dans la file d'attente sous la forme d'un numéro unique: 1, 2, 3, 4, etc.\nDéfinition de la plage de file d'attente à 5: les conducteurs verront leur position dans la file d'attente sous la forme d'une plage: 1-5, 6-10, 11-15, 16-20, etc.\nDéfinition de la plage de file d'attente à 10: les conducteurs verront leur position dans la file d'attente sous la forme d'une plage: 1-10, 11-20, 21-30, 31-40, etc. ",
        "queueCanceledTooltip": "1. Lorsque le passager annule ou ne se présente pas, le conducteur restera en position supérieure s'il revient dans la file d'attente dans le délai fixé.\n2. La position du conducteur sera prioritaire si le conducteur revient dans la file d'attente dans le délai défini après avoir effectué une réservation pour un court trajet. ",
        "DELETE_QUEUING_AREA": "Supprimer la zone de file d'attente",
        "DELETE_CONFIRM": "Voulez-vous supprimer la zone de file d'attente ?",
        "EDIT_QUEUING_AREA": "Modifier la zone de file d'attente",
        "ADD_QUEUING_AREA": "Ajouter zone de file d'attente",
        "DETAIL_QUEUING_AREA": "Détail de la zone de mise en file d'attente",
        "Queuing_area": "Zone de file d'attente",
        "Address": "Adresse",
        "Enter_a_location": "Entrez un lieu",
        "Entered_Address_is_incorrect": "Le système ne peut pas déterminer votre position. Veuillez utiliser l'adresse suggéré.",
        "Not_supported_zone": "La zone de file d'attente n'est pas dans",
        "Active_mDispatcher_list": "Liste des mDispatcher actifs",
        "Queue_list": "Liste de file d'attente",
        "Allow_radius": "Rayon autorisé",
        "Min_drivers_required": "# Min Pilotes nécessaires ",
        "Open_queuing_area": "Ouvrir la zone de file d'attente",
        "Auto_dispatch": "Envoi automatique aux pilotes en file d'attente (inutile d'utiliser l'application partenaire)",
        "Active_car_list": "Liste des véhicules actifs",
        "mDispatcher": "mDispatcher",
        "Google_Address": "Adresse Google",
        "Status": "Statut",
        "Update_status_error": "Erreur de mise à jour du statut",
        "driver_checkin_area": "Zone d'enregistrement des chauffeurs",
        "EDIT_POLYGONS": "Modifier les polygones",
        "pax_pickup_area": "Zone de prise en charge des passagers",
        "pickup_area": "Zone de prise en charge",
        "your_chosen_polygon": "Votre polygone choisi",
        "other_queues": "Autres files d'attente",
        "operation_zones": "Zones d'opération",
        "delete_pickup_area_confirm": "Voulez-vous vraiment supprimer cette zone deprise en charge?",
        "delete_pickup_area": "Veuillez choisir la zone d'enregistrement du chauffeur.",
        "please_choose_driver_check_in_area": "Veuillez choisir une zone de prise en charge.",
        "please_choose_pick_up_area": "Veuillez choisir la zone de prise en charge.",
        "Load_queuing_area_fail": "Des erreurs se sont produites lors du chargement de la zone de file d'attente",
        "Create_queuingArea_success": "La zone de file d'attente a été créée avec succès",
        "Update_queuingArea_success": "La zone de file d'attente a été mise à jour avec succès.",
        "Delete_queuingArea_success": "La zone de file d'attente a été supprimée avec succès",
        "Delete_queuingArea_fail": "Des erreurs se sont produites lors de la suppression de la zone de file d'attente",
        "Create_queuingArea_fail": "Des erreurs se sont produites lors de la création de la zone de file d'attente",
        "Load_queuingArea_fail": "Des erreurs se sont produites lors du chargement de la zone de file d'attente",
        "Update_queuingArea_fail": "Des erreurs se sont produites lors de la mise à jour de la zone de file d'attente"
    },
    "appBanner": {
        "Save": "Enregistrer",
        "Pax_app": "Appli passager",
        "Apply_to": "Appliquer à",
        "Please_select_view": "Veuillez sélectionner une vue",
        "Select_Type": "Veuillez sélectionner le type de bannière",
        "Home_view": "Vue d'ensemble",
        "Other_view": "Autre vue",
        "Banner_1": "Banière #1",
        "Upload_an_image": "Aucune image sélectionnée",
        "Action": "action",
        "NA": "N/A",
        "Link_to_website": "Lien vers le site web",
        "Make_a_call": "Passer un appel",
        "Send_an_email": "Envoyer un mail",
        "Banner_2": "Banière #2",
        "Banner_3": "Banière #3",
        "Driver_app": "Appli Chauffeur",
        "pax": "Passgener App",
        "driver": "Application conducteur ",
        "merchant": "Application marchand",
        "Name": "Nom",
        "viewType": "Type",
        "status": "Statut",
        "image": "Image",
        "html": "HTML",
        "Delete_Banner": "Supprimer la bannière",
        "Delete_confirm_banner": "Êtes-vous sûr de vouloir supprimer la bannière sélectionnée?",
        "Delete_banner_success": "La bannière a été supprimée avec succès",
        "Delete_banner_fail": "Des erreurs se sont produites lors de la suppression de la bannière",
        "edit_banner": "Modifier la bannière",
        "detail_banner": "Détails de la bannière",
        "create_banner": "Ajouter une bannière",
        "note_1": "*L'extension de fichier doit être .jpg, .jpeg, .png, .gif et moins de 8MB.",
        "note_2": "* Les images doivent être au format 16:9",
        "note_3": "*Les autres vue comprennent Boîte de réception, Parrainer un ami, Factures, Mes réservations, Codes Promo, Ajouter une CB/Modes de paiement, Profil, En attente d'execution/Réservation Confirmée, Vue complète.",
        "Update_app_banner_success": "La bannière de l'application a été mise à jour avec succès",
        "Update_app_banner_fail": "Échec de la mise à jour de la bannière de l'application !",
        "Create_app_banner_success": "La bannière de l'application a été créée avec succès",
        "Create_app_banner_fail": "Échec de la création de la bannière de l'application !",
        "Note": "Veuillez utiliser le fichier au format .png (fond transparent, taille 400:200px) pour une meilleure performance de l'application.",
        "Limit_size_upload": "La taille du fichier doit être inférieure à 8 Mo.",
        "display_duration": "Durée d'affichage",
        "playback_settings": "Paramètres de retour",
        "display_banner_again_after": "Afficher à nouveau les bannières après",
        "stop_display_banner_after": "Arrêter l'affichage de la bannière après",
        "enable_playback": "Activer le retour",
        "Update_playback_success": "Les paramètres de lecture ont été mis à jour avec succès",
        "Update_playback_fail": "Échec de la mise à jour des paramètres de lecture !",
        "language": "Langue",
        "single": "Langue unique",
        "multi": "Multilingue",
        "es-ES": "Espagnol",
        "en-US": "Anglais",
        "fr-FR": "Français",
        "id-ID": "Indonésien",
        "vi-VN": "Vietnamien",
        "ur-PK": "Ourdou",
        "ms-MY": "Malaisien",
        "ar-AR": "Arabe",
        "nb-NO": "Norvégien",
        "en-GB": "Anglais (Royaume-Uni)",
        "am-ET": "Amharique",
        "ro-RO": "Roumain",
        "version": "Version de l'application",
        "comparisonVersionApp": {
            "is": "Est",
            "is_not": "N'est pas",
            "is_one_of": "Est l'un de",
            "is_not_one_of": "N'est pas l'un de",
            "greater_or_equal": "Supérieur ou égal",
            "less_or_equal": "Inférieur ou égal"
        },
        "platform": "Plateforme",
        "platformItem": {
            "all": "Tout",
            "iOS": "iOS",
            "android": "Android"
        },
        "userStatus": "Statut de l'utilisateur",
        "Active": "actif",
        "Inactive": "Inactif",
        "in_review_completed": "En cours de révision (profil complété)",
        "in_review_incomplete": "En cours de révision (profil incomplet)",
        "in_review_inProgress": "In review (En cours de révision (profil en cours))",
        "zones": "Zones"
    },
    "reservation": {
        "name": "Réservation",
        "company": "Entreprise",
        "carType": "Type de voiture",
        "licensePlate": "Plaque d'immatriculation : %{name}",
        "driver": "Conducteur : %{name}",
        "showAllDrivers": "Afficher tous les conducteurs",
        "available": "Disponible ",
        "reserved": "Réservé",
        "search_holder": "Search here",
        "all": "Tout",
        "today": "Aujourd'hui",
        "thisWeek": "Cette semaine",
        "day": "Day",
        "week": "Week",
        "bookingID": "ID de réservation",
        "tripId": "ID du trajet",
        "pickupTime": "Heure de prise en charge",
        "pickupLocation": "Lieu de prise en charge",
        "monday": "Lundi",
        "tuesday": "Mardi",
        "wednesday": "Mercredi",
        "thursday": "Jeudi",
        "friday": "Vendredi",
        "saturday": "Samedi",
        "sunday": "Dimanche",
        "overlapped": "Chevauchement",
        "noData": "Aucune donnée trouvée.",
        "bookingDetails": "Détails de la réservation",
        "reservedHint": "Les réservations sont confirmées",
        "availableHint": "Aucune réservation confirmée",
        "overlappedHint": "Deux réservations confirmées ou plus se chevauchent"
    },
    "dashboard": {
        "API": "API",
        "cc": "CC",
        "dmc": "Tableau de réservation",
        "streetSharing": "Partage de rue",
        "kiosk": "Kiosque",
        "mDispatcher": "mDispatcher",
        "paxApp": "Super App",
        "webBooking": "Réservation Web",
        "carHailing": "Locations Véhicules",
        "acceptance": "Acceptation",
        "booking_com": "Booking.com",
        "completed": "Terminé",
        "noShow": "Non-présentation",
        "driverNoShow": "Non-présentation du conducteur",
        "canceled": "Annulé",
        "incident": "Incident",
        "rate1": "1 Étoile",
        "rate2": "2 Étoile",
        "rate3": "3 Étoile",
        "rate4": "4 Étoile",
        "rate5": "5 Étoile",
        "Export_to_Excel": "Exporter vers Excel",
        "Profit": "Gain",
        "day_change": "Taux journalier",
        "week_change": "Taux hebdomadaire ",
        "month_change": "Taux mensuel",
        "Booking_requests": "Les réservations",
        "Complete_bookings": "Demandes finalisées",
        "New_customers": "Nouveaux clients",
        "Booking_dashboard": "Tableau de réservation",
        "others": "Autres",
        "Revenue_booking": "Gains et réservations finalisées",
        "Profit_finish_booking": "Gains et réservations finalisées",
        "Booking_request": "Demande de réservation",
        "Finished_booking": "Réservations finalisées",
        "failed": "Échoué",
        "partialCompleted": "Partiellement complété",
        "Finished_booking_char_header": "Réservations finalisées ({0})",
        "Bookings": "Réservations ({0})",
        "Ratings": "Étoile ({0})",
        "Daily": "Journalier",
        "Weekly": "Hebdomadaire",
        "Monthly": "Mensuel",
        "Total_customer": "Nombre total de clients {0}",
        "ProfitToolTips": "L'argent que la flotte gagne après avoir exclu toutes les dépenses",
        "RevenueToolTips": "L'argent que la flotte reçoit effectivement pendant la période sélectionnée, y compris la promotion, les déductions pour les conducteurs, les taxes, etc.",
        "ProfitChangeToolTips": "Le pourcentage de variation des bénéfices de la flotte par rapport à la période précédente",
        "BookingRequestsToolTips": "Nombre total de réservations créées pendant la période choisie.",
        "PercentageOfAcceptanceToolTips": "Le pourcentage de réservations acceptées pendant la période sélectionnée",
        "BookingChangeHint": "Le pourcentage de variation des réservations créées par rapport à la période précédente",
        "CompletedBookingHint": "Nombre total de réservations finalisées pendant la période choisie.",
        "PercentageOfSatisfactionHint": "Le pourcentage de satisfaction pendant la période sélectionnée",
        "CompleteBookingDailyChangeHint": "Le pourcentage de variation des réservations effectuées par rapport à la période précédente.",
        "NewCustomersHint": "Nombre total de nouveaux clients enregistrés pendant la période choisie",
        "CustomerChangeHint": "Le nombre et le pourcentage d'évolution des clients par rapport à la période précédente",
        "TotalCustomer": "Nombre total de clients dans le système",
        "ProfitAndFinishedBookingHint": "Profit et réservations terminées de la flotte pendant la période sélectionnée",
        "BookingRequestHint": "Nombre total de réservations à la demande et de réservations créées pendant la période sélectionnée",
        "FinishedBookingChartsHint": "Nombre total de réservations à la demande et de réservations clôturées pendant la période sélectionnée, y compris les annulations, non-présentation, incidents et complétées",
        "Customer_count": "{0} clients au total",
        "Revenue": "Recette"
    },
    "referral": {
        "first_package": "1er forfait (c'est-à-dire la première réservation complétée de Pax)",
        "driver_refers_to_pax": "Driver refers to Passengers",
        "driver_will_get": "Le conducteur recevra",
        "money": "Argent",
        "amount": "Montant ",
        "percent": "Percent",
        "settlement": "Commission (% du montant sous-total de chaque réservation complétée)",
        "pax_will_get": "Pax recevra",
        "promotion_code": "Code promotionnel",
        "select_a_promotion": "Sélectionner un code promotionnel",
        "maximum": "Maximum",
        "second_package": "2ème forfait",
        "from": "De ",
        "to": "À ",
        "After_2nd_package": "Après le 2ème forfait",
        "from_end_value_of_above_package": "À partir de la valeur du dernier forfait ci-dessus + 1",
        "Expiration_date": "Date d'expiration",
        "Never": "Jamais",
        "Customized_date": "Date personnalisée",
        "limited": "Limité ",
        "unlimited": "Illimité ",
        "Valid_from": "Valide à partir du",
        "Valid_to": "Valide jusqu'au",
        "Invitation_limit": "Invitation limit/user",
        "Status": "Statut",
        "Active": "actif",
        "Inactive": "Inactif",
        "note": "Veuillez noter qu'une fois la campagne activée, toute mise à jour des valeurs de récompense n'affectera que les nouveaux clients.",
        "Required_fields": "Champs obligatoires",
        "refferal_update_successfully": "Les paramètres de parrainage ont été mis à jour avec succès",
        "distributeIncentiveToDriver": "Distribuer l'incitation au conducteur",
        "Immediate": "Immédiat",
        "Periodic": "Périodique (Manuellement)",
        "Period": "Période",
        "startDate": "Date de début",
        "nextDistributionDate": "Date de la prochaine distribution",
        "oneMonth": "1 mois",
        "threeMonth": "3 mois",
        "sixMonth": "6 mois",
        "passenger_refers_to_pax": "Passenger refers to Passengers",
        "referer_will_get": "Le parrain recevra",
        "referee_will_get": "Le parrainé recevra",
        "promo": "Promotion",
        "Pax_invitation_limit": "Limite d'invitation/utilisateur",
        "promoPaidBy": "Promotion payée par",
        "fleet": "Flotte",
        "driver": "Client",
        "promoCode": "Code promotionnel",
        "isSendInbox": "Envoyer un message",
        "isDefaultCode": "Application automatique sur l'application",
        "autoApplyOnWeb": "Application automatique sur le web",
        "isDefaultCode_hint": "Ajouter le code promotionnel à la liste du client et l'appliquer automatiquement à la réservation lorsque le client passe une commande",
        "Actions": "Actions",
        "add_promoCode": "Ajouter ",
        "Send_an_in_box_automatically_to_new_customers": "Envoyer un message au client",
        "set_default_promo_code": "Application automatique sur l'application",
        "EDIT_PROMO_CODE": "Modifier le code promotionnel",
        "DETAIL_PROMO_CODE": "Détails du code promotionnel",
        "CREATE_PROMO_CODE": "Créer un code promotionnel",
        "DELETE_PROMO_CODE": "Supprimer le code promotionnel",
        "DELETE_CONFIRM_PROMO_CODE": "Voulez-vous supprimer ce code promotionnel ?",
        "ERROR_INPUT_SOURCE": "Veuillez en choisir au moins un."
    },
    "upload_document": {
        "NO_FILE_CHOSEN": "Aucun fichier choisi",
        "Limit_size_upload": "La taille du fichier dépasse la limite autorisée {0} Mo."
    },
    "payment_info": {
        "member_since": "Membre depuis",
        "package_name": "Nom du forfait",
        "last_payment": "Dernier paiement",
        "credit_card": "Carte de crédit",
        "last_digits": "4 derniers chiffres",
        "default": "Défaut",
        "add_new_card": "Ajouter une nouvelle carte",
        "history": "Historique",
        "transaction_date": "Date de transaction",
        "transaction_id": "ID de la transaction",
        "billing_cycle": "Cycle de facturation",
        "amount": "Montant ",
        "payment_history": "Historique de facturation",
        "card_information": "Informations sur la carte",
        "card_holder": "Titulaire de la carte",
        "card_number": "Numéro de carte",
        "expiration_date": "Date d'expiration",
        "cvv": "CVV"
    },
    "search_by": {
        "group_id": "ID du groupe",
        "booking_id": "Réservation #",
        "recurring_id": "Numéro récurrent",
        "ExternalID": "Numéro externe",
        "tripId": "Numéro du voyage",
        "driver_name": "Nom du Driver",
        "driver_phone_number": "Numéro de téléphone",
        "license_plate": "Plaque d'immatriculation",
        "vehicle": "Véhicule",
        "operator": "Opérateur",
        "passenger_email": "Email du passager",
        "passenger_name": "Nom du passager",
        "passenger_phone_number": "Numéro de téléphone du passager",
        "destination": "Destination",
        "pick_up": "Départ",
        "flight_number": "Vol #",
        "book_from": "Réservé de",
        "note": "Remarques",
        "email": "E-mail",
        "phone": "Numéro de téléphone"
    },
    "withdrawal": {
        "transferToEWallet": "*Transféré vers un portefeuille électronique externe {0}",
        "channelCode": "Code du canal",
        "channelName": "Nom du canal",
        "reversed": "Annulé",
        "requestTime": "Demande de temps",
        "referenceId": "Numéro de référence",
        "driverName": "Nom du conducteur",
        "phoneNumber": "Numéro de téléphone",
        "company": "Entreprise",
        "description": "Description",
        "requestAmount": "Montant de la demande",
        "transferAmount": "Montant du transfert",
        "currentBalance": "Solde actuel",
        "currency": "Devise",
        "action": "action",
        "approve": "Approuver",
        "reject": "Rejeter",
        "transferToBankAccount": "Transférer vers le compte bancaire *{0}",
        "transferToWingBank": "*Transféré vers l'ID de la banque Wing {0}",
        "transferToCreditWallet": "Tranférer vers le porte-monnaie",
        "reason": "Raison",
        "search": "Nom du conducteur, téléphone, entreprise, ID de transaction, numéro de référence",
        "message": {
            "approve": "Êtes-vous sûr de vouloir payer à ce chauffeur un {0}?",
            "approveMulti": "Etes-vous sûr de vouloir régler le chauffeur séléctionné ?",
            "approveSuccess": "La demande sélectionnée a été payée",
            "approveFail": "Selected request was not successful. Please try again",
            "approveMultiSuccess": "{0} des {1} demandes sélectionnées ont été payées ",
            "approveMultiFail": "{0} dans la demande sélectionnée par {1} n'a pas abouti. Veuillez réessayer",
            "buttonConfirmTitle": "Oui",
            "closeButtonText": "Non",
            "pleaseInputReason": "Veuillez entrer une raison",
            "rejectSuccess": "La demande du chauffeur a été rejetée",
            "rejectFail": "Le rejet de la demande a échoué"
        },
        "getDataFailure": "Impossible d'obtenir les données",
        "rejectRequest": "Rejeter la demande"
    },
    "dynamicSurcharge": {
        "operationZone": "Zone d'opération",
        "activeSurcharge": "Surcharge active",
        "surcharge": "Taxes ",
        "surchargeName": "Nom de la surtaxe",
        "parameter": "Paramètre",
        "pickupPoint": "Zone de prise en charge",
        "dropOffPoint": "Zone de dépose",
        "delete_surcharge_success": "La surcharge a été supprimée avec succès",
        "delete_surcharge_fail": "Des erreurs se sont produites lors de la suppression de la surcharge",
        "update_surcharge_fail": "Des erreurs se sont produites lors de la mise à jour de la surcharge",
        "update_surcharge_success": "La surcharge a été mise à jour avec succès",
        "create_surcharge_fail": "Des erreurs se sont produites lors de la création de la surcharge",
        "create_surcharge_success": "La surcharge a été créée avec succès",
        "active_surcharge_fail": "Des erreurs se sont produites lors de l'activation de la surcharge",
        "active_surcharge_success": "La surcharge a été activée avec succès",
        "deactive_surcharge_fail": "Des erreurs se sont produites lors de la désactivation de la surcharge",
        "deactive_surcharge_success": "La surcharge a été désactivée avec succès",
        "delete_surcharge": "Supprimer la surcharge",
        "delete_confirm_message": "Êtes-vous sûr de vouloir supprimer la surcharge sélectionnée ?",
        "note": "Remarque : voici de combien votre tarif de base sera multiplié. Exemple : un tarif de 20 $ deviendrait 30 $ lorsque le paramètre est à 1,5x"
    },
    "dynamicFare": {
        "operationZone": "Zone d'opération",
        "activeFare": "Tarif actif",
        "fare": "Tarif",
        "fareName": "Nom du tarif",
        "factor": "Multiplier par un facteur",
        "fix_amount": "Montant",
        "parameter": "Paramètre",
        "delete_fare_success": "Le tarif a été supprimé avec succès",
        "delete_fare_fail": "Des erreurs se sont produites lors de la suppression du tarif",
        "update_fare_fail": "Des erreurs se sont produites lors de la mise à jour du tarif",
        "update_fare_success": "Le tarif a été mis à jour avec succès",
        "create_fare_fail": "Des erreurs se sont produites lors de la création du tarif",
        "create_fare_success": "Le tarif a été créé avec succès",
        "active_fare_fail": "Des erreurs se sont produites lors de l'activation du tarif",
        "active_fare_success": "Le tarif a été activé avec succès",
        "deactive_fare_fail": "Des erreurs se sont produites lors de la désactivation du tarif",
        "deactive_fare_success": "Le tarif a été désactivé avec succès",
        "delete_fare": "Supprimer le tarif",
        "delete_confirm_message": "Êtes-vous sûr de vouloir supprimer le tarif sélectionné ?",
        "note": "Remarque : voici de combien votre tarif de base sera multiplié. Exemple : un tarif de 20 $ deviendrait 30 $ lorsque le paramètre est à 1,5x",
        "note_amount": "Remarque : voici combien sera ajouté à votre tarif de base. Exemple : un tarif de 20 $ deviendrait 25 $ lorsque le montant défini est de 5 $"
    },
    "notifications": {
        "search": "Rechercher l'ID de réservation, ID externe",
        "searchProviderName": "Rechercher le nom du fournisseur",
        "statusItem": {
            "all": "Toutes les notifications",
            "canceledByDriver": "Canceled by driver",
            "canceledByPartner": "Canceled by partner",
            "reservationReminder": "Rappel de réservation",
            "localPending": "Local - En attente",
            "reservationIsNotStarted": "La réservation n'a pas commencé",
            "partnerRequestsCars": "Demande de voitures partenaires",
            "timeout": "Expiration",
            "noShow": "Affilié - Non présentation",
            "driverNoShow": "Non-présentation du conducteur",
            "affiliatePending": "Affilié - En attente",
            "affiliatePaymentFailed": "Paiement de l'affilié échoué",
            "affiliateTimeout": "Expiration de l'affilié",
            "flightApi": "API de vol",
            "DebtWriteOff": "Effacement de dette",
            "driverCancelTrip": "Driver cancels trip",
            "minimumSeatRequired": "Nombre minimum de sièges requis",
            "newFarmInJobFrom3rd": "Booking.com  - Nouvelle réservation",
            "canceledJobBy3rd": "Booking.com  - Annulée",
            "updatedJobBy3rd": "Booking.com  - Mise à jour",
            "incidentJobBy3rd": "Booking.com - Incident",
            "newFarmInJobFromHolidayTaxis": "HolidayTaxis - Nouvelle réservation",
            "canceledJobByHolidayTaxis": "HolidayTaxis - Annulée",
            "updatedJobByHolidayTaxis": "HolidayTaxis - Mise à jour",
            "newFarmInJobFromKarhoo": "Karhoo - Nouvelle réservation",
            "canceledJobByKarhoo": "Karhoo - Annulée",
            "updatedJobByKarhoo": "Karhoo - Mise à jour",
            "newFarmInJobFromHoppa": "Hoppa - Nouvelle réservation",
            "canceledJobByHoppa": "Hoppa - Annulé",
            "updatedJobByHoppa": "Hoppa - Mis à jour",
            "newFarmInJobFromKlook": "Klook - Nouvelle réservation",
            "canceledJobByKlook": "Klook - Annulé",
            "updatedJobByKlook": "Klook - Mis à jour",
            "newFarmInJobFromTransferZ": "TransferZ - Nouvelle réservation",
            "canceledJobByTransferZ": "TransferZ - Annulé",
            "updatedJobByTransferZ": "TransferZ - Mis à jour",
            "incidentReport": "Incident",
            "incidentAutoReport": "Besoin de révision"
        },
        "sos": {
            "sosSearch": "Rechercher l'ID de réservation, nom du passager, nom du conducteur",
            "statusItem": {
                "all": "Tout",
                "driver": "Conducteurs",
                "passenger": "Clients",
                "crew": "Équipe"
            }
        }
    },
    "smartData": {
        "No": "N°",
        "driverName": "Nom",
        "phone": "Téléphone",
        "rating": "Étoile",
        "completed": "Terminé",
        "noShow": "Non-présentation",
        "driverNoShow": "Absence du conducteur",
        "incident": "Incident",
        "canceled": "Annulée par le conducteur",
        "accepted": "Accepté",
        "reject": "Rejeter",
        "ignore": "Ignorer",
        "earning": "Revenus",
        "query": {
            "top20": "Top 20",
            "top50": "Top 50",
            "top100": "Top 100",
            "bottom20": "Bas 20",
            "bottom50": "Bas 50",
            "bottom100": "Bas 100"
        },
        "status": {
            "canceled": "Annulée par le conducteur",
            "noShow": "Non-présentation",
            "driverNoShow": "Non-présentation du conducteur",
            "incident": "Incident",
            "completed": "Terminé",
            "earning": "Revenus",
            "reject": "Rejeter",
            "ignore": "Ignorer",
            "accepted": "Accepté"
        }
    },
    "Reject": "Non présentation",
    "Do not allow Driver to start reservat": "Affiliation",
    "intercityRate": {
        "Delete_intercity_rate": "Supprimer le tarif intercité",
        "edit_intercity_rate": "Modifier le tarif intercité",
        "view_intercity_rate": "Afficher le tarif intercité",
        "add_intercity_rate": "Ajouter un tarif intercité",
        "Delete_confirm_intercity_rate": "Voulez-vous supprimer cet élément ?",
        "Update_intercity_rate_success": "Le tarif intercité a été mis à jour avec succès",
        "Update_intercity_rate_fail": "Des erreurs se sont produites lors de la mise à jour du tarif intercité",
        "Created_intercity_rate_success": "Le tarif intercité a été créé avec succès",
        "Created_intercity_rate_fail": "Des erreurs se sont produites lors de la création du tarif intercité",
        "Update_intercity_rate_route_success": "L'itinéraire du tarif intercité a été mis à jour avec succès",
        "Update_intercity_rate_route_fail": "Des erreurs se sont produites lors de la mise à jour de l'itinéraire intercité",
        "Created_intercity_rate_route_success": "L'itinéraire du tarif intercité a été créé avec succès",
        "Created_intercity_rate_route_fail": "Des erreurs se sont produites lors de la création de l'itinéraire intercité",
        "Loading_intercity_rate_fail": "Des erreurs se sont produites lors du chargement des détails du tarif intercité",
        "Delete_intercity_rate_route_fail": "Des erreurs se sont produites lors de la suppression de l'itinéraire du tarif intercité",
        "Delete_intercity_rate_success": "Le tarif intercité a été supprimé avec succès",
        "Delete_intercity_rate_fail": "Des erreurs se sont produites lors de la suppression du tarif intercité"
    },
    "intercityRoute": {
        "alias": "Alias",
        "routeNameHint": "Pour modifier le nom de l'itinéraire, veuillez aller dans Paramètres > Zone > Intercité et modifier le nom des zones de la ville en conséquence.",
        "pricePerSeat": "Prix par siège (hors taxes)",
        "distance": "Distance",
        "duration": "Durée",
        "cancellationPenalty": "Montant de la pénalité par siège",
        "noShow": "Passager/partenaire non présenté",
        "penalty": "Montant de la pénalité par siège",
        "no_show_tooltip": "Le montant facturé au client par siège. En plus de la pénalité, le client paiera la taxe ou les frais technologiques si appliqués.",
        "firstLocation": "Première localisation",
        "secondLocation": "Deuxième localisation",
        "routeOneSetup": "Configurer l'itinéraire 1",
        "routetwoSetup": "Configurer l'itinéraire 2",
        "schedules": "Horaires",
        "date": "Date",
        "time": "Heure",
        "editSchedule": "Modifier l'horaire",
        "addSchedule": "Ajouter un horaire",
        "requestTimeEnable": "Permettre au client de définir une heure de demande",
        "extraFee": "Frais supplémentaires",
        "hideRouteEnable": "Masquer cet itinéraire",
        "timeRange": "Plage horaire",
        "workingTime": "Temps de travail",
        "applyForOtherDays": "Appliquer pour les autres jours",
        "limitSeatLuggage": "Limiter les sièges / bagages",
        "warningMinimumSeats": "Nombre minimum de sièges requis",
        "warningMinimumSeatsHint": "Nombre minimum de sièges requis pour effectuer un voyage",
        "allowStartLessMinRequiredSeats": "Allow driver to start trip regardless of the minimum seat requirement",
        "allowStartLessMinRequiredSeatsHint": "Driver can start a trip even if requested seats less than minimum seat required",
        "freeLuggagePerSeat": "Bagage gratuit par siège",
        "freeLuggagePerSeatHint": "Number free of luggage included per seat",
        "allowToAddExtraLuggage": "Allow to add additional luggage",
        "allowToAddExtraLuggageHint": "Passenger can request to add more luggage",
        "feePerExtraLuggage": "Frais par bagage supplémentaire",
        "Delete_intercity_route": "Supprimer l'itinéraire intercité",
        "Delete_confirm_intercity_route": "Voulez-vous supprimer cet itinéraire ?",
        "Update_intercity_route_fail": "Intercity route has been updated successfully",
        "Update_intercity_route_success": "L'itinéraire intercité a été mis à jour avec succès",
        "created_intercity_route_success": "L'itinéraire intercité a été créé avec succès",
        "created_intercity_route_fail": "Des erreurs se sont produites lors de la création de l'itinéraire intercité",
        "Delete_intercity_route_success": "L'itinéraire intercité a été supprimé avec succès",
        "Delete_intercity_route_fail": "Des erreurs se sont produites lors de la suppression de l'itinéraire intercité",
        "penalty_less_than_or_equal_to_price": "Veuillez entrer une valeur inférieure ou égale au prix par siège.",
        "scheduleTimeOverlap": "Les heures de programmation ne doivent pas se chevaucher",
        "allows_adding_extra": "Permet d'ajouter un supplément lorsque le client demande une heure qui n'est pas prévue par la flotte.",
        "this_is_to_limit_users": "Cela permet de limiter les utilisateurs (c'est-à-dire client, conducteur, opérateur) dans la création de nouvelles réservations ou voyages sur cet itinéraire. Les réservations ou voyages existants restent réservés."
    },
    "dayOfWeek": {
        "0": "Dimanche",
        "1": "Lundi",
        "2": "Mardi",
        "3": "Mercredi",
        "4": "Jeudi",
        "5": "Vendredi",
        "6": "Samedi"
    },
    "intercityBooking": {
        "route": "Itinéraire",
        "departureDate": "Date de départ",
        "departureTime": "Heure de départ",
        "Departure": "Départ",
        "Arrival": "Arrivée",
        "RefundFare": "Remboursement du tarif",
        "intercityZoneNote": "These zones are not operational zone. And they are used for setting intercity rate only.",
        "zoneNameHint": "Veuillez garder le nom de votre zone court et clair afin que vos clients puissent le rechercher et le sélectionner facilement.",
        "zoneUploadNote_2": "Il est recommandé que la résolution de l'image soit de 1095x360 et que la taille du fichier soit inférieure à 5 Mo.",
        "Complete_booking": "Finaliser la commande",
        "ConfirmCancel": "Confirmer l'annulation"
    },
    "deliveryRate": {
        "Delete_delivery_rate": "Supprimer le tarif de livraison",
        "edit_delivery_rate": "Modifier le tarif de livraison",
        "view_delivery_rate": "Afficher le tarif de livraison",
        "add_delivery_rate": "Ajouter un tarif de livraison",
        "Delete_confirm_delivery_rate": "Voulez-vous supprimer cet élément ?",
        "Update_delivery_rate_success": "Le tarif de livraison a été mis à jour avec succès",
        "Update_delivery_rate_fail": "Des erreurs se sont produites lors de la mise à jour du tarif de livraison",
        "Created_delivery_rate_success": "Le tarif de livraison a été créé avec succès",
        "Created_delivery_rate_fail": "Des erreurs se sont produites lors de la création du tarif de livraison",
        "Update_delivery_rate_route_success": "L'itinéraire du tarif de livraison a été mis à jour avec succès",
        "Update_delivery_rate_route_fail": "Des erreurs se sont produites lors de la mise à jour de l'itinéraire de livraison",
        "Created_delivery_rate_route_success": "L'itinéraire du tarif de livraison a été créé avec succès",
        "Created_delivery_rate_route_fail": "Des erreurs se sont produites lors de la création de l'itinéraire de livraison",
        "Loading_delivery_rate_fail": "Des erreurs se sont produites lors du chargement des détails du tarif de livraison",
        "Delete_delivery_rate_route_fail": "Des erreurs se sont produites lors de la suppression de l'itinéraire du tarif de livraison",
        "Delete_delivery_rate_success": "Le tarif de livraison a été supprimé avec succès",
        "Delete_delivery_rate_fail": "Des erreurs se sont produites lors de la suppression du tarif de livraison",
        "distance_km": "Tarif par km",
        "distance_mile": "Tarif par mile",
        "flat": "Tarif fixe",
        "startingFee": "Frais de départ",
        "feeFirstDistance": "Tarif pour la première distance",
        "feeSecondDistance": "Tarif pour la deuxième distance",
        "feeThirdDistance": "Tarif pour la troisième distance",
        "feeAfterThirdDistance": "Tarif après la troisième distance",
        "feePerMinute": "Tarif par minute",
        "feeMinimum": "Tarif minimum",
        "feeFirstStop": "Tarif pour le premier arrêt",
        "feeExtraStop": "Tarif pour chaque arrêt supplémentaire"
    },
    "aiAtlasSettings": {
        "title": "Chatbot Atlas AI",
        "titleDes": "Faites savoir à Atlas votre entreprise et votre service.",
        "information": "Informations sur l'Atlas",
        "informationDes": "Par exemple, ajoutez des détails sur l'entreprise comme l'email, le numéro de téléphone, l'adresse, etc.",
        "updateSettingSuccess": "Mise à jour des paramètres de l'IA Atlas réussie",
        "updateSettingFail": "Échec de la mise à jour des paramètres de l'IA Atlas"
    },
    "pwaSettings": {
        "pwa": "PWA",
        "iconName": "Icône et nom",
        "logoBackgroundColor": "Logo, arrière-plan et couleur",
        "longName": "Nom long",
        "shortName": "Nom court",
        "icon192": "Icône sur l'écran d'accueil (192x192)",
        "icon512": "Icône sur l'écran de démarrage",
        "logo": "Logo (300x300)",
        "logoMenu": "Logo du menu (300x300)",
        "backgroundImage": "Image d'arrière-plan - Transport (1024x500)",
        "backgroundImageDelivery": "Image d'arrière-plan - Livraison (1024x500)",
        "mainColor": "Couleur principale",
        "secondaryColor": "Couleur secondaire",
        "showMainColor": "Afficher la couleur principale au lieu de l'image d'arrière-plan",
        "success": "Les paramètres PWA ont été mis à jour avec succès",
        "failed": "Échec de la mise à jour des paramètres PWA. Veuillez réessayer !",
        "errorUploadFileSize": "Les dimensions requises sont {0}x{0} px.",
        "hideWBInstallAppBtn": "Masquer le bouton d'installation de l'application",
        "enableBookNow": "Maintenant",
        "enableGuestCheckout": "Paiement invité",
        "enableBookLater": "Plus tard",
        "enableHideRecipient": "Masquer les informations du destinataire (contenu du colis, instructions de livraison)",
        "pwaLink": "PWA pour passager",
        "partnerLink": "PWA pour partenaire",
        "pwaDriverLink": "PWA pour conducteur",
        "providerSignUp": "Lien d'inscription du conducteur",
        "AdsTracking": "Suivi des publicités",
        "googleId": "ID de balise Google",
        "placeholdergoogleId": "Saisir l'ID de balise Google",
        "metaId": "ID Pixel Meta",
        "placeholdermetaId": "Saisir l'ID Pixel Meta"
    },
    "emailConfig": {
        "emailServer": "Serveur de messagerie",
        "default": "Par défaut",
        "customized": "Personnalisé",
        "fromName": "Nom de l'expéditeur",
        "email": "E-mail de l'expéditeur",
        "replyTo": "Répondre à",
        "userAuth": "Nom d'utilisateur",
        "password": "Mot de passe",
        "smtpServer": "Serveur SMTP",
        "port": "Port SMTP",
        "isAuthenticated": "Authentifié",
        "option": "Activer l'option",
        "none": "Aucun",
        "tls": "TLS",
        "ssl": "SSL",
        "save": "Enregistrer",
        "cancel": "Annuler",
        "success": "Mise à jour du serveur de messagerie réussie",
        "fail": "Échec de la mise à jour du serveur de messagerie",
        "loadFail": "Échec du chargement des détails du serveur de messagerie"
    },
    "driverFields": {
        "Load_fail": "",
        "Edit": "Modifier",
        "View": "Afficher",
        "Cancel": "Annuler",
        "show": "Afficher",
        "hide": "Masquer",
        "EDIT_DRIVER_FIELDS": "Modifier les champs du conducteur",
        "DETAIL_DRIVER_FIELDS": "Détails des champs du conducteur",
        "ADD_DRIVER_FIELDS": "Ajouter des champs du conducteur",
        "fieldKey": "Clé des champs",
        "fieldName": "Nom des champs",
        "availableCC": "Disponible dans le centre de commande",
        "availableDrvSignUp": "Disponible lors de l'inscription du conducteur",
        "availableCompanyCar": "Conducteur individuel - Chauffeurs de transport",
        "deliveryCompany": "Conducteur individuel - Chauffeurs de livraison",
        "availableIndividualCar": "Disponible dans le centre de commande",
        "deliveryIndividual": "Disponible lors de l'inscription du conducteur",
        "required": "Requis",
        "Update_fail": "Des erreurs se sont produites lors de la mise à jour des champs du conducteur",
        "Update_success": "Les champs du conducteur ont été mis à jour avec succès",
        "FieldKey": "Clé des champs",
        "FieldName": "Nom des champs (anglais américain)",
        "CommandCenter": "Disponible dans le centre de commande",
        "SignUp": "Disponible lors de l'inscription du conducteur",
        "CompanyTransport": "Voiture de société - Transport",
        "CompanyDelivery": "Voiture de société - Livraison",
        "IndividualTransport": "Voiture individuelle - Transport",
        "IndividualDelivery": "Voiture individuelle - Livraison",
        "Require": "Requis",
        "Actions": "Actions",
        "fieldType": "Type de champs",
        "default": "Par défaut",
        "customized": "Personnalisé"
    },
    "driverDocument": {
        "Load_fail": "",
        "Edit": "Modifier",
        "View": "Afficher",
        "Cancel": "Annuler",
        "show": "Afficher",
        "hide": "Masquer",
        "EDIT_DRIVER_DOCUMENT": "Modifier le document du conducteur",
        "DETAIL_DRIVER_DOCUMENT": "Détails du document du conducteur",
        "ADD_DRIVER_DOCUMENT": "Ajouter un document du conducteur",
        "documentKey": "Clé du document",
        "documentName": "Nom du document",
        "documentNameDetail": {
            "zh-HK": "Chinois traditionnel",
            "it-IT": "Italien standard",
            "es-ES": "Espagnol",
            "en-US": "Anglais américain",
            "fr-FR": "Français standard",
            "zh-CN": "Chinois simplifié",
            "id-ID": "Indonésien",
            "vi-VN": "Vietnamien",
            "ur-PK": "Ourdou (République islamique du Pakistan)",
            "ms-MY": "Malais (Malaisie)",
            "ar-AR": "Arabe",
            "en-GB": "Anglais (Royaume-Uni)",
            "nb-NO": "Norvégien",
            "am-ET": "Amharique",
            "ro-RO": "Roumain",
            "th-TH": "Thaï",
            "ta-IN": "Tamoul",
            "hi-IN": "Hindi",
            "te-IN": "Télougou",
            "ka-GE": "Géorgien",
            "ru-RU": "Russe",
            "kn-IN": "Kannada"
        },
        "isIndividual": "Voiture de société - Chauffeurs de transport",
        "deliveryCompany": "Voiture de société - Chauffeurs de livraison",
        "isOwner": "Conducteur individuel - Chauffeurs de transport",
        "deliveryIndividual": "Conducteur individuel - Chauffeurs de livraison",
        "availableCC": "Disponible dans le centre de commande",
        "availableDrvSignUp": "Disponible lors de l'inscription du conducteur",
        "isRequired": "Requis",
        "isExpiredDate": "Date d'expiration - Centre de commande",
        "expiredDateForDrvSignUp": "Date d'expiration - Inscription du conducteur",
        "requireExpiredDate": "Date d'expiration requise",
        "requireExpiredDateForDrvSignUp": "Date d'expiration requise",
        "requireDocumentId": "ID du document requis",
        "documentId": "ID du document - Centre de commande",
        "documentIdForDrvSignUp": "ID du document - Inscription du conducteur",
        "Update_fail": "Des erreurs se sont produites lors de la mise à jour du document du conducteur",
        "Update_success": "Le document du conducteur a été mis à jour avec succès",
        "DocumentKey": "Clé du document",
        "DocumentName": "Nom du document (anglais américain)",
        "CommandCenter": "Disponible dans le centre de commande",
        "SignUp": "Disponible lors de l'inscription du chauffeur",
        "CompanyTransport": "Voiture d’entreprise - Transport",
        "CompanyDelivery": "Voiture de société - Livraison",
        "IndividualTransport": "Voiture individuelle - Transport",
        "IndividualDelivery": "Voiture individuelle - Livraison",
        "Require": "Requis",
        "Actions": "Actions"
    },
    "holidayTaxis": {
        "title": "Identifiants API HolidayTaxis",
        "note": "Communiquez avec l'équipe technique de HolidayTaxis pour obtenir une clé API afin de vous connecter à leur système.",
        "apiKey": "Clé API",
        "placeHolderApiKey": "Saisir la clé API"
    },
    "trailNotes": {
        "maxLengthFiles": "Maximum 3 fichiers par commentaire",
        "maxSizeFiles": "Maximum 10 Mo par fichier",
        "typeFiles": "Type de fichier pris en charge : pdf, doc, docx, csv, xls, xlsx, jpeg, jpg, png, webp, txt, note",
        "maxComments": "Maximum 20 commentaires par réservation",
        "bookingActivity": "Activité de réservation",
        "viewAll": "Voir tout",
        "operator": "Opérateur",
        "driver": "Chauffeur",
        "passenger": "Client",
        "pHInput": "Ajoutez un nouveau commentaire. Vous pouvez cliquer sur Enregistrer pour sauvegarder la note. Vous pouvez également glisser et déposer plusieurs fichiers ici.",
        "addFiles": "Ajouter des fichiers",
        "save": "Sauvegarder",
        "inputNotes": "Veuillez saisir du texte",
        "successDeleteTrailNotes": "Supprimer les notes de suivi avec succès",
        "successCreateTrailNotes": "Créer des notes de suivi avec succès",
        "deleteTrailNote": "Supprimer une note de suivi",
        "msgDeleteTrailNote": "Êtes-vous sûr de vouloir supprimer ceci ?"
    },
    "supplier": {
        "permissionRequired": "L'opérateur doit sélectionner une autorisation",
        "offerDetail": "Détail de l'offre",
        "orderDetail": "Détails de la commande",
        "bookingNumber": "Numéro de réservation",
        "date": "Date",
        "pickupLocation": "Pick up Location",
        "dropoffLocation": "Lieu de dépôt",
        "passenger": "Passager",
        "luggage": "Bagage",
        "pickupService": "Service de ramassage",
        "pickupSignage": "Signalisation de prise en charge",
        "flightNumber": "Numéro de vol",
        "departure": "Départ",
        "arrival": "Arrivée",
        "terminal": "Terminal",
        "gate": "Porte",
        "meetGreet": "Accueil pancarte",
        "specialRequests": "Demandes spéciales",
        "additionalServices": "Services supplémentaires",
        "price": "Prix",
        "prices": "Prix",
        "guest": "Client",
        "serviceClass": "Classe de service",
        "distance": "Distance",
        "duration": "Durée",
        "acceptOffer": "Accepter l'offre",
        "updateBooking": "Modifier réservation",
        "package": "Paquet",
        "route": "Route",
        "assignedChauffer": "Chauffeur assigné",
        "assignedVehicle": "Véhicule assigné",
        "logs": "Journaux",
        "link": "Liens",
        "desLink": "Cliquez pour copier le lien",
        "trackLink": "Lien de suivi",
        "driverLink": "Lien du chauffeur",
        "close": "Fermer",
        "links": "Liens",
        "linksDes": "Cliquez pour copier le lien",
        "status": "Statut",
        "rating": "Note",
        "permissions": "Autorisations",
        "permissionsNote": "Attribuez différents niveaux d'autorisation à votre équipe. Vous pouvez choisir si vos opérateurs ont une visibilité sur les offres ouvertes ou uniquement sur les missions déjà acceptées.",
        "owner": "Propriétaire",
        "ownerNote": "Accès complet",
        "manageUsers": "Gérer les utilisateurs",
        "manageUsersNote": "Ajouter/supprimer de nouveaux opérateurs",
        "manageDrivers": "Gérer les chauffeurs",
        "manageDriversNote": "Ajouter/supprimer les chauffeurs",
        "manageVehicles": "Gérer les véhicules",
        "manageVehiclesNote": "Ajouter/supprimer des véhicules",
        "mapView": "Carte en direct",
        "mapViewNote": "Suivre les chauffeurs et les trajets actifs en direct sur la carte.",
        "calendarView": "Vue calendrier",
        "calendarViewNote": "Afficher le calendrier de tous les voyages assignés.",
        "bookingView": "Vue des réservations",
        "bookingViewNote": "Afficher et gérer les réservations actuelles, assigner les chauffeurs et allouer des véhicules.",
        "offersView": "Vue des offres",
        "offersViewNote": "Accepter de nouvelles offres d'emploi.",
        "pricing": "Prix",
        "pricingNote": "Voir les prix des voyages",
        "report": "Rapports",
        "reportNote": "Voir les rapports de réservation et financiers",
        "reportExport": "Exporter les rapports",
        "reportExportNote": "Exporter les rapports au format .csv",
        "userDetail": "Détail de l'utilisateur",
        "addOperator": "Ajouter un opérateur",
        "updateOperator": "Mettre à jour l'opérateur",
        "supplier": "Fournisseur",
        "zone": "Zone",
        "emails": "E-mails",
        "email": "Email",
        "phoneNumber": "Numéro de téléphone",
        "Deactivate": "Désactiver",
        "Activate": "Activer",
        "ALERT_SELECT_DEACTIVATE": "Veuillez sélectionner un fournisseur à désactiver",
        "ALERT_SELECT_ACTIVATE": "Veuillez sélectionner un fournisseur à activer",
        "CONFIRM_DEACTIVATE_MULTI": "Voulez-vous désactiver ces fournisseurs ?",
        "CONFIRM_ACTIVATE_MULTI": "Voulez-vous activer ces fournisseurs ?",
        "Update_supplier_user_status_success": "Le statut du fournisseur a été mis à jour avec succès",
        "Update_supplier_user_status_fail": "Des erreurs sont survenues lors de la mise à jour du statut du fournisseur.",
        "agent": "Agent",
        "Supplier": "Fournisseur",
        "addSupplier": "Ajouter un fournisseur",
        "detailSupplier": "Détail du fournisseur",
        "addUser": "Ajouter un utilisateur",
        "Add": "Ajouter",
        "ContactInfo": "Coordonnées",
        "policy": "Politique",
        "users": "Utilisateurs",
        "setting": "Paramètre",
        "zones": "Zones",
        "actions": "Actions",
        "companyName": "Nom de l'entreprise",
        "corporationType": "Type de société",
        "country": "Pays",
        "nationality": "Nationalité",
        "driverIC": "IC de pilote",
        "ADMIN_INFORMATION": "Informations administratives",
        "firstName": "Prénom",
        "lastName": "Nom de famille",
        "commissionValue": "Commission de la flotte",
        "commissionValueDes": "Définir les commissions que la flotte gagne pour chaque commande complétée.",
        "SupplierType": "Type de fournisseur",
        "SupplierTypeDes": "Sélectionner un type de fournisseur.",
        "paymentMethodsApplyDes": "Méthodes de paiement spécifiques aux emplois que les fournisseurs peuvent traiter :",
        "bookingSettings": "Paramètres de réservation",
        "bookingSettingsDes": "Configurer la visibilité des emplois, les heures de publication et les délais pour une gestion efficace des fournisseurs.",
        "advanceBookingVisibilityTooltip": "Spécifier combien de jours à l'avance les fournisseurs peuvent voir les commandes.",
        "delayBroadcastToolTip": "Définir un délai à partir de l'heure de publication, si définie, ou du début de la journée (00:00). Ce délai contrôle le moment où les emplois deviennent visibles pour les fournisseurs après l'heure initiale de publication.",
        "releaseTimeToolTip": "Définissez l'heure de la journée à laquelle les travaux sont libérés aux fournisseurs, à partir du premier jour où ils peuvent voir les réservations. Assurez-vous que cette heure laisse aux fournisseurs suffisamment de temps de préparation.",
        "otherSettings": "Autres paramètres",
        "hideFare": "Chauffeur - Toujours masquer le tarif",
        "hideFareDes": "Masquer le tarif pour tous les chauffeurs de ce fournisseur.",
        "supplierJobRequired": "Acceptation des emplois par le fournisseur requise",
        "supplierJobRequiredDes": "Les fournisseurs doivent reconnaître et accepter les emplois avant de pouvoir assigner un chauffeur/véhicule ou permettre aux chauffeurs du marché de voir l'emploi.",
        "supplierApproval": "Approbation des chauffeurs/véhicules des fournisseurs",
        "supplierApprovalDes": "Permettre aux opérateurs de fournisseurs d'activer les chauffeurs et les véhicules au sein de leur flotte.",
        "emailsApply": "Notifications par e-mail",
        "emailsApplyDes": "E-mails pour envoyer de nouveaux emplois et mises à jour de réservation.",
        "address": "Adresse",
        "zipCode": "Code postal",
        "city": "Ville",
        "state": "État/Province",
        "tax": "Numéro d'identification fiscale",
        "businessRegistration": "Numéro d'inscription d'entreprise",
        "vatNumber": "Numéro de TVA",
        "mobile": "Mobile",
        "editOperator": "Modifier l'opérateur",
        "searchEmail": "Rechercher un e-mail",
        "acceptOfferSuccess": "Offre acceptée avec succès",
        "acceptOfferFail": "Réservation non trouvée ou un autre fournisseur a accepté la réservation",
        "driverPayout": "Paiement du chauffeur",
        "payout": "Paiement",
        "totalPayout": "Paiement total",
        "totalPayoutDes": "Le paiement total comprend le montant de base ainsi que tous les frais supplémentaires que vous avez choisi d’allouer à vos fournisseurs.",
        "supplierPayout": "Paiement du fournisseur",
        "driverTip": "Pourboire du chauffeur",
        "cancel": "Annuler",
        "save": "Sauvegarder",
        "activeSupplier": "Fournisseur actif",
        "userName": "Nom d'utilisateur",
        "bookingCompletedView": "Réservations terminées",
        "bookingCompletedViewNote": "Afficher l'historique de toutes les réservations terminées.",
        "driverEarning": "Gain du chauffeur",
        "payoutCurrency": "Devise de paiement",
        "payoutCurrencyDes": "Devise à payer au fournisseur/chauffeur",
        "autoCreatePayout": "Création automatique de paiement",
        "autoCreatePayoutDes": "Configurez quand créer automatiquement un relevé de paiement pour vos partenaires.",
        "startDate": "Date de début",
        "frequency": "Fréquence",
        "daily": "Quotidien",
        "weekly": "Hebdomadaire",
        "biWeekly": "Bimensuel",
        "monthly": "Mensuel",
        "commissionSupplier": "Commission",
        "commissionSupplierDes": "Set commissions que le fournisseur gagne pour chaque commande complète.",
        "amount": "Montant fixe",
        "percent": "Pourcentage",
        "commissionSupplierValue": "Saisir la valeur de la commission",
        "payments": "Paiements",
        "paymentsDes": "Solde à vous verser à chaque échéance de paiement",
        "ConnectWithStripe": "Se connecter avec Stripe",
        "viewStripeAccount": "Voir le compte Stripe",
        "viewBankInfo": "Voir les informations bancaires",
        "AddBankInfo": "Ajouter des informations bancaires",
        "confirmChangeBalane": "Êtes-vous sûr de vouloir changer le solde du fournisseur ?",
        "changeBalaneSuccess": "Le solde de trésorerie du fournisseur a été mis à jour avec succès.",
        "restrictedZoneAccess": "Accès Zone Restreinte",
        "restrictedZoneAccessDes": "Définir des zones spécifiques à haute sécurité ou contrôlées—telles que des bases militaires ou des installations de l'armée de l'air—où les prises en charge ou les dépôts ne sont autorisés que pour les conducteurs agréés ayant un accès spécial ou des permis.",
        "DrvSignUpLink": "Lien d'inscription des conducteurs"
    },
    "vehicleLeadTime": {
        "vehicleLeadTime": "Politique de délai de livraison des véhicules",
        "customLocationLeadTime": "Délais de livraison pour un emplacement personnalisé",
        "leadTime": "Délai de livraison",
        "ConfirmDelete": "Êtes-vous sûr de vouloir supprimer cette politique ?",
        "Delete_success": "La politique a été supprimée avec succès.",
        "Update_Policy_success": "La politique a été mise à jour avec succès.",
        "Create_Policy_success": "La politique a été créée avec succès",
        "Update_Policy_fail": "Les erreurs se sont produites lors de la mise à jour de la politique",
        "Create_Policy_fail": "Les erreurs se sont produites lors de la création de la politique",
        "setDefaultSuccess": "La politique de délai de livraison par défaut des véhicules a été définie avec succès.",
        "setDefaultFail": "Les erreurs se sont produites lors de la définition de la politique par défaut.",
        "Policies": "Politiques",
        "pricingPolicy": "Politique de tarification",
        "customizeLeadTime": "Personnaliser le délai de livraison",
        "SelectVehiclePolicy": "Sélectionner la politique de délai de livraison du véhicule"
    },
    "noResultFound": "Aucun résultat trouvé",
    "invalidDate": "La date n’est pas valide. Veuillez saisir la date au format mm/jj/aaaa.",
    "billingUsage": {
        "GSNTitle": "Portefeuille GSN",
        "GSNNote": "Les flottes rechargent pour envoyer ou recevoir des missions depuis le réseau.",
        "GSNPlatform": "Plateforme",
        "GSNPlatformNote": "Suivi de l'abonnement et de l'utilisation des réservations. Facturé en fin de cycle de facturation. Ceci reste distinct de votre portefeuille GSN.",
        "GSNPlatformLimit": "Facturation plateforme",
        "GSNPlatformLimitNote": "Suivi de l'abonnement et de l'utilisation. Facturé en fin de cycle de facturation. Ceci est distinct de votre portefeuille GSN.",
        "usageBalanceNote": "Suivi de l'abonnement et de l'utilisation. Facturé en fin de cycle de facturation. Ceci est distinct de votre portefeuille GSN.",
        "usageBalanceNoteDate": "Abonnement et utilisation impayés",
        "usageBalanceNoteDateValue": "échéance le %{date}.",
        "usageBalance": "Solde d'utilisation",
        "platformUsage": "Utilisation plateforme",
        "payoutBalance": "Solde de versement",
        "invoicePayoutBalanceTooltip": "Gains des courses réseau terminées, disponibles pour retrait. Si votre solde crédit est insuffisant, ce solde peut servir à couvrir les transactions réseau.",
        "autoPayoutBalanceTooltip": "Ce solde correspond à ce que vous avez gagné sur le réseau et que vous pouvez retirer. Si votre crédit est bas, les frais peuvent être prélevés automatiquement ici.",
        "creditBalance": "Solde crédit",
        "gsnCreditBalance": "Solde crédit GSN",
        "totalBalance": "Solde total",
        "paid": "Terminé",
        "failed": "Échoué",
        "processing": "En traitement",
        "pending": "En attente",
        "bookingDeduct": "GSN Farm-Out",
        "cancellationPenalty": "GSN annulation tardive",
        "noShowPenalty": "GSN non-présentation",
        "withdraw": "Retirer",
        "bookingEarning": "GSN Farm-In",
        "booking": "Frais de plateforme",
        "subscriptionFee": "Subscription Fee",
        "waived": "Waived*",
        "learnMore": "En savoir plus",
        "viewUsage": "View Usage",
        "productDiscovery": "Découverte de produit",
        "productDiscoveryDescription": "Explorez tout ce que vous pouvez lancer avec GoodJourney. Découvrez des applications pour conducteurs, des outils de réservation en ligne et d'autres produits pour dynamiser vos opérations.",
        "overview": "Aperçu",
        "paymentMethods": "Méthodes de paiement",
        "billingHistory": "Historique de facturation",
        "creditGrants": "Subventions de crédit",
        "transactionHistory": "Histoire des transactions",
        "getStartedDescription": "Votre guide tout-en-un de la plateforme. Explorez des tutoriels étape par étape, des FAQ et des meilleures pratiques pour maîtriser les réservations, l'envoi, les paiements, et plus encore.",
        "getStartedButton": "Commencer",
        "walletOverview": "Aperçu du portefeuille",
        "calculateTotal": "Total = Crédit + Espèces",
        "autoRechargeOn": "Lorsque votre solde de crédit atteint 0 $, vous passerez au niveau gratuit. Activez le rechargement automatique pour maintenir automatiquement votre solde de crédit à jour.",
        "autoRechargeOff": "Astuce : Activez le rechargement automatique pour maintenir votre solde à jour. Lorsque votre crédit tombe à 0 $, les nouvelles réservations seront mises en pause jusqu'à ce que vous ajoutiez des fonds.",
        "updateSettingsOn": "Mettre à jour les paramètres",
        "updateSettingsOff": "Activer le rechargement automatique",
        "autoChargeTitle": "Paramètres de recharge automatique",
        "autoChargeTitleQuestion": "Souhaitez-vous configurer le rechargement automatique ?",
        "autoChargeCbx": "Oui, rechargez automatiquement ma carte lorsque mon solde de crédit tombe en dessous d'un seuil.",
        "crdBelow": "Lorsque le solde créditeur descend en dessous de",
        "crdBelowNote": "Enter an amount between $5 and $100",
        "backupTo": "Ramener le solde créditeur à",
        "backupToNote": "Enter an amount between $10 and $100",
        "greaterThan": "La valeur doit être supérieure à {0}",
        "lessThan": "La valeur doit être inférieure à {0}",
        "AddBalance": "Ajouter au solde de crédit",
        "toAdd": "Montant à ajouter",
        "confirm": "Confirmer le paiement",
        "usageCredit": "Crédit d'utilisation de bon voyage",
        "estTotal": "Total estimé",
        "topUpSuccess": "Recharge réussie",
        "topUpFailMessage": "Les erreurs se sont produites lors du rechargement de crédit.",
        "autoRechargeSuccess": "Les paramètres de recharge automatique ont été mis à jour avec succès.",
        "autoRechargeFailMessage": "Les erreurs se sont produites lors de la mise à jour des paramètres de recharge automatique.",
        "creditBalanceTooltip": "Votre solde prépayé sert à payer les frais de plateforme et votre usage. Veillez à le maintenir approvisionné pour que votre service fonctionne sans interruption.",
        "gsnCreditBalanceTooltip": "Crédits prépayés pour envoyer et recevoir des courses sur le réseau. Maintenez un solde suffisant pour continuer à transacter sans interruption.",
        "creditLineTitle": "Ligne de crédit",
        "creditLineTooltip": "Limite de crédit pour l’activité Good Journey Network. Le montant utilisé est déduit de la limite ; le disponible est la marge restante avant paiement.",
        "creditLineLimit": "Limite",
        "creditLineUsed": "Utilisé",
        "creditLineAvailable": "Disponible",
        "creditLineNextPaymentLead": "Prochain paiement automatique %{date}",
        "creditLineNextPaymentTail": "ou lorsque votre solde atteint %{limitAmount}",
        "creditLineNextPaymentTailOnly": "Le paiement est dû lorsque votre solde atteint %{limitAmount}",
        "creditLineMakePayment": "Effectuer un paiement",
        "cashBalanceTooltip": "Ceci est votre revenu provenant des travaux complétés sur le réseau. Ce montant est disponible pour retrait. Si votre solde de crédit est faible, des frais peuvent également être déduits de ici.",
        "systemTopUp": "Recharge du système",
        "gsnManualTopUp": "Recharge manuelle",
        "gsnSystemTopUp": "Recharge du système",
        "autoTopUp": "Rechargement automatique",
        "manualTopUp": "Recharge manuelle",
        "subscription": "Abonnement",
        "subscriptionOneTime": "Abonnement unique",
        "subscriptionAddOn": "Option d'abonnement",
        "subscriptionAddOnOneTime": "Abonnement Supplémentaire Unique",
        "booking": "Frais de réservation",
        "addOn": "Module complémentaire",
        "subscriptionEnded": "Votre abonnement a expiré. Sélectionnez un nouveau plan pour continuer.",
        "continue": "Continuer",
        "openGuide": "Ouvrir le guide",
        "amountMustBeGreaterThan": "Le montant doit être supérieur à {0}",
        "amountMustBeLessThan": "Le montant doit être inférieur à {0}",
        "billingAndUsage": "Facturation et Utilisation",
        "manageSubscription": "Gérer l'abonnement",
        "failedToOpenBillingUrl": "Échec de l'ouverture de l'URL de facturation",
        "autoChargeAmountMustBeGreaterThanThreshold": "Lorsque la recharge automatique est activée, le montant doit être supérieur au seuil de recharge (5).",
        "rechargeWillHappenImmediately": "La recharge se fera immédiatement.",
        "rechargeWillHappenImmediatelyDescription": "Votre solde de crédit est en dessous du seuil de recharge que vous avez défini, donc une recharge aura lieu immédiatement après que vous ayez enregistré ces paramètres.",
        "amountIsRequired": "Le montant est requis",
        "selectPaymentMethod": "Choisissez un mode de paiement",
        "byContinuingYouAgree": "En continuant, vous acceptez notre",
        "serviceCreditTerms": "conditions de crédit de service",
        "paidCreditsNonRefundable": "Les crédits payés ne sont pas remboursables et expirent un an après la date d'achat.",
        "back": "Retour",
        "cancel": "Annuler",
        "topUp": "Recharger",
        "autoRechargeIs": "Auto recharge est",
        "on": "on",
        "off": "éteint",
        "viewTransactions": "Voir les transactions",
        "bankInfo": "Informations bancaires",
        "setupPayment": "Configurer le paiement",
        "bookingUsage": "Booking Usage",
        "overages": "Overages",
        "included": "included",
        "of": "of",
        "extra": "extra",
        "received": "Reçu",
        "state": "État",
        "active": "Actif",
        "expired": "Expiré",
        "balance": "Équilibre",
        "expires": "Expire",
        "last7Days": "7 Derniers Jours",
        "viewHistory": "Voir l'historique",
        "creditsListedHereWillBeRemoved": "Les crédits indiqués ici seront retirés du solde à leur date d'expiration.",
        "recentTransactions": "Transactions récentes",
        "onlyPreviewShown": "Seule un aperçu est affiché. Consultez les transactions pour le grand livre complet.",
        "showingTransactionsPast12Months": "Affichage des transactions des 12 derniers mois",
        "filter": "Filtrer",
        "export": "Exporter",
        "all": "Tout",
        "date": "Date",
        "amount": "Montant",
        "addOns": "Extensions",
        "edit": "Modifier",
        "usage": "Usage",
        "usageThisCycle": "Utilisation de ce cycle",
        "requests": "requêtes",
        "base": "Base",
        "overage": "Dépassement",
        "per": "par",
        "endOfSubscription": "Fin de l'abonnement",
        "fleetPlan": "Plan de flotte",
        "currentPlan": "Plan actuel",
        "billing": "Facturation",
        "startDate": "Date de début",
        "nextBillingDate": "Fin de l'abonnement",
        "change": "Changer",
        "getStarted": "Commencer",
        "oneTimeSetup": "Configuration unique :",
        "fee": "Frais :",
        "overagePerRequest": "Dépassement",
        "overagePerRequestText": "sur demande",
        "upToRequestsIncluded": "Jusqu'à",
        "requestsIncluded": "demandes incluses",
        "subscribed": "Abonné",
        "contactUs": "Contactez-nous",
        "enableOnlyWhatYouNeed": "Activez uniquement ce dont vous avez besoin. Les prix s'ajustent avec le cycle de facturation. Les options supplémentaires basées sur l'utilisation pour tout dépassement seront déduites de votre portefeuille de flotte.",
        "subscriptionSummary": "Résumé de l'abonnement",
        "reviewAndUpdate": "Vérifiez et mettez à jour votre abonnement.",
        "plan": "Plan",
        "ongoingTotal": "Total en cours",
        "nextBillingCycle": "Prochain cycle de facturation",
        "cancelSubscription": "Annuler l'abonnement",
        "areYouSureCancelSubscription": "Êtes-vous sûr de vouloir annuler votre abonnement ? Vous continuerez à avoir accès au service.",
        "until": "jusqu'à",
        "resumeSubscription": "Reprendre l'abonnement",
        "no": "Non",
        "yes": "Oui",
        "updateSubscription": "Mettre à jour l'abonnement",
        "upgrade": "Mettre à niveau",
        "from": "De :",
        "totalDueToday": "Total dû aujourd'hui",
        "howProrationWorks": "Comment fonctionne la proratisation",
        "prorationDescription": "Tout temps inutilisé de votre plan actuel ou des options supplémentaires sera crédité sur le nouveau plan. Les options supplémentaires ajoutées en cours de cycle ne sont facturées que pour les jours restants dans la période de facturation actuelle.",
        "pleaseSelectPaymentMethod": "Veuillez sélectionner un mode de paiement.",
        "paymentConfirmedSuccessfully": "Paiement confirmé avec succès",
        "failedToConfirmPayment": "Échec de la confirmation du paiement",
        "confirmPayment": "Confirm Payment",
        "failedToGetBillingPlan": "Échec de l'obtention du plan de facturation par code de pays",
        "failedToGetPreview": "Échec de l'obtention du plan de facturation d'aperçu",
        "failedToPreviewAddOns": "Échec de l'aperçu des modules complémentaires",
        "subscriptionCancelledSuccessfully": "Abonnement annulé avec succès",
        "failedToCancelSubscription": "Échec de l'annulation de l'abonnement",
        "addOnChangedSuccessfully": "Add-on modifié avec succès",
        "failedToChangedAddOn": "Échec du changement de l'add-on",
        "failedToGetUsage": "Échec de l'obtention de l'utilisation",
        "annual": "Annuel",
        "monthly": "Mensuel",
        "currentPlanButton": "Plan actuel",
        "upgradeButton": "Mettre à niveau",
        "save": "Enregistrer",
        "expiresText": "Expire",
        "noExpiry": "Pas d'expiration",
        "managePayment": "Gérer le paiement",
        "changePlan": "Change Plan",
        "addOns": "Modules complémentaires",
        "viewUsage": "Voir l'utilisation",
        "requestWithdrawal": "Demander un retrait",
        "withdraw": "Retirer",
        "withdrawalGsn": {
            "requestWithdrawal": "Demander un retrait",
            "reviewWithdrawal": "Vérifier le retrait",
            "payTo": "Payer à",
            "availableBalance": "Solde disponible ({currency})",
            "payoutBalance": "Solde de versement ({currency})",
            "payoutBalanceLabel": "Solde de versement",
            "amountOwedToPlatform": "Montant dû à la plateforme",
            "availableToWithdraw": "Disponible pour retrait",
            "amountToWithdraw": "Montant à retirer ({currency})",
            "minimumWithdrawal": "Retrait minimum : {amount} {currency}",
            "minimumTransferAmount": "Montant de transfert minimum : {amount} {currency}",
            "noPayoutMethods": "Aucun moyen de paiement",
            "review": "Vérifier",
            "payoutSpeed": "Vitesse de versement",
            "normalPayout": "Versement standard",
            "instantPayout": "Versement instantané",
            "recommended": "Recommandé",
            "transferFeePercent": "Frais de transfert {percent} %",
            "transferFee": "Frais de transfert",
            "withdrawalAmount": "Montant du retrait",
            "amountDeducted": "Montant déduit",
            "youWillReceive": "Vous recevrez",
            "totalToReceive": "Total à recevoir",
            "confirmWithdrawal": "Confirmer le retrait",
            "disclaimer": "Les retraits sont envoyés en USD",
            "disclaimer1": "Les banques bénéficiaires peuvent convertir les fonds en devise locale et appliquer leurs propres frais et taux de change",
            "disclaimer2": "Le montant final reçu peut différer du montant envoyé.",
            "requestSuccess": "Demande de retrait envoyée avec succès."
        },
        "addNewPaymentMethod": "Ajouter un nouveau moyen de paiement",
        "warningCurrentBalance": "Le montant dû à la plateforme dépasse votre solde de versement actuel. Vous ne pouvez pas demander de retrait pour le moment."
    },
    "signup": {
        "limitation": {
            "driver": "Driver",
            "vehicle": "Vehicle",
            "operator": "Operator",
            "drivers": "Drivers",
            "vehicles": "Vehicles",
            "operators": "Operators"
        },
        "language": "Langue",
        "contactHeader": "Pour toute question ou problème, veuillez contacter",
        "stepAccountTitle": "Créer un compte",
        "stepAccountDesc": "Veuillez fournir votre nom d'utilisateur et votre mot de passe.",
        "stepCompanyTitle": "Détails de l'entreprise",
        "stepCompanyDesc": "Ajoutez votre logo, thème de couleur et informations sur l'entreprise.",
        "stepZoneTitle": "Zone d'opération",
        "stepZoneDesc": "Sélectionnez votre ville d'opération.",
        "stepPlanTitle": "Choisissez un plan",
        "stepPlanDesc": "Sélectionnez un plan de paiement qui vous convient.",
        "stepPlanCustom": "Votre Plan Personnalisé",
        "stepPlanTitleCustom": "Examinez Votre Plan Personnalisé",
        "stepPlanDescCustom": "Un plan conçu spécifiquement pour votre flotte.",
        "accountStepTitle": "Créer un compte",
        "accountStepUsername": "Nom d'utilisateur",
        "accountStepEmail": "Email",
        "accountStepChoosePassword": "Choisir un mot de passe",
        "accountStepConfirmPassword": "Confirmer le mot de passe",
        "accountStepPasswordHint": "Le mot de passe doit comporter au moins 8 caractères, 1 lettre majuscule et 1 caractère spécial.",
        "accountStepCreateAccount": "Créer un compte",
        "accountStepAlreadyHaveAccount": "Vous avez déjà un compte ?",
        "accountStepCaptchaError": "Veuillez vérifier le captcha.",
        "accountStepGenericError": "Une erreur est survenue lors de la création du compte.",
        "accountStepSuccess": "Compte créé avec succès",
        "usernameRequired": "Le nom d'utilisateur est requis",
        "usernameMinLength": "Le nom d'utilisateur doit comporter au moins 3 caractères.",
        "usernameMaxLength": "Le nom d'utilisateur doit comporter moins de 20 caractères.",
        "usernamePattern": "Le nom d'utilisateur doit commencer par une lettre minuscule et ne peut contenir que des lettres minuscules et des chiffres",
        "emailRequired": "L'email est requis",
        "emailInvalid": "L'email n'est pas valide",
        "passwordRequired": "Un mot de passe est requis.",
        "passwordMinLength": "Le mot de passe doit comporter au moins 8 caractères.",
        "passwordPattern": "Le mot de passe doit contenir au moins 1 lettre majuscule et 1 caractère spécial.",
        "confirmPasswordMismatch": "Les mots de passe ne correspondent pas",
        "companyStepTitle": "Détails de l'entreprise",
        "companyStepAddLogo": "Ajouter un logo",
        "companyStepColorTheme": "Thème de couleur",
        "companyStepSelectThemeColor": "Choisir la couleur du thème",
        "companyStepFirstName": "Prénom",
        "companyStepLastName": "Nom de famille",
        "companyStepPhone": "Téléphone",
        "companyStepEmail": "Email",
        "companyStepCompanyName": "Nom de l'entreprise",
        "companyStepFleetId": "ID de flotte",
        "companyStepCompanyAddress": "Adresse de l'entreprise",
        "companyStepCompanyWebsite": "Site Web de l'entreprise",
        "companyStepDriversNumber": "Combien de conducteurs dans votre flotte ?",
        "companyStepVehiclesNumber": "Combien de véhicules dans votre flotte ?",
        "companyStepContinue": "Continuer",
        "companyStepGenericError": "Une erreur est survenue lors de l'enregistrement de l'entreprise.",
        "companyStepSuccess": "Entreprise enregistrée avec succès",
        "companyStepPhoneInvalid": "Veuillez entrer un numéro de téléphone valide.",
        "companyNameRequired": "Le nom de l'entreprise est requis",
        "fleetIdRequired": "FleetId est requis",
        "fleetIdPattern": "Doit comporter entre 4 et 30 caractères, doit commencer par une lettre minuscule et ne peut contenir que des lettres minuscules et des chiffres",
        "zoneStepTitle": "Configurer la zone d'opération",
        "zoneStepDescription": "Ceci est votre zone d'opération initiale. Pour de futures expansions, n'hésitez pas à",
        "zoneStepSearchAddress": "Rechercher une adresse",
        "zoneStepLatitude": "Latitude",
        "zoneStepLongitude": "Longitude",
        "zoneStepRadius": "Jusqu'où irez-vous en dehors de votre zone centrale ?",
        "zoneStepRadiusDescription": "Distance la plus éloignée du point central.",
        "zoneStepContinue": "Continuer",
        "zoneStepGenericError": "Une erreur est survenue lors de l'enregistrement de la zone.",
        "zoneStepSuccess": "Zone enregistrée avec succès",
        "zoneStepInvalidCoordinates": "La latitude et la longitude ne sont pas valides.",
        "latitudeRequired": "La latitude est requise",
        "latitudeDecimalPlaces": "La latitude peut avoir au maximum 10 décimales.",
        "latitudeRange": "La latitude doit être comprise entre -90 et 90 degrés.",
        "longitudeRequired": "La longitude est requise",
        "longitudeDecimalPlaces": "La longitude peut avoir au maximum 10 décimales.",
        "longitudeRange": "La longitude doit être comprise entre -180 et 180 degrés.",
        "radiusRequired": "Le rayon est requis",
        "radiusMinError": "Le rayon doit être d'au moins {0} km.",
        "radiusMaxError": "Le rayon ne peut pas dépasser {0} km.",
        "contactUs": "contactez-nous",
        "planTitle": "Choisir un plan",
        "planDescription": "Choisissez un plan qui correspond à vos besoins. Améliorez ou annulez à tout moment. Pas de frais cachés, jamais.",
        "planDescriptionCustom": "Un plan conçu spécifiquement pour votre flotte.",
        "billingMonthly": "Mensuel",
        "billingAnnual": "Annuel",
        "saveBadge": "Économisez 20%",
        "popularBadge": "LES PLUS POPULAIRES",
        "customPricing": "Personnalisé",
        "periodAnnual": "Annuel",
        "periodMonthly": "Mensuel",
        "bonusCredits": "Bonus {0} Crédits Unique",
        "savePercentage": "Économisez {0}%",
        "oneTimeSetupFee": "Frais d'Installation Unique",
        "waived": "Waived*",
        "planFeatures": {
            "feePerBooking39": "3,9 % par réservation",
            "feePerBooking29": "2,9 % par réservation",
            "feePerBooking": "{0} par réservation supplémentaire",
            "freeBookingPerMonth": "{0} réservations GRATUITES par mois",
            "unlimitedUsers": "Utilisateurs illimités",
            "commandCenterAdminDashboard": "Tableau de bord administrateur du centre de commandement",
            "nativeDriverApp": "Application de pilote natif",
            "webDriverApp": "Application Web Driver",
            "customerBookingLink": "Lien de réservation client",
            "plusEverythingInStartup": "Plus tout ce qui est dans Startup",
            "corporateManagement": "Gestion d'entreprise",
            "invoicingManagement": "Gestion de la facturation",
            "driverPayoutManagement": "Gestion des paiements des conducteurs",
            "promotionManagement": "Gestion des promotions",
            "plusEverythingInPro": "Plus tout dans Pro",
            "tierDiscountPricing": "Tarification à rabais par niveau",
            "customFeatureDevelopment": "Développement de fonctionnalités personnalisées",
            "unlimitedOperators": "Opérateurs Illimités",
            "unlimitedDrivers": "Conducteurs Illimités",
            "unlimitedVehicles": "Véhicules Illimités"
        },
        "planDescriptions": {
            "enterprise": "Enterprise comprend la facturation personnalisée, l'intégration dédiée, la tarification avec remise par niveau et le développement de fonctionnalités personnalisées pour s'adapter parfaitement à votre flux de travail spécifique."
        },
        "limitedNotes": "(*) Promotion exclusive à durée limitée",
        "unlimitedText": "Illimité",
        "volumeDiscount": "Remise de volume",
        "letsTalkButton": "Parlons !",
        "buildingStepTitle": "Construire votre flotte...",
        "congratulationsTitle": "Félicitations ! Votre compte est prêt.",
        "congratulationsDescription": "Connectez-vous à votre tableau de bord administrateur ici.",
        "congratulationsViewDashboard": "Voir le tableau de bord",
        "congratulationsContact": "Questions ? Contactez-nous à",
        "fleetIdDescription": "Choisissez un code court et simple pour votre flotte — facile à partager et à retenir.",
        "fleetIdPlaceholder": "par exemple, goodjourney",
        "firstNameRequired": "Le prénom est requis",
        "logIn": "Se connecter",
        "instead": "à la place.",
        "submittingData": "Soumission des données...",
        "upload": "Télécharger",
        "phoneNumberPlaceholder": "Numéro de téléphone +1",
        "km": "KM",
        "selectPlan": "Choisir un plan",
        "upgrade": "Mettre à niveau",
        "goodJourney": "Bon voyage",
        "loading": "Chargement...",
        "lastNameRequired": "Le nom de famille est requis",
        "agreeToTerms": "En continuant, vous reconnaissez avoir lu et acceptez",
        "termsOfService": "Conditions d'utilisation",
        "privacyPolicy": "Politique de confidentialité",
        "and": "et",
        "refresh": "Actualiser",
        "takingTooLong": "Trop long?"
    },
    "addonTemplate": {
        "Addon_Template": "Add-On Template",
        "Add_On_Template": "Add-On Template",
        "Create_addon_template_success": "Add-on template has been created successfully",
        "Create_addon_template_fail": "The errors occurred while creating add-on template",
        "Update_addon_template_success": "Add-on template has been updated successfully",
        "Update_addon_template_fail": "The errors occurred while updating add-on template",
        "Update_template_success": "Template has been updated successfully",
        "Update_template_fail": "The errors occurred while updating template",
        "Edit_Template": "Edit Template",
        "New_Template": "New Template",
        "Enter_Add_On_Template_Name": "Enter Add-On Template Name*",
        "Confirm_Delete": "Confirm Delete",
        "Confirm_Delete_Message": "Are you sure you want to delete this template? Deleting this template will unlink from all the partners/corp it links to",
        "Delete_success": "Template has been deleted successfully",
        "Delete_fail": "The errors occurred while deleting template",
        "Set_Default": "Set as Default",
        "Confirm_Set_Default_Message": "Are you sure you want to set this Add-On as default?",
        "Set_Default_Success": "Add-on template has been set as default successfully",
        "Set_Default_Fail": "The errors occurred while setting add-on template as default",
        "Clone_addon_template": "Clone Add-On Template"
    },
    "addonService": {
        "Additional_Service": "Additional Service",
        "Service_Name": "Service Name",
        "Description": "Description",
        "desPlaceholder": "Brief description of the service",
        "namePlaceholder": "e.g. Meet & Greet, Local-E Sim, GST Tax",
        "Who_pays_for_this_add_on": "Who pays for this add-on?",
        "customer": "Customer",
        "driver": "Driver",
        "fleet": "Fleet",
        "Required": "Required",
        "Apply_Tax": "Apply Tax",
        "Itemize": "Itemize",
        "Attribute": "Attribute",
        "Fee_Type": "Fee Type",
        "feeType.amount": "Amount",
        "feeType.percentageSubtotal": "Percentage of Subtotal",
        "feeType.percentageTotal": "Percentage of Total",
        "feeType.custom": "Custom (Driver Input)",
        "Unit_Settings": "Unit Settings",
        "unit.none": "None",
        "unit.perDay": "per day",
        "unit.eachTime": "each time",
        "unit.perPerson": "per person",
        "Maximum_Quantity": "Maximum Quantity",
        "Maximum_Quantity_Value": "Maximum Quantity Value",
        "How_much_will_the_fleet_make": "How much will the fleet make for this add-on?",
        "Fleet_Commission": "Fleet Commission",
        "Percentage": "Percentage",
        "Amount": "Amount",
        "Currency": "Currency",
        "Unlimited": "Unlimited",
        "Limited": "Limited",
        "Vehicle_Type": "Vehicle Type",
        "Service_Type": "Service Type",
        "Meeting_Zone": "Meeting Zone",
        "Trip_Context": "Trip Context",
        "Trip_Context_Value": {
            "departure": "Departure",
            "arrival": "Arrival"
        },
        "Operation_Zone": "Operation Zone",
        "Restricted_Zone": "Restricted Zone",
        "User_Type": "User Type",
        "Price_Unit": "Price Unit",
        "Info": "Info",
        "Rules": "Rules",
        "Basic_Information": "Basic Information",
        "Delete": "Delete",
        "Delete_addon_service": "Are you sure you want to delete this add-on service?",
        "Delete_success": "Add-on service has been deleted successfully",
        "Delete_fail": "The errors occurred while deleting add-on service",
        "Create_addon_service_success": "Add-on service has been created successfully",
        "Create_addon_service_fail": "The errors occurred while creating add-on service",
        "Update_addon_service_success": "Add-on service has been updated successfully",
        "Update_addon_service_fail": "The errors occurred while updating add-on service",
        "Please_save_template_first": "Please save the template first before adding services",
        "Attribute_Tooltip": "Travel Attribute: Used to map this add-on to its corresponding standardized service key across connected OTAs (e.g., CHILD_SEAT, MEET_GREET).",
        "feeType": {
            "amount": "Amount",
            "percentageSubtotal": "Percentage of Subtotal",
            "percentageTotal": "Percentage of Total",
            "custom": "Custom (Driver Input)"
        },
        "unit": {
            "none": "None",
            "perDay": "Per day (Charge per day)",
            "eachTime": "Each time (Charge per ride)",
            "perPerson": "Per person (Charge per person)",
            "each": "Each (Charge per quantity)"
        },
        "none": "None",
        "perDay": "Per day",
        "eachTime": "Each time",
        "perPerson": "Per person",
        "each": "Each",
        "Unit_Settings_Title": "Unit Settings",
        "Itemize_Tooltip": "Itemize: This will list the add-on as a separate line item in the fare breakdown. If this is disabled, it will be under additional services.",
        "Booking_Channel": "Booking Channel",
        "pointToPoint": "Point To Point",
        "fromAirport": "From Airport",
        "toAirport": "To Airport",
        "hourly": "Hourly",
        "roundTrip": "Round Trip",
        "ADD_ON_BOOKING_CHANNEL_VALUE": {
            "PWA": "Web App",
            "passenger": "Customer App",
            "API": "API",
            "CC": "Command Center",
            "partner": "Partner App",
            "CarHailing": "Street Hailing",
            "streetSharing": "Street Sharing"
        },
        "Select_Attribute": "Select Attribute",
        "allowNoteInput": "Driver Input: Notes or Receipts",
        "allowNoteInputTooltip": "Allows drivers to submit notes and upload supporting photos or receipts for this service at the end of the trip (e.g. parking fees, tolls, additional charges).",
        "isDriverCapability": "Driver Capability",
        "Driver_Capability_Tooltip": "Exposes this service as a selectable capability in the driver profile. Used for driver profiling and booking-to-driver matching.",
        "isVehicleAttribute": "Vehicle Attribute",
        "Vehicle_Attribute_Tooltip": "Exposes this service as a selectable attribute in the vehicle profile. Used for vehicle profiling and booking matching.",
        "linkAtr": "Link attributes to a specific driver.",
        "addOnServicePolicy": "Add-On Policy",
        "selectAddonTemplate": "Select Add-on Template"
    }
};
